import { Component, OnInit, Inject, ViewChild, HostListener, ChangeDetectorRef, NgZone } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject, forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { B2BService } from 'src/app/b2-b.service';
import { SignalRService, OrderProcessingProgressUpdate } from 'src/app/services/signalr.service';
import { ManagementComponent } from '../management.component';
import { GridApi, ColumnApi, ColDef } from 'ag-grid-community';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-new-purchase-order',
  templateUrl: './new-purchase-order.component.html',
  styleUrls: ['./new-purchase-order.component.css'],
      providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
  
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
      ],
})
export class NewPurchaseOrderComponent implements OnInit {

  constructor(public parent:ManagementComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private signalRService: SignalRService, private ngZone: NgZone) {
      translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
      translate.setDefaultLang('en');

      const browserLang = this.parent.getLanguage();
      translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

       // Debounce search.
       this.searchMainOrders.pipe(
        debounceTime(750),
        distinctUntilChanged())
        .subscribe(value => {
          this.LoadingMainSearchTerm = true;

          this.InitializeFilter();
          this.DisablePeriod();
          this.ClearPeriod();

          // Main search must span all dates - clear the default 6-month window
          this.Filter.FromDate = null;
          this.Filter.ToDate = null;
          this.FromDate = new FormControl(null);
          this.ToDate = new FormControl(null);

          this.Filter.SearchTerm = value;
          this.GetProductsFiltered(1);
        });

        // Debounce search.
        this.searchB2BUser.pipe(
          debounceTime(400),
          distinctUntilChanged())
          .subscribe(value => {
            this.GetUserClientsFiltered(value);
          });

            // Debounce search.
       this.searchUserManagerUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetUserManagersFiltered(value);
        });

       // Debounce search.
       this.searchPartnerUpdate.pipe(
        debounceTime(400),
        distinctUntilChanged())
        .subscribe(value => {
          this.GetPartnersFiltered(value, null, true);
        });

       // Debounce search.
       this.searchTermUpdate.pipe(
        debounceTime(500),
        distinctUntilChanged())
        .subscribe(value => {
          this.Filter.SearchTerm = value;

          if(this.Filter.SearchTerm?.length > 2){
            this.applyFilter(1);
          }
        });

       // Debounce brand search.
       this.brandSearchTermUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetBrandsFiltered(value);
          }
        });

       // Debounce supplier search (100ms - faster like cell popup).
       this.searchSupplierUpdate.pipe(
        debounceTime(100),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetSuppliersFiltered(value);
          }
        });

       // Debounce partner popup search (header overlay).
       this.partnerPopupSearchUpdate.pipe(
        debounceTime(200),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.GetPartnersFilteredPopup(value);
          }
        });

       // Debounce NEW PO partner pre-popup search.
       this.newPOPartnerSearchUpdate.pipe(
        debounceTime(250),
        distinctUntilChanged())
        .subscribe(value => {
          if(value?.length >= 1){
            this.searchNewPOPartners(value);
          }
        });
    }

    @ViewChild('autosize') autosize: CdkTextareaAutosize;
    searchTermUpdate = new Subject<string>();
    searchPartnerUpdate = new Subject<string>();
    partnerPopupSearchUpdate = new Subject<string>();
    searchUserManagerUpdate = new Subject<string>();
    searchB2BUser = new Subject<string>();
    searchMainOrders = new Subject<string>();
    brandSearchTermUpdate = new Subject<string>();
    searchSupplierUpdate = new Subject<string>();
    newPOPartnerSearchUpdate = new Subject<string>();

    LoadingMainSearchTerm:boolean = false;

    // Brand filter properties
    BrandFilter: {[k: string]: any} = {};
    Brands: any[] = [];
    showBrandDropdown: boolean = false;
    showBrandPopup: boolean = false;
    brandSearchTerm: string = '';
    loadingBrands: boolean = false;

    // Supplier filter properties
    SupplierFilter: {[k: string]: any} = {};
    Suppliers: any[] = [];
    showSupplierDropdown: boolean = false;
    showSupplierPopup: boolean = false;
    supplierSearchTerm: string = '';
    loadingSuppliers: boolean = false;

    // Partner filter properties (header overlay)
    showPartnerPopup: boolean = false;
    partnerSearchTerm: string = '';
    loadingPartners: boolean = false;

    // ✅ NEW PO (empty) partner pre-popup properties
    showNewPOPartnerPopup: boolean = false;
    newPOPartnerSearchTerm: string = '';
    newPOPartners: any[] = [];
    loadingNewPOPartners: boolean = false;

    // ProgressStatus filter properties (header overlay)
    showProgressStatusFilterPopup: boolean = false;

    // Grid header widths for custom overlay
    gridHeaderWidths: any[] = [];

    searchMainOrdersSearchTerm:string;

    // Convert to Order - Send Email dropdown (default false)
    sendEmailOnConvert: boolean = false;
    showSendEmailResults: boolean = false;
    sendEmailOptions = [
      { value: true, label: 'Send Email' },
      { value: false, label: 'Do Not Send Email' }
    ];
    ShowConvertToOfferConfirmation: boolean = false;
    ShowGeneratePOConfirmation: boolean = false;

    // ✅ Progress Status change confirmation popup (prevents accidental double-click status changes)
    ShowStatusChangeConfirmation: boolean = false;
    statusChangeConfirmItems: any[] = []; // [{ brand, name, currentStatusName, nextStatusName }] for display
    private pendingStatusChange: any = null; // { params, isProductsGrid, isMulti, items: [{ row, cartItem, nextStatus }] }

    // ✅ Generate PO Popup properties
    ShowGeneratePOPopup: boolean = false;
    GeneratedPurchaseOrders: any[] = []; // ✅ Store PurchaseOrder objects from API
    generatePOGridApis: any[] = []; // Array of grid APIs, one per supplier
    generatePOColumnDefs: any[] = [];
    generatePOGridOptions: any = {
      rowHeight: 26,
      headerHeight: 26,
      stopEditingWhenCellsLoseFocus: true,
      singleClickEdit: false,
      domLayout: 'autoHeight',
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      enableRangeSelection: true,
      suppressClipboardApi: true,
      suppressMovableColumns: true,
      suppressClipboardPaste: false,
      suppressLastEmptyLineOnPaste: true,
      rowClassRules: {
        GridNotValid: (p: any) => p.data?.CartItemStatus?.ID === 0,
        GridValid: (p: any) => {
          const isStock = p.data?.SelectedOffer?.IsStockOffer === true;
          const hasQty = p.data?.SelectedOffer?.StockQuantity > 0;
          const isNotMfgStock = p.data?.SelectedOffer?.IsManufacturerStockOffer !== true;
          return p.data?.CartItemStatus?.ID === 1 && isStock && hasQty && isNotMfgStock;
        },
        GridValidNoStock: (p: any) => {
          const statusId = p.data?.CartItemStatus?.ID;
          if (statusId !== 1) return false;
          const isStock = p.data?.SelectedOffer?.IsStockOffer === true;
          const hasQty = p.data?.SelectedOffer?.StockQuantity > 0;
          const isNotMfgStock = p.data?.SelectedOffer?.IsManufacturerStockOffer !== true;
          return !(isStock && hasQty && isNotMfgStock);
        }
      },
      processDataFromClipboard: (params: any) => {
        const data = params.data;
        if (!data || data.length === 0) return data;

        // Find which poIndex this grid belongs to
        // processDataFromClipboard doesn't have params.api, so use the focused grid
        let poIndex = -1;
        for (let i = 0; i < this.generatePOGridApis.length; i++) {
          const api = this.generatePOGridApis[i];
          if (api && api.getFocusedCell()) {
            poIndex = i;
            break;
          }
        }
        if (poIndex < 0) return data;

        const gridApi = this.generatePOGridApis[poIndex];
        const focusedCell = gridApi?.getFocusedCell();
        const startRowIndex = focusedCell?.rowIndex ?? 0;
        const pasteRowCount = data.length;
        const requiredRowCount = startRowIndex + pasteRowCount;
        const currentRowCount = gridApi?.getDisplayedRowCount() ?? 0;

        if (requiredRowCount > currentRowCount) {
          const rowsToAdd = requiredRowCount - currentRowCount;
          this.addMoreGeneratePORows(poIndex, rowsToAdd);
        }

        return data;
      },
      onPasteEnd: (params: any) => {
        // Find which poIndex this grid belongs to
        const gridApi = params.api;
        const poIndex = this.generatePOGridApis.indexOf(gridApi);
        if (poIndex >= 0) {
          this.handleGeneratePOPaste(params, poIndex);
        }
      }
    };
    // ✅ Per-PO header checkbox state for select all
    generatePOHeaderCheckboxSelected: { [poIndex: number]: boolean } = {};
    // ✅ Per-PO dropdown toggle states
    generatePODropdownStates: { [poIndex: number]: {
      showResp: boolean; showType: boolean; showCompany: boolean; showDeliveryPref: boolean;
      showConsolidation: boolean; showPaymentTerm: boolean; showPaymentType: boolean;
      showSendEmail: boolean; showAgents: boolean; showDiscountType: boolean; showPickupAddress: boolean;
    } } = {};
    // ✅ Per-PO group collapse states (entire PO card)
    generatePOGroupCollapsed: { [poIndex: number]: boolean } = {};
    // ✅ Per-PO section collapse states
    generatePOSectionCollapsed: { [poIndex: number]: { totals: boolean; contactInfo: boolean; terms: boolean; shipping: boolean } } = {};
    // ✅ Per-PO Partner Agents selection
    generatePOSelectedAgents: { [poIndex: number]: any[] } = {};
    // ✅ Per-PO new agent email input
    generatePONewAgentEmail: { [poIndex: number]: string } = {};
    generatePOIsValidEmail: { [poIndex: number]: boolean } = {};

    // ✅ Purchase Currency dropdown properties
    showPurchaseCurrencyDropdown: boolean = false;
    purchaseCurrencyDropdownPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '60px' };
    purchaseCurrencyRowIndex: number = -1;

    // ✅ Bulk Best Price popup properties
    ShowBulkBestPricePopup: boolean = false;
    bulkBestPriceConfigStatuses: any[] = [];
    bulkBestPriceStockStatuses: any[] = [];
    selectedBulkConfigStatus: any = null;
    selectedBulkStockStatus: any = null;
    bulkBestPriceLoading: boolean = false;

    // ✅ Bulk Best Price SignalR progress properties
    showBulkBestPriceProgress: boolean = false;
    bulkBestPriceProgressPercent: number = 0;
    bulkBestPriceProgressCompleted: number = 0;
    bulkBestPriceProgressTotal: number = 0;
    bulkBestPriceProgressMessage: string = '';
    bulkBestPriceOverwriteSellPrice: boolean = false;

    // ✅ Generate PO Purchase Currency dropdown state (per PO index)
    showGeneratePOCurrencyResults: { [poIndex: number]: boolean } = {};

    // ✅ Bulk PO Creation Results Popup properties
    ShowBulkPOResultsPopup: boolean = false;
    BulkPOCreationResults: any = null; // Stores the response from BulkCreatePurchaseOrders API
    BulkPOCreationLoading: boolean = false;

    // ✅ PO Pre-Check Warning Popup properties
    ShowPOPreCheckWarning: boolean = false;
    POPreCheckWarningItems: any[] = []; // Items with non-New progress status
    POPreCheckValidItems: any[] = []; // Items with New (Not Ordered) progress status

    // ✅ PO Purchase Data Missing Warning Popup properties
    ShowPOPurchaseDataWarning: boolean = false;
    POPurchaseDataWarningItems: any[] = []; // Items with missing Supplier and/or Purchase Price
    POPurchaseDataProblematicGridItems: any[] = []; // Grid row items with missing purchase data (for Get Best Offers)
    POPurchaseDataBestOffersLoading: boolean = false; // Loading state for Get Best Offers button

    // ✅ PO Mixed Purchase Currency Warning Popup properties
    ShowPOMixedCurrencyWarning: boolean = false;
    POMixedCurrencyWarningItems: any[] = []; // [{ supplier, currency, products: string[] }]
    private _pendingPOMixedCurrencyCartItems: any[] = []; // CartItems to re-use after user chooses "Proceed"

    // ✅ Sell Currency (SC) popup properties
    ShowChangeSellCurrencyPopup: boolean = false;
    selectedSellCurrency: any = null;
    showSellCurrencyResults: boolean = false;
    selectedOfferDBIDForCurrency: number = 0;
    selectedCartItemForCurrency: any = null;

    // ✅ EditContainer Partner & Currency Management
    editContainerPartnerSearchTerm: string = '';
    editContainerPartnerSearchTermUpdate = new Subject<string>();
    editContainerSearchedPartners: any[] = [];
    editContainerLoadingPartners: boolean = false;
    showEditContainerPartnerResults: boolean = false;
    showEditContainerCurrencyResults: boolean = false;

    ngOnInit(): void {
      this.loadAutoSaveDelay();
      this.InitializeFilter();
      this.GetOfferMasterData();
      this.GetShippingMasterData();
      this.initProductsGrid();
      this.initUndoDatabase();

      // ✅ EditContainer Partner search debounce
      this.editContainerPartnerSearchTermUpdate.pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(() => {
        this.GetEditContainerPartnersFiltered();
      });
    }

    // Initialize Products tab grid - same as offer grid but with extra Offer/Partner columns
    initProductsGrid(): void {
      // Copy offer column defs (exclude last column: save button, we'll add save at the end)
      const baseColumns = this.offerColumnDefs.slice(0, -1).map((col: ColDef) => {
        return { ...col };
      });
      // Get the save column to add at the end
      const saveColumn = { ...this.offerColumnDefs[this.offerColumnDefs.length - 1] };

      // Delete column
      const deleteColumn: ColDef = {
        headerName: '',
        field: 'delete',
        editable: false,
        width: 25,
        minWidth: 25,
        maxWidth: 25,
        suppressMenu: true,
        sortable: false,
        resizable: false,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' },
        cellRenderer: () => {
          const disabled = this.isCanceled;
          const color = disabled ? '#bdbdbd' : '#d32f2f';
          const cursor = disabled ? 'not-allowed' : 'pointer';
          return `<i class="material-icons" style="font-size: 14px; color: ${color}; cursor: ${cursor};" title="${disabled ? 'Disabled - Order Canceled' : 'Delete'}">close</i>`;
        },
        onCellClicked: (params: any) => {
          // ✅ Disable delete on canceled orders
          if (this.isCanceled) return;
          // Check if there are selected rows for multi-delete
          if (this.hasSelectedCartItems()) {
            this.IsMultiDelete = true;
          } else {
            this.IsMultiDelete = false;
            this.DeleteCartItemParams = params;
          }
          this.ShowDeleteCartItemConfirmation = true;
        }
      };

      // Put index and status columns first (index at position 0, status at position 1 in offerColumnDefs)
      const indexCol = {
        ...baseColumns[0],
        headerClass: 'products-index-header', // index column with products-specific headerClass
        // ✅ Double-click the checkbox cell → select/deselect the whole group (between separator borders)
        onCellDoubleClicked: (params: any) => {
          this.toggleProductsGroupSelection(params.api, params.rowIndex);
        }
      };
      const statusCol = {
        ...baseColumns[1],
        headerClass: 'products-status-header',
        // Colored background by progress status (only this status column is tinted; rest of grid stays white)
        cellStyle: (params: any) => {
          const statusId = params.data?.CartItem?.ProgressStatus?.ID;
          let color = '#333';
          let backgroundColor = 'rgba(0, 0, 0, 0.05)';

          switch (statusId) {
            case -9999: color = '#c62828'; backgroundColor = 'rgba(198, 40, 40, 0.12)'; break;
            case -1000: color = '#e65100'; backgroundColor = 'rgba(230, 81, 0, 0.12)'; break;
            case 0: color = '#1565c0'; backgroundColor = 'rgba(21, 101, 192, 0.12)'; break;
            case -10: color = '#7b1fa2'; backgroundColor = 'rgba(123, 31, 162, 0.12)'; break;
            case 2: color = '#2e7d32'; backgroundColor = 'rgba(46, 125, 50, 0.12)'; break;
            case 3: color = '#00695c'; backgroundColor = 'rgba(0, 105, 92, 0.12)'; break;
          }

          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
            color: color,
            backgroundColor: backgroundColor,
            cursor: 'pointer'
          };
        },
        // Override cellRenderer to set progressStatusPopupIsProductsGrid based on actual grid API
        cellRenderer: (params: any) => {
          const alias = params.data?.CartItem?.ProgressStatus?.Alias ?? '';
          // Create element with right-click handler
          const container = document.createElement('div');
          container.style.cssText = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
          container.innerHTML = `<span style="font-size: 9px; font-weight: 600;">${alias}</span>`;

          // Add right-click (context menu) handler
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            const cartItem = params.data?.CartItem;
            if (!cartItem) return;

            // Set popup position near the click
            this.progressStatusPopupPosition = {
              top: (event.clientY) + 'px',
              left: (event.clientX) + 'px'
            };

            // Store clicked row info
            this.progressStatusPopupCartItem = cartItem;
            this.progressStatusPopupRowIndex = params.rowIndex;
            // Determine which grid this cell actually belongs to by comparing params.api
            this.progressStatusPopupIsProductsGrid = (params.api === this.productsGridApi);

            // Show the popup
            this.showProgressStatusCellPopup = true;
            this.cdr.detectChanges(); // Trigger Angular change detection
          });

          return container;
        },
        onCellDoubleClicked: (params: any) => {
          const isProducts = (params.api === this.productsGridApi);
          this.handleProgressStatusDoubleClick(params, isProducts);
        }
      };
      const restColumns = baseColumns.slice(2); // all other columns

      // Override Quantity column cellRenderer for Products grid to set splitProductIsProductsGrid = true
      const qtyColIndex = restColumns.findIndex((col: ColDef) => col.field === 'quantity');
      if (qtyColIndex >= 0) {
        restColumns[qtyColIndex] = {
          ...restColumns[qtyColIndex],
          cellRenderer: (params: any) => {
            const qty = params.value ?? '';
            const offer = params.data?.CartItem?.SelectedOffer;
            const hasMOQ = offer?.MOQ != null && offer.MOQ > 1;
            const container = document.createElement('div');
            container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;' + (hasMOQ ? 'color:#d32f2f;font-weight:700;' : '');
            container.textContent = qty.toString();
            if (hasMOQ) container.title = 'MOQ: ' + offer.MOQ;

            return container;
          }
        };
      }

      // Delivery Preference column (DP): P=Partial(green), F=Full(red)
      const deliveryPrefCol: ColDef = {
        headerName: 'DP',
        field: 'deliveryPreference',
        editable: false,
        minWidth: 30,
        maxWidth: 35,
        width: 33,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const dpId = params.data?.CartItem?.DeliveryPreference?.ID;
          const bg = dpId === 1 ? 'rgba(253, 79, 87, 0.6)' : 'rgba(50, 170, 58, 0.6)';
          return { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0', cursor: 'pointer', backgroundColor: bg, color: '#fff' };
        },
        cellRenderer: (params: any) => {
          const dpId = params.data?.CartItem?.DeliveryPreference?.ID;
          const alias = dpId === 1 ? 'FD' : 'PD';
          const container = document.createElement('div');
          container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;';
          container.innerHTML = `<span style="font-size:9px;font-weight:700;color:#fff;">${alias}</span>`;
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            const cartItem = params.data?.CartItem;
            if (!cartItem) return;
            this.deliveryPreferencePopupPosition = { top: event.clientY + 'px', left: event.clientX + 'px' };
            this.deliveryPreferencePopupCartItem = cartItem;
            this.deliveryPreferencePopupRowIndex = params.rowIndex;
            this.deliveryPreferencePopupIsProductsGrid = (params.api === this.productsGridApi);
            this.showDeliveryPreferencePopup = true;
            this.cdr.detectChanges();
          });
          return container;
        }
      };

      // Consolidation Type column (CT): C=Consolidated(green), D=DispatchImmediately(red)
      const consolidationTypeCol: ColDef = {
        headerName: 'CT',
        field: 'consolidationType',
        editable: false,
        minWidth: 30,
        maxWidth: 35,
        width: 33,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const ctId = params.data?.CartItem?.ConsolidationType?.ID;
          const bg = ctId === 1 ? 'rgba(253, 79, 87, 0.6)' : 'rgba(50, 170, 58, 0.6)';
          return { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0', cursor: 'pointer', backgroundColor: bg, color: '#fff' };
        },
        cellRenderer: (params: any) => {
          const ctId = params.data?.CartItem?.ConsolidationType?.ID;
          const alias = ctId === 1 ? 'I' : 'GR';
          const container = document.createElement('div');
          container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;';
          container.innerHTML = `<span style="font-size:9px;font-weight:700;color:#fff;">${alias}</span>`;
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();
            const cartItem = params.data?.CartItem;
            if (!cartItem) return;
            this.consolidationTypePopupPosition = { top: event.clientY + 'px', left: event.clientX + 'px' };
            this.consolidationTypePopupCartItem = cartItem;
            this.consolidationTypePopupRowIndex = params.rowIndex;
            this.consolidationTypePopupIsProductsGrid = (params.api === this.productsGridApi);
            this.showConsolidationTypePopup = true;
            this.cdr.detectChanges();
          });
          return container;
        }
      };

      this.productsColumnDefs = [
        indexCol,
        {
          headerName: 'Partner',
          field: 'partnerName',
          editable: false,
          minWidth: 60,
          flex: 1,
          suppressMenu: true,
          cellClassRules: {
            GridUrgentPartnerCell: (p: any) => {
              const ci = p.data?.CartItem;
              if (!ci) return false;
              if (ci.ConsolidationType?.ID === 1) return true;
              const lt = ci.SelectedOffer?.LeadTime;
              if (lt && lt.Type?.ID === 0 && lt.Units < 4) return true;
              return false;
            }
          },
          valueGetter: (params: any) => params.data?.PartnerName ?? '',
          cellRenderer: (params: any) => {
            const partnerName = params.data?.PartnerName ?? '';
            const refNum = params.data?.CartItem?.CartItemOrderInfo?.ReferenceNumber || params.data?.ReferenceNumber || '';
            const debatorPO = params.data?.CartItem?.CartItemOrderInfo?.DebatorPO || params.data?.DebatorPO || '';
            const statusAlias = params.data?.CartItem?.ProgressStatus?.Alias ?? '';
            let html = `<div style="display: flex; flex-direction: column; line-height: 1.3; justify-content: center; height: 100%;">`;
            html += `<span style="font-size: 9px; font-weight: 500; font-style: italic; color: #1a3a5c; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${partnerName}</span>`;
            if (refNum || statusAlias) {
              html += `<div style="display: flex; align-items: center; gap: 4px;">`;
              if (refNum) {
                html += `<span style="font-size: 8px; color: #1976d2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${refNum}</span>`;
              }
              if (statusAlias) {
                html += `<span style="font-size: 7px; font-weight: 600; color: #fff; background: #1565c0; padding: 1px 4px; border-radius: 3px; white-space: nowrap;">${statusAlias}</span>`;
              }
              html += `</div>`;
            }
            if (debatorPO) {
              html += `<span style="font-size: 8px; color: #f60; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${debatorPO}</span>`;
            }
            html += `</div>`;
            return html;
          },
          onCellDoubleClicked: (params: any) => {
            const rowNode = params.node;
            const rowData = rowNode?.data;
            this.ProductsClickedRow = rowData;
            this.ProductsClickedRowIndex = params.rowIndex;
            this.loadChainHistory();
          }
        },
        ...restColumns,
        saveColumn,
        deleteColumn
      ];

      this.productsDefaultColDef = {
        ...this.offerDefaultColDef,
        cellStyle: { fontSize: '10px' },
        // Default every products-grid cell to white; only status / DP / CT columns set their own colored background
        cellClass: 'cell-white'
      };

      this.productsGridOptions = {
        rowHeight: 56,
        headerHeight: 32,
        enableRangeSelection: true,
        suppressClipboardApi: true,
        enableFillHandle: true,
        enableClipboard: true,
        suppressClipboardPaste: false,
        suppressLastEmptyLineOnPaste: true,
        rowSelection: 'multiple',
        suppressRowClickSelection: true,
        stopEditingWhenCellsLoseFocus: true,
        singleClickEdit: false,
        undoRedoCellEditing: true,
        suppressMovableColumns: true,
        tooltipShowDelay: 0,
        tooltipHideDelay: 10000,
        enableBrowserTooltips: true,
        context: { componentParent: this },
        undoRedoCellEditingLimit: 20,
        domLayout: 'autoHeight',
        suppressContextMenu: true, // Suppress AG Grid's default context menu to use custom popups
        rowClassRules: {
          GridValid: (p: any) => {
            const isStock = p.data?.CartItem?.SelectedOffer?.IsStockOffer === true;
            const hasQty = p.data?.CartItem?.SelectedOffer?.StockQuantity > 0;
            const isNotMfgStock = p.data?.CartItem?.SelectedOffer?.IsManufacturerStockOffer !== true;
            return isStock && hasQty && isNotMfgStock;
          },
          GridAdminPriceEdit: (p: any) => p.data?.CartItem?.AdminPriceEdit === true,
          'reference-group-separator': (p: any) => {
            const nextRowNode = p.api?.getDisplayedRowAtIndex(p.rowIndex + 1);
            if (!nextRowNode) return false;

            const groupingID = this.selectedGrouping?.ID;

            // Group by Partner (ID=1)
            if (groupingID === 1) {
              const currentPartner = p.data?.PartnerName;
              const nextPartner = nextRowNode?.data?.PartnerName;
              return currentPartner != null && nextPartner != null && currentPartner !== nextPartner;
            }

            // Group by Brand (ID=2)
            if (groupingID === 2) {
              const currentBrand = p.data?.CartItem?.Product?.Brand?.Name;
              const nextBrand = nextRowNode?.data?.CartItem?.Product?.Brand?.Name;
              return currentBrand != null && nextBrand != null && currentBrand !== nextBrand;
            }

            // Default: group by ReferenceNumber
            const currentRef = p.data?.ReferenceNumber;
            const nextRef = nextRowNode?.data?.ReferenceNumber;
            return currentRef != null && nextRef != null && currentRef !== nextRef;
          }
        },
        onGridReady: (params: any) => {
          this.productsGridApi = params.api;
          params.api.sizeColumnsToFit();
          // Inject header checkbox after grid is ready
          setTimeout(() => this.injectProductsHeaderCheckbox(), 100);
        },
        onCellContextMenu: (event: any) => {
          if (event.column?.getColId() === 'quantity') {
            event.event?.preventDefault();
            event.event?.stopPropagation();

            const cartItem = event.data?.CartItem;
            if (!cartItem || !cartItem.ID) return;

            const currentQty = cartItem?.Quantity || event.value || 0;
            if (currentQty <= 1) return;

            this.splitProductPopupPosition = {
              top: (event.event.clientY) + 'px',
              left: (event.event.clientX) + 'px'
            };

            this.splitProductCartItem = cartItem;
            this.splitProductRowIndex = event.rowIndex;
            this.splitProductOriginalQty = currentQty;
            this.splitProductQty1 = currentQty;
            this.splitProductQty2 = 0;
            this.splitProductIsProductsGrid = true;

            this.showSplitProductPopup = true;
            this.cdr.detectChanges();
          }
        },
        onCellEditingStarted: (event: any) => {
          const rowIndex = event.rowIndex;
          this.onCellEditingStarted(rowIndex, true);
        },
        onCellValueChanged: (event: any) => this.onProductsCellValueChanged(event),
        onRangeSelectionChanged: (event: any) => {
          if (event.finished) {
            const cellRanges = event.api.getCellRanges();
            if (cellRanges && cellRanges.length > 0) {
              const selectedRowIndices = new Set<number>();
              cellRanges.forEach((range: any) => {
                const startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
                const endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
                for (let i = startRow; i <= endRow; i++) {
                  selectedRowIndices.add(i);
                }
              });
              // Only update IsSelected if more than 1 row is selected (actual multi-select)
              if (selectedRowIndices.size > 1) {
                selectedRowIndices.forEach((rowIndex: number) => {
                  const rowNode = event.api.getDisplayedRowAtIndex(rowIndex);
                  if (rowNode?.data?.CartItem) {
                    rowNode.data.CartItem.IsSelected = true;
                  }
                });
                event.api.refreshCells({ columns: ['index'], force: true });
              }
            }
          }
        },
        // ✅ Grid-level cell click: deselect all if clicking on an unselected row (not on checkbox)
        onCellClicked: (event: any) => {
          const target = event.event?.target as HTMLElement;
          // Don't interfere with checkbox clicks or button clicks
          if (target?.classList?.contains('cart-item-checkbox') ||
              target?.closest('button') ||
              target?.closest('.material-icons')) {
            return;
          }
          // If clicking on a row that is NOT selected, deselect all selected rows
          const clickedRowIsSelected = event.data?.CartItem?.IsSelected === true;
          if (!clickedRowIsSelected && this.hasSelectedCartItems()) {
            this.deselectAllProductItems();
          }
        },
        tabToNextCell: (params: any) => {
          const { previousCellPosition } = params;
          if (!previousCellPosition) return previousCellPosition;

          // If multiple rows are selected, suppress TAB navigation (stay on same row)
          const selectedItems = this.getSelectedProductItems();
          if (selectedItems.length > 1) {
            return previousCellPosition;
          }

          const rowIndex = previousCellPosition.rowIndex;
          const totalRows = params.api.getDisplayedRowCount();
          if (rowIndex >= totalRows - 1) return previousCellPosition;
          const nextRowNode = params.api.getDisplayedRowAtIndex(rowIndex + 1);
          if (!nextRowNode?.data?.CartItem) return previousCellPosition;
          return {
            rowIndex: rowIndex + 1,
            column: previousCellPosition.column,
            rowPinned: previousCellPosition.rowPinned
          };
        }
      };

    }

    countryID:number = null;
    Filter: {[k: string]: any} = {};
    MasterData: {[k: string]: any} = {};
    CurrentShippingAddress:any;
    activeFilters:{[k: string]: any} = [];
    Orders:{[k: string]: any} = [];
    Totals:{[k: string]: any} = [];
    searchTerm:string;
    Partners:any[];
    resultsLength:number = 0;
    partner:any;
    CurrentOrder:any;
    UserClientsSearchTerm:string;

    // ✅ Computed property to check if order is canceled
    get isCanceled(): boolean {
      return this.CurrentOrder?.OCStatus?.ID === -1;
    }

    FromDate: FormControl;
    ToDate: FormControl;

    loadingOrders:boolean;
    showFilter:boolean;
    ShowExportBulkQuestion:boolean;
    AllSelected:boolean;
    ShowOrderCancelation:boolean;
    ShowOrderCopy:boolean;
    ShowEditContainer:boolean;

    // ✅ Discount Type dropdown state
    showDiscountTypeDropdown: boolean = false;

    // ✅ Payment Term dropdown state
    showPaymentTermDropdown: boolean = false;

    // ✅ Weight Type dropdown state
    showWeightTypeDropdown: boolean = false;

    // Custom dropdown states for filter container
    showStatusDropdown: boolean = false;
    showCurrencyDropdown: boolean = false;
    showUserManagerDropdown: boolean = false;
    showTranzactionTypeDropdown: boolean = false;

    // Country filter properties
    showCountryDropdown: boolean = false;
    countrySearchTerm: string = '';
    Countries: any[] = [];

    // Progress Status filter properties (for FilterContainer)
    showProgressStatusDropdown: boolean = false;

    SearchUserManager:string;
    UserManagers:any[];
    UserManagersLength:number = 0;
    UserManager:any;

    SearchUserUploader:string;
    UserClients:any[];
    UserClientsLength:number = 0;
    UserUploader:any;

    ShowOrderBillingInformation:boolean = false;
    ShowOrderShippingInformation:boolean = false;
    ShowOrderGeneralInformation:boolean = false;
    ShowOrderProductsInformation:boolean = true;

    // Shipping section dropdown states
    showShippingAddressDropdown: boolean = false;
    showShippingCountryDropdown: boolean = false;
    showShippingResponsabilityDropdown: boolean = false;
    showShippingServiceTypeDropdown: boolean = false;
    showShippingCompanyDropdown: boolean = false;
    showShippingCostDischargeTypeDropdown: boolean = false;
    HasInvoicedShippingCosts: boolean = false;

    // Invoice popup (double-click on INV status)
    showInvoicePopup: boolean = false;
    invoicePopupData: any = null;
    invoicePopupLoading: boolean = false;

    // Shipping master data
    ShippingResponsabilities: any[] = [];
    ShippingServiceTypes: any[] = [];
    ShippingCompanies: any[] = [];
    APIShippingCompanies: any[] = [];
    ShippingDirections: any[] = [];
    ShippingWays: any[] = [];
    ShippingWeightTypes: any[] = [];
    ShippingDownloadTypes: any[] = [];

    // ✅ Bulk PO shipping-label state
    BulkPOCompanyShippingAddresses: any[] = [];

    // Tab state: 'offers' | 'products' | 'onhold'
    activeTab: string = 'products';
    // Legacy compatibility getter
    get showOffersTab(): boolean { return this.activeTab === 'offers'; }
    set showOffersTab(v: boolean) { this.activeTab = v ? 'offers' : 'products'; }

    // On-Hold tab data
    OnHoldItems: any[] = [];
    OnHoldPager: any = { PageIndex: 1, PageSize: 50, TotalCount: 0, Pages: 0 };
    loadingOnHold: boolean = false;
    onHoldGridApi: GridApi;

    // Products grouping dropdown state
    showGroupingDropdown: boolean = false;
    selectedGrouping: any = { ID: -1 }; // Default: No Grouping
    groupingDropdownPosition: { top: string; left: string } = { top: '0px', left: '0px' };

    // Dispatch filter dropdown state
    showDispatchFilterDropdown: boolean = false;
    dispatchFilterMode: string = 'all'; // 'all' | 'dispatch'
    dispatchFilterDropdownPosition: { top: string; left: string } = { top: '0px', left: '0px' };

    // Period dropdown state (compact filter bar, replaces the mat-select period picker)
    showPeriodDropdown: boolean = false;
    periodDropdownPosition: { top: string; left: string } = { top: '0px', left: '0px' };

    // Products tab data
    ProductItems: any[] = [];
    ProductsPager: any = { PageIndex: 1, PageSize: 50, TotalCount: 0, Pages: 0 };
    loadingProducts: boolean = false;
    productsGridApi: GridApi;

    // Products grid uses same column defs as offer grid - initialized in ngOnInit
    productsColumnDefs: ColDef[] = [];
    productsDefaultColDef: any = {};
    productsGridOptions: any = {};

    // Auto-save feature with configurable delay
    AutoSave: boolean = true;
    OfferAutoSave: boolean = true;
    autoSaveDelay: number = 0.25; // seconds, persisted to localStorage (min 0.25, max 2.00)
    private readonly AUTO_SAVE_DELAY_KEY = 'oc_autoSaveDelay';
    savingRow: boolean = false;
    savingGridRow: boolean = false; // Grid-specific saving indicator (minimalist spinner in pagination row)
    autoSaveTimer: any = null;
    autoSaveRowIndex: number = -1;
    autoSavePendingCartItem: any = null;
    autoSaveIsProductsGrid: boolean = true;
    autoSaveLastEditedColumn: string = '';

    // In-memory Undo system - max 5 snapshots
    private undoSnapshots: string[] = []; // JSON strings of ProductItems
    private readonly MAX_UNDO_SNAPSHOTS = 5;
    undoSnapshotCount: number = 0;
    showSaveAfterUndo: boolean = false; // Show "Save All" button after undo to persist changes
    private skipNextUndoSnapshot: boolean = false; // Skip snapshot on system-initiated grid refresh (e.g., after BulkCreatePurchaseOrders)

    // Products grid popup state
    ShowProductsETAAlternatives: boolean = false;
    ShowProductsSupplierAlternatives: boolean = false;
    ShowProductsBrandCollateral: boolean = false;
    ProductsBrandCollateralList: any[] = [];
    ProductsSideOffers: any[] = [];
    ProductsClickedRow: any = null;
    ProductsClickedRowIndex: number = -1;
    ProductsBrandPopupPosition: any = {};
    ProductsSearchResultsPosition: any = {};
    ProductsSupplierPopupPosition: any = {};
    ProductsLoadingSideOffers: boolean = false;
    selectedProductsNamePopupTab: number = 0;
    ProductsSupplierPopupSearchTerm: string = '';

    // ✅ Price History tab state (default tab in the name-column popup)
    ProductsPriceHistory: any[] = [];
    ProductsLoadingPriceHistory: boolean = false;

    // ✅ Chain History popup state
    ShowChainHistory: boolean = false;
    ChainHistoryLoading: boolean = false;
    ChainHistoryOrderChain: any[] = [];
    ChainHistoryItemChain: any[] = [];
    ProductsSupplierPopupSearchResults: any[] = [];

    // ✅ Split Product Popup state
    showSplitProductPopup: boolean = false;
    showSplitProductDialog: boolean = false;
    splitProductCartItem: any = null;
    splitProductRowIndex: number = -1;
    splitProductOriginalQty: number = 0;
    splitProductQty1: number = 0; // Original quantity (adjusted)
    splitProductQty2: number = 0; // Split quantity
    splitProductPopupPosition: any = { top: '0px', left: '0px' };
    splitProductIsProductsGrid: boolean = true;
    splitProductInvoices: any[] = []; // Associated invoices for the cart item
    splitProductShippingData: any[] = []; // Associated shipping/tracking data for the cart item
    splitProductLoadingAssociations: boolean = false; // Loading state for fetching associations

    // ✅ Export Products state variables
    showExportDialog: boolean = false;
    exporting: boolean = false;
    generatingPackageList: boolean = false;

    // ✅ Package List dialog state (persists until page refresh)
    showPackageListDialog: boolean = false;
    packageListVariant: string = 'confidential'; // 'showSupplier' or 'confidential'
    exportableColumns: { field: string, label: string, selected: boolean }[] = [
      { field: 'partner', label: 'Partner', selected: true },
      { field: 'offer', label: 'Offer', selected: true },
      { field: 'brand', label: 'Brand', selected: true },
      { field: 'partNumber', label: 'Part Number', selected: true },
      { field: 'name', label: 'Name', selected: true },
      { field: 'quantity', label: 'Quantity', selected: true },
      { field: 'officialListPrice', label: 'List Price', selected: false },
      { field: 'officialDiscount', label: 'Discount', selected: false },
      { field: 'price', label: 'Final Price', selected: true },
      { field: 'eta', label: 'Delivery', selected: true },
      { field: 'supplier', label: 'Supplier', selected: true },
      { field: 'purchase', label: 'Purchase', selected: false },
      { field: 'purchaseDiscount', label: 'PD', selected: false }
    ];

    // AG Grid for Offer Products
    offerGridApi: GridApi;
    offerColumnApi: ColumnApi;
    offerGridRowData: any[] = [];
    CartItemRows: any[] = [];

    // ✅ Excel Export Column Control - synced with ag-Grid column widths
    columnWidths: { [key: string]: number } = {};

    // ✅ Sync column widths from ag-Grid to ExcelExportControlRow
    syncColumnWidths(retryCount: number = 0): void {
      // Find the ag-grid element inside EditContainer
      const gridElement = document.querySelector('.EditContainer .ProductsAGGridContainer ag-grid-angular');
      if (!gridElement) {
        console.log('📏 ag-grid element not found, retry:', retryCount);
        if (retryCount < 20) {
          setTimeout(() => this.syncColumnWidths(retryCount + 1), 150);
        }
        return;
      }

      // Find all header cells - they can be nested in different containers
      const headerCells = gridElement.querySelectorAll('.ag-header-cell');
      if (!headerCells || headerCells.length === 0) {
        console.log('📏 No header cells found, retry:', retryCount);
        if (retryCount < 20) {
          setTimeout(() => this.syncColumnWidths(retryCount + 1), 150);
        }
        return;
      }

      const widths: { [key: string]: number } = {};
      headerCells.forEach((cell: Element) => {
        const colId = cell.getAttribute('col-id');
        const width = (cell as HTMLElement).offsetWidth;
        if (colId && width > 0) {
          widths[colId] = width;
        }
      });

      console.log('📏 Synced column widths from DOM:', widths, 'cell count:', headerCells.length);
      this.columnWidths = { ...widths };
      this.cdr.detectChanges();
    }

    // ✅ Get width style for ExcelExportControlRow cell
    getColumnWidth(field: string): { [key: string]: string } {
      const width = this.columnWidths[field];
      if (width) {
        return { 'width': width + 'px', 'min-width': width + 'px', 'max-width': width + 'px', 'flex': 'none' };
      }
      return {};
    }

    // ✅ Check if all export columns are selected
    get allExportColumnsSelected(): boolean {
      const pdf = this.CurrentOrder?.PDFColumns;
      if (!pdf) return false;
      return pdf.ListPrice && pdf.Discount && pdf.StandardDelivery && pdf.HSCode && pdf.COO && pdf.Weight;
    }

    // ✅ Toggle all export columns
    toggleAllExportColumns(checked: boolean): void {
      if (!this.CurrentOrder) return;
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = { ID: 0, OrderDBID: 0, ListPrice: false, Discount: false, StandardDelivery: true, HSCode: true, COO: true, Weight: true };
      }
      this.CurrentOrder.PDFColumns.ListPrice = checked;
      this.CurrentOrder.PDFColumns.Discount = checked;
      this.CurrentOrder.PDFColumns.StandardDelivery = checked;
      this.CurrentOrder.PDFColumns.HSCode = checked;
      this.CurrentOrder.PDFColumns.COO = checked;
      this.CurrentOrder.PDFColumns.Weight = checked;
      this.savePDFColumns();
    }

    // ✅ Handle individual export column checkbox change
    onExportColumnChange(columnName: string, checked: boolean): void {
      if (!this.CurrentOrder) return;
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = { ID: 0, OrderDBID: 0, ListPrice: false, Discount: false, StandardDelivery: true, HSCode: true, COO: true, Weight: true };
      }
      switch (columnName) {
        case 'ListPrice': this.CurrentOrder.PDFColumns.ListPrice = checked; break;
        case 'Discount': this.CurrentOrder.PDFColumns.Discount = checked; break;
        case 'ETA': this.CurrentOrder.PDFColumns.StandardDelivery = checked; break;
        case 'HSCode': this.CurrentOrder.PDFColumns.HSCode = checked; break;
        case 'COO': this.CurrentOrder.PDFColumns.COO = checked; break;
        case 'Weight': this.CurrentOrder.PDFColumns.Weight = checked; break;
      }
      this.savePDFColumns();
    }

    // ✅ Save PDFColumns to backend
    savePDFColumns(): void {
      if (!this.CurrentOrder?.DBID || !this.CurrentOrder?.PDFColumns) return;
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        OrderDBID: this.CurrentOrder.DBID,
        PDFColumns: this.CurrentOrder.PDFColumns,
        OrderType: 'OrderConfirmation'
      };
      this.managementService.UpdateOrderPDFColumns(request).subscribe((response: any) => {
        if (response.Status !== 1) {
          console.error('Failed to save PDF columns:', response.Message);
        }
      });
    }

    // ✅ Popup state variables (matching create-new-quotation)
    ShowSearchResultsAlternatives: boolean = false;
    ShowETAAlternatives: boolean = false;
    ShowSupplierAlternatives: boolean = false;
    ShowFallbackSelection: boolean = false;
    ShowBrandCollateral: boolean = false;
    ShowBrandCollateralNewProduct: boolean = false;
    ShowRedRowETAPopup: boolean = false;
    ShowWeightPopup: boolean = false;
    ShowRedRowEditPopup: boolean = false;
    ShowPartnerSearchPopup: boolean = false;
    ShowCOOSearchPopup: boolean = false;
    ShowDeleteCartItemConfirmation: boolean = false;
    DeleteCartItemParams: any = null;
    IsMultiDelete: boolean = false;
    IsMultiDeleteEditContainer: boolean = false;

    // Change Partner Confirmation
    ShowChangePartnerConfirmation: boolean = false;
    PendingPartnerChange: any = null;

    // Progress Status right-click popup
    showProgressStatusCellPopup: boolean = false;
    progressStatusPopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    progressStatusPopupCartItem: any = null;
    progressStatusPopupRowIndex: number = -1;
    progressStatusPopupIsProductsGrid: boolean = false;

    // DeliveryPreference right-click popup
    showDeliveryPreferencePopup: boolean = false;
    deliveryPreferencePopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    deliveryPreferencePopupCartItem: any = null;
    deliveryPreferencePopupRowIndex: number = -1;
    deliveryPreferencePopupIsProductsGrid: boolean = false;

    // ConsolidationType right-click popup
    showConsolidationTypePopup: boolean = false;
    consolidationTypePopupPosition: { top: string; left: string } = { top: '0px', left: '0px' };
    consolidationTypePopupCartItem: any = null;
    consolidationTypePopupRowIndex: number = -1;
    consolidationTypePopupIsProductsGrid: boolean = false;

    SearchResultAlternatives: any[] = [];
    FallbackOffers: any[] = [];
    LeadTimeTypes: any[] = [];
    LeadTimeUnits: number[] = Array.from({ length: 31 }, (_, i) => i);
    SelectedLeadTimeType: any = null;
    SelectedLeadTimeUnits: number = 0;
    CurrentRedRowCartItem: any = null;
    CurrentRedRowIndex: number = -1;
    LeadTimeSmartInput: string = '';
    LeadTimeInlineSuggestion: string = '';
    LeadTimeSuggestions: any[] = [];

    // Position objects for popups
    SearchResultsPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    BrandPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    SupplierPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };
    COOPopupPosition: { top: string; left: string; width: string } = { top: '0px', left: '0px', width: '0px' };

    ClickedRow: any;
    ClickedRowIndex: number;
    namePlaceholder: string = 'Search product or part number...';
    selectedNamePopupTab: number = 1;

    // Partner search popup
    PartnerSearchRowIndex: number = -1;
    PartnerSearchTerm: string = '';
    PartnerSearchResults: any[] = [];
    LoadingPartners: boolean = false;

    // COO search popup
    COOSearchRowIndex: number = -1;
    COOSearchTerm: string = '';
    COOSearchResults: any[] = [];

    // Loading states
    LoadingSideOffers: boolean = false;

    // ✅ Side offers for supplier alternatives popup
    SideOffers: any[] = [];
    OriginalSideOffers: any[] = [];
    SupplierPopupSearchTerm: string = '';
    SupplierPopupSearchResults: any[] = [];
    LoadingSupplierPopupSearch: boolean = false;

    // ✅ Brand collateral list
    BrandCollateralList: any[] = [];

    // ✅ Name column search properties
    private nameSearchSubject = new Subject<{ rowIndex: number; searchTerm: string; quantity: any }>();

    // ✅ Admin-specific column definitions (exact copy from create-new-quotation)
    // Track header checkbox state
    productsHeaderCheckboxSelected: boolean = false;
    offerHeaderCheckboxSelected: boolean = false;

    toggleAllProductsSelected(api: any) {
      console.log('🔄 ORDER-CONFIRMATIONS: toggleAllProductsSelected called');
      this.productsHeaderCheckboxSelected = !this.productsHeaderCheckboxSelected;
      console.log('   New state:', this.productsHeaderCheckboxSelected);

      let count = 0;
      api.forEachNode((node: any) => {
        if (node.data?.CartItem) {
          node.data.CartItem.IsSelected = this.productsHeaderCheckboxSelected;
          count++;
        }
      });
      console.log('   Updated', count, 'items');

      api.refreshCells({ columns: ['index'], force: true });
      // Update header checkbox
      this.updateHeaderCheckbox(api);
    }

    updateHeaderCheckbox(api: any) {
      const headerCheckbox = document.querySelector('.products-header-checkbox') as HTMLInputElement;
      console.log('🔍 ORDER-CONFIRMATIONS: updateHeaderCheckbox - found checkbox:', !!headerCheckbox);
      if (headerCheckbox) {
        headerCheckbox.checked = this.productsHeaderCheckboxSelected;
      }
    }

    /**
     * Inject the header checkbox into the products grid index column header
     */
    injectProductsHeaderCheckbox() {
      console.log('🔧 ORDER-CONFIRMATIONS: injectProductsHeaderCheckbox called');
      const headerCell = document.querySelector('.products-index-header');
      console.log('   Found header cell:', !!headerCell);

      if (headerCell) {
        // Try ag-header-cell-text first, fallback to ag-header-cell-comp-wrapper for empty headers
        let headerContent = headerCell.querySelector('.ag-header-cell-text') as HTMLElement;
        if (!headerContent) {
          headerContent = headerCell.querySelector('.ag-header-cell-comp-wrapper') as HTMLElement;
        }
        if (!headerContent) {
          // Fallback: use the header cell itself
          headerContent = headerCell as HTMLElement;
        }
        console.log('   Found header content:', !!headerContent);
        console.log('   Existing checkbox:', !!headerContent?.querySelector('.products-header-checkbox'));

        if (headerContent && !headerContent.querySelector('.products-header-checkbox')) {
          // Create checkbox element
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'products-header-checkbox';
          checkbox.checked = this.productsHeaderCheckboxSelected;
          checkbox.style.cursor = 'pointer';
          checkbox.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleAllProductsSelected(this.productsGridApi);
          });
          // Clear and append
          headerContent.innerHTML = '';
          headerContent.appendChild(checkbox);
          console.log('   ✅ Checkbox injected successfully');
        }
      } else {
        console.log('   ⚠️ Header cell not found - grid may not be ready');
      }
    }

    // ✅ Toggle all items in EditContainer grid
    toggleAllOfferSelected(api: any) {
      console.log('🔄 ORDER-CONFIRMATIONS: toggleAllOfferSelected called');
      this.offerHeaderCheckboxSelected = !this.offerHeaderCheckboxSelected;
      console.log('   New state:', this.offerHeaderCheckboxSelected);

      let count = 0;
      api.forEachNode((node: any) => {
        if (node.data?.CartItem) {
          node.data.CartItem.IsSelected = this.offerHeaderCheckboxSelected;
          count++;
        }
      });
      console.log('   Updated', count, 'items');

      api.refreshCells({ columns: ['index'], force: true });
      this.updateOfferHeaderCheckbox();
    }

    updateOfferHeaderCheckbox() {
      const headerCheckbox = document.querySelector('.offer-header-checkbox') as HTMLInputElement;
      console.log('🔍 ORDER-CONFIRMATIONS: updateOfferHeaderCheckbox - found checkbox:', !!headerCheckbox);
      if (headerCheckbox) {
        headerCheckbox.checked = this.offerHeaderCheckboxSelected;
      }
    }

    /**
     * Inject the header checkbox into the offer/EditContainer grid index column header
     */
    injectOfferHeaderCheckbox() {
      console.log('🔧 ORDER-CONFIRMATIONS: injectOfferHeaderCheckbox called');
      const headerCell = document.querySelector('.offer-index-header');
      console.log('   Found header cell:', !!headerCell);

      if (headerCell) {
        // Try ag-header-cell-text first, fallback to ag-header-cell-comp-wrapper for empty headers
        let headerContent = headerCell.querySelector('.ag-header-cell-text') as HTMLElement;
        if (!headerContent) {
          headerContent = headerCell.querySelector('.ag-header-cell-comp-wrapper') as HTMLElement;
        }
        if (!headerContent) {
          // Fallback: use the header cell itself
          headerContent = headerCell as HTMLElement;
        }
        console.log('   Found header content:', !!headerContent);
        console.log('   Existing checkbox:', !!headerContent?.querySelector('.offer-header-checkbox'));

        if (headerContent && !headerContent.querySelector('.offer-header-checkbox')) {
          // Create checkbox element
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.className = 'offer-header-checkbox';
          checkbox.checked = this.offerHeaderCheckboxSelected;
          checkbox.style.cursor = 'pointer';
          checkbox.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleAllOfferSelected(this.offerGridApi);
          });
          // Clear and append
          headerContent.innerHTML = '';
          headerContent.appendChild(checkbox);
          console.log('   ✅ Checkbox injected successfully');
        }
      } else {
        console.log('   ⚠️ Header cell not found - grid may not be ready');
      }
    }

    offerColumnDefs: ColDef[] = [
      {
        headerName: '',
        field: 'index',
        editable: false,
        minWidth: 45,
        maxWidth: 55,
        width: 50,
        suppressMenu: true,
        headerClass: 'offer-index-header',
        cellRenderer: (params: any) => {
          const rowIndex = params.rowIndex + 1;
          const isSelected = params.data?.CartItem?.IsSelected === true;
          return `<div style="display: flex; align-items: center; width: 100%; height: 100%; padding: 0 4px 0 0; margin-left: -8px;">
                    <input type="checkbox" ${isSelected ? 'checked' : ''} class="cart-item-checkbox" data-row="${params.rowIndex}" />
                    <span style="cursor: pointer; margin-left: auto;">${rowIndex}</span>
                  </div>`;
        },
        onCellClicked: (params: any) => {
          // Only toggle IsSelected when clicking directly on the checkbox
          const target = params.event?.target as HTMLElement;
          console.log('📋 ORDER-CONFIRMATIONS: Index cell clicked, target:', target?.className);

          if (target?.classList?.contains('cart-item-checkbox')) {
            const cartItem = params.data?.CartItem;
            console.log('   Checkbox clicked, cartItem exists:', !!cartItem);
            if (cartItem) {
              cartItem.IsSelected = !cartItem.IsSelected;
              console.log('   New IsSelected state:', cartItem.IsSelected);
              params.api.refreshCells({ rowNodes: [params.node], columns: ['index'], force: true });

              // Update header checkbox state
              this.updateOfferHeaderCheckbox();
            }
          }
        }
      },
      {
        headerName: 'S',
        field: 'progressStatus',
        editable: false,
        minWidth: 35,
        maxWidth: 40,
        width: 38,
        suppressMenu: true,
        headerClass: 'offer-status-header',
        cellStyle: (params: any) => {
          const statusId = params.data?.CartItem?.ProgressStatus?.ID;
          let color = '#333';

          switch (statusId) {
            case -9999: color = '#c62828'; break;
            case -1000: color = '#e65100'; break;
            case 0: color = '#1565c0'; break;
            case -10: color = '#7b1fa2'; break;
            case 2: color = '#2e7d32'; break;
            case 3: color = '#00695c'; break;
          }

          return {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0',
            color: color,
            cursor: 'pointer'
          };
        },
        cellRenderer: (params: any) => {
          const alias = params.data?.CartItem?.ProgressStatus?.Alias ?? '';
          // Create element with right-click handler
          const container = document.createElement('div');
          container.style.cssText = 'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;';
          container.innerHTML = `<span style="font-size: 9px; font-weight: 600;">${alias}</span>`;

          // Add right-click (context menu) handler
          container.addEventListener('contextmenu', (event: MouseEvent) => {
            event.preventDefault();
            event.stopPropagation();

            const cartItem = params.data?.CartItem;
            if (!cartItem) return;

            // Set popup position near the click
            this.progressStatusPopupPosition = {
              top: (event.clientY) + 'px',
              left: (event.clientX) + 'px'
            };

            // Store clicked row info
            this.progressStatusPopupCartItem = cartItem;
            this.progressStatusPopupRowIndex = params.rowIndex;
            this.progressStatusPopupIsProductsGrid = false; // This is the offer grid

            // Show the popup
            this.showProgressStatusCellPopup = true;
            this.cdr.detectChanges(); // Trigger Angular change detection
          });

          return container;
        },
        onCellDoubleClicked: (params: any) => {
          this.handleProgressStatusDoubleClick(params, false);
        }
      },
      {
        headerName: 'Brand',
        field: 'brand',
        // ✅ Brand not editable - treat all rows as CartItemStatus.ID === 1
        editable: false,
        singleClickEdit: true,
        minWidth: 87,
        flex: 0.52,
        suppressMenu: true,
        // ✅ Always use BrandCellRenderer - treat all rows as CartItemStatus.ID === 1
        cellRenderer: (params: any) => this.BrandCellRenderer(params),
        cellClassRules: {}
      },
      {
        headerName: 'PartNumber',
        field: 'partNumber',
        editable: () => !this.isCanceled,
        minWidth: 70,
        flex: 1,
        suppressMenu: true,
        valueGetter: (params: any) => {
          const partNumber = params.data?.CartItem?.Product?.PartNumber;
          return partNumber ?? '';
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) {
            params.data.CartItem = {};
          }
          if (!params.data.CartItem.Product) {
            params.data.CartItem.Product = {};
          }
          params.data.CartItem.Product.PartNumber = params.newValue;
          return true;
        }
      },
      {
        headerName: 'Name',
        field: 'name',
        editable: () => !this.isCanceled,
        minWidth: 250,
        flex: 22,
        suppressMenu: true,
        cellRenderer: this.NameCellRenderer.bind(this),
        cellClassRules: {}
      },
      {
        headerName: 'Qty',
        field: 'quantity',
        editable: () => !this.isCanceled,
        singleClickEdit: false,
        type: 'numericColumn',
        valueParser: this.numberParser,
        minWidth: 40,
        maxWidth: 55,
        flex: 0.4,
        suppressMenu: true,
        cellRenderer: (params: any) => {
          const qty = params.value ?? '';
          const offer = params.data?.CartItem?.SelectedOffer;
          const hasMOQ = offer?.MOQ != null && offer.MOQ > 1;
          const container = document.createElement('div');
          container.style.cssText = 'width:100%;height:100%;display:flex;align-items:center;justify-content:center;' + (hasMOQ ? 'color:#d32f2f;font-weight:700;' : '');
          container.textContent = qty.toString();
          if (hasMOQ) container.title = 'MOQ: ' + offer.MOQ;

          return container;
        },
        tooltipValueGetter: function (params) {
          const selectedOffer = params.data?.CartItem?.SelectedOffer;
          if (selectedOffer?.ChangedQunatityFromMOQ) {
            return params.context?.componentParent?.MOQAdjustmentTooltip;
          }
          if (selectedOffer?.StockQuantity > 0 && selectedOffer?.IsManufacturerStockOffer !== true) {
            return `Stock: ${selectedOffer.StockQuantity}`;
          }
          return null;
        }
      },
      {
        headerName: 'List-Price',
        field: 'officialListPrice',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 60,
        maxWidth: 90,
        flex: 1.5,
        suppressMenu: true,
        cellRenderer: (p: any) => this.officialListPriceCellRenderer(p),
        cellClass: 'listprice-cell'
      },
      {
        headerName: '%Discount',
        field: 'officialDiscount',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 55,
        maxWidth: 55,
        flex: 0.4,
        suppressMenu: true,
        cellStyle: { textAlign: 'center' },
        cellRenderer: (p: any) => this.officialDiscountCellRenderer(p)
      },
      {
        headerName: 'Final-Price',
        field: 'price',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 60,
        flex: 2,
        suppressMenu: true,
        cellRenderer: this.priceCellRenderer.bind(this),
        cellClass: 'yourprice-cell'
      },
      {
        headerName: 'SC',
        field: 'sellCurrency',
        editable: false,
        minWidth: 50,
        maxWidth: 50,
        flex: 0.4,
        suppressMenu: true,
        cellStyle: { cursor: 'pointer', textAlign: 'center' },
        valueGetter: (params: any) => {
          const cartItem = params.data?.CartItem;
          if (!cartItem) return '';
          // Priority: CartItemOrderInfo.OrderCurrency (cart-level, authoritative), fallback to SelectedOffer.Currency (item-level, can be stale)
          return cartItem.CartItemOrderInfo?.OrderCurrency?.Symbol
            || cartItem.SelectedOffer?.Currency?.Symbol
            || '';
        },
        onCellClicked: (params: any) => {
          // Open the sell currency change popup - preselect from clicked row's SelectedOffer.Currency
          const rowCurrency = params.data?.CartItem?.SelectedOffer?.Currency;
          this.selectedSellCurrency = rowCurrency || this.CurrentOrder?.Cart?.Currency || null;
          // Store OfferDBID from row data (Products tab) or from CurrentOrder (Edit container)
          this.selectedOfferDBIDForCurrency = params.data?.OfferDBID || this.CurrentOrder?.DBID || 0;
          // Store CartItem from row data so backend can resolve OrderConfirmation when CurrentOrder is null
          this.selectedCartItemForCurrency = params.data?.CartItem || null;
          this.ShowChangeSellCurrencyPopup = true;
        }
      },
      {
        headerName: 'Delivery',
        field: 'eta',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 50,
        maxWidth: 120,
        flex: 1.2,
        suppressMenu: true,
        cellRenderer: this.ETACellRenderer.bind(this)
      },
      {
        headerName: 'Supplier',
        field: 'supplier',
        editable: () => !this.isCanceled,
        singleClickEdit: false,
        minWidth: 100,
        flex: 2.2,
        suppressMenu: true,
        cellRenderer: this.SupplierCellRenderer.bind(this),
        valueGetter: (params: any) => {
          const cartItem = params.data?.CartItem;
          const partnerName = cartItem?.SelectedOffer?.Partner?.Name;
          const configName = cartItem?.SelectedOffer?.Configuration?.Name;
          if (partnerName && partnerName.trim() !== '') {
            return partnerName;
          }
          return configName ?? '';
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) {
            params.data.CartItem = {};
          }
          if (!params.data.CartItem.SelectedOffer) {
            params.data.CartItem.SelectedOffer = {};
          }
          if (!params.data.CartItem.SelectedOffer.Partner) {
            params.data.CartItem.SelectedOffer.Partner = {};
          }
          params.data.CartItem.SelectedOffer.Partner.Name = params.newValue;
          return true;
        }
      },
      {
        headerName: 'Purchase',
        field: 'purchase',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 60,
        flex: 1.6,
        suppressMenu: true,
        valueGetter: (params: any) => {
          const listPrice = params.data?.CartItem?.SelectedOffer?.ListPrice;
          return (listPrice != null && listPrice !== '') ? listPrice : '';
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) {
            params.data.CartItem = {};
          }
          if (!params.data.CartItem.SelectedOffer) {
            params.data.CartItem.SelectedOffer = {};
          }
          const rawValue = (params.newValue ?? '').toString().trim();
          params.data.CartItem.SelectedOffer.ListPrice = rawValue === '' ? null : params.newValue;
          return true;
        },
        cellStyle: (params: any) => {
          const priceStatusID = params.data?.CartItem?.CartItemPriceStatus?.ID;
          if (priceStatusID === 1) {
            return { color: '#32aa3a' };
          } else if (priceStatusID === -1) {
            return { color: '#d32f2f', fontWeight: 'bold' };
          }
          return null;
        }
      },
      {
        headerName: 'PC',
        field: 'purchaseCurrency',
        editable: false,
        minWidth: 65,
        maxWidth: 65,
        flex: 0.4,
        suppressMenu: true,
        cellStyle: { cursor: 'pointer', textAlign: 'center' },
        valueGetter: (params: any) => {
          const selectedOffer = params.data?.CartItem?.SelectedOffer;
          if (!selectedOffer) return '';
          if (!selectedOffer.PurchaseCurrency) {
            const listPriceOfferPurchaseCurrency = params.data?.CartItem?.Product?.ListPriceOffers?.[0]?.PurchaseCurrency;
            if (listPriceOfferPurchaseCurrency) {
              selectedOffer.PurchaseCurrency = JSON.parse(JSON.stringify(listPriceOfferPurchaseCurrency));
            } else if (selectedOffer.Currency) {
              selectedOffer.PurchaseCurrency = JSON.parse(JSON.stringify(selectedOffer.Currency));
            }
          }
          return selectedOffer.PurchaseCurrency?.Symbol || '';
        },
        onCellClicked: (params: any) => {
          const rowIndex = params.rowIndex;
          const cellElement = params.event?.target?.closest('.ag-cell') as HTMLElement | null;
          if (!cellElement) return;
          const gridContainer = document.querySelector('.ProductsAGGridContainer') as HTMLElement;
          if (!gridContainer) return;
          const cellRect = cellElement.getBoundingClientRect();
          const containerRect = gridContainer.getBoundingClientRect();
          const top = cellRect.bottom - containerRect.top;
          const left = cellRect.left - containerRect.left;
          const width = Math.max(cellRect.width, 120);
          this.purchaseCurrencyDropdownPosition = { top: `${top}px`, left: `${left}px`, width: `${width}px` };
          this.purchaseCurrencyRowIndex = rowIndex;
          this.showPurchaseCurrencyDropdown = true;
        }
      },
      {
        headerName: 'PD',
        field: 'purchaseDiscount',
        editable: () => !this.isCanceled,
        singleClickEdit: true,
        minWidth: 55,
        maxWidth: 55,
        flex: 0.4,
        suppressMenu: true,
        valueGetter: (params: any) => {
          const pdValue = params.data?.CartItem?.Price?.PurchaseDiscount?.Value;
          return pdValue != null ? pdValue : null;
        },
        valueSetter: (params: any) => {
          if (!params.data.CartItem) params.data.CartItem = {};
          if (!params.data.CartItem.Price) params.data.CartItem.Price = {};
          if (!params.data.CartItem.Price.PurchaseDiscount) params.data.CartItem.Price.PurchaseDiscount = {};
          params.data.CartItem.Price.PurchaseDiscount.Value = params.newValue;
          return true;
        },
        valueFormatter: (params: any) => {
          if (params.value == null) return '';
          return `${Number(params.value).toFixed(2)}%`;
        },
        cellStyle: (params: any) => {
          const base: any = { textAlign: 'center' };
          if (params.value != null && params.value < 0) {
            base.color = '#d32f2f';
            base.fontWeight = 'bold';
          }
          return base;
        }
      },
      {
        headerName: 'Margin',
        field: 'margin',
        width: 65,
        minWidth: 55,
        maxWidth: 80,
        editable: false,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const margin = params.value;
          const parsed = parseFloat(margin);
          const color = isNaN(parsed) ? '#666' : (parsed >= 0 ? '#2e7d32' : '#d32f2f');
          return { fontSize: '10px', fontWeight: '600', color: color, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' };
        },
        valueGetter: (params: any) => {
          // Use backend-calculated ProfitMargin from CartItemPriceStatus if available
          const backendMargin = params.data?.CartItem?.CartItemPriceStatus?.ProfitMargin;
          if (backendMargin != null) {
            return `${backendMargin}%`;
          }
          // Fallback: calculate locally, normalizing both prices to base currency via ExchangeRate
          // (mirrors backend DetermineCartItemPriceStatus logic)
          const sellPrice = parseFloat(params.data?.CartItem?.SelectedOffer?.SellingPrice || params.data?.CartItem?.Price?.UIUnitPrice) || 0;
          const purchasePrice = parseFloat(params.data?.CartItem?.SelectedOffer?.ListPrice) || 0;
          if (sellPrice > 0 && purchasePrice > 0) {
            const sellCurrency = params.data?.CartItem?.Price?.Currency ?? params.data?.CartItem?.SelectedOffer?.Currency;
            const purchaseCurrency = params.data?.CartItem?.SelectedOffer?.PurchaseCurrency ?? params.data?.CartItem?.SelectedOffer?.Currency;
            const sellRate = (sellCurrency?.ExchangeRate > 0) ? sellCurrency.ExchangeRate : 1;
            const purchaseRate = (purchaseCurrency?.ExchangeRate > 0) ? purchaseCurrency.ExchangeRate : 1;
            const sellInBase = sellPrice * sellRate;
            const purchaseInBase = purchasePrice * purchaseRate;
            const margin = ((sellInBase - purchaseInBase) / sellInBase) * 100;
            const formatted = margin % 1 === 0 ? margin.toFixed(0) : parseFloat(margin.toFixed(2)).toString();
            return `${formatted}%`;
          }
          return '';
        }
      },
      {
        headerName: '',
        field: 'save',
        minWidth: 20,
        maxWidth: 25,
        width: 22,
        suppressMenu: true,
        sortable: false,
        editable: false,
        suppressSizeToFit: true,
        cellStyle: { padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellRenderer: (params: any) => {
          const cartItem = params.data?.CartItem;
          if (!cartItem) {
            return '';
          }
          const disabled = this.isCanceled;
          // ✅ Green icon when SelectedOffer.ID is 0 or missing (new/unsaved offer), blue when existing
          const hasOfferId = cartItem?.SelectedOffer?.ID != null && cartItem.SelectedOffer.ID > 0;
          const color = disabled ? '#bdbdbd' : (hasOfferId ? '#2196F3' : '#4CAF50');
          const cursor = disabled ? 'not-allowed' : 'pointer';
          const title = disabled ? 'Disabled - Order Canceled' : (hasOfferId ? 'Double-click to save' : 'Double-click to save new offer');
          return `<i class="material-icons" style="font-size: 12px; color: ${color}; cursor: ${cursor};" title="${title}">save</i>`;
        },
        onCellDoubleClicked: (params: any) => {
          // ✅ Disable save on canceled orders
          if (this.isCanceled) return;

          const cartItem = params.data?.CartItem;
          const hasOfferId = cartItem?.SelectedOffer?.ID != null && cartItem.SelectedOffer.ID > 0;

          if (!hasOfferId && cartItem) {
            // ✅ GREEN DISK: No offer ID - first create the offer via SaveAdminQuotationProduct, then save OC cart item
            this.SaveNewOfferThenUpdateCartItem(params);
          } else {
            // ✅ BLUE DISK: Existing offer - save directly
            this.AddUpdateOrderConfirmationCartItem(params);
          }
        }
      }
    ];

    offerDefaultColDef = {
      resizable: true,
      flex: 1,
      minWidth: 100,
      cellClass: (params: any) => {
        return params.colDef.field === 'name' ? 'cell-white' : 'cell-gray';
      }
    };

    offerGridOptions = {
      rowHeight: 30,
      headerHeight: 30,
      enableRangeSelection: true,
      suppressClipboardApi: true,
      enableFillHandle: true,
      enableClipboard: true,
      suppressClipboardPaste: false,
      suppressLastEmptyLineOnPaste: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      stopEditingWhenCellsLoseFocus: true,
      singleClickEdit: false,
      undoRedoCellEditing: true,
      suppressMovableColumns: true,
      tooltipShowDelay: 0,
      tooltipHideDelay: 10000,
      enableBrowserTooltips: true,
      context: {
        componentParent: this
      },
      undoRedoCellEditingLimit: 20,
      suppressContextMenu: true, // Suppress AG Grid's default context menu to use custom popups
      domLayout: 'autoHeight',
      rowClassRules: {
        GridValid: (p) => {
          const isStock = p.data?.CartItem?.SelectedOffer?.IsStockOffer === true;
          const hasQty = p.data?.CartItem?.SelectedOffer?.StockQuantity > 0;
          const isNotMfgStock = p.data?.CartItem?.SelectedOffer?.IsManufacturerStockOffer !== true;
          return isStock && hasQty && isNotMfgStock;
        },
        GridAdminPriceEdit: p => p.data?.CartItem?.AdminPriceEdit === true
      },
      onGridReady: (params: any) => {
        this.offerGridApi = params.api;
        params.api.sizeColumnsToFit();
        // ✅ Inject header checkbox after grid is ready
        setTimeout(() => this.injectOfferHeaderCheckbox(), 100);
      },
      onCellContextMenu: (event: any) => {
        if (event.column?.getColId() === 'quantity') {
          event.event?.preventDefault();
          event.event?.stopPropagation();

          const cartItem = event.data?.CartItem;
          if (!cartItem || !cartItem.ID) return;

          const currentQty = cartItem?.Quantity || event.value || 0;
          if (currentQty <= 1) return;

          this.splitProductPopupPosition = {
            top: (event.event.clientY) + 'px',
            left: (event.event.clientX) + 'px'
          };

          this.splitProductCartItem = cartItem;
          this.splitProductRowIndex = event.rowIndex;
          this.splitProductOriginalQty = currentQty;
          this.splitProductQty1 = currentQty;
          this.splitProductQty2 = 0;
          this.splitProductIsProductsGrid = false;

          this.showSplitProductPopup = true;
          this.cdr.detectChanges();
        }
      },
      onCellEditingStarted: (event: any) => {
        const rowIndex = event.rowIndex;
        const colId = event.column?.getColId();
        this.onCellEditingStarted(rowIndex, false, colId);
      },
      onCellValueChanged: (event: any) => this.onOfferCellValueChanged(event),
      // ✅ Simple tab navigation - treat all rows the same (as CartItemStatus.ID === 1)
      tabToNextCell: (params: any) => {
        const { previousCellPosition } = params;
        if (!previousCellPosition) {
          return previousCellPosition;
        }

        // If multiple rows are selected, suppress TAB navigation (stay on same row)
        const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
        if (selectedItems.length > 1) {
          return previousCellPosition;
        }

        const rowIndex = previousCellPosition.rowIndex;
        const totalRows = params.api.getDisplayedRowCount();
        if (rowIndex >= totalRows - 1) {
          return previousCellPosition;
        }
        const nextRowNode = params.api.getDisplayedRowAtIndex(rowIndex + 1);
        if (!nextRowNode || !nextRowNode.data || !nextRowNode.data.CartItem) {
          return previousCellPosition;
        }
        return {
          rowIndex: rowIndex + 1,
          column: previousCellPosition.column,
          rowPinned: previousCellPosition.rowPinned
        };
      }
    };

  InitializeFilter(){

    this.Filter = {};
    this.Filter.SearchTerm = "";
    this.Filter.MainSearchTerm = "";

    // Default to last 1 year for performance optimization
    this.Filter.FromDate = moment().subtract(1, 'year').format('YYYY-MM-DD');
    this.Filter.ToDate = moment().format('YYYY-MM-DD');
    this.FromDate = new FormControl(moment().subtract(1, 'year'));
    this.ToDate = new FormControl(moment());

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;

    this.Filter.Partner = {};
    this.Filter.Partner = null;

    this.Filter.UserUploader = {};
    this.Filter.UserUploader = null;

    this.Filter.UserManager = {};
    this.Filter.UserManager = null;

    this.Filter.Period = {};
    this.Filter.Period = null;

    this.Filter.Country = {};
    this.Filter.Country = null;

    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.Company = {};
    this.Filter.Company = null;

    this.Filter.IndividualStatus = {};
    this.Filter.IndividualStatus = null;

    this.Filter.Status = {};
    this.Filter.Status = null;

    this.Filter.TranzactionType = {};
    this.Filter.TranzactionType = null;

    this.Filter.Brand = {};
    this.Filter.Brand = null;

    this.Filter.Supplier = {};
    this.Filter.Supplier = null;

    this.Filter.SortingOrder = {};
    this.Filter.SortingOrder = null;

    this.Filter.DeliveryPreference = null;
    this.Filter.ConsolidationType = null;

    this.Filter.GroupingSettings = this.selectedGrouping;

    // Initialize brand filter
    this.InitializeBrandFilter();
    // Initialize supplier filter
    this.InitializeSupplierFilter();
  }

  InitializeBrandFilter(){
    this.BrandFilter = {};
    this.BrandFilter.SearchTerm = "";
    this.BrandFilter.Pager = {};
    this.BrandFilter.Pager.PageIndex = 1;
    this.BrandFilter.Pager.PageSize = 10;
    this.BrandFilter.Pager.TotalCount = 0;
  }

  GetBrandsFiltered(searchTerm: string, page = 1){
    this.BrandFilter.Pager.PageIndex = page;
    this.BrandFilter.SearchTerm = searchTerm;
    this.loadingBrands = true;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.BrandFilter
    };

    this.managementService.GetBrandsFiltered(request).subscribe(response => {
      this.loadingBrands = false;
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Brands = response["Brands"];

        if(this.Brands.length == 1){
          this.selectBrandFilter(this.Brands[0]);
          this.Brands = [];
          this.BrandFilter.SearchTerm = "";
          this.brandSearchTerm = "";
        }
      }
    });
  }

  selectBrandFilter(brand: any){
    this.Filter.Brand = brand;
    this.brandSearchTerm = brand?.Name || '';
    this.showBrandDropdown = false;
    this.showBrandPopup = false;
    this.Brands = [];

    // Add to active filters
    this.AddActiveFilter(brand.Name, 'Brand');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearBrandFilter(){
    this.Filter.Brand = null;
    this.brandSearchTerm = '';
    this.Brands = [];
    this.showBrandDropdown = false;
    this.showBrandPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Brand');

    // Reload current tab's grid without brand filter
    this.parent.loading = true;
    this.applyFilter(1);
  }

  openBrandPopup(){
    this.showBrandPopup = true;
    this.brandSearchTerm = '';
    this.Brands = [];
  }

  onBrandDropdownFocus(){
    this.showBrandDropdown = true;
    if(this.Brands == null || this.Brands.length == 0){
      this.GetBrandsFiltered("", 1);
    }
  }

  onBrandSearchInput(value: string){
    // Clear current brand selection when user types something different
    if (this.Filter.Brand && value !== this.Filter.Brand.Name) {
      this.Filter.Brand = null;
      this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Brand');
    }
    // Open dropdown and trigger search
    this.showBrandDropdown = true;
    this.brandSearchTermUpdate.next(value);
  }

  InitializeSupplierFilter(){
    this.SupplierFilter = {};
    this.SupplierFilter.SearchTerm = "";
    this.SupplierFilter.Pager = {};
    this.SupplierFilter.Pager.PageIndex = 1;
    this.SupplierFilter.Pager.PageSize = 10;
    this.SupplierFilter.Pager.TotalCount = 0;
  }

  GetSuppliersFiltered(searchTerm: string, page = 1){
    this.SupplierFilter.Pager.PageIndex = page;
    this.SupplierFilter.SearchTerm = searchTerm;
    this.loadingSuppliers = true;

    var request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: page,
      PageSize: 10,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.service.SearchPartnersSimplifiedFiltered(request).subscribe((response: any) => {
      this.loadingSuppliers = false;
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Suppliers = response["Partners"];

        // Auto-select if only 1 result
        if(this.Suppliers.length == 1){
          this.selectSupplierFilter(this.Suppliers[0]);
        }
      }
    });
  }

  selectSupplierFilter(supplier: any){
    this.Filter.Supplier = supplier;
    this.supplierSearchTerm = supplier?.Name || '';
    this.showSupplierPopup = false;
    this.showSupplierDropdown = false;
    this.Suppliers = [];

    // Add to active filters
    this.AddActiveFilter(supplier.Name, 'Supplier');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearSupplierFilter(){
    this.Filter.Supplier = null;
    this.supplierSearchTerm = '';
    this.Suppliers = [];
    this.showSupplierPopup = false;
    this.showSupplierDropdown = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Supplier');

    // Reload current tab's grid without supplier filter
    this.parent.loading = true;
    this.applyFilter(1);
  }

  openSupplierPopup(){
    this.showSupplierPopup = true;
    this.supplierSearchTerm = '';
    this.Suppliers = [];
  }

  // ✅ Partner filter popup methods (header overlay)
  openPartnerPopup(){
    this.showPartnerPopup = true;
    this.partnerSearchTerm = '';
    this.Partners = [];
  }

  GetPartnersFilteredPopup(searchTerm: string){
    const request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: 1,
      PageSize: 50,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.loadingPartners = true;
    this.service.SearchPartnersSimplifiedFiltered(request).subscribe((response: any) => {
      this.loadingPartners = false;
      if(response["Status"] == 1){
        this.Partners = response["Partners"];
        // Auto-select if only 1 result
        if(this.Partners.length == 1){
          this.selectPartnerFilter(this.Partners[0]);
        }
      }
    });
  }

  selectPartnerFilter(partner: any){
    this.Filter.Partner = partner;
    this.partnerSearchTerm = partner?.Name || '';
    this.searchTerm = partner?.Name || '';
    this.partner = partner;
    this.showPartnerPopup = false;
    this.Partners = [];

    // Add to active filters
    this.AddActiveFilter(partner.Name, 'Partner');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearPartnerFilter(){
    this.Filter.Partner = null;
    this.partnerSearchTerm = '';
    this.searchTerm = '';
    this.partner = null;
    this.Partners = [];
    this.showPartnerPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Partner');

    // Reload current tab's grid without partner filter
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ ProgressStatus filter popup methods (header overlay)
  openProgressStatusFilterPopup(): void {
    this.showProgressStatusFilterPopup = true;
  }

  selectProgressStatusGridFilter(status: any): void {
    this.Filter.CartItemProgressStatus = status;
    this.showProgressStatusFilterPopup = false;

    // Add to active filters
    this.AddActiveFilter(status.Name, 'ProgressStatus');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearProgressStatusFilter(): void {
    this.Filter.CartItemProgressStatus = null;
    this.showProgressStatusFilterPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'ProgressStatus');

    // Reload current tab's grid without ProgressStatus filter
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ Double-click the progress-status filter button -> quick-select the "Not Ordered" (New, ID 0) status
  selectNotOrderedProgressStatusFilter(): void {
    const notOrdered = this.MasterData?.CartItemProgressStatuses?.find((s: any) => s.ID === 0);
    if (notOrdered) {
      this.selectProgressStatusGridFilter(notOrdered);
    }
  }

  // ✅ DeliveryPreference filter methods
  showDeliveryPreferenceFilterPopup: boolean = false;

  selectDeliveryPreferenceGridFilter(dp: any): void {
    this.Filter.DeliveryPreference = dp;
    this.showDeliveryPreferenceFilterPopup = false;
    this.AddActiveFilter(dp.Name, 'DeliveryPreference');
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearDeliveryPreferenceFilter(): void {
    this.Filter.DeliveryPreference = null;
    this.showDeliveryPreferenceFilterPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'DeliveryPreference');
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ ConsolidationType filter methods
  showConsolidationTypeFilterPopup: boolean = false;

  selectConsolidationTypeGridFilter(ct: any): void {
    this.Filter.ConsolidationType = ct;
    this.showConsolidationTypeFilterPopup = false;
    this.AddActiveFilter(ct.Name, 'ConsolidationType');
    this.parent.loading = true;
    this.applyFilter(1);
  }

  clearConsolidationTypeFilter(): void {
    this.Filter.ConsolidationType = null;
    this.showConsolidationTypeFilterPopup = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'ConsolidationType');
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ Products grouping dropdown
  toggleGroupingDropdown(btn: HTMLElement): void {
    if (this.showGroupingDropdown) {
      this.showGroupingDropdown = false;
      return;
    }
    const rect = btn.getBoundingClientRect();
    this.groupingDropdownPosition = {
      top: (rect.bottom + 4) + 'px',
      left: rect.left + 'px'
    };
    this.showGroupingDropdown = true;
  }

  selectGrouping(grouping: any): void {
    this.selectedGrouping = grouping;
    this.Filter.GroupingSettings = grouping;
    this.showGroupingDropdown = false;
    if (this.activeTab === 'onhold') {
      this.GetOnHoldProductsFiltered(1);
    } else {
      this.GetProductsFiltered(1);
    }
  }

  // ✅ Double-click the grouping button -> quick-select "Group by Brand" (ID 2)
  selectBrandGrouping(): void {
    const brandGrouping = this.MasterData?.ProductsGroupingSettings?.find((g: any) => g.ID === 2);
    if (brandGrouping) {
      this.selectGrouping(brandGrouping);
    }
  }

  // ✅ Dispatch filter dropdown
  toggleDispatchFilterDropdown(btn: HTMLElement): void {
    if (this.showDispatchFilterDropdown) {
      this.showDispatchFilterDropdown = false;
      return;
    }
    const rect = btn.getBoundingClientRect();
    this.dispatchFilterDropdownPosition = {
      top: (rect.bottom + 4) + 'px',
      left: rect.left + 'px'
    };
    this.showDispatchFilterDropdown = true;
  }

  selectDispatchFilter(mode: string): void {
    this.dispatchFilterMode = mode;
    this.showDispatchFilterDropdown = false;

    if (mode === 'dispatch') {
      // Set ConsolidationType filter to Dispatch Immediately (ID=1)
      const dispatchType = this.MasterData?.OrderConsolidationTypes?.find((t: any) => t.ID === 1);
      if (dispatchType) {
        this.Filter.ConsolidationType = dispatchType;
      }
    } else {
      this.Filter.ConsolidationType = null;
    }

    this.GetProductsFiltered(1);
  }

  // ✅ Period dropdown (compact filter bar)
  togglePeriodDropdown(btn: HTMLElement): void {
    if (this.showPeriodDropdown) {
      this.showPeriodDropdown = false;
      return;
    }
    const rect = btn.getBoundingClientRect();
    this.periodDropdownPosition = {
      top: (rect.bottom + 4) + 'px',
      left: rect.left + 'px'
    };
    this.showPeriodDropdown = true;
  }

  selectPeriod(p: any): void {
    this.Filter.Period = p;
    this.showPeriodDropdown = false;
    this.AddActiveFilter(p.Name, 'Period');
    this.applyFilter();
  }

  // ✅ Reset every filter on this page back to its default and reload the grid
  resetAllFilters(): void {
    // All Filter.* properties used on this page
    this.Filter.Administration = null;
    this.Filter.AccountingSeries = null;
    this.Filter.IndividualStatus = null;
    this.Filter.DocumentNumber = null;
    this.Filter.Product = null;
    this.Filter.Partner = null;
    this.Filter.Period = null;
    this.Filter.Country = null;
    this.Filter.Currency = null;
    this.Filter.InvoiceDocType = null;
    this.Filter.UserManager = null;
    this.Filter.UserUploader = null;
    this.Filter.Brand = null;
    this.Filter.Supplier = null;
    this.Filter.CartItemProgressStatus = null;
    this.Filter.DeliveryPreference = null;
    this.Filter.ConsolidationType = null;
    this.Filter.TranzactionType = null;
    this.Filter.GroupingSettings = null;
    this.Filter.SearchTerm = '';
    this.Filter.MainSearchTerm = '';

    // Reset date range to last-1-year default (mirrors ngOnInit)
    this.Filter.FromDate = moment().subtract(1, 'year').format('YYYY-MM-DD');
    this.Filter.ToDate = moment().format('YYYY-MM-DD');
    this.FromDate = new FormControl(moment().subtract(1, 'year'));
    this.ToDate = new FormControl(moment());

    // Clear in-memory search-term vars
    this.brandSearchTerm = '';
    this.supplierSearchTerm = '';
    this.partnerSearchTerm = '';
    this.searchTerm = '';
    this.partner = null;
    this.Brands = [];
    this.Suppliers = [];
    this.Partners = [];

    // Reset grouping / dispatch UI state
    this.selectedGrouping = { ID: -1 };
    this.dispatchFilterMode = 'all';

    // Clear active filter chips
    this.activeFilters = [];

    // Reload the grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ Helper methods for ProgressStatus colors (used in filter popup)
  getProgressStatusBgColor(statusId: number): string {
    // eCartItemProgressStatus enum values:
    // Canceled = -9999, Hold = -1000, New = 0, OrderedToSupplier = -10, ReadyInWarehouse = 2, Invoiced = 3
    switch (statusId) {
      case -9999: // Canceled - light red
        return 'rgba(244, 67, 54, 0.15)';
      case -1000: // Hold - light orange
        return 'rgba(255, 152, 0, 0.15)';
      case 0: // New - light blue
        return 'rgba(33, 150, 243, 0.15)';
      case -10: // OrderedToSupplier - light purple
        return 'rgba(156, 39, 176, 0.15)';
      case 2: // ReadyInWarehouse - light green
        return 'rgba(76, 175, 80, 0.15)';
      case 3: // Invoiced - light teal
        return 'rgba(0, 150, 136, 0.15)';
      default:
        return 'transparent';
    }
  }

  getProgressStatusTextColor(statusId: number): string {
    switch (statusId) {
      case -9999: // Canceled
        return '#c62828';
      case -1000: // Hold
        return '#e65100';
      case 0: // New
        return '#1565c0';
      case -10: // OrderedToSupplier
        return '#7b1fa2';
      case 2: // ReadyInWarehouse
        return '#2e7d32';
      case 3: // Invoiced
        return '#00796b';
      default:
        return '#333';
    }
  }

  ClearPeriod(){
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type != "Period");
    this.Filter.Period = null;
  }

  DisablePeriod(){
    this.Filter.Period = null;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type != "Period");
  }

  GetOfferMasterData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.managementService.GetOrderConfirmationMasterData(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.MasterData = response;

        // Always default to "Not Ordered" progress status filter (ID: 0)
        if (!this.Filter.CartItemProgressStatus) {
          const notOrdered = this.MasterData?.CartItemProgressStatuses?.find((s: any) => s.ID === 0);
          if (notOrdered) {
            this.Filter.CartItemProgressStatus = notOrdered;
          }
        }

        // Always load products tab
        this.activeTab = 'products';
        this.GetProductsFiltered(1);
      }

      this.parent.loading = false;
     });
  }

  // ✅ Select discount type for current order
  selectDiscountType(type: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    if (!this.CurrentOrder.Cart.Total) this.CurrentOrder.Cart.Total = {};
    if (!this.CurrentOrder.Cart.Total.Discount) {
      this.CurrentOrder.Cart.Total.Discount = { Type: null, Value: null };
    }
    this.CurrentOrder.Cart.Total.Discount.Type = type;
    this.showDiscountTypeDropdown = false;
  }

  // ✅ Select payment term for current order
  selectPaymentTerm(term: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.PaymentTerm = term;
    this.showPaymentTermDropdown = false;
  }

  // ✅ Select weight type for current order
  selectWeightType(wt: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.WeightMeasurementType = wt;
    this.showWeightTypeDropdown = false;
  }

  // ✅ Handle weight input change - set ForcedUIWeight flag
  onWeightChange(value: any): void {
    if (!this.CurrentOrder) return;
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};

    // If empty/null/undefined/0, set weight to 0 and ForcedUIWeight to false
    if (value === null || value === undefined || value === '' || value === 0) {
      this.CurrentOrder.Cart.Weight = 0;
      this.CurrentOrder.Cart.ForcedUIWeight = false;
    } else {
      // User entered a non-zero value, set ForcedUIWeight to true
      this.CurrentOrder.Cart.ForcedUIWeight = true;
    }
  }

  // ✅ Validate decimal input - only allow numbers, comma and dot
  validateDecimalInput(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Allow: numbers (0-9), comma (,) and dot (.)
    if (/^[0-9,.]$/.test(charCode)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  // ✅ Validate discount input - only allow numbers and comma
  validateDiscountInput(event: KeyboardEvent): boolean {
    const charCode = event.key;
    // Allow: numbers (0-9) and comma (,)
    if (/^[0-9,]$/.test(charCode)) {
      return true;
    }
    event.preventDefault();
    return false;
  }

  // ✅ Apply order discount - calls backend to recalculate Total with discount
  ApplyOrderDiscount(): void {
    if (!this.CurrentOrder?.Cart?.Total?.Discount?.Type || !this.CurrentOrder?.Cart?.Total?.Discount?.Value) {
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      OrderConfirmation: JSON.parse(JSON.stringify(this.CurrentOrder))
    };

    this.parent.loading = true;

    this.service.ApplyOrderConfirmationDiscount(request).subscribe((response: any) => {
      if (response?.Status !== 1) {
        this.parent.openSnackBar(response?.Message || 'Error applying discount', 'OK', 'alert-info-snackbar');
      } else if (response?.Status === 1) {
        // Update CurrentOrder with the returned OrderConfirmation (which has updated Total)
        this.CurrentOrder = response.OrderConfirmation;
        // Update the corresponding order in the Orders list
        this.updateOrderInList(response.OrderConfirmation);
        this.parent.openSnackBar(response?.Message || 'Discount applied successfully', 'OK', 'light-info-snackbar');
      }
      this.parent.loading = false;
    });
  }

  // ✅ Clear order discount - nulls the discount and calls backend to recalculate Total
  ClearOrderDiscount(): void {
    // Create a copy with null Cart.Total.Discount to clear it
    const orderCopy = JSON.parse(JSON.stringify(this.CurrentOrder));
    if (orderCopy?.Cart?.Total) {
      orderCopy.Cart.Total.Discount = null;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      OrderConfirmation: orderCopy
    };

    this.parent.loading = true;

    this.service.ApplyOrderConfirmationDiscount(request).subscribe((response: any) => {
      if (response?.Status !== 1) {
        this.parent.openSnackBar(response?.Message || 'Error clearing discount', 'OK', 'alert-info-snackbar');
      } else if (response?.Status === 1) {
        // Update CurrentOrder with the returned OrderConfirmation (which has updated Total without discount)
        this.CurrentOrder = response.OrderConfirmation;
        // Reset local discount fields
        if (this.CurrentOrder?.Cart?.Total) {
          this.CurrentOrder.Cart.Total.Discount = { Type: null, Value: null };
        }
        // Update the corresponding order in the Orders list
        this.updateOrderInList(response.OrderConfirmation);
        this.parent.openSnackBar('Discount cleared successfully', 'OK', 'light-info-snackbar');
      }
      this.parent.loading = false;
    });
  }

  // ✅ Update an order in the Orders list after discount changes
  updateOrderInList(updatedOrder: any): void {
    if (!updatedOrder?.DBID || !this.Orders) return;
    const index = this.Orders.findIndex((o: any) => o.DBID === updatedOrder.DBID);
    if (index !== -1) {
      this.Orders[index] = updatedOrder;
    }
  }

  // ✅ Get Shipping Master Data (responsabilities, service types, companies)
  GetShippingMasterData() {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage()
    };

    this.managementService.GetShippingMasterData(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingResponsabilities = response["ShippingResponsabilities"] || [];
        this.ShippingServiceTypes = response["ShippingServiceTypes"] || [];
        this.ShippingCompanies = response["ShippingCompanies"] || [];
        this.APIShippingCompanies = response["APIShippingCompanies"] || [];
        this.ShippingDirections = response["Directions"] || [];
        this.ShippingWays = response["ShippingWays"] || [];
        this.ShippingWeightTypes = response["WeightTypes"] || [];
        this.ShippingDownloadTypes = response["DownloadTypes"] || [];

        // ✅ Match ShippingResponsability ID with full object from master data
        if (this.CurrentOrder?.Cart?.ShippingResponsability?.ID !== undefined) {
          const matchedResp = this.ShippingResponsabilities.find(r => r.ID === this.CurrentOrder.Cart.ShippingResponsability.ID);
          if (matchedResp) {
            this.CurrentOrder.Cart.ShippingResponsability = JSON.parse(JSON.stringify(matchedResp));
          }
        }

        // ✅ Match ShippingServiceType ID with full object from master data
        if (this.CurrentOrder?.Cart?.ShippingServiceType?.ID !== undefined) {
          const matchedType = this.ShippingServiceTypes.find(t => t.ID === this.CurrentOrder.Cart.ShippingServiceType.ID);
          if (matchedType) {
            this.CurrentOrder.Cart.ShippingServiceType = JSON.parse(JSON.stringify(matchedType));
          }
        }

        // ✅ Get country-specific shipping companies based on shipping address (for CurrentOrder context)
        this.GetCountryShippingOptions();
      }
    });
  }

  // ✅ Get Country-specific Shipping Options (shipping companies available for the destination country)
  GetCountryShippingOptions(): void {
    const country = this.CurrentOrder?.ShippingAddress?.Country || this.CurrentOrder?.Cart?.Partner?.BillingAddress?.Country;

    if (!country?.ID) {
      console.log('❌ No country available for shipping options');
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Country: country,
      PartnerID: this.CurrentOrder?.Cart?.Partner?.ID,
      DirectionID: 1 // export (sending to customer)
    };

    this.managementService.GetCountryShippingOptions(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingCompanies = response["ShippingCompanies"] || [];
        console.log('✅ Country Shipping Options loaded:', this.ShippingCompanies);

        // ✅ Match ShippingCompany ID with full object from country options
        if (this.CurrentOrder?.Cart?.ShippingCompany?.ID) {
          const matchedCompany = this.ShippingCompanies.find(c => c.ID === this.CurrentOrder.Cart.ShippingCompany.ID);
          if (matchedCompany) {
            this.CurrentOrder.Cart.ShippingCompany = JSON.parse(JSON.stringify(matchedCompany));
          }
        }
      }
    });
  }

  // ✅ Shipping section select methods
  selectShippingAddress(addr: any) {
    const previousCountryID = this.CurrentOrder?.ShippingAddress?.Country?.ID;
    this.CurrentOrder.ShippingAddress = JSON.parse(JSON.stringify(addr));
    this.showShippingAddressDropdown = false;

    // ✅ Refresh shipping companies if country changed
    if (addr?.Country?.ID && addr.Country.ID !== previousCountryID) {
      this.GetCountryShippingOptions();
    }
  }

  selectShippingCountry(c: any) {
    const previousCountryID = this.CurrentOrder?.ShippingAddress?.Country?.ID;
    this.CurrentOrder.ShippingAddress.Country = JSON.parse(JSON.stringify(c));
    this.showShippingCountryDropdown = false;

    // ✅ Refresh shipping companies if country changed
    if (c?.ID && c.ID !== previousCountryID) {
      this.GetCountryShippingOptions();
    }
  }

  selectShippingResponsability(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingResponsability = JSON.parse(JSON.stringify(item));
    this.showShippingResponsabilityDropdown = false;
  }

  selectShippingServiceType(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingServiceType = JSON.parse(JSON.stringify(item));
    this.showShippingServiceTypeDropdown = false;
  }

  selectShippingCompany(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingCompany = JSON.parse(JSON.stringify(item));
    this.showShippingCompanyDropdown = false;
  }

  selectShippingCostDischargeType(item: any) {
    if (!this.CurrentOrder.Cart) this.CurrentOrder.Cart = {};
    this.CurrentOrder.Cart.ShippingCostDischargeType = JSON.parse(JSON.stringify(item));
    this.showShippingCostDischargeTypeDropdown = false;
  }

  ResetMainSearch(){
    this.searchMainOrders.next(null);
    this.Filter.SearchTerm = "";
  }

  // ✅ ALWAYS enforce Not Ordered progress status on every backend call that uses this.Filter
  private enforceNotOrderedFilter(): void {
    if (!this.Filter.CartItemProgressStatus || this.Filter.CartItemProgressStatus.ID !== 0) {
      const notOrdered = this.MasterData?.CartItemProgressStatuses?.find((s: any) => s.ID === 0);
      this.Filter.CartItemProgressStatus = notOrdered || { ID: 0, Name: 'Not Ordered', Alias: 'NO' };
    }
  }

  // ✅ Helper method to apply filters based on active tab
  applyFilter(page = 1) {
    this.GetProductsFiltered(page);
  }

  GetOrdersFiltered(page = 1){
    this.enforceNotOrderedFilter();
    this.Filter.Pager.PageIndex = page;

    if(this.Filter.DisplayAllPagesTotals == true){
      this.Filter.ExchangeToTargetCurrency = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.loadingOrders = true;
    this.showFilter = false;

    this.managementService.GetOrderConfirmationsFiltered(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Orders = response["OrderConfirmations"];
        this.Totals = response["Totals"];
        // Pager with TotalCount is now returned from the main query
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        // Debug: Check if Total data is present
        if(this.Orders?.length > 0){
          console.log('📊 ORDER-CONFIRMATIONS: Sample order total structure:', this.Orders[0]?.Cart?.Total);
        }
      }

      this.LoadingMainSearchTerm = false;
      this.loadingOrders = false;
    });

    // No need for separate COUNT call - it's included in the main response now
  }

  GetOrdersFilteredCOUNT(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.managementService.GetOrderConfirmationsFilteredCOUNT(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Filter.Pager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }

    });
  }

  GetProductsFiltered(page = 1){
    // ✅ Clear undo history on data reload - snapshots only track in-session edits
    this.clearUndoHistory();
    this.Filter.Pager.PageIndex = page;

    this.enforceNotOrderedFilter();

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.loadingProducts = true;
    this.showFilter = false;

    this.managementService.GetOrderConfirmationsProductsFiltered(request).subscribe(response => {
      console.log('📥 ORDER-CONFIRMATIONS: GetProductsFiltered response Status:', response["Status"]);
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        // Format items for AG Grid - response.CartItems is now List<CartItem> directly
        const items = response["CartItems"] || [];
        console.log('   CartItems count:', items.length);
        this.ProductItems = items.map((cartItem: any, index: number) => {
          const leadTime = cartItem?.SelectedOffer?.LeadTime;
          const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

          return {
            index: index + 1,
            brand: cartItem?.Product?.Brand?.Name || cartItem?.UserSelectedBrand?.Name || '',
            partNumber: cartItem?.Product?.PartNumber || '',
            name: cartItem?.UIProductValue || cartItem?.Product?.Name || '',
            quantity: cartItem?.Quantity || 0,
            officialListPrice: cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice || '',
            officialDiscount: cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value || '',
            price: cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || '',
            total: (() => { const sp = cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice; const q = cartItem?.Quantity || 0; return sp > 0 && q > 0 ? parseFloat((sp * q).toFixed(4)).toString() : ''; })(),
            eta: etaDisplay,
            supplier: cartItem?.SelectedOffer?.Partner?.Name || '',
            purchase: cartItem?.SelectedOffer?.ListPrice || '',
            hscode: cartItem?.Product?.Stats?.HSCode || '',
            coo: cartItem?.Product?.Stats?.COO?.ShortName || '',
            weight: cartItem?.Product?.Stats?.Weight != null
              ? `${cartItem.Product.Stats.Weight} ${cartItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
              : '',
            CartItem: cartItem, // Keep reference to original CartItem
            // Extra offer context columns from CartItemOrderInfo
            OfferID: cartItem?.CartItemOrderInfo?.OrderID || '',
            OfferDBID: cartItem?.CartItemOrderInfo?.OrderDBID || 0,
            ReferenceNumber: cartItem?.CartItemOrderInfo?.ReferenceNumber || '',
            DebatorPO: cartItem?.CartItemOrderInfo?.DebatorPO || '',
            PartnerName: cartItem?.CartItemOrderInfo?.OrderPartner?.Name || '',
            OfferEventRegister: cartItem?.CartItemOrderInfo?.OrderEventRegister || null
          };
        });

        console.log('   ProductItems length:', this.ProductItems.length);

        this.ProductsPager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        // Resize grid columns and re-inject header checkbox
        if (this.productsGridApi) {
          console.log('   Resizing grid and injecting header checkbox');
          setTimeout(() => {
            this.productsGridApi.sizeColumnsToFit();
            this.injectProductsHeaderCheckbox();
          }, 100);
        } else {
          console.log('   ⚠️ productsGridApi not available');
        }

        // Reset skip flag (used by system-initiated refreshes like BulkCreatePurchaseOrders)
        this.skipNextUndoSnapshot = false;
      }

      this.LoadingMainSearchTerm = false;
      this.loadingProducts = false;
      this.parent.loading = false;
    });
  }

  GetOnHoldProductsFiltered(page = 1){
    // ✅ Clear undo history on data reload - snapshots only track in-session edits
    this.clearUndoHistory();
    this.enforceNotOrderedFilter();
    this.Filter.Pager.PageIndex = page;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Filter: this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
      this.Filter.FromDate = moment(this.FromDate.value._d).format('YYYY-MM-DD');
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
      this.Filter.ToDate = moment(this.ToDate.value._d).format('YYYY-MM-DD');
    }

    this.loadingProducts = true;
    this.showFilter = false;

    this.managementService.GetOrderConfirmationsOnHoldProductsFiltered(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        const items = response["CartItems"] || [];
        this.ProductItems = items.map((cartItem: any, index: number) => {
          const leadTime = cartItem?.SelectedOffer?.LeadTime;
          const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

          return {
            index: index + 1,
            brand: cartItem?.Product?.Brand?.Name || cartItem?.UserSelectedBrand?.Name || '',
            partNumber: cartItem?.Product?.PartNumber || '',
            name: cartItem?.UIProductValue || cartItem?.Product?.Name || '',
            quantity: cartItem?.Quantity || 0,
            officialListPrice: cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice || '',
            officialDiscount: cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value || '',
            price: cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || '',
            eta: etaDisplay,
            supplier: cartItem?.SelectedOffer?.Partner?.Name || '',
            purchase: cartItem?.SelectedOffer?.ListPrice || '',
            purchaseDiscount: cartItem?.Price?.PurchaseDiscount?.Value ?? null,
            CartItem: cartItem,
            OfferID: cartItem?.CartItemOrderInfo?.OrderID || '',
            OfferDBID: cartItem?.CartItemOrderInfo?.OrderDBID || 0,
            ReferenceNumber: cartItem?.CartItemOrderInfo?.ReferenceNumber || '',
            DebatorPO: cartItem?.CartItemOrderInfo?.DebatorPO || '',
            PartnerName: cartItem?.CartItemOrderInfo?.OrderPartner?.Name || '',
            OfferEventRegister: cartItem?.CartItemOrderInfo?.OrderEventRegister || null
          };
        });

        this.ProductsPager = response["Pager"];

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));

        if (this.productsGridApi) {
          setTimeout(() => {
            this.productsGridApi.sizeColumnsToFit();
            this.injectProductsHeaderCheckbox();
          }, 100);
        }
      }

      this.LoadingMainSearchTerm = false;
      this.loadingProducts = false;
      this.parent.loading = false;
    });
  }

  AddActiveFilter(filterName:string, filterType:string){
    var filter = {
      ID:this.parent.newGuid(),
      Name:filterName,
      Type:filterType
    };

    if(this.Filter.Administration != null && this.activeFilters.find(x => x.Type == filterType)){
      this.showFilter = false;
      this.applyFilter();
    }

    this.activeFilters = this.activeFilters.filter(x => x.Name != filterName && x.Type != filterType);
    this.activeFilters.push(filter);

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  RemoveActiveFilter(ID:string, filterType:string){
    this.activeFilters = this.activeFilters.filter(x => x.ID != ID);

    if(filterType == "Administration"){
      this.Filter.Administration = null;
    }
    else if(filterType == "Series"){
      this.Filter.AccountingSeries = null;
    }
    else if(filterType == "Status"){
      this.Filter.IndividualStatus = null;
    }
    else if(filterType == "DocumentNumber"){
      this.Filter.DocumentNumber = null;
    }
    else if(filterType == "Product"){
      this.Filter.Product = null;
      this.Filter.SearchTerm = null;
    }
    else if(filterType == "Partner"){
      this.Filter.Partner = null;
    }
    else if(filterType == "Period"){
      this.Filter.Period = null;
    }
    else if(filterType == "Country"){
      this.Filter.Country = null;
    }
    else if(filterType == "Currency"){
      this.Filter.Currency = null;
    }
    else if(filterType == "InvoiceDocType"){
      this.Filter.InvoiceDocType = null;
    }
    else if(filterType == "UserManager"){
      this.Filter.UserManager = null;
    }
    else if(filterType == "UserUploader"){
      this.Filter.UserUploader = null;
    }
    else if(filterType == "Brand"){
      this.Filter.Brand = null;
      this.brandSearchTerm = '';
    }
    else if(filterType == "Supplier"){
      this.Filter.Supplier = null;
      this.supplierSearchTerm = '';
    }
    else if(filterType == "ProgressStatus"){
      this.Filter.CartItemProgressStatus = null;
    }
    else if(filterType == "DeliveryPreference"){
      this.Filter.DeliveryPreference = null;
    }
    else if(filterType == "ConsolidationType"){
      this.Filter.ConsolidationType = null;
    }

    this.applyFilter();
  }

  // ✅ Custom Dropdown Methods for Filter Container
  closeAllFilterDropdowns() {
    this.showStatusDropdown = false;
    this.showCurrencyDropdown = false;
    this.showUserManagerDropdown = false;
    this.showBrandDropdown = false;
    this.showSupplierDropdown = false;
    this.showPartnerPopup = false;
    this.showTranzactionTypeDropdown = false;
    this.showProgressStatusFilterPopup = false;
    this.showCountryDropdown = false;
    this.showProgressStatusDropdown = false;
  }

  onStatusDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showStatusDropdown = true;
  }

  selectStatusFilter(status: any) {
    this.Filter.IndividualStatus = status;
    this.AddActiveFilter(status.Name, 'Status');
    this.showStatusDropdown = false;

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  onCurrencyDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showCurrencyDropdown = true;
  }

  selectCurrencyFilter(currency: any) {
    this.Filter.Currency = currency;
    this.AddActiveFilter(currency.Name, 'Currency');
    this.showCurrencyDropdown = false;

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  onUserManagerDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showUserManagerDropdown = true;
  }

  selectUserManagerFilter(userManager: any) {
    this.Filter.UserManager = userManager;
    this.AddActiveFilter(userManager.Email, 'UserManager');
    this.showUserManagerDropdown = false;

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  onSupplierDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showSupplierDropdown = true;
    if (this.Suppliers == null || this.Suppliers.length == 0) {
      this.GetSuppliersFiltered('', 1);
    }
  }

  onSupplierSearchInput(value: string) {
    // Clear current supplier selection when user types something different
    if (this.Filter.Supplier && value !== this.Filter.Supplier.Name) {
      this.Filter.Supplier = null;
      this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Supplier');
    }
    // Open dropdown and trigger search
    this.showSupplierDropdown = true;
    this.searchSupplierUpdate.next(value);
  }

  onTranzactionTypeDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showTranzactionTypeDropdown = true;
  }

  selectTranzactionTypeFilter(tranzactionType: any) {
    this.Filter.TranzactionType = tranzactionType;
    this.AddActiveFilter(tranzactionType.Name, 'TranzactionType');
    this.showTranzactionTypeDropdown = false;

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  // ✅ Country filter handlers
  onCountryDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showCountryDropdown = true;
    // Filter countries from MasterData if available
    if (!this.Countries || this.Countries.length === 0) {
      this.GetCountriesFiltered('');
    }
  }

  selectCountryFilter(country: any) {
    this.Filter.Country = country;
    this.countrySearchTerm = country?.Name || '';
    this.showCountryDropdown = false;
    this.Countries = [];
    this.AddActiveFilter(country.Name, 'Country');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  onCountrySearchInput(searchTerm: string) {
    if (searchTerm?.length >= 1) {
      this.GetCountriesFiltered(searchTerm);
    } else {
      this.GetCountriesFiltered('');
    }
  }

  clearCountryFilter() {
    this.Filter.Country = null;
    this.countrySearchTerm = '';
    this.Countries = [];
    this.showCountryDropdown = false;
    this.activeFilters = this.activeFilters.filter((x: any) => x.Type !== 'Country');
  }

  GetCountriesFiltered(searchTerm: string) {
    // Filter from MasterData.Countries if available
    if (this.MasterData?.Countries?.length > 0) {
      if (searchTerm && searchTerm.length > 0) {
        this.Countries = this.MasterData.Countries.filter((x: any) =>
          x.Name?.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
      } else {
        this.Countries = [...this.MasterData.Countries];
      }
    } else if (this.parent?.masterData?.Countries?.length > 0) {
      // Fallback to parent.masterData.Countries
      if (searchTerm && searchTerm.length > 0) {
        this.Countries = this.parent.masterData.Countries.filter((x: any) =>
          x.Name?.toLowerCase().startsWith(searchTerm.toLowerCase())
        );
      } else {
        this.Countries = [...this.parent.masterData.Countries];
      }
    }
  }

  // ✅ Progress Status filter handlers (for FilterContainer dropdown)
  onProgressStatusDropdownFocus() {
    this.closeAllFilterDropdowns();
    this.showProgressStatusDropdown = true;
  }

  selectProgressStatusFilter(status: any) {
    this.Filter.CartItemProgressStatus = status;
    this.showProgressStatusDropdown = false;
    this.AddActiveFilter(status.Name, 'ProgressStatus');

    // Apply filter immediately - reload current tab's grid
    this.parent.loading = true;
    this.applyFilter(1);
  }

  AnyChecked:boolean;

  CheckIfAnyChecked(){
    this.AnyChecked = false;

    this.Orders.forEach(element => {
      if(element.IsSelected){
        this.AnyChecked = true;
      }
    });
  }

  SelectAll(){
    this.Orders.forEach(r => {
      r.IsSelected = this.AllSelected;
    });

    this.CheckIfAnyChecked();
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }

        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:50,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];

         if(this.Partners.length == 1){
          this.partner = this.Partners[0]; this.resultsLength = 0; this.searchTerm = this.Partners[0].Name; this.Filter.Partner = this.Partners[0]; this.AddActiveFilter(this.Partners[0].Name, 'Partner');
          this.applyFilter(1);
         }
        }

        this.parent.loading = false;
      });
    }
  }

  InitializeUserManagersOnClick(searchTerm:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:searchTerm,
    };

    if((searchTerm.length >= 3) && (this.UserManagers == null || this.UserManagers.length == 0)){
      this.parent.loading = true;

      this.service.GetUsersFiltered(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.UserManagers = response["Users"];
          this.UserManagersLength = this.UserManagers.length;
        }

        this.parent.loading = false;
      });
    }
    else{
      this.UserManagers = [];
      this.UserManagersLength = 0;
    }
  }

  GetUserManagersFiltered(s:string){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
    };

    this.parent.loading = true;

    this.service.GetUsersFiltered(request).subscribe(response => {

      if(response["Status"] != 1){

      }
      else if(response["Status"] == 1){
        this.UserManagers = response["Users"];
        this.UserManagersLength = this.UserManagers.length;
      }

      this.parent.loading = false;
    });

  }

  InitializeUserClientsOnClick(searchTerm:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:searchTerm,
    };

    if((searchTerm.length >= 3) && (this.UserClients == null || this.UserClients.length == 0)){
      this.parent.loading = true;

      this.B2BService.GetB2BUserClients(request).subscribe(response => {

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.UserClients = response["Users"];
          this.UserClientsLength = this.UserClients.length;
        }

        this.parent.loading = false;
      });
    }
    else{
      this.UserClients = [];
      this.UserClientsLength = 0;
    }
  }

  GetUserClientsFiltered(s:string){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SearchTerm:s,
    };

    this.parent.loading = true;

    this.B2BService.GetB2BUserClients(request).subscribe(response => {

      if(response["Status"] != 1){

      }
      else if(response["Status"] == 1){
        this.UserClients = response["Users"];
        this.UserClientsLength = this.UserClients.length;
      }

      this.parent.loading = false;
    });

  }

  ClearUserClients(){
    this.Filter.UserUploader = null;
    this.UserClientsSearchTerm = null;
    this.UserClients = [];
    this.UserClientsLength = 0;
   }

  OpenOrderCancelation(o:any){
    this.CurrentOrder = JSON.parse(JSON.stringify(o));
    this.ShowOrderCancelation = true;
  }

  // ✅ Toggle status dropdown for a specific order
  toggleStatusDropdown(o: any, event: Event): void {
    event.stopPropagation();
    // Close all other dropdowns first
    this.Orders.forEach((order: any) => {
      if (order.DBID !== o.DBID) {
        order.showStatusDropdown = false;
      }
    });
    o.showStatusDropdown = !o.showStatusDropdown;
  }

  // ✅ Close all status dropdowns (call on document click)
  closeAllStatusDropdowns(): void {
    this.Orders.forEach((order: any) => {
      order.showStatusDropdown = false;
    });
  }

  // ✅ Handle status change from dropdown
  OnStatusChange(o: any, newStatus: any): void {
    // Close dropdown
    o.showStatusDropdown = false;

    // Skip if same status selected
    if (newStatus.ID === o.OCStatus?.ID) {
      return;
    }

    // For cancellation (status ID = 11), show confirmation popup
    if (newStatus.ID === 11) {
      this.OpenOrderCancelation(o);
      return;
    }

    // For all other status changes, call ChangeOrderConfirmationStatus directly
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: o.ID,
      DBID: o.DBID,
      OrderConfirmationStatus: {
        ID: newStatus.ID,
      }
    };

    this.parent.loading = true;

    this.managementService.ChangeOrderConfirmationStatus(request).subscribe(response => {
      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if (response["Status"] == 1) {
        o.OCStatus = JSON.parse(JSON.stringify(response["OrderConfirmationStatus"]));
        this.parent.openSnackBar(response["Message"] || 'Status updated', "OK", "light-info-snackbar");
      }
      this.parent.loading = false;
    });
  }

  CancelOrder(o:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DBID:o.DBID,
    };

    this.parent.loading = true;

    this.managementService.CancelOrderConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Orders.forEach(order => {
          if(order.DBID == o.DBID){
            order.ProcessingStatus = response["ProcessingStatus"];
            order.OfferStatus = response["OfferStatus"];
            order.OCStatus = response["OrderConfirmationStatus"];
          }
        });
        this.ShowOrderCancelation = false;
        this.parent.openSnackBar(response["Message"] || 'Order cancelled', "OK", "light-info-snackbar");
      }

      this.parent.loading = false;
    });
  }

  OpenCopyOrder(o:any){
    this.CurrentOrder = JSON.parse(JSON.stringify(o));
    this.ShowOrderCopy = true;
  }

  CopyOrder(o:any){
    this.GetOffer(o.ID);
  }

  GetOffer(OfferID:string){
    console.log('📥 ORDER-CONFIRMATIONS: GetOffer called with ID:', OfferID);

    var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    OrderConfirmationID:OfferID,
    GetCartItems:true,
    WithLogs:true,
  };

  this.parent.loading = true;

  this.managementService.GetOrderConfirmation(request).subscribe(response => {
    console.log('📥 ORDER-CONFIRMATIONS: GetOrderConfirmation response Status:', response["Status"]);

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrentOrder = response["OrderConfirmation"];
      this.HasInvoicedShippingCosts = response["HasInvoicedShippingCosts"] || false;
      console.log('   CurrentOrder set:', !!this.CurrentOrder);
      console.log('   Cart.Items count:', this.CurrentOrder?.Cart?.Items?.length);

      // ✅ Initialize ShippingCost if not present
      if (!this.CurrentOrder.Cart) {
        this.CurrentOrder.Cart = {};
      }
      if (!this.CurrentOrder.Cart.ShippingCost) {
        this.CurrentOrder.Cart.ShippingCost = { UIUnitPrice: null };
      }

      // ✅ Initialize PDFColumns if not present (with correct defaults)
      if (!this.CurrentOrder.PDFColumns) {
        this.CurrentOrder.PDFColumns = {
          ID: 0,
          OrderDBID: this.CurrentOrder.DBID || 0,
          ListPrice: false,
          Discount: false,
          StandardDelivery: true,
          HSCode: true,
          COO: true,
          Weight: true
        };
      }

      // ✅ Initialize Discount if not present
      if (!this.CurrentOrder.Discount) {
        this.CurrentOrder.Discount = { Type: null, Value: null };
      }

      // ✅ Collapse all sections, show only Products section
      this.ShowOrderBillingInformation = false;
      this.ShowOrderShippingInformation = false;
      this.ShowOrderGeneralInformation = false;
      this.ShowOrderProductsInformation = true;

      this.ShowEditContainer = true;
      console.log('   ShowEditContainer:', this.ShowEditContainer);

      // Load AG Grid data
      setTimeout(() => {
        this.loadOfferGridData();
      }, 100);

      // ✅ Reload shipping master data to match IDs with full objects
      this.GetShippingMasterData();
    }

    this.parent.loading = false;
  });

  }

  PrintOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ExportOrderConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.parent.loading = false;
    });
  }

  download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  ExportOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ExportOrderConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.parent.loading = false;
    });
  }


  ExportOrderExcel(o:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
    };
    this.parent.loading = true;
    this.managementService.ExportOrderConfirmationExcel(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else if(response["Status"] == 1){
        var Document = response["Document"];
        this.downloadExcel(Document.Name, Document.PDFStream);
      }
      this.parent.loading = false;
    });
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

  var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

  var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
  newWindow.document.write(htmlPop);
  };

  ShowAllProductsDetails:boolean = false;

  ShowAllProductsDetailsFunction(e:boolean){
    this.ShowAllProductsDetails = e;
    this.CurrentOrder.Cart.Items.forEach(element => {
      element.Product.ShowDetails = e;
    });
  }

  AwknowledgeOrder(o:any){
    if(o.ProcessingStatus?.ID == 0){
      this.ChangeOrderStatus(o);
    }
  }

  ChangeOrderStatus(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DBID:o.DBID,
      ProcessingStatus:this.MasterData.OrderStatuses.filter(x => x.ID == 1)[0],
      Type:o.Type,
      ID:o.ID,
    };

    this.parent.loading = true;

    this.managementService.ChangeOrderStatus(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        o.ProcessingStatus = response["ProcessingStatus"];
      }

      this.parent.loading = false;
    });
  }

  AskClientStatusNotificationEmail:boolean;

  AddNewOffer(){
    if(this.parent.loading != true){

     console.log('📦 [OC-AddNewOffer] ====== SAVE BUTTON CLICKED ======');
     console.log('📦 [OC-AddNewOffer] CurrentOrder.Cart.Items BEFORE sync. Count:', this.CurrentOrder?.Cart?.Items?.length);
     console.log('📦 [OC-AddNewOffer] Items BEFORE sync:', this.CurrentOrder?.Cart?.Items?.map((item: any, i: number) => ({
       idx: i, ID: item?.ID, PartNumber: item?.Product?.PartNumber, Qty: item?.Quantity,
       SellingPrice: item?.SelectedOffer?.SellingPrice, PriceUI: item?.Price?.UIUnitPrice,
       Discount: item?.Product?.Stats?.StandardListPrice?.Discount?.Value
     })));

     // ✅ Sync CurrentOrder.Cart.Items from AG Grid to ensure all edits are captured
     this.syncGridItemsToCurrentOrder();

     console.log('📦 [OC-AddNewOffer] Items AFTER sync:', this.CurrentOrder?.Cart?.Items?.map((item: any, i: number) => ({
       idx: i, ID: item?.ID, PartNumber: item?.Product?.PartNumber, Qty: item?.Quantity,
       SellingPrice: item?.SelectedOffer?.SellingPrice, PriceUI: item?.Price?.UIUnitPrice,
       Discount: item?.Product?.Stats?.StandardListPrice?.Discount?.Value
     })));

     // ✅ Filter out empty rows (CartItemStatus.ID !== 1 OR Quantity is null/0)
     const offerToSave = JSON.parse(JSON.stringify(this.CurrentOrder));
     if (offerToSave?.Cart?.Items) {
       const beforeFilter = offerToSave.Cart.Items.length;
       offerToSave.Cart.Items = offerToSave.Cart.Items.filter((item: any) => {
         const hasValidStatus = item?.CartItemStatus?.ID === 1;
         const hasValidQuantity = item?.Quantity != null && item?.Quantity > 0;
         return hasValidStatus || hasValidQuantity;
       });
       console.log(`📦 [OC-AddNewOffer] Filtered: ${beforeFilter} → ${offerToSave.Cart.Items.length}`);
     }

     console.log('📦 [OC-AddNewOffer] FINAL items being sent:', offerToSave?.Cart?.Items?.map((item: any, i: number) => ({
       idx: i, ID: item?.ID, PartNumber: item?.Product?.PartNumber, Brand: item?.Product?.Brand?.Name,
       Qty: item?.Quantity, SellingPrice: item?.SelectedOffer?.SellingPrice, PriceUI: item?.Price?.UIUnitPrice,
       Discount: item?.Product?.Stats?.StandardListPrice?.Discount?.Value, Purchase: item?.SelectedOffer?.ListPrice
     })));

     var request = {
       User:this.parent.User,
       Language:this.parent.getLanguage(),
       OrderConfirmation:offerToSave,
       SendEmail:this.sendEmailOnConvert
     };

     this.parent.loading = true;

     this.managementService.AddNewOrderConfirmation(request).subscribe(response => {

       if(response["Status"] != 1){
         console.error('❌ [OC-AddNewOffer] FAILED:', response["Message"]);
         this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
         // ✅ Keep EditContainer open on error
       }
       else if(response["Status"] == 1){
        console.log('✅ [OC-AddNewOffer] SUCCESS');
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        var OrderConfirmation = JSON.parse(JSON.stringify(response["OrderConfirmation"]));

        if(OrderConfirmation.OCStatus?.ID != this.CurrentOrder.OCStatus?.ID){
          this.AskClientStatusNotificationEmail = true;
        }

        this.Orders.forEach(element => {
          if(element.DBID == OrderConfirmation.DBID){
            element.OCStatus = OrderConfirmation.OCStatus;
          }
        });

        // ✅ Only close EditContainer on success
        this.ShowEditContainer = false;
       }

       this.parent.loading = false;
      });
    }
   }

   // Send Email Dropdown Methods
   onSendEmailFocus() {
    this.showSendEmailResults = true;
   }

   selectSendEmailOption(option: any) {
    this.sendEmailOnConvert = option.value;
    this.showSendEmailResults = false;
   }

   getSendEmailLabel(): string {
    const found = this.sendEmailOptions.find(o => o.value === this.sendEmailOnConvert);
    return found ? found.label : 'Select Option';
   }

   // Convert OrderConfirmation to Offer - Show confirmation popup
   AddOfferFromOrderConfirmation(){
    if(this.parent.loading != true && this.CurrentOrder){
      this.ShowConvertToOfferConfirmation = true;
    }
   }

   // Confirm and execute the conversion
   ConfirmConvertToOffer(){
    if(this.parent.loading != true && this.CurrentOrder){
      // ✅ Filter out empty rows before sending to backend
      const orderConfirmationToConvert = JSON.parse(JSON.stringify(this.CurrentOrder));
      if (orderConfirmationToConvert?.Cart?.Items) {
        orderConfirmationToConvert.Cart.Items = orderConfirmationToConvert.Cart.Items.filter((item: any) => {
          const hasValidStatus = item?.CartItemStatus?.ID === 1;
          const hasValidQuantity = item?.Quantity != null && item?.Quantity > 0;
          return hasValidStatus || hasValidQuantity;
        });
      }

      var request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        OrderConfirmation: orderConfirmationToConvert,
        SendEmail: this.sendEmailOnConvert
      };

      this.parent.loading = true;

      this.managementService.AddOfferFromOrderConfirmation(request).subscribe(response => {
        this.ShowConvertToOfferConfirmation = false;

        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var refNumber = response["Offer"]?.ReferenceNumber || '';
          this.parent.openSnackBar(response["Message"] + (refNumber ? ' - ' + refNumber : ''), "OK", "light-info-snackbar");
          this.ShowEditContainer = false;
        }

        this.parent.loading = false;
      });
    }
   }

   ChangeGridCellItem(item:any){
    console.log('💾 ORDER-CONFIRMATIONS: ChangeGridCellItem called');
    console.log('   Item ID:', item?.ID);
    console.log('   CurrentOrder exists:', !!this.CurrentOrder);
    console.log('   Partner exists:', !!this.CurrentOrder?.Cart?.Partner);

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      item:item,
      Partner:this.CurrentOrder.Cart.Partner,
      Company:this.CurrentOrder.Company,
    };

    this.B2BService.ChangeGridCellItem(request).subscribe(response => {
      console.log('   Response Status:', response["Status"]);

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        console.log('   ✅ Item saved successfully');

        var Item = response["item"];

        this.CurrentOrder.Cart.Items.forEach((cell, index) => {
          if(cell.UIID == item.UIID){
            this.CurrentOrder.Cart.Items[index] = JSON.parse(JSON.stringify(Item));
          }
        });
      }
     });
  }

  ShowConfirmationQuestion:boolean = false;

  PreCheckOfferConfirmation(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      OrderConfirmation:o,
    };

    this.managementService.PreCheckOrderConfirmationConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
      }
      else if(response["Status"] == 1){
        this.CurrentOrder = o;
        this.ShowConfirmationQuestion = true;
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
      }
     });
  }

  ConfirmOrder(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:o.ID,
      DBID:o.DBID,
      OrderConfirmationStatus:{
        ID:12,
      }
    };

    this.managementService.ChangeOrderConfirmationStatus(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        o.OCStatus = JSON.parse(JSON.stringify(response["OrderConfirmationStatus"]));
        this.SendClientRequestToPendingOrderConfirmation(o);
      }
     });
  }

  SendClientRequestToPendingOrderConfirmation(o:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      OrderConfirmationID:o.ID,
      GetCartItems:true,
      WithLogs:true,
      GetCartItemsPurchaseOfferData:true,
    };

    this.parent.loading = true;

    this.managementService.GetOrderConfirmation(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.parent.loading = false;
      }
      else if(response["Status"] == 1){
        this.CurrentOrder = response["OrderConfirmation"];

        // Call B2B SendClientRequestToPendingOrderConfirmation endpoint
        var Sendrequest = {
          User:this.parent.User,
          Language:this.parent.getLanguage(),
          OrderConfirmation:JSON.parse(JSON.stringify(this.CurrentOrder)),
        };

        this.B2BService.SendClientRequestToPendingOrderConfirmation(Sendrequest).subscribe(response => {

          if(response["Status"] != 1){
            this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 60000);
          }
          else if(response["Status"] == 1){

            var message = JSON.parse(JSON.stringify(response["Message"]));
            if(message?.length > 0){
              this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 60000);
            }

            var InjectionError = JSON.parse(JSON.stringify(response["InjectionError"]));

            this.Orders.forEach(order => {
              if(order.DBID == o.DBID){
                order.InjectionError = JSON.parse(JSON.stringify(InjectionError));
              }
            });
          }

          this.parent.loading = false;
         });
      }
    });
  }

  SelectItemSupplierVariants(item:any){
    this.CurrentOrder.Cart.Items.forEach(element => {
      if(element.UIID == item.UIID){
        element.IsSelected = !element.IsSelected;
      }
      else{
        element.IsSelected = false;
      }
    });
  }

  // Number parser for grid
  numberParser(params: any): number | null {
    const value = params.newValue;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }

  // MOQ Adjustment Tooltip
  MOQAdjustmentTooltip: string = 'Quantity adjusted to meet MOQ';

  // AG Grid Methods for Offer Products
  onOfferGridReady(params: any): void {
    console.log('🎯 ORDER-CONFIRMATIONS: onOfferGridReady called');
    this.offerGridApi = params.api;
    this.offerColumnApi = params.columnApi;
    console.log('   offerGridApi initialized:', !!this.offerGridApi);
    this.loadOfferGridData();
    params.api.sizeColumnsToFit();
    // ✅ Sync column widths for ExcelExportControlRow
    setTimeout(() => this.syncColumnWidths(), 200);
  }

  calculateGridHeaderWidths(): void {
    const gridContainer = document.querySelector('.ProductsAGGridContainer');
    if (!gridContainer) {
      return;
    }

    const headerRow = gridContainer.querySelector('.ag-header-row');
    const headerCells = gridContainer.querySelectorAll('.ag-header-cell');
    if (!headerRow || headerCells.length === 0) return;

    const headerRowRect = (headerRow as HTMLElement).getBoundingClientRect();
    const containerRect = (gridContainer as HTMLElement).getBoundingClientRect();
    const widths: any[] = [];

    headerCells.forEach((cell: any, index: number) => {
      const cellRect = cell.getBoundingClientRect();
      const colId = cell.getAttribute('col-id');

      widths.push({
        field: colId,
        width: cellRect.width,
        left: cellRect.left - containerRect.left,
        index: index
      });
    });

    this.gridHeaderWidths = widths;
  }

  // Products Grid Ready Handler (for main Products tab)
  onProductsGridReady(params: any): void {
    console.log('🎯 ORDER-CONFIRMATIONS: onProductsGridReady called');
    this.productsGridApi = params.api;
    console.log('   productsGridApi initialized:', !!this.productsGridApi);
    params.api.sizeColumnsToFit();

    // Calculate header widths for custom overlay
    setTimeout(() => {
      this.calculateGridHeaderWidths();
    }, 500);

    // Recalculate on column resize
    params.api.addEventListener('columnResized', () => {
      this.calculateGridHeaderWidths();
    });
  }

  loadOfferGridData(): void {
    console.log('📊 ORDER-CONFIRMATIONS: loadOfferGridData called');
    console.log('   CurrentOrder exists:', !!this.CurrentOrder);
    console.log('   Cart.Items length:', this.CurrentOrder?.Cart?.Items?.length);

    if (!this.CurrentOrder?.Cart?.Items) {
      this.offerGridRowData = [];
      return;
    }

    this.offerGridRowData = this.CurrentOrder.Cart.Items.map((item: any, index: number) => {
      const leadTime = item?.SelectedOffer?.LeadTime;
      const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

      return {
        index: index + 1,
        brand: item?.Product?.Brand?.Name || item?.UserSelectedBrand?.Name || '',
        partNumber: item?.Product?.PartNumber || '',
        name: item?.UIProductValue || item?.Product?.Name || '',
        quantity: item?.Quantity || 0,
        // ✅ List-Price: Manufacturer's list price from Product.Stats.StandardListPrice.UIUnitPrice
        officialListPrice: item?.Product?.Stats?.StandardListPrice?.UIUnitPrice || '',
        officialDiscount: item?.Product?.Stats?.StandardListPrice?.Discount?.Value || '',
        // ✅ Final-Price: Sell price from SelectedOffer.SellingPrice (what we sell to customer)
        price: item?.SelectedOffer?.SellingPrice || item?.Price?.UIUnitPrice || '',
        total: (() => { const sp = item?.SelectedOffer?.SellingPrice || item?.Price?.UIUnitPrice; const q = item?.Quantity || 0; return sp > 0 && q > 0 ? `${parseFloat((sp * q).toFixed(4))} ${this.CurrentOrder.Cart.Currency?.Symbol}` : ''; })(),
        eta: etaDisplay,
        supplier: item?.SelectedOffer?.Partner?.Name || '',
        // ✅ Purchase: from SelectedOffer.ListPrice (what we buy from supplier)
        purchase: item?.SelectedOffer?.ListPrice || '',
        // ✅ PD: Purchase Discount from Price.PurchaseDiscount.Value
        purchaseDiscount: item?.Price?.PurchaseDiscount?.Value ?? null,
        CartItem: item, // Keep reference to original item
        // Extra offer context columns (same as ProductItems)
        OfferID: this.CurrentOrder?.ID || '',
        OfferDBID: this.CurrentOrder?.DBID || 0,
        ReferenceNumber: this.CurrentOrder?.ReferenceNumber || '',
        DebatorPO: this.CurrentOrder?.DebatorPO || '',
        PartnerName: this.CurrentOrder?.Cart?.Partner?.Name || '',
        OfferEventRegister: this.CurrentOrder?.EventRegister || null
      };
    });

    this.CartItemRows = [...this.offerGridRowData];
    console.log('   offerGridRowData length:', this.offerGridRowData.length);
    console.log('   CartItemRows length:', this.CartItemRows.length);

    if (this.offerGridApi) {
      console.log('   Resizing grid and injecting header checkbox');
      // ✅ Explicitly set row data to force grid update (fixes currency change grid disappearing)
      this.offerGridApi.setRowData(this.offerGridRowData);
      this.offerGridApi.sizeColumnsToFit();
      // Re-inject header checkbox after data load
      setTimeout(() => this.injectOfferHeaderCheckbox(), 100);
    } else {
      console.log('   ⚠️ offerGridApi not available');
    }
  }

  onOfferCellValueChanged(event: any): void {
    const field = event.colDef.field;
    const newValue = event.newValue;
    const rowNode = event.node;
    const rowIndex = event.rowIndex;
    const cartItem = event.data?.CartItem;

    if (!cartItem) return;

    const currentOrderItem = this.CurrentOrder?.Cart?.Items?.[rowIndex];
    const refMatch = currentOrderItem === cartItem;
    console.log(`✏️ [OC-onOfferCellValueChanged] field="${field}" row=${rowIndex} newValue="${newValue}" CartItem.ID=${cartItem?.ID} refMatch=${refMatch}`);
    if (!refMatch) {
      console.warn(`⚠️ [OC-onOfferCellValueChanged] REFERENCE MISMATCH at row ${rowIndex}!`);
    }

    // ---------- QUANTITY changes ----------
    if (field === 'quantity') {
      const parsedQty = this.parseNumberFromAnyFormat(newValue);
      if (parsedQty === null || isNaN(parsedQty) || parsedQty < 0) {
        return;
      }
      cartItem.Quantity = parsedQty;
      rowNode.data.quantity = parsedQty;

      // ✅ Recalculate Total = FinalPrice × Quantity
      const finalPrice = cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || 0;
      if (finalPrice > 0 && parsedQty > 0) {
        const total = Math.round(finalPrice * parsedQty * 100) / 100;
        if (!cartItem.Price) cartItem.Price = {};
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'quantity');
      return;
    }

    // ---------- LIST-PRICE changes (recalculates Final-Price based on Discount) ----------
    if (field === 'officialListPrice') {
      const parsedListPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedListPrice === null || isNaN(parsedListPrice) || parsedListPrice < 0) {
        rowNode.setDataValue('officialListPrice', event.oldValue);
        return;
      }

      // ✅ Ensure Product.Stats.StandardListPrice exists
      if (!cartItem.Product) cartItem.Product = {};
      if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
      if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};

      // ✅ Store the list price
      cartItem.Product.Stats.StandardListPrice.UIUnitPrice = parsedListPrice;

      // ✅ Get current discount percentage
      const discountPercent = cartItem.Product?.Stats?.StandardListPrice?.Discount?.Value || 0;

      // ✅ Calculate new Final-Price based on List-Price and Discount
      const newFinalPrice = Math.round(parsedListPrice * (1 - discountPercent / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialListPrice = parsedListPrice;
      rowNode.data.price = newFinalPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'officialListPrice');
      return;
    }

    // ---------- DISCOUNT changes (recalculates Final-Price based on List-Price) ----------
    if (field === 'officialDiscount') {
      const parsedDiscount = this.parseNumberFromAnyFormat(newValue);
      if (parsedDiscount === null || isNaN(parsedDiscount) || parsedDiscount < 0 || parsedDiscount > 100) {
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // ✅ Check if ListPrice exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice == null || listPrice <= 0) {
        this.parent.openSnackBar('Cannot calculate: List-Price is missing', 'OK', 'alert-info-snackbar');
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // ✅ Update the discount value in CartItem
      if (!cartItem.Product.Stats.StandardListPrice.Discount) {
        cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
      }
      cartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

      // ✅ Calculate new Final-Price based on List-Price and new Discount
      const newFinalPrice = Math.round(listPrice * (1 - parsedDiscount / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialDiscount = parsedDiscount;
      rowNode.data.price = newFinalPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'officialDiscount');
      return;
    }

    // ---------- FINAL-PRICE changes (recalculates Discount based on List-Price) ----------
    if (field === 'price') {
      const parsedPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedPrice === null || isNaN(parsedPrice) || parsedPrice < 0) {
        rowNode.setDataValue('price', event.oldValue);
        return;
      }

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = parsedPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = parsedPrice;

      // ✅ Recalculate Discount if List-Price exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice != null && listPrice > 0) {
        const newDiscount = Math.round((1 - parsedPrice / listPrice) * 100 * 100) / 100;
        const clampedDiscount = Math.max(0, Math.min(100, newDiscount));

        // ✅ Ensure discount object exists
        if (!cartItem.Product) cartItem.Product = {};
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = clampedDiscount;
        rowNode.data.officialDiscount = clampedDiscount;
      }

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (parsedPrice > 0 && qty > 0) {
        const total = Math.round(parsedPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total} ${this.CurrentOrder?.Cart?.Currency?.Symbol || ''}`;
      }

      // ✅ Update grid display fields
      rowNode.data.price = parsedPrice;

      // ✅ Recalculate cart-level totals
      this.recalculateCartTotals();

      this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'price');
      return;
    }

    // ---------- BRAND changes (Brand identification via backend) ----------
    if (field === 'brand') {
      const newBrand = (event.newValue ?? '').toString().trim();
      const oldBrand = (event.oldValue ?? '').toString().trim();

      if (!newBrand) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newBrand
      };

      this.managementService.IdentifyGridBrand(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (cartItem) {
            if (!cartItem.Product) cartItem.Product = {};
            cartItem.Product.Brand = response["Brand"];

            const brandDisplay = response["Brand"]?.Name ?? '';
            rowNode.data.brand = brandDisplay;

            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.offerGridApi.stopEditing();
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'brand');
          }
        } else {
          rowNode.data.brand = oldBrand;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify brand', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.brand = oldBrand;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify brand', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- SUPPLIER changes (Supplier column - Partner identification via backend) ----------
    if (field === 'supplier') {
      console.log('🔍 [OC] onOfferCellValueChanged for Supplier:', event.newValue);
      const newSupplier = (event.newValue ?? '').toString().trim();
      const oldSupplier = (event.oldValue ?? '').toString().trim();

      // ✅ Cleared supplier — remove Partner, Configuration and SelectedOffer.ID but keep Purchase/PC
      if (!newSupplier) {
        if (cartItem.SelectedOffer) {
          cartItem.SelectedOffer.Partner = null;
          cartItem.SelectedOffer.ID = 0;
          cartItem.SelectedOffer.Configuration = null;
        }
        rowNode.data.supplier = '';
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, false, 'supplier');
        return;
      }

      // ✅ Helper function to apply supplier result to a single cart item
      const applySupplierToItem = (itemCartItem: any, itemNode: any, identifiedOffer: any, identifiedPartner: any) => {
        if (!itemCartItem) return;
        if (!itemCartItem.SelectedOffer) itemCartItem.SelectedOffer = {};

        itemCartItem.SelectedOffer.Partner = identifiedPartner;
        itemCartItem.SelectedOffer.ID = (identifiedOffer.ID != null && identifiedOffer.ID > 0) ? identifiedOffer.ID : 0;
        itemCartItem.SelectedOffer.ListPrice = identifiedOffer.ListPrice;
        itemCartItem.SelectedOffer.Currency = identifiedOffer.Currency;
        itemCartItem.SelectedOffer.PurchaseCurrency = identifiedOffer.Currency;

        if (itemCartItem.Product?.ListPriceOffers?.[0]) {
          itemCartItem.Product.ListPriceOffers[0].PurchaseCurrency = identifiedOffer.Currency;
          itemCartItem.Product.ListPriceOffers[0].Currency = identifiedOffer.Currency;
        }

        // Update grid display fields
        if (itemNode) {
          itemNode.data.supplier = identifiedPartner?.Name || '';
          itemNode.data.purchase = identifiedOffer.ListPrice || '';
        }
      };

      // ✅ Single item update (Edit Container popup grid)
      const productId = cartItem?.Product?.ID;
      const fallbackCurrency = cartItem?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newSupplier,
        CompanyID: this.parent.B2BPartner?.FK_CompanyID || 0,
        ProductID: productId || null,
        FallbackCurrency: fallbackCurrency
      };

      this.managementService.IdentifyPartnerWithOffers(request).subscribe(response => {
        if (response["Status"] === 1 && response["Offers"] && response["Offers"].length > 0) {
          const identifiedOffer = response["Offers"][0];
          const identifiedPartner = identifiedOffer?.Partner;

          if (!identifiedPartner) {
            this.parent.openSnackBar('Supplier found but missing partner details', "OK", "alert-info-snackbar");
            return;
          }

          applySupplierToItem(cartItem, rowNode, identifiedOffer, identifiedPartner);
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.startAutoSaveTimer(rowIndex, cartItem, false, 'supplier');
        } else {
          console.warn('⚠️ Backend could not identify partner:', response["Message"]);
          rowNode.data.supplier = oldSupplier;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify supplier', "OK", "alert-info-snackbar");
        }
      }, () => {
        console.error('❌ Error calling IdentifyPartnerWithOffers');
        rowNode.data.supplier = oldSupplier;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify supplier', "OK", "alert-info-snackbar");
      });

      return;
    }

    // ---------- ETA changes (Standard-Delivery - Lead time identification via backend) ----------
    if (field === 'eta') {
      const newETA = (event.newValue ?? '').toString().trim();
      const oldETA = (event.oldValue ?? '').toString().trim();

      if (!newETA || newETA === '------') return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newETA,
        IsProlonged: false
      };

      this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (response["LeadTime"] && cartItem) {
            if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};

            cartItem.SelectedOffer.LeadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
            cartItem.SelectedOffer.IsStockOffer = response["IsStock"];

            const leadTime = cartItem.SelectedOffer.LeadTime;
            const etaDisplay = leadTime?.UIOutput ??
              (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

            rowNode.data.eta = etaDisplay;
            this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, false, 'eta');
          }
        } else {
          rowNode.data.eta = oldETA;
          this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse lead time', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.eta = oldETA;
        this.offerGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing lead time', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- PURCHASE (ListPrice) changes ----------
    if (field === 'purchase') {
      const rawValue = (event.newValue ?? '').toString().trim();
      const newPurchase = rawValue === '' ? null : parseFloat(rawValue.replace(',', '.'));

      // If user typed invalid text, ignore
      if (newPurchase !== null && isNaN(newPurchase)) return;

      // Update CartItem.SelectedOffer.ListPrice
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ListPrice = newPurchase;

      // Also update ListPriceOffers[0] if exists
      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].ListPrice = newPurchase;
      }

      // ✅ Reverse-calculate PD: PD = (1 - Purchase / OfficialListPrice) × 100
      const officialListPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (newPurchase != null && officialListPrice != null && officialListPrice > 0) {
        const newPD = Math.round((1 - newPurchase / officialListPrice) * 10000) / 100;
        if (!cartItem.Price) cartItem.Price = {};
        if (!cartItem.Price.PurchaseDiscount) cartItem.Price.PurchaseDiscount = {};
        cartItem.Price.PurchaseDiscount.Value = newPD;
        rowNode.data.purchaseDiscount = newPD;
      } else {
        // Clear PD when purchase is cleared or no official list price
        if (cartItem.Price?.PurchaseDiscount) {
          cartItem.Price.PurchaseDiscount.Value = null;
        }
        rowNode.data.purchaseDiscount = null;
      }

      rowNode.data.purchase = newPurchase;
      this.offerGridApi.refreshCells({ rowNodes: [rowNode], columns: ['purchase', 'purchaseDiscount'], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'purchase');
      return;
    }

    // ---------- PURCHASE DISCOUNT (PD) changes ----------
    if (field === 'purchaseDiscount') {
      const parsedPD = this.parseNumberFromAnyFormat(newValue);
      if (parsedPD === null || isNaN(parsedPD)) {
        return;
      }

      // Get ListPrice to reverse-calculate purchase price
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice == null || listPrice <= 0) {
        console.log('❌ No valid ListPrice for PD reverse calculation, skipping');
        return;
      }

      // Reverse-calculate purchase price: PurchaseCost = ListPrice × (1 - PD / 100)
      const newPurchasePrice = Math.round((listPrice * (1 - parsedPD / 100)) * 100) / 100;

      // Update CartItem
      if (!cartItem.Price) cartItem.Price = {};
      if (!cartItem.Price.PurchaseDiscount) cartItem.Price.PurchaseDiscount = {};
      cartItem.Price.PurchaseDiscount.Value = parsedPD;

      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ListPrice = newPurchasePrice;

      // Also update ListPriceOffers[0] if exists
      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].ListPrice = newPurchasePrice;
      }

      rowNode.data.purchase = newPurchasePrice;
      rowNode.data.purchaseDiscount = parsedPD;
      this.offerGridApi.refreshCells({ rowNodes: [rowNode], columns: ['purchase', 'purchaseDiscount'], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'purchaseDiscount');
      return;
    }

    // ---------- NAME changes (plain text update — no product search on placed orders) ----------
    if (field === 'name') {
      const newName = (event.newValue ?? '').toString().trim();
      const oldName = (event.oldValue ?? '').toString().trim();

      // Skip if empty or unchanged
      if (!newName || newName === oldName) return;

      // ✅ Update CartItem product name directly (no B2B search — these are placed orders)
      if (!cartItem.Product) cartItem.Product = {};
      cartItem.Product.Name = newName;
      cartItem.UIProductValue = newName;
      rowNode.data.name = newName;
      this.offerGridApi.refreshCells({ rowNodes: [rowNode], columns: ['name'], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, false, 'name');
      return;
    }
  }

  // Products Grid Cell Value Changed Handler (same logic, uses productsGridApi)
  onProductsCellValueChanged(event: any): void {
    const field = event.colDef.field;
    const newValue = event.newValue;
    const rowNode = event.node;
    const rowIndex = event.rowIndex;
    const cartItem = event.data?.CartItem;

    if (!cartItem) return;

    // ---------- QUANTITY changes ----------
    if (field === 'quantity') {
      const parsedQty = this.parseNumberFromAnyFormat(newValue);
      if (parsedQty === null || isNaN(parsedQty) || parsedQty < 0) {
        return;
      }

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      if (isBulkUpdate) {
        // Apply Quantity to ALL selected items
        selectedItems.forEach((item: any) => {
          if (item.CartItem) {
            item.CartItem.Quantity = parsedQty;

            // Recalculate Total = FinalPrice × Quantity
            const itemFinalPrice = item.CartItem?.SelectedOffer?.SellingPrice || item.CartItem?.Price?.UIUnitPrice || 0;
            if (itemFinalPrice > 0 && parsedQty > 0) {
              const total = Math.round(itemFinalPrice * parsedQty * 100) / 100;
              if (!item.CartItem.Price) item.CartItem.Price = {};
              item.CartItem.Price.UIQtyPrice = total;
              item.total = `${total}`;
            }
            item.quantity = parsedQty;
          }
        });
        this.productsGridApi.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        // Single item update
        cartItem.Quantity = parsedQty;

        // ✅ Recalculate Total = FinalPrice × Quantity
        const finalPrice = cartItem?.SelectedOffer?.SellingPrice || cartItem?.Price?.UIUnitPrice || 0;
        if (finalPrice > 0 && parsedQty > 0) {
          const total = Math.round(finalPrice * parsedQty * 100) / 100;
          if (!cartItem.Price) cartItem.Price = {};
          cartItem.Price.UIQtyPrice = total;
          rowNode.data.total = `${total}`;
        }

        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true);
      }
      return;
    }

    // ---------- LIST-PRICE changes (recalculates Final-Price based on Discount) ----------
    if (field === 'officialListPrice') {
      const parsedListPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedListPrice === null || isNaN(parsedListPrice) || parsedListPrice < 0) {
        rowNode.setDataValue('officialListPrice', event.oldValue);
        return;
      }

      // ✅ Ensure Product.Stats.StandardListPrice exists
      if (!cartItem.Product) cartItem.Product = {};
      if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
      if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};

      // ✅ Store the list price
      cartItem.Product.Stats.StandardListPrice.UIUnitPrice = parsedListPrice;

      // ✅ Get current discount percentage
      const discountPercent = cartItem.Product?.Stats?.StandardListPrice?.Discount?.Value || 0;

      // ✅ Calculate new Final-Price based on List-Price and Discount
      const newFinalPrice = Math.round(parsedListPrice * (1 - discountPercent / 100) * 100) / 100;

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = newFinalPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = newFinalPrice;

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (newFinalPrice > 0 && qty > 0) {
        const total = Math.round(newFinalPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total}`;
      }

      // ✅ Update grid display fields
      rowNode.data.officialListPrice = parsedListPrice;
      rowNode.data.price = newFinalPrice;

      this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- DISCOUNT changes (recalculates Final-Price based on List-Price) ----------
    if (field === 'officialDiscount') {
      const parsedDiscount = this.parseNumberFromAnyFormat(newValue);
      if (parsedDiscount === null || isNaN(parsedDiscount) || parsedDiscount < 0 || parsedDiscount > 100) {
        rowNode.setDataValue('officialDiscount', event.oldValue);
        return;
      }

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      if (isBulkUpdate) {
        // Apply Discount to ALL selected items (each recalculates its own Final-Price based on its List-Price)
        selectedItems.forEach((item: any) => {
          if (item.CartItem) {
            const itemListPrice = item.CartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
            if (itemListPrice != null && itemListPrice > 0) {
              // Ensure discount object exists
              if (!item.CartItem.Product) item.CartItem.Product = {};
              if (!item.CartItem.Product.Stats) item.CartItem.Product.Stats = {};
              if (!item.CartItem.Product.Stats.StandardListPrice) item.CartItem.Product.Stats.StandardListPrice = {};
              if (!item.CartItem.Product.Stats.StandardListPrice.Discount) {
                item.CartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
              }
              item.CartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

              // Calculate new Final-Price
              const newFinalPrice = Math.round(itemListPrice * (1 - parsedDiscount / 100) * 100) / 100;
              if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
              item.CartItem.SelectedOffer.SellingPrice = newFinalPrice;
              if (!item.CartItem.Price) item.CartItem.Price = {};
              item.CartItem.Price.UIUnitPrice = newFinalPrice;

              // Recalculate Total
              const qty = item.CartItem.Quantity || 0;
              if (newFinalPrice > 0 && qty > 0) {
                const total = Math.round(newFinalPrice * qty * 100) / 100;
                item.CartItem.Price.UIQtyPrice = total;
                item.total = `${total}`;
              }

              item.officialDiscount = parsedDiscount;
              item.price = newFinalPrice;
            }
          }
        });
        this.productsGridApi.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        // Single item update
        const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
        if (listPrice == null || listPrice <= 0) {
          this.parent.openSnackBar('Cannot calculate: List-Price is missing', 'OK', 'alert-info-snackbar');
          rowNode.setDataValue('officialDiscount', event.oldValue);
          return;
        }

        // Update the discount value in CartItem
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = parsedDiscount;

        // Calculate new Final-Price based on List-Price and new Discount
        const newFinalPrice = Math.round(listPrice * (1 - parsedDiscount / 100) * 100) / 100;

        // Update Final-Price in CartItem
        if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
        cartItem.SelectedOffer.SellingPrice = newFinalPrice;
        if (!cartItem.Price) cartItem.Price = {};
        cartItem.Price.UIUnitPrice = newFinalPrice;

        // Recalculate Total
        const qty = cartItem.Quantity || 0;
        if (newFinalPrice > 0 && qty > 0) {
          const total = Math.round(newFinalPrice * qty * 100) / 100;
          cartItem.Price.UIQtyPrice = total;
          rowNode.data.total = `${total}`;
        }

        // Update grid display fields
        rowNode.data.officialDiscount = parsedDiscount;
        rowNode.data.price = newFinalPrice;

        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true);
      }
      return;
    }

    // ---------- FINAL-PRICE changes (recalculates Discount based on List-Price) ----------
    if (field === 'price') {
      const parsedPrice = this.parseNumberFromAnyFormat(newValue);
      if (parsedPrice === null || isNaN(parsedPrice) || parsedPrice < 0) {
        rowNode.setDataValue('price', event.oldValue);
        return;
      }

      // ✅ Update Final-Price in CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.SellingPrice = parsedPrice;
      if (!cartItem.Price) cartItem.Price = {};
      cartItem.Price.UIUnitPrice = parsedPrice;

      // ✅ Recalculate Discount if List-Price exists
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice != null && listPrice > 0) {
        const newDiscount = Math.round((1 - parsedPrice / listPrice) * 100 * 100) / 100;
        const clampedDiscount = Math.max(0, Math.min(100, newDiscount));

        // ✅ Ensure discount object exists
        if (!cartItem.Product) cartItem.Product = {};
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        if (!cartItem.Product.Stats.StandardListPrice) cartItem.Product.Stats.StandardListPrice = {};
        if (!cartItem.Product.Stats.StandardListPrice.Discount) {
          cartItem.Product.Stats.StandardListPrice.Discount = { Type: { ID: 1, Name: '%' }, Value: 0 };
        }
        cartItem.Product.Stats.StandardListPrice.Discount.Value = clampedDiscount;
        rowNode.data.officialDiscount = clampedDiscount;
      }

      // ✅ Recalculate Total
      const qty = cartItem.Quantity || 0;
      if (parsedPrice > 0 && qty > 0) {
        const total = Math.round(parsedPrice * qty * 100) / 100;
        cartItem.Price.UIQtyPrice = total;
        rowNode.data.total = `${total}`;
      }

      // ✅ Update grid display fields
      rowNode.data.price = parsedPrice;

      this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- BRAND changes ----------
    if (field === 'brand') {
      const newBrand = (event.newValue ?? '').toString().trim();
      const oldBrand = (event.oldValue ?? '').toString().trim();
      if (!newBrand) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newBrand
      };

      this.managementService.IdentifyGridBrand(request).subscribe(response => {
        if (response["Status"] === 1) {
          if (!cartItem.Product) cartItem.Product = {};
          cartItem.Product.Brand = response["Brand"];
          rowNode.data.brand = response["Brand"]?.Name ?? '';
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.productsGridApi.stopEditing();
          this.startAutoSaveTimer(rowIndex, cartItem, true);
        } else {
          rowNode.data.brand = oldBrand;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not identify brand', "OK", "alert-info-snackbar");
        }
      }, error => {
        rowNode.data.brand = oldBrand;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify brand', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- SUPPLIER changes (Supplier column - Partner identification via backend) ----------
    if (field === 'supplier') {
      console.log('🔍 [OC-Products] onProductsCellValueChanged for Supplier:', event.newValue);
      const newSupplier = (event.newValue ?? '').toString().trim();
      const oldSupplier = (event.oldValue ?? '').toString().trim();

      // ✅ Cleared supplier — remove Partner, Configuration and SelectedOffer.ID but keep Purchase/PC
      if (!newSupplier) {
        if (cartItem.SelectedOffer) {
          cartItem.SelectedOffer.Partner = null;
          cartItem.SelectedOffer.ID = 0;
          cartItem.SelectedOffer.Configuration = null;
        }
        rowNode.data.supplier = '';
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true, 'supplier');
        return;
      }

      // ✅ Helper function to apply supplier result to a single cart item
      const applySupplierToItem = (itemCartItem: any, itemNode: any, identifiedOffer: any, identifiedPartner: any) => {
        if (!itemCartItem) return;
        if (!itemCartItem.SelectedOffer) itemCartItem.SelectedOffer = {};

        itemCartItem.SelectedOffer.Partner = identifiedPartner;
        itemCartItem.SelectedOffer.ID = (identifiedOffer.ID != null && identifiedOffer.ID > 0) ? identifiedOffer.ID : 0;
        itemCartItem.SelectedOffer.ListPrice = identifiedOffer.ListPrice;
        itemCartItem.SelectedOffer.Currency = identifiedOffer.Currency;
        itemCartItem.SelectedOffer.PurchaseCurrency = identifiedOffer.Currency;

        if (itemCartItem.Product?.ListPriceOffers?.[0]) {
          itemCartItem.Product.ListPriceOffers[0].PurchaseCurrency = identifiedOffer.Currency;
          itemCartItem.Product.ListPriceOffers[0].Currency = identifiedOffer.Currency;
        }

        // Update grid display fields
        if (itemNode) {
          itemNode.data.supplier = identifiedPartner?.Name || '';
          itemNode.data.purchase = identifiedOffer.ListPrice || '';
        }
      };

      // ✅ Check for multi-select bulk update
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      if (isBulkUpdate) {
        // ✅ Bulk: call IdentifyPartnerWithOffers for EACH selected item in parallel
        this.parent.loading = true;

        const requests = selectedItems.map((item: any) => {
          const itemCartItem = item.CartItem;
          const itemProductId = itemCartItem?.Product?.ID;
          const itemCurrency = itemCartItem?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;
          return this.managementService.IdentifyPartnerWithOffers({
            User: this.parent.User,
            Language: this.parent.getLanguage(),
            CellText: newSupplier,
            CompanyID: this.parent.B2BPartner?.FK_CompanyID || 0,
            ProductID: itemProductId || null,
            FallbackCurrency: itemCurrency
          });
        });

        forkJoin(requests).subscribe(responses => {
          this.parent.loading = false;
          let successCount = 0;

          responses.forEach((response: any, index: number) => {
            const item = selectedItems[index];
            const itemCartItem = item.CartItem;

            if (response["Status"] === 1 && response["Offers"] && response["Offers"].length > 0) {
              const identifiedOffer = response["Offers"][0];
              const identifiedPartner = identifiedOffer?.Partner;

              if (identifiedPartner) {
                // Find the row node by matching CartItem
                let itemNode: any = null;
                this.productsGridApi.forEachNode((node: any) => {
                  if (node.data?.CartItem === itemCartItem) {
                    itemNode = node;
                  }
                });
                applySupplierToItem(itemCartItem, itemNode, identifiedOffer, identifiedPartner);
                successCount++;
              }
            }
          });

          this.productsGridApi.refreshCells({ force: true });
          if (successCount > 0) {
            this.BulkUpdateSelectedCartItems(selectedItems);
          }
          console.log(`📦 BULK SUPPLIER UPDATE: ${successCount}/${selectedItems.length} items updated`);
        }, () => {
          this.parent.loading = false;
          this.parent.openSnackBar('Could not identify supplier for some items', "OK", "alert-info-snackbar");
        });
      } else {
        // ✅ Single item update
        const productId = cartItem?.Product?.ID;
        const fallbackCurrency = cartItem?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;
        const request = {
          User: this.parent.User,
          Language: this.parent.getLanguage(),
          CellText: newSupplier,
          CompanyID: this.parent.B2BPartner?.FK_CompanyID || 0,
          ProductID: productId || null,
          FallbackCurrency: fallbackCurrency
        };

        this.managementService.IdentifyPartnerWithOffers(request).subscribe(response => {
          if (response["Status"] === 1 && response["Offers"] && response["Offers"].length > 0) {
            const identifiedOffer = response["Offers"][0];
            const identifiedPartner = identifiedOffer?.Partner;

            if (!identifiedPartner) {
              this.parent.openSnackBar('Supplier found but missing partner details', "OK", "alert-info-snackbar");
              return;
            }

            applySupplierToItem(cartItem, rowNode, identifiedOffer, identifiedPartner);
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, true, 'supplier');
          } else {
            rowNode.data.supplier = oldSupplier;
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.parent.openSnackBar(response["Message"] || 'Could not identify supplier', "OK", "alert-info-snackbar");
          }
        }, () => {
          rowNode.data.supplier = oldSupplier;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar('Could not identify supplier', "OK", "alert-info-snackbar");
        });
      }

      return;
    }

    // ---------- ETA changes ----------
    if (field === 'eta') {
      const newETA = (event.newValue ?? '').toString().trim();
      const oldETA = (event.oldValue ?? '').toString().trim();
      if (!newETA || newETA === '------') return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newETA,
        IsProlonged: false
      };

      // Check for multi-select bulk update - if multiple items are selected, apply to all
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
        if (response["Status"] === 1 && response["LeadTime"]) {
          const leadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
          const isStock = response["IsStock"];
          const etaDisplay = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

          if (isBulkUpdate) {
            // Apply LeadTime to ALL selected items
            selectedItems.forEach((item: any) => {
              if (item.CartItem) {
                if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
                item.CartItem.SelectedOffer.LeadTime = JSON.parse(JSON.stringify(leadTime));
                item.CartItem.SelectedOffer.IsStockOffer = isStock;
                item.eta = etaDisplay;
              }
            });
            this.productsGridApi.refreshCells({ force: true });
            this.BulkUpdateSelectedCartItems(selectedItems);
          } else {
            // Single item update
            if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
            cartItem.SelectedOffer.LeadTime = leadTime;
            cartItem.SelectedOffer.IsStockOffer = isStock;
            rowNode.data.eta = etaDisplay;
            this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
            this.startAutoSaveTimer(rowIndex, cartItem, true);
          }
        } else {
          rowNode.data.eta = oldETA;
          this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Could not parse lead time', "OK", "alert-info-snackbar");
        }
      }, () => {
        rowNode.data.eta = oldETA;
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error parsing lead time', "OK", "alert-info-snackbar");
      });
      return;
    }

    // ---------- PURCHASE (ListPrice) changes ----------
    if (field === 'purchase') {
      const rawValue = (event.newValue ?? '').toString().trim();
      const newPurchase = rawValue === '' ? null : parseFloat(rawValue.replace(',', '.'));

      // If user typed invalid text, ignore
      if (newPurchase !== null && isNaN(newPurchase)) return;

      // Update CartItem.SelectedOffer.ListPrice
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ListPrice = newPurchase;

      // Also update ListPriceOffers[0] if exists
      if (cartItem.Product?.ListPriceOffers?.length > 0) {
        cartItem.Product.ListPriceOffers[0].ListPrice = newPurchase;
      }

      // ✅ Reverse-calculate PD: PD = (1 - Purchase / OfficialListPrice) × 100
      const officialListPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (newPurchase != null && officialListPrice != null && officialListPrice > 0) {
        const newPD = Math.round((1 - newPurchase / officialListPrice) * 10000) / 100;
        if (!cartItem.Price) cartItem.Price = {};
        if (!cartItem.Price.PurchaseDiscount) cartItem.Price.PurchaseDiscount = {};
        cartItem.Price.PurchaseDiscount.Value = newPD;
        rowNode.data.purchaseDiscount = newPD;
      } else {
        // Clear PD when purchase is cleared or no official list price
        if (cartItem.Price?.PurchaseDiscount) {
          cartItem.Price.PurchaseDiscount.Value = null;
        }
        rowNode.data.purchaseDiscount = null;
      }

      rowNode.data.purchase = newPurchase;
      this.productsGridApi.refreshCells({ rowNodes: [rowNode], columns: ['purchase', 'purchaseDiscount'], force: true });
      this.startAutoSaveTimer(rowIndex, cartItem, true);
      return;
    }

    // ---------- PURCHASE DISCOUNT (PD) changes ----------
    if (field === 'purchaseDiscount') {
      const parsedPD = this.parseNumberFromAnyFormat(newValue);
      if (parsedPD === null || isNaN(parsedPD)) {
        return;
      }

      // Get ListPrice to reverse-calculate purchase price
      const listPrice = cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice;
      if (listPrice == null || listPrice <= 0) {
        console.log('❌ No valid ListPrice for PD reverse calculation, skipping');
        return;
      }

      // Reverse-calculate purchase price: PurchaseCost = ListPrice × (1 - PD / 100)
      const newPurchasePrice = Math.round((listPrice * (1 - parsedPD / 100)) * 100) / 100;

      // Check for multi-select bulk update
      const selectedItems = this.getSelectedProductItems();
      const isBulkUpdate = selectedItems.length > 1;

      const applyPDToItem = (ci: any, ri: number) => {
        if (!ci) return;
        if (!ci.Price) ci.Price = {};
        if (!ci.Price.PurchaseDiscount) ci.Price.PurchaseDiscount = {};
        ci.Price.PurchaseDiscount.Value = parsedPD;

        if (!ci.SelectedOffer) ci.SelectedOffer = {};
        const itemListPrice = ci.Product?.Stats?.StandardListPrice?.UIUnitPrice;
        if (itemListPrice != null && itemListPrice > 0) {
          ci.SelectedOffer.ListPrice = Math.round((itemListPrice * (1 - parsedPD / 100)) * 100) / 100;
        }

        if (ci.Product?.ListPriceOffers?.length > 0) {
          ci.Product.ListPriceOffers[0].ListPrice = ci.SelectedOffer.ListPrice;
        }

        const node = this.productsGridApi.getDisplayedRowAtIndex(ri);
        if (node) {
          node.data.purchase = ci.SelectedOffer.ListPrice;
          node.data.purchaseDiscount = parsedPD;
        }
      };

      if (isBulkUpdate) {
        selectedItems.forEach((item: any) => {
          applyPDToItem(item.CartItem, item.rowIndex ?? this.productsGridApi.getDisplayedRowAtIndex(0)?.rowIndex);
        });
        this.productsGridApi.refreshCells({ columns: ['purchase', 'purchaseDiscount'], force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        applyPDToItem(cartItem, rowIndex);
        this.productsGridApi.refreshCells({ rowNodes: [rowNode], columns: ['purchase', 'purchaseDiscount'], force: true });
        this.startAutoSaveTimer(rowIndex, cartItem, true, 'purchaseDiscount');
      }
      return;
    }

    // ---------- NAME changes (plain text update — no product search on placed orders) ----------
    if (field === 'name') {
      const nameRowIndex = event.rowIndex;
      const newName = (event.newValue ?? '').toString().trim();
      const oldName = (event.oldValue ?? '').toString().trim();

      // Skip if empty or unchanged
      if (!newName || newName === oldName) return;

      // ✅ Update CartItem product name directly (no B2B search — these are placed orders)
      if (!cartItem.Product) cartItem.Product = {};
      cartItem.Product.Name = newName;
      cartItem.UIProductValue = newName;
      rowNode.data.name = newName;
      this.productsGridApi.refreshCells({ rowNodes: [rowNode], columns: ['name'], force: true });
      this.startAutoSaveTimer(nameRowIndex, cartItem, true, 'name');
      return;
    }
  }

  // ========== Products Grid Button Click Handler ==========
  onProductsGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const button = target.closest('[data-type]') as HTMLElement;
    if (!button) return;

    const type = button.getAttribute('data-type');
    const rowIndexStr = button.getAttribute('data-row');
    const rowIndex = rowIndexStr ? parseInt(rowIndexStr, 10) : -1;

    if (rowIndex < 0) return;

    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(rowIndex);
    const rowData = rowNode?.data;
    const cartItem = rowData?.CartItem;

    this.ProductsClickedRow = rowData;
    this.ProductsClickedRowIndex = rowIndex;

    switch (type) {
      case 'brand-collateral':
        this.ShowProductsBrandCollateral = true;
        this.calculateProductsPopupPosition(button, 'brand');
        if (cartItem) {
          this.SearchProductsBrands(cartItem);
        }
        break;

      case 'productalternatives':
        this.ShowProductsETAAlternatives = true;
        this.selectedProductsNamePopupTab = 0;
        this.calculateProductsPopupPosition(button, 'name');
        // Check for Product.ID or IndustryProductID
        const productId1 = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
        if (productId1) {
          // ✅ Default tab is Price History
          this.GetProductsItemPriceHistory(productId1);
        }
        break;

      case 'supplierAlternatives':
        this.ShowProductsSupplierAlternatives = true;
        this.calculateProductsPopupPosition(button, 'supplier');
        // Check for Product.ID or IndustryProductID
        const productId2 = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
        if (productId2) {
          const offerId2 = cartItem?.SelectedOffer?.ID || cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetProductsSideOffers(productId2, offerId2);
        }
        break;
    }
  }

  calculateProductsPopupPosition(element: HTMLElement, type: string): void {
    const gridContainer = document.querySelector('.ProductsAGGridContainer') as HTMLElement;
    if (!gridContainer) return;

    const containerRect = gridContainer.getBoundingClientRect();

    // Find the actual cell element (parent of button)
    const cellElement = element.closest('.ag-cell') as HTMLElement;
    const cellRect = cellElement ? cellElement.getBoundingClientRect() : element.getBoundingClientRect();

    const top = cellRect.bottom - containerRect.top;
    const left = cellRect.left - containerRect.left;

    switch (type) {
      case 'brand':
        this.ProductsBrandPopupPosition = { position: 'absolute', top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
      case 'name':
        this.ProductsSearchResultsPosition = { position: 'absolute', top: `${top}px`, left: '0px', width: '100%' };
        break;
      case 'supplier':
        // Width from supplier column to end of grid
        const popupWidth = containerRect.width - left;
        this.ProductsSupplierPopupPosition = { position: 'absolute', top: `${top}px`, left: `${left}px`, width: `${popupWidth}px` };
        break;
    }
  }

  closeProductsPopups(): void {
    this.ShowProductsETAAlternatives = false;
    this.ShowProductsSupplierAlternatives = false;
    this.ShowProductsBrandCollateral = false;
    this.ProductsSupplierPopupSearchTerm = '';
    this.ProductsSupplierPopupSearchResults = [];
    this.selectedProductsNamePopupTab = 0;
    this.ProductsPriceHistory = [];
    this.showPurchaseCurrencyDropdown = false;
    this.ShowChainHistory = false;
  }

  // ✅ Handle Products Name popup tab change (matching EditSectionProducts pattern)
  onProductsNamePopupTabChange(tabIndex: number): void {
    this.selectedProductsNamePopupTab = tabIndex;

    const cartItem = this.ProductsClickedRow?.CartItem;
    if (!cartItem) return;

    const productId = cartItem?.Product?.ID || cartItem?.IndustryProductID || cartItem?.SelectedOffer?.IndustryProductID;
    const offerId = cartItem?.SelectedOffer?.ID || cartItem?.Product?.ListPriceOffers?.[0]?.ID;

    if (tabIndex === 0) {
      // Tab 0: Price History - past transactions snapshot for this product
      if (productId) {
        this.GetProductsItemPriceHistory(productId);
      }
    } else if (tabIndex === 1) {
      // Tab 1: Other Offers - same product, different suppliers/configs
      if (productId) {
        this.GetProductsSideOffers(productId, offerId);
      }
    } else if (tabIndex === 2) {
      // Tab 2: Similar Products - alternative products from SearchResults
      const productIds = (cartItem?.SearchResults ?? []).map((s: any) => s.ProductID || s.IndustryProductID);
      if (productIds?.length > 0) {
        this.GetProductsSimilarProducts(productIds, offerId, cartItem?.Product?.Brand);
      } else if (productId) {
        // Fallback: use current product ID if no SearchResults
        this.GetProductsSimilarProducts([productId], offerId, cartItem?.Product?.Brand);
      }
    }
  }

  // ✅ Load chain history for the currently clicked cart item
  loadChainHistory(): void {
    const cartItem = this.ProductsClickedRow?.CartItem;
    if (!cartItem?.ID || cartItem.ID <= 0) {
      this.parent.openSnackBar('Item not saved yet — no chain history available', 'OK', 'alert-info-snackbar');
      return;
    }

    this.ShowChainHistory = true;
    this.ChainHistoryLoading = true;
    this.ChainHistoryOrderChain = [];
    this.ChainHistoryItemChain = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItemID: cartItem.ID,
      OrderTypeID: -1 // OC
    };

    this.managementService.GetItemChainHistory(request).subscribe((response: any) => {
      this.ChainHistoryLoading = false;
      if (response['Status'] === 1) {
        this.ChainHistoryOrderChain = response['OrderChain'] || [];
        this.ChainHistoryItemChain = response['ItemChain'] || [];
      } else {
        this.ChainHistoryOrderChain = [];
        this.ChainHistoryItemChain = [];
      }
    }, () => {
      this.ChainHistoryLoading = false;
      this.ChainHistoryOrderChain = [];
      this.ChainHistoryItemChain = [];
    });
  }

  getChainItemQuantities(stepDBID: number): any {
    if (!this.ChainHistoryItemChain?.length) return null;
    const item = this.ChainHistoryItemChain.find(i => i.FKOrderGroupsDBID === stepDBID);
    return item || null;
  }

  getOrderTypeName(typeId: number): string {
    switch (typeId) {
      case 4: return 'Offer Request';
      case 2: return 'Offer';
      case -1: return 'Order Confirmation';
      case 1: return 'Purchase Order';
      default: return 'Unknown';
    }
  }

  getOrderTypeIcon(typeId: number): string {
    switch (typeId) {
      case 4: return 'mail_outline';
      case 2: return 'description';
      case -1: return 'assignment_turned_in';
      case 1: return 'local_shipping';
      default: return 'help_outline';
    }
  }

  getOrderTypeColor(typeId: number): string {
    switch (typeId) {
      case 4: return '#7c4dff';
      case 2: return '#2196f3';
      case -1: return '#4caf50';
      case 1: return '#f60';
      default: return '#999';
    }
  }

  // ✅ Get similar products for Products grid popup (using collateral API)
  GetProductsSimilarProducts(productIds: number[], offerId: number, brand: any): void {
    this.ProductsLoadingSideOffers = true;
    this.ProductsSideOffers = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductIDs: productIds,
      SelectedOfferID: offerId,
      UISelectedBrand: brand,
      BestOfferOnly: true,
      GetAlsoCollateralSpecialOffers: true,
      GetOnlySpecialOffers: false,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: null,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.B2BService.GetIndustryProductCalculatedSideOffersWithCollateral(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"] || []));
        this.ProductsSideOffers = cartItems;
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  SearchProductsBrands(cartItem: any): void {
    this.ProductsLoadingSideOffers = true;
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.Product?.PartNumber || ''
    };

    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        this.ProductsBrandCollateralList = response["Brands"] || [];
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  // ✅ Load the price-history snapshot for a product (default Price History tab)
  GetProductsItemPriceHistory(ProductID: number): void {
    this.ProductsLoadingPriceHistory = true;
    this.ProductsPriceHistory = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ProductID: ProductID,
    };

    this.managementService.GetOrderConfirmationItemHistoryPrices(request).subscribe(response => {
      if (response["Status"] === 1) {
        this.ProductsPriceHistory = response["HistoryPrices"] || [];
      }
      this.ProductsLoadingPriceHistory = false;
    });
  }

  // ✅ Apply a historical record to the current Products row: switch SelectedOffer (ID, Partner, ListPrice, PurchaseCurrency) + auto-save
  selectProductsPriceHistory(historyItem: any): void {
    if (this.isCanceled) return;
    if (!this.ProductsClickedRow?.CartItem) return;

    const rowIndex = this.ProductsClickedRowIndex;
    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};

    // Switch the selected offer to the historical one
    cartItem.SelectedOffer.ID = historyItem?.SelectedOfferID || 0;

    // Supplier / Partner
    cartItem.SelectedOffer.Partner = {
      ID: historyItem?.SupplierPartnerID || null,
      Name: historyItem?.SupplierName || ''
    };

    // Purchase price -> ListPrice
    cartItem.SelectedOffer.ListPrice = historyItem?.PurchasePrice ?? null;

    // Purchase currency
    if (historyItem?.PurchaseCurrencyID) {
      cartItem.SelectedOffer.PurchaseCurrency = {
        ID: historyItem.PurchaseCurrencyID,
        Symbol: historyItem.PurchaseCurrencySymbol || '',
        Name: historyItem.PurchaseCurrencyName || ''
      };
    }

    // Keep ListPriceOffers[0] in sync (used by fallback valueGetters)
    if (cartItem.Product?.ListPriceOffers?.length > 0) {
      cartItem.Product.ListPriceOffers[0].ID = cartItem.SelectedOffer.ID;
      cartItem.Product.ListPriceOffers[0].Partner = JSON.parse(JSON.stringify(cartItem.SelectedOffer.Partner));
      cartItem.Product.ListPriceOffers[0].ListPrice = cartItem.SelectedOffer.ListPrice;
      if (cartItem.SelectedOffer.PurchaseCurrency) {
        cartItem.Product.ListPriceOffers[0].PurchaseCurrency = JSON.parse(JSON.stringify(cartItem.SelectedOffer.PurchaseCurrency));
      }
    }

    // Update displayed row values (Supplier + Purchase columns)
    rowNode.data.supplier = cartItem.SelectedOffer.Partner?.Name || '';
    rowNode.data.purchase = cartItem.SelectedOffer.ListPrice ?? '';
    this.ProductsClickedRow.supplier = rowNode.data.supplier;
    this.ProductsClickedRow.purchase = rowNode.data.purchase;

    this.productsGridApi?.refreshCells({ rowNodes: [rowNode], force: true });

    // Close the popup
    this.ShowProductsETAAlternatives = false;
    this.ShowProductsSupplierAlternatives = false;

    // ✅ Trigger auto-save
    this.startAutoSaveTimer(rowIndex, cartItem, true, 'supplier');
  }

  GetProductsSideOffers(IndustryProductID: number, offerId: number): void {
    this.ProductsLoadingSideOffers = true;
    this.ProductsSupplierPopupSearchTerm = '';
    this.ProductsSupplierPopupSearchResults = [];

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductID: IndustryProductID,
      SelectedOfferID: offerId,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: null,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"] || []));
        // Sort by ListPrice ascending (best price first) - same as original
        this.ProductsSideOffers = cartItems.sort((a: any, b: any) => {
          const priceA = a?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          const priceB = b?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          return priceA - priceB;
        });
      }
      this.ProductsLoadingSideOffers = false;
    });
  }

  // Search suppliers in Products grid popup
  SearchProductsSupplierPopup(): void {
    if (!this.ProductsSupplierPopupSearchTerm || this.ProductsSupplierPopupSearchTerm.length < 2) {
      this.ProductsSupplierPopupSearchResults = [];
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      SearchTerm: this.ProductsSupplierPopupSearchTerm,
      PageIndex: 1,
      PageSize: 50
    };

    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      if (response["Status"] === 1) {
        this.ProductsSupplierPopupSearchResults = response["Partners"] || [];
      }
    });
  }

  // Select partner from search in Products grid
  SelectProductsPartnerFromSearch(partner: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    // Check for multi-select bulk update - if multiple items are selected, apply to all
    const selectedItems = this.getSelectedProductItems();
    const cartItem = this.ProductsClickedRow.CartItem;
    const isBulkUpdate = selectedItems.length > 1;

    if (isBulkUpdate) {
      // Apply Supplier to ALL selected items
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
          item.CartItem.SelectedOffer.Partner = JSON.parse(JSON.stringify(partner));
          item.supplier = partner?.Name ?? '';
        }
      });
      this.productsGridApi?.refreshCells({ force: true });
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsSupplierPopupSearchTerm = '';
      this.ProductsSupplierPopupSearchResults = [];
      this.BulkUpdateSelectedCartItems(selectedItems);
    } else {
      // Single item update
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.Partner = partner;

      this.ProductsClickedRow.supplier = partner?.Name ?? '';
      this.productsGridApi?.refreshCells({ force: true });
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsSupplierPopupSearchTerm = '';
      this.ProductsSupplierPopupSearchResults = [];

      // ✅ Trigger 2-second auto-save timer
      this.startAutoSaveTimer(this.ProductsClickedRowIndex, cartItem, true);
    }
  }

  selectProductsBrand(brand: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    const cartItem = this.ProductsClickedRow.CartItem;
    if (!cartItem.Product) cartItem.Product = {};
    cartItem.Product.Brand = brand;

    this.ProductsClickedRow.brand = brand?.Name ?? '';
    this.productsGridApi?.refreshCells({ force: true });
    this.ShowProductsBrandCollateral = false;
  }

  selectProductsSideOffer(item: any): void {
    if (!this.ProductsClickedRow?.CartItem) return;

    const cartItem = this.ProductsClickedRow.CartItem;

    // Get CartItem.ID for preserving after update
    const cartItemID = cartItem?.ID || 0;

    // Get the clicked item's currency for PrefferedCurrency
    const clickedItemCurrency = item?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Ensure CartItem.Product.ListPriceOffers has at least one element (backend requires this)
    if (!cartItem.Product) {
      cartItem.Product = {};
    }
    if (!cartItem.Product.ListPriceOffers || cartItem.Product.ListPriceOffers.length === 0) {
      cartItem.Product.ListPriceOffers = [cartItem.SelectedOffer || {}];
    }

    // ✅ Build request like create-new-quotation does
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      SelectedOffer: item.Product?.ListPriceOffers?.[0] || item.SelectedOffer,
      CartItem: cartItem,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: clickedItemCurrency,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.ProductsLoadingSideOffers = true;

    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
      if (response["Status"] == 1) {
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;

        // ✅ Preserve the original CartItem.ID
        c.ID = cartItemID;

        // Apply to row
        this.applyProductsSearchResultToRow(this.ProductsClickedRowIndex, c);
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error switching offer', "OK", "alert-info-snackbar");
      }

      this.ShowProductsETAAlternatives = false;
      this.ShowProductsSupplierAlternatives = false;
      this.ProductsLoadingSideOffers = false;
    });
  }

  /**
   * Apply search result to Products tab row
   */
  applyProductsSearchResultToRow(rowIndex: number, resultCartItem: any): void {
    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    // Preserve original order info columns
    const originalOfferDBID = rowNode.data.OfferDBID;
    const originalOfferID = rowNode.data.OfferID;
    const originalReferenceNumber = rowNode.data.ReferenceNumber;
    const originalDebatorPO = rowNode.data.DebatorPO;
    const originalPartnerName = rowNode.data.PartnerName;
    const originalOfferEventRegister = rowNode.data.OfferEventRegister;
    const originalCartItemID = rowNode.data.CartItem?.ID;
    const originalUIID = rowNode.data.CartItem?.UIID;
    const originalCartItemOrderInfo = rowNode.data.CartItem?.CartItemOrderInfo;

    // Copy new product data from result
    const c = JSON.parse(JSON.stringify(resultCartItem));
    c.LoadingCell = false;
    c.ID = originalCartItemID;
    c.UIID = originalUIID;
    // Preserve CartItemOrderInfo from original row
    c.CartItemOrderInfo = originalCartItemOrderInfo;

    // Extract display values from CartItem (same as create-new-quotation)
    const brand = c?.Product?.Brand?.Name ?? '';
    const name = c?.Product?.Name ?? '';
    const partNumber = c?.Product?.PartNumber ?? '';
    const quantity = c?.Quantity ?? rowNode.data.quantity ?? '';
    const price = c?.SelectedOffer?.SellingPrice || c?.Price?.UIUnitPrice || '';
    const total = (() => { const sp = c?.SelectedOffer?.SellingPrice || c?.Price?.UIUnitPrice; const q = c?.Quantity || 0; return sp > 0 && q > 0 ? parseFloat((sp * q).toFixed(4)).toString() : ''; })();
    const eta = c?.SelectedOffer?.LeadTime?.UIOutput ??
      (c?.SelectedOffer?.LeadTime?.Units > 0
        ? `${c.SelectedOffer.LeadTime.Units} ${c.SelectedOffer.LeadTime.Type?.Name || ''}`
        : '------');
    const supplier = c?.SelectedOffer?.Partner?.Name ?? '';
    const purchase = c?.SelectedOffer?.ListPrice ?? '';
    const hscode = c?.Product?.Stats?.HSCode ?? '';
    const coo = c?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = c?.Product?.Stats?.Weight != null
      ? `${c.Product.Stats.Weight} ${c.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
      : '';

    // ✅ Use setData like quotations/new to properly update the row
    rowNode.setData({
      index: rowNode.data.index,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      supplier,
      purchase,
      hscode,
      coo,
      weight,
      // Preserve order info columns
      OfferDBID: originalOfferDBID,
      OfferID: originalOfferID,
      ReferenceNumber: originalReferenceNumber,
      DebatorPO: originalDebatorPO,
      PartnerName: originalPartnerName,
      OfferEventRegister: originalOfferEventRegister,
      CartItem: c
    });

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(rowIndex, c, true);
  }

  // Cell Renderers
  BrandCellRenderer(params: any): string {
    const brand = (params.value ?? '').toString().trim();

    return `
      <span class="brand-cell-content">
        <span class="brand-text">${brand}</span>
      </span>
    `;
  }

  NameCellRenderer(params: any): string {
    const name = params.value?.toString().trim() ?? '';
    const isEmpty = name.length === 0;
    const rowIndex = params.rowIndex;
    const placeholder = 'Search product or part number...';

    const displayText = isEmpty
      ? `<span class="name-placeholder">${placeholder}</span>`
      : `<span class="name-text">${name}</span>`;

    // Return text + button as siblings, no wrapper
    return `${displayText}<button class="dropdown-trigger material-icon-trigger" style="position: absolute; right: 5px; top: 2.5px;" data-row="${rowIndex}" data-type="productalternatives" title="View Product-Alternatives"><i class="material-icons">expand_more</i></button>`;
  }

  ETACellRenderer(params: any): string {
    const cartItem = params.data?.CartItem;
    const base = (params.data?.eta || '').toString().trim();
    const isStock = cartItem?.SelectedOffer?.IsStockOffer;
    const isManufacturerStock = cartItem?.SelectedOffer?.IsManufacturerStockOffer === true;
    const showStock = isStock && isManufacturerStock !== true;

    let stockSuffix = '';
    if (showStock) {
      const stockQty = cartItem?.SelectedOffer?.StockQuantity;
      // Show (S) for stock, then (X) for quantity if available
      stockSuffix = (base ? ' ' : '') + '(S)';
      if (stockQty != null && stockQty > 0) {
        stockSuffix += `(${stockQty})`;
      }
    }

    const etaText = (base + stockSuffix).trim() || '------';

    return `
      <span class="name-cell-content">
        <span class="${base ? 'eta-text' : 'eta-placeholder'}">${etaText}</span>
      </span>
    `;
  }

  SupplierCellRenderer(params: any): string {
    const supplier = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;
    return `<span style="display: flex; align-items: center; width: calc(100% - 22px); height: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${supplier || ''}</span><button class="dropdown-trigger material-icon-trigger" style="position: absolute; right: 5px; top: 2.5px;" data-row="${rowIndex}" data-type="supplierAlternatives" title="View Supplier Alternatives"><i class="material-icons">expand_more</i></button>`;
  }

  priceCellRenderer(params: any): string {
    const price = params.value ?? '';
    const cartItem = params.data?.CartItem;
    const rowIndex = params.rowIndex;

    let showTriangle = false;
    let tooltipText = '';
    let priceClass = '';

    if (Array.isArray(cartItem?.SearchResults)) {
      const special = cartItem.SearchResults.find((x: any) => x.SpecialOffer === true && x.MOQ > 1 && x.FKBrandID == cartItem?.Product?.Brand?.ID);
      if (special && special?.Price?.UIUnitPrice < cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice) {
        showTriangle = true;
        const unitPrice = special?.Price?.UIUnitPrice;
        const currencyName = special?.Price?.Currency?.Symbol ?? special?.Price?.Currency?.Name ?? '';
        const priceStr = typeof unitPrice === 'number' && isFinite(unitPrice) ? unitPrice.toFixed(2) : (unitPrice ?? '');
        tooltipText = `Special: ${priceStr} ${currencyName} - min. x${special?.MOQ ?? 0}`;
      }
    }

    const isSpecialList = cartItem?.SelectedOffer?.Configuration?.SpecialPriceList === true;
    if (isSpecialList) {
      showTriangle = true;
      if (!tooltipText) {
        tooltipText = 'Special price available';
      }
      priceClass = 'special-price-highlight';
    }

    const triangle = showTriangle
      ? `<button class="price-corner-triangle dropdown-trigger"
                 data-row="${rowIndex}"
                 data-type="productSpecials"
                 data-tooltip="${tooltipText}"
                 aria-label="${tooltipText}"></button>`
      : '';

    return `
      <div class="price-cell-wrapper">
        <span class="${priceClass}">${price}</span>
        ${triangle}
      </div>
    `;
  }

  officialListPriceCellRenderer(params: any): string {
    // ✅ List-Price: Manufacturer's list price from Product.Stats.StandardListPrice
    let amount = params.data?.officialListPrice;
    if (amount == null || amount === '') {
      // Fallback: Live product stats
      const olp = params.data?.CartItem?.Product?.Stats?.StandardListPrice;
      amount = olp?.UIUnitPrice;
    }

    if (amount == null || amount === '' || (typeof amount !== 'number' && isNaN(Number(amount)))) {
      return '';
    }

    const amtStr = typeof amount === 'number' ? amount.toFixed(2) : Number(amount).toFixed(2);
    return `<span class="official-list-price">${amtStr}</span>`;
  }

  officialDiscountCellRenderer(params: any): string {
    const cartItem = params.data?.CartItem;
    // ✅ First try row data field (set in loadOfferGridData), then fallback to nested CartItem path
    let discount = params.data?.officialDiscount;
    if (discount == null || discount === '') {
      discount = cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value;
    }
    const adminPriceEdit = cartItem?.AdminPriceEdit === true;
    const rowIndex = params.rowIndex;

    if (discount == null || discount === '' || discount === 0) {
      return '';
    }

    const discountStr = typeof discount === 'number' ? discount.toFixed(2) : Number(discount).toFixed(2);
    const revertIcon = adminPriceEdit
      ? `<i class="material-icons revert-pencil"
            data-row="${rowIndex}"
            data-type="revert-discount"
            style="font-size: 14px; color: #f60; cursor: pointer; margin-left: 4px;"
            title="Revert to original">edit</i>`
      : '';

    return `<span class="discount-cell-content">${discountStr}%${revertIcon}</span>`;
  }

  // Open Red Row Edit Popup
  OpenRedRowEditPopup(cartItem: any, rowIndex: number): void {
    this.CurrentRedRowCartItem = cartItem;
    this.CurrentRedRowIndex = rowIndex;
    this.ShowRedRowEditPopup = true;
  }

  COOCellRenderer(params: any): string {
    const coo = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;

    // ✅ Always clickable - treat all rows as CartItemStatus.ID === 1
    return `
      <span class="coo-cell-clickable"
            data-row="${rowIndex}"
            data-type="coo-search"
            style="display: flex; align-items: center; width: 100%; height: 100%; cursor: pointer;"
            title="Click to select country of origin">
        <span class="coo-text">${coo}</span>
      </span>
    `;
  }

  // Add more rows functionality - adds to CurrentOrder.Cart.Items
  addMoreRows(count: number = 50): void {
    if (!this.offerGridApi) return;

    // ✅ Ensure CurrentOrder.Cart.Items exists
    if (!this.CurrentOrder) {
      this.CurrentOrder = {};
    }
    if (!this.CurrentOrder.Cart) {
      this.CurrentOrder.Cart = {};
    }
    if (!this.CurrentOrder.Cart.Items) {
      this.CurrentOrder.Cart.Items = [];
    }

    const currentCount = this.offerGridApi.getDisplayedRowCount();
    const newRows: any[] = [];

    // Pre-populate values from CurrentOrder
    const partnerName = this.CurrentOrder?.Cart?.Partner?.Name || '';
    const offerID = this.CurrentOrder?.ID || '';
    const offerDBID = this.CurrentOrder?.DBID || 0;
    const referenceNumber = this.CurrentOrder?.ReferenceNumber || '';
    const debatorPO = this.CurrentOrder?.DebatorPO || '';
    const cartID = this.CurrentOrder?.Cart?.ID || 0;
    const offerEventRegister = this.CurrentOrder?.EventRegister || null;

    for (let i = 0; i < count; i++) {
      // ✅ Create empty CartItem object (like create-new-quotation)
      const emptyCartItem: any = {
        Product: {
          Brand: {},
          Stats: {}
        },
        SelectedOffer: {
          LeadTime: {}
        },
        Quantity: null,
        Price: {},
        // ✅ Pre-populate CartItemOrderInfo for backend save operations
        CartItemOrderInfo: {
          OrderID: offerID,
          OrderDBID: offerDBID,
          ReferenceNumber: referenceNumber,
          DebatorPO: debatorPO,
          OrderPartner: this.CurrentOrder?.Cart?.Partner || {},
          OrderEventRegister: offerEventRegister
        }
      };

      const row = {
        index: currentCount + i + 1,
        brand: '',
        partNumber: '',
        name: '',
        quantity: null,
        officialListPrice: null,
        officialDiscount: null,
        price: null,
        total: null,
        eta: '',
        supplier: '',
        purchase: null,
        hscode: '',
        coo: '',
        weight: '',
        CartItem: emptyCartItem,
        // ✅ Pre-populate offer context columns (like existing rows)
        PartnerName: partnerName,
        OfferID: offerID,
        OfferDBID: offerDBID,
        ReferenceNumber: referenceNumber,
        DebatorPO: debatorPO,
        CartID: cartID,
        OfferEventRegister: offerEventRegister
      };

      // ✅ Add to CurrentOrder.Cart.Items
      this.CurrentOrder.Cart.Items.push(emptyCartItem);

      this.CartItemRows.push(row);
      newRows.push(row);
    }

    // 🔥 Update the grid
    this.offerGridApi.applyTransaction({ add: newRows });
    console.log('✅ Added', count, 'rows to grid and CurrentOrder.Cart.Items');
  }

  deleteRow(rowIndex: number): void {
    if (!this.offerGridApi) return;

    const rowNode = this.offerGridApi.getDisplayedRowAtIndex(rowIndex);
    if (rowNode) {
      this.offerGridApi.applyTransaction({ remove: [rowNode.data] });
    }
  }

  // Clear grid
  ClearGrid(): void {
    this.CartItemRows = [];
    this.offerGridRowData = [];
    if (this.offerGridApi) {
      this.offerGridApi.setRowData([]);
    }
  }

  // ✅ Update Offer Shipping Address and Shipping Settings
  UpdateOfferShippingAddress(): void {
    if (!this.CurrentOrder?.ShippingAddress) {
      this.parent.openSnackBar('No shipping address to save', 'OK', 'alert-info-snackbar');
      return;
    }

    if (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0) {
      this.parent.openSnackBar('Offer not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      // ✅ Pass OrderConfirmation structure as expected by backend
      OrderConfirmation: {
        DBID: this.CurrentOrder.DBID,
        ShippingAddress: this.CurrentOrder.ShippingAddress,
        Cart: {
          Partner: { ID: this.CurrentOrder.Cart?.Partner?.ID },
          ShippingResponsability: this.CurrentOrder.Cart?.ShippingResponsability,
          ShippingServiceType: this.CurrentOrder.Cart?.ShippingServiceType,
          ShippingCompany: this.CurrentOrder.Cart?.ShippingCompany,
          ShippingCost: this.CurrentOrder.Cart?.ShippingCost,
          HasInsurance: this.CurrentOrder.Cart?.HasInsurance,
          PaymentTerm: this.CurrentOrder.Cart?.PaymentTerm,
          Weight: this.CurrentOrder.Cart?.Weight,
          WeightMeasurementType: this.CurrentOrder.Cart?.WeightMeasurementType
        }
      }
    };

    this.parent.loading = true;
    this.managementService.UpdateOrderConfirmationShippingAddress(request).subscribe((response: any) => {
      this.parent.loading = false;
      if (response["Status"] === 1) {
        this.parent.openSnackBar(response["Message"] || 'Shipping information saved', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error saving shipping information', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      console.error('UpdateOrderConfirmationShippingAddress error:', error);
      this.parent.openSnackBar('Error saving shipping information', 'OK', 'alert-info-snackbar');
    });
  }

  // Grid cell button click handler
  onGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const button = target.closest('[data-type]') as HTMLElement;
    if (!button) return;

    const type = button.getAttribute('data-type');
    const rowIndexStr = button.getAttribute('data-row');
    const rowIndex = rowIndexStr ? parseInt(rowIndexStr, 10) : -1;

    if (rowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(rowIndex);
    const rowData = rowNode?.data;
    const cartItem = rowData?.CartItem;

    this.ClickedRow = rowData;
    this.ClickedRowIndex = rowIndex;

    switch (type) {
      case 'delete-row':
        this.deleteRow(rowIndex);
        break;

      case 'brand-collateral':
        this.ShowBrandCollateral = true;
        this.calculatePopupPosition(button, 'brand');
        // ✅ Load brand collateral
        if (cartItem) {
          this.SearchIndustryProductB2BBrandsVersion2(rowIndex, cartItem);
        }
        break;

      case 'productalternatives':
        this.ShowETAAlternatives = true;
        this.ShowSearchResultsAlternatives = false;
        this.selectedNamePopupTab = 1;
        this.calculatePopupPosition(button, 'name');
        // ✅ Load side offers for Name popup Tab 1 (Other Offers)
        if (cartItem?.Product?.ID) {
          const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetIndustryProductCalculatedSideOffers(rowIndex, cartItem.Product.ID, offerId);
        }
        break;

      case 'fallback':
        this.ShowFallbackSelection = true;
        this.calculatePopupPosition(button, 'name');
        break;

      case 'supplierAlternatives':
        this.ShowSupplierAlternatives = true;
        this.calculatePopupPosition(button, 'supplier');
        // ✅ Load side offers for supplier alternatives
        if (cartItem?.Product?.ID) {
          const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
          this.GetIndustryProductCalculatedSideOffers(rowIndex, cartItem.Product.ID, offerId);
        }
        break;

      case 'supplier-search':
        this.PartnerSearchRowIndex = rowIndex;
        this.ShowPartnerSearchPopup = true;
        this.calculatePopupPosition(button, 'supplier');
        break;

      case 'clear-supplier':
        if (cartItem?.SelectedOffer) {
          cartItem.SelectedOffer.Partner = null;
        }
        this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        break;

      case 'coo-search':
        this.COOSearchRowIndex = rowIndex;
        this.ShowCOOSearchPopup = true;
        this.calculatePopupPosition(button, 'coo');
        break;

      case 'productSpecials':
        this.ShowSearchResultsAlternatives = true;
        this.selectedNamePopupTab = 1;
        this.calculatePopupPosition(button, 'name');
        break;

      case 'revert-discount':
        // Revert discount to original value
        if (cartItem) {
          cartItem.AdminPriceEdit = false;
          this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        }
        break;
    }
  }

  // Calculate popup position relative to clicked element
  calculatePopupPosition(element: HTMLElement, type: string): void {
    const rect = element.getBoundingClientRect();

    // Find the closest ProductsAGGridContainer (works for both popup and Products tab grids)
    const gridContainer = element.closest('.ProductsAGGridContainer') || document.querySelector('.ProductsAGGridContainer');
    const containerRect = gridContainer?.getBoundingClientRect() || { top: 0, left: 0, width: 1000 };

    const top = rect.bottom - containerRect.top + 5;
    const left = rect.left - containerRect.left;

    switch (type) {
      case 'brand':
        this.BrandPopupPosition = { top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
      case 'name':
        // ✅ Name popup spans full grid width
        this.SearchResultsPosition = { top: `${top}px`, left: '0px', width: '100%' };
        break;
      case 'supplier':
        this.SupplierPopupPosition = { top: `${top}px`, left: `${left}px`, width: '450px' };
        break;
      case 'coo':
        this.COOPopupPosition = { top: `${top}px`, left: `${left}px`, width: '250px' };
        break;
    }
  }

  // Close all popups
  closeAllPopups(): void {
    this.ShowSearchResultsAlternatives = false;
    this.ShowETAAlternatives = false;
    this.ShowSupplierAlternatives = false;
    this.ShowFallbackSelection = false;
    this.ShowBrandCollateral = false;
    this.ShowBrandCollateralNewProduct = false;
    this.ShowRedRowETAPopup = false;
    this.ShowWeightPopup = false;
    this.ShowRedRowEditPopup = false;
    this.ShowPartnerSearchPopup = false;
    this.ShowCOOSearchPopup = false;
  }

  // Select alternative offer
  selectAlternativeOffer(offer: any): void {
    if (!this.ClickedRow || this.ClickedRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      cartItem.SelectedOffer = offer;
      cartItem.Price = offer.Price || offer.SellPrice;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.closeAllPopups();
  }

  // Select partner for red row
  selectPartner(partner: any): void {
    if (this.PartnerSearchRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.PartnerSearchRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      if (!cartItem.SelectedOffer) {
        cartItem.SelectedOffer = {};
      }
      cartItem.SelectedOffer.Partner = partner;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.ShowPartnerSearchPopup = false;
    this.PartnerSearchRowIndex = -1;
  }

  // Select COO for row
  selectCOO(country: any): void {
    if (this.COOSearchRowIndex < 0) return;

    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.COOSearchRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (cartItem) {
      if (!cartItem.Product) {
        cartItem.Product = {};
      }
      if (!cartItem.Product.Stats) {
        cartItem.Product.Stats = {};
      }
      cartItem.Product.Stats.COO = country;
    }

    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
    this.ShowCOOSearchPopup = false;
    this.COOSearchRowIndex = -1;
  }

  // ✅ Get side offers for supplier alternatives popup
  GetIndustryProductCalculatedSideOffers(rowIndex: number, IndustryProductID: number, offerId: number): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      IndustryProductID: IndustryProductID,
      SelectedOfferID: offerId,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: this.CurrentOrder?.Cart?.Currency,
        ConfigStatus: { ID: -9000 } // VisibleOnlyForAdminPurchases
      }
    };

    this.SideOffers = [];
    this.LoadingSideOffers = true;

    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe(response => {
      if (response["Status"] == 1) {
        const cartItems = JSON.parse(JSON.stringify(response["CartItems"]));
        // Sort by ListPrice ascending (best price first)
        this.SideOffers = cartItems.sort((a: any, b: any) => {
          const priceA = a?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          const priceB = b?.SelectedOffer?.ListPrice ?? Number.MAX_VALUE;
          return priceA - priceB;
        });
        this.OriginalSideOffers = JSON.parse(JSON.stringify(this.SideOffers));
        this.SupplierPopupSearchTerm = '';
        this.SupplierPopupSearchResults = [];
      }
      this.LoadingSideOffers = false;
    });
  }

  // ✅ Search partners in supplier popup
  SearchSupplierPopup(): void {
    const searchTerm = this.SupplierPopupSearchTerm?.trim() || '';

    if (searchTerm.length === 0) {
      this.SupplierPopupSearchResults = [];
      return;
    }

    if (searchTerm.length < 2) {
      this.SupplierPopupSearchResults = [];
      return;
    }

    const request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: null
    };

    this.LoadingSupplierPopupSearch = true;

    this.service.GetPartnersFiltered(request).subscribe(response => {
      if (response["Status"] === 1) {
        this.SupplierPopupSearchResults = response["Partners"] ?? [];
      }
      this.LoadingSupplierPopupSearch = false;
    });
  }

  // ✅ Select a side offer from the Supplier Alternatives popup
  SelectSideOffer(selectedCartItem: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    // Update CartItem.SelectedOffer with the clicked popup row's SelectedOffer
    cartItem.SelectedOffer = JSON.parse(JSON.stringify(selectedCartItem.SelectedOffer));

    // Update CartItem.Product.ListPriceOffers[0] with the clicked popup row's SelectedOffer
    if (cartItem.Product && cartItem.Product.ListPriceOffers && cartItem.Product.ListPriceOffers.length > 0) {
      cartItem.Product.ListPriceOffers[0] = JSON.parse(JSON.stringify(selectedCartItem.SelectedOffer));
    }

    // Update row data fields
    rowNode.data.supplier = selectedCartItem.SelectedOffer?.Partner?.Name || '';
    rowNode.data.purchase = selectedCartItem.SelectedOffer?.ListPrice || '';
    const leadTime = selectedCartItem.SelectedOffer?.LeadTime;
    rowNode.data.eta = leadTime?.UIOutput ?? (leadTime?.Units > 0 ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}` : '------');

    // Refresh the grid row
    rowNode.setData(rowNode.data);
    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });

    // Close the popup
    this.ShowSupplierAlternatives = false;

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(this.ClickedRowIndex, cartItem, false);
  }

  // ✅ Open the Bulk Best Price popup (Config Status + Stock Status thresholds)
  openBulkBestPricePopup(): void {
    this.bulkBestPriceConfigStatuses = this.parent?.CartMasterData?.ConfigStatuses || [];
    this.bulkBestPriceStockStatuses = this.parent?.CartMasterData?.B2BStockStatuses || [];

    // Pre-select Config Status threshold (VisibleOnlyForAdminPurchases = -9000), fallback to first
    this.selectedBulkConfigStatus = this.bulkBestPriceConfigStatuses.find((c: any) => c.ID === -9000)
      || this.bulkBestPriceConfigStatuses[0] || null;

    // Pre-select Stock Status = AllOffers (-1) by default
    this.selectedBulkStockStatus = this.bulkBestPriceStockStatuses.find((s: any) => s.ID === -1)
      || this.bulkBestPriceStockStatuses[0] || null;

    this.ShowBulkBestPricePopup = true;
  }

  // ✅ Close the Bulk Best Price popup
  closeBulkBestPricePopup(): void {
    this.ShowBulkBestPricePopup = false;
  }

  // ✅ Bulk lookup of the best calculated offer per selected product and place it on Purchase + PC columns
  async applyBulkBestPrice(): Promise<void> {
    const selectedItems = this.getSelectedProductItems();
    if (!selectedItems || selectedItems.length === 0) {
      this.ShowBulkBestPricePopup = false;
      return;
    }

    // Build product id + connected brand pairs (test for nulls)
    const products = selectedItems
      .filter((item: any) => item?.CartItem?.Product?.ID != null && item.CartItem.Product.ID > 0)
      .map((item: any) => ({
        IndustryProductID: item.CartItem.Product.ID,
        Brand: item.CartItem.Product?.Brand || null
      }));

    if (products.length === 0) {
      this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
      this.ShowBulkBestPricePopup = false;
      return;
    }

    // ── Connect SignalR for real-time progress ──
    let signalRConnectionId = '';
    try {
      signalRConnectionId = await this.signalRService.connect();
      console.log('💰 BulkBestPrice - SignalR connected:', signalRConnectionId);
    } catch (error) {
      console.warn('💰 BulkBestPrice - SignalR connection failed, proceeding without progress', error);
    }

    // Show progress overlay
    this.bulkBestPriceProgressPercent = 0;
    this.bulkBestPriceProgressCompleted = 0;
    this.bulkBestPriceProgressTotal = products.length;
    this.bulkBestPriceProgressMessage = this.translate.instant('BulkBestPriceStarting');
    this.showBulkBestPriceProgress = true;
    this.ShowBulkBestPricePopup = false;

    // Subscribe to SignalR progress updates
    let progressSubscription: any = null;
    if (signalRConnectionId) {
      progressSubscription = this.signalRService.searchItemCompleted$.subscribe(
        (update) => {
          this.ngZone.run(() => {
            this.bulkBestPriceProgressPercent = update.ProgressPercent;
            this.bulkBestPriceProgressCompleted = update.CompletedCount;
            this.bulkBestPriceProgressTotal = update.TotalCount;
            this.bulkBestPriceProgressMessage = update.Message || `${update.CompletedCount} / ${update.TotalCount}`;
          });
        }
      );
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      Products: products,
      SelectedOfferID: 0,
      MaxRank: 1,
      Pager: { PageIndex: 1, PageSize: 1 },
      ApplyClientRestrictions: false,
      StockStatus: this.selectedBulkStockStatus?.ID ?? -1,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: this.CurrentOrder?.Cart?.Currency,
        ConfigStatus: { ID: this.selectedBulkConfigStatus?.ID ?? -9000 }
      },
      SignalRConnectionId: signalRConnectionId || null,
      BatchId: 'bbp_' + Date.now()
    };

    this.bulkBestPriceLoading = true;

    this.B2BService.GetIndustryProductsBulkBestOffers(request).subscribe((response: any) => {
      this.bulkBestPriceLoading = false;
      this.showBulkBestPriceProgress = false;

      // Cleanup SignalR subscription
      if (progressSubscription) {
        progressSubscription.unsubscribe();
      }

      if (response["Status"] !== 1) {
        this.parent.openSnackBar(response["Message"], 'OK', 'alert-info-snackbar');
        return;
      }

      const resultItems = response["CartItems"] || [];
      if (resultItems.length === 0) {
        this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
        return;
      }

      // Map each returned best offer back onto its row (matched by Product.ID)
      const appliedItems: any[] = [];
      const overwriteSellPrice = this.bulkBestPriceOverwriteSellPrice;
      selectedItems.forEach((item: any) => {
        const productId = item?.CartItem?.Product?.ID;
        if (productId == null) return;

        const match = resultItems.find((r: any) => r?.Product?.ID === productId);
        const bestOffer = match?.SelectedOffer;
        if (!bestOffer) return;

        item.CartItem.SelectedOffer = JSON.parse(JSON.stringify(bestOffer));

        if (item.CartItem.Product?.ListPriceOffers?.length > 0) {
          item.CartItem.Product.ListPriceOffers[0] = JSON.parse(JSON.stringify(bestOffer));
        }

        // Keep flat display fields in sync (Purchase + Supplier)
        item.supplier = bestOffer?.Partner?.Name || '';
        item.purchase = bestOffer?.ListPrice ?? '';

        // ✅ Overwrite Final Sell-Price when toggle is ON
        if (overwriteSellPrice) {
          const sellPrice = bestOffer?.SellingPrice || bestOffer?.SellPrice?.UIUnitPrice || bestOffer?.ListPrice || 0;
          if (sellPrice > 0) {
            item.CartItem.SelectedOffer.SellingPrice = sellPrice;
            if (!item.CartItem.Price) item.CartItem.Price = {};
            item.CartItem.Price.UIUnitPrice = sellPrice;
            item.price = sellPrice;

            // Recalculate Total
            const qty = item.CartItem.Quantity || 0;
            if (qty > 0) {
              const total = Math.round(sellPrice * qty * 100) / 100;
              item.CartItem.Price.UIQtyPrice = total;
              item.total = `${total}`;
            }
          }
        }

        appliedItems.push(item);
      });

      this.productsGridApi?.refreshCells({ force: true });

      if (appliedItems.length > 0) {
        this.BulkUpdateSelectedCartItems(appliedItems);
        this.parent.openSnackBar(this.translate.instant('BestPriceApplied'), 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ✅ Select partner from search results
  SelectPartnerFromSearch(partner: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    if (!cartItem.SelectedOffer) {
      cartItem.SelectedOffer = {};
    }
    cartItem.SelectedOffer.Partner = partner;

    // Update row data
    rowNode.data.supplier = partner?.Name || '';

    // Refresh the grid row
    rowNode.setData(rowNode.data);
    this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });

    // Close the popup
    this.ShowSupplierAlternatives = false;

    // ✅ Trigger 2-second auto-save timer
    this.startAutoSaveTimer(this.ClickedRowIndex, cartItem, false);
  }

  // ✅ Get brand collateral for brand popup
  SearchIndustryProductB2BBrandsVersion2(rowIndex: number, cartItem: any): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.UIProductValue || cartItem?.Product?.Name,
    };

    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;

    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        this.BrandCollateralList = JSON.parse(JSON.stringify(response["Brands"] ?? []));
      }
      this.LoadingSideOffers = false;
    });
  }

  // ✅ Switch to selected brand
  SwitchGridBrandVersion2(brand: any): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CartItem: this.ClickedRow?.CartItem,
      Pager: { PageIndex: 1, PageSize: 25 },
      MaxRank: 100,
      UISelectedBrand: JSON.parse(JSON.stringify(brand)),
    };

    this.LoadingSideOffers = true;

    this.B2BService.SwitchGridBrandVersion2(request).subscribe(response => {
      if (response["Status"] == 1) {
        const c = JSON.parse(JSON.stringify(response["CartItem"]));
        const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
        if (rowNode) {
          console.log(`🔀 [OC-SwitchGridBrandVersion2] row=${this.ClickedRowIndex}. Replacing CartItem. OLD ID=${rowNode.data.CartItem?.ID}, NEW brand=${c?.Product?.Brand?.Name}`);
          rowNode.data.CartItem = c;
          rowNode.data.brand = c?.Product?.Brand?.Name || '';
          rowNode.data.name = c?.UIProductValue || c?.Product?.Name || '';
          rowNode.setData(rowNode.data);
          this.offerGridApi?.refreshCells({ rowNodes: [rowNode], force: true });
        }
      }
      this.LoadingSideOffers = false;
      this.ShowBrandCollateral = false;
    });
  }

  // ✅ Handle Name popup tab change
  onNamePopupTabChange(tabIndex: number): void {
    this.selectedNamePopupTab = tabIndex;

    if (tabIndex === 1) {
      // Tab 1: Other Offers - reload side offers
      const cartItem = this.ClickedRow?.CartItem;
      if (cartItem?.Product?.ID) {
        const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
        this.GetIndustryProductCalculatedSideOffers(this.ClickedRowIndex, cartItem.Product.ID, offerId);
      }
    } else if (tabIndex === 2) {
      // Tab 2: Similar Products - placeholder for future implementation
      this.SideOffers = [];
    }
  }

  // ✅ Switch grid product offer (select from Name popup) - calls backend API like quotations/new
  SwitchGridProductOffer(item: any): void {
    const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) return;

    // Get CartItem.ID for preserving after update
    const cartItemID = cartItem?.ID || 0;

    // Get the clicked item's currency for PrefferedCurrency
    const clickedItemCurrency = item?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Clone the CartItem and ensure Product.ListPriceOffers is populated (required by backend)
    const cartItemForRequest = JSON.parse(JSON.stringify(this.ClickedRow?.CartItem));
    if (cartItemForRequest?.Product && !cartItemForRequest.Product.ListPriceOffers) {
      // Backend requires ListPriceOffers - populate from SelectedOffer if missing
      cartItemForRequest.Product.ListPriceOffers = [cartItemForRequest.SelectedOffer];
    }

    // Build request like create-new-quotation does
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.CurrentOrder?.Cart?.Partner?.ID,
      SelectedOffer: item.Product?.ListPriceOffers?.[0] || item.SelectedOffer,
      CartItem: cartItemForRequest,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: clickedItemCurrency,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.LoadingSideOffers = true;

    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
      if (response["Status"] == 1) {
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;

        // ✅ Preserve the original CartItem.ID
        c.ID = cartItemID;

        // Apply to row
        this.applySearchResultToRow(this.ClickedRowIndex, c, this.offerGridApi);
      }

      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }

  /**
   * Parse a number from any format (US, EU, or mixed).
   * Handles:
   * - "1029.99" → 1029.99 (US format)
   * - "1,029.99" → 1029.99 (US format with thousands)
   * - "1.029,99" → 1029.99 (EU format with thousands)
   * - "1029,99" → 1029.99 (EU format)
   */
  parseNumberFromAnyFormat(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Convert to string
    let str = String(value).trim();

    // Remove any whitespace
    str = str.replace(/\s+/g, '');

    // If empty after trimming, return null
    if (str === '') {
      return null;
    }

    // Count dots and commas
    const dotCount = (str.match(/\./g) || []).length;
    const commaCount = (str.match(/,/g) || []).length;

    // Determine format based on separators
    if (dotCount === 0 && commaCount === 0) {
      // No separators - just a number
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount === 1 && commaCount === 0) {
      // Only dot - assume decimal separator (US format)
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount === 0 && commaCount === 1) {
      // Only comma - could be thousands or decimal separator
      const commaPos = str.indexOf(',');
      const afterComma = str.substring(commaPos + 1);

      if (afterComma.length <= 2) {
        // Decimal separator (EU format)
        str = str.replace(',', '.');
      } else {
        // Thousands separator
        str = str.replace(',', '');
      }

      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount > 1 && commaCount === 0) {
      // Multiple dots - assume thousands separators (EU format)
      str = str.replace(/\./g, '');
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (commaCount > 1 && dotCount === 0) {
      // Multiple commas - assume thousands separators
      str = str.replace(/,/g, '');
      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    } else if (dotCount >= 1 && commaCount >= 1) {
      // Both dots and commas - determine which is decimal separator
      const lastDotPos = str.lastIndexOf('.');
      const lastCommaPos = str.lastIndexOf(',');

      if (lastDotPos > lastCommaPos) {
        // Dot is decimal separator (US format)
        str = str.replace(/,/g, '');
      } else {
        // Comma is decimal separator (EU format)
        str = str.replace(/\./g, '');
        str = str.replace(',', '.');
      }

      const num = parseFloat(str);
      return isNaN(num) ? null : num;
    }

    // Fallback
    const num = parseFloat(str);
    return isNaN(num) ? null : num;
  }

  // ✅ Select purchase currency for a row - exchanges SelectedOffer.ListPrice via backend
  // and overwrites the grid for single-row OR multi-select scenarios.
  selectPurchaseCurrency(currency: any) {
    const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(this.purchaseCurrencyRowIndex);
    if (!rowNode) {
      this.showPurchaseCurrencyDropdown = false;
      return;
    }

    const cartItem = rowNode.data?.CartItem;
    if (!cartItem) {
      this.showPurchaseCurrencyDropdown = false;
      return;
    }

    // Build the list of rows to exchange: bulk if >1 selected, else just the clicked row.
    const selectedItems = this.getSelectedProductItems();
    const isBulkUpdate = selectedItems.length > 1;
    const rowsToExchange: any[] = isBulkUpdate ? selectedItems : [rowNode.data];

    // Single-mode early exit if nothing actually changes
    if (!isBulkUpdate) {
      const currentPurchaseCurrencyId = cartItem.SelectedOffer?.PurchaseCurrency?.ID;
      if (currentPurchaseCurrencyId === currency.ID) {
        this.showPurchaseCurrencyDropdown = false;
        return;
      }
    }

    this.showPurchaseCurrencyDropdown = false;

    // Extract CartItems (keep OLD PurchaseCurrency intact so backend knows the source currency)
    const cartItemsForRequest = rowsToExchange
      .map((r: any) => r?.CartItem)
      .filter((ci: any) => ci != null);

    if (cartItemsForRequest.length === 0) return;

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItems: cartItemsForRequest,
      NewPurchaseCurrency: currency
    };

    this.savingGridRow = true;
    this.B2BService.ExchangeCartItemsPurchaseCurrency(request).subscribe((response: any) => {
      this.savingGridRow = false;

      if (response?.Status !== 1 || !Array.isArray(response?.CartItems)) {
        console.error('❌ ExchangeCartItemsPurchaseCurrency failed:', response?.Message);
        this.parent.openSnackBar(response?.Message || 'Currency exchange failed', 'OK', 'alert-info-snackbar');
        return;
      }

      // Apply exchanged values back onto the original rows (response preserves order)
      rowsToExchange.forEach((row: any, idx: number) => {
        const updated = response.CartItems[idx];
        if (!row?.CartItem || !updated?.SelectedOffer) return;

        if (!row.CartItem.SelectedOffer) row.CartItem.SelectedOffer = {};
        row.CartItem.SelectedOffer.ListPrice = updated.SelectedOffer.ListPrice;
        row.CartItem.SelectedOffer.PurchaseCurrency = updated.SelectedOffer.PurchaseCurrency;
        row.CartItem.CartItemPriceStatus = updated.CartItemPriceStatus;

        if (row.CartItem.Product?.ListPriceOffers?.length > 0) {
          row.CartItem.Product.ListPriceOffers[0].PurchaseCurrency = updated.SelectedOffer.PurchaseCurrency;
        }

        row.purchase = updated.SelectedOffer.ListPrice ?? '';
      });

      this.productsGridApi?.refreshCells({ columns: ['purchase', 'purchaseCurrency'], force: true });

      if (isBulkUpdate) {
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        this.startAutoSaveTimer(this.purchaseCurrencyRowIndex, cartItem, true);
      }
    }, (error: any) => {
      this.savingGridRow = false;
      console.error('❌ ExchangeCartItemsPurchaseCurrency error:', error);
      this.parent.openSnackBar('Currency exchange failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Toggle Generate PO Currency dropdown for a specific PO
  toggleGeneratePOCurrencyDropdown(poIndex: number): void {
    // Close all other dropdowns first
    Object.keys(this.showGeneratePOCurrencyResults).forEach(key => {
      if (parseInt(key) !== poIndex) {
        this.showGeneratePOCurrencyResults[parseInt(key)] = false;
      }
    });
    // Toggle the current dropdown
    this.showGeneratePOCurrencyResults[poIndex] = !this.showGeneratePOCurrencyResults[poIndex];
  }

  // ✅ Select purchase currency for all items in a Generate PO group (calls backend API)
  selectGeneratePOCurrency(poIndex: number, currency: any): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart?.Items) {
      this.showGeneratePOCurrencyResults[poIndex] = false;
      return;
    }

    // Close dropdown and show loading
    this.showGeneratePOCurrencyResults[poIndex] = false;
    this.parent.loading = true;

    const request = {
      PurchaseOrder: po,
      NewCurrency: currency,
      Language: this.parent.getLanguage(),
      User: this.parent.User,
    };

    this.managementService.ChangePurchaseOrderCurrency(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1 && response.PurchaseOrder) {
          // Preserve local-only properties that backend doesn't return
          const oldPO = this.GeneratedPurchaseOrders[poIndex];
          const newPO = response.PurchaseOrder;

          // Initialize Discount if not present (required for ngModel binding)
          if (!newPO.Discount) {
            newPO.Discount = oldPO?.Discount || { Type: null, Value: 0, Applied: false };
          }

          // Initialize Cart.ShippingCost if not present
          if (newPO.Cart && !newPO.Cart.ShippingCost) {
            newPO.Cart.ShippingCost = oldPO?.Cart?.ShippingCost || { UIUnitPrice: 0 };
          }

          // Update the PO in the array with returned data
          this.GeneratedPurchaseOrders[poIndex] = newPO;

          // Update grid row data
          const gridApi = this.generatePOGridApis[poIndex];
          if (gridApi && newPO.Cart?.Items) {
            gridApi.setRowData(newPO.Cart.Items);
          }
          this.parent.openSnackBar('Currency updated', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating currency', 'OK', 'alert-info-snackbar');
        }
      },
      error: (err: any) => {
        this.parent.loading = false;
        console.error('ChangePurchaseOrderCurrency error:', err);
        this.parent.openSnackBar('Error updating currency', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ✅ Get the current purchase currency for a PO (from first item or default)
  getGeneratePOCurrentCurrency(poIndex: number): string {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart?.Items?.length) return 'Select Currency';

    const firstItem = po.Cart.Items[0];
    const currency = firstItem?.SelectedOffer?.PurchaseCurrency || firstItem?.SelectedOffer?.Currency;
    return currency?.Name || 'Select Currency';
  }

  // ✅ Sell Currency (SC) popup methods
  selectSellCurrency(currency: any): void {
    this.selectedSellCurrency = currency;
    this.showSellCurrencyResults = false;
  }

  confirmChangeSellCurrency(): void {
    if (!this.selectedSellCurrency) {
      this.parent.openSnackBar('Please select a currency', 'OK', 'alert-info-snackbar');
      return;
    }
    if (!this.selectedOfferDBIDForCurrency || this.selectedOfferDBIDForCurrency <= 0) {
      this.parent.openSnackBar('Offer not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    this.parent.loading = true;
    this.showSellCurrencyResults = false;

    const request = {
      OrderConfirmationDBID: this.selectedOfferDBIDForCurrency,
      CurrencyID: this.selectedSellCurrency.ID,
      NewCurrency: this.selectedSellCurrency,
      OrderConfirmation: this.CurrentOrder,
      CartItem: this.selectedCartItemForCurrency,
      Language: this.parent.getLanguage(),
      User: this.parent.User,
    };

    this.managementService.ChangeOrderConfirmationCurrency(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the returned OrderConfirmation (with exchanged prices)
          if (response.OrderConfirmation) {
            this.CurrentOrder = response.OrderConfirmation;
            // Update the corresponding order in Orders array to refresh OrderCardRow
            const orderIndex = (this.Orders as any[]).findIndex((o: any) => o.ID === this.CurrentOrder.ID);
            if (orderIndex !== -1) {
              this.Orders[orderIndex] = response.OrderConfirmation;
              this.Orders = [...(this.Orders as any[])]; // Trigger Angular change detection
            }
          }
          // Reload offer items to get updated prices (use setTimeout to allow Angular change detection to complete)
          setTimeout(() => {
            this.loadOfferGridData();
          }, 0);
          this.ShowChangeSellCurrencyPopup = false;
          this.parent.openSnackBar('Currency updated with exchanged prices', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating currency', 'OK', 'alert-info-snackbar');
        }
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating currency', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ========== NAME COLUMN PRODUCT SEARCH ==========

  /**
   * Search for products to replace in an existing offer
   * Called when user edits the Name column - directly applies result like quotations/new
   */
  searchOfferProduct(rowIndex: number, searchTerm: string, quantity: number): void {
    if (!searchTerm || searchTerm.trim().length < 2) {
      return;
    }

    // Get the CartItem ID for this row (try EditContainer grid first, then Products tab grid)
    const gridApi = this.offerGridApi || this.productsGridApi;
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    // Get currency from the row's CartItem or current order
    const itemCurrency = rowNode?.data?.CartItem?.SelectedOffer?.Currency || this.CurrentOrder?.Cart?.Currency;

    // ✅ Use the same request format as quotations/new (SearchIndustryProductB2BOffersWithMasterData)
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: searchTerm,
      Quantity: quantity,
      Pager: { PageIndex: 1, PageSize: 10 },
      MaxRank: 10,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: itemCurrency,
        ConfigStatus: { ID: -9000 }
      },
      // ─── Pre-loaded data: eliminates sequential DB fetches per search ───
      PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
      PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
      PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
      PreloadedPartner: this.parent.B2BPartner || null,
      PreloadedIsBlocked: false,
    };

    // Show loading state on the row
    if (rowNode.data.CartItem) {
      rowNode.data.CartItem.LoadingCell = true;
    }
    gridApi.refreshCells({ rowNodes: [rowNode], force: true });

    // ✅ Use Combined endpoint - handles short search terms (< 5 chars) via parallel FTS + ExactMatch
    this.B2BService.SearchIndustryProductB2BOffersWithMasterDataCombined(request).subscribe({
      next: (response: any) => {
        if (response.Status === 1 || response.Status === -2) {
          const c = JSON.parse(JSON.stringify(response.CartItem));
          c.LoadingCell = false;

          // ✅ Apply the result directly to the row (like quotations/new)
          this.applySearchResultToRow(rowIndex, c, gridApi);
        } else {
          // No results - remove loading state
          if (rowNode.data.CartItem) {
            rowNode.data.CartItem.LoadingCell = false;
          }
          gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        }
      },
      error: () => {
        if (rowNode.data.CartItem) {
          rowNode.data.CartItem.LoadingCell = false;
        }
        gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error searching products', 'OK', 'alert-info-snackbar');
      }
    });
  }

  /**
   * Apply search result directly to the row (like quotations/new does)
   */
  applySearchResultToRow(rowIndex: number, resultCartItem: any, gridApi: any): void {
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    const cartItem = rowNode.data.CartItem;
    if (!cartItem) return;

    // ✅ PRESERVE the original CartItem.ID, UIID, and order info (for DB update)
    const originalCartItemID = cartItem.ID;
    const originalUIID = cartItem.UIID;
    const originalOfferDBID = rowNode.data.OfferDBID;
    const originalOfferID = rowNode.data.OfferID;
    const originalReferenceNumber = rowNode.data.ReferenceNumber;
    const originalDebatorPO = rowNode.data.DebatorPO;
    const originalPartnerName = rowNode.data.PartnerName;
    const originalOfferEventRegister = rowNode.data.OfferEventRegister;
    const originalCartItemOrderInfo = cartItem.CartItemOrderInfo;

    // Copy new product data from result
    const c = JSON.parse(JSON.stringify(resultCartItem));
    c.LoadingCell = false;

    // ✅ RESTORE the original IDs and order info
    c.ID = originalCartItemID;
    c.UIID = originalUIID;
    c.CartItemOrderInfo = originalCartItemOrderInfo;

    // Extract display values from CartItem (same as create-new-quotation)
    const brand = c?.Product?.Brand?.Name ?? '';
    const name = c?.UIProductValue ?? c?.Product?.Name ?? '';
    const partNumber = c?.Product?.PartNumber ?? '';
    const quantity = c?.Quantity ?? rowNode.data.quantity ?? '';

    // ✅ Price logic: use SellPrice like quotations/new
    const sellPrice = c?.SelectedOffer?.SellPrice?.UIUnitPrice;
    const showPrice = sellPrice > 0;
    const price = showPrice ? sellPrice : (c?.Price?.UIUnitPrice ?? '');
    const total = (() => { const sp = c?.SelectedOffer?.SellingPrice || c?.Price?.UIUnitPrice; const q = c?.Quantity || 0; return sp > 0 && q > 0 ? parseFloat((sp * q).toFixed(4)).toString() : ''; })();

    const eta = c?.SelectedOffer?.LeadTime?.UIOutput ??
      (c?.SelectedOffer?.LeadTime?.Units > 0
        ? `${c.SelectedOffer.LeadTime.Units} ${c.SelectedOffer.LeadTime.Type?.Name || ''}`
        : '------');
    const supplier = c?.SelectedOffer?.Partner?.Name ?? '';
    const purchase = c?.SelectedOffer?.ListPrice ?? '';
    const hscode = c?.Product?.Stats?.HSCode ?? '';
    const coo = c?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = c?.Product?.Stats?.Weight != null
      ? `${c.Product.Stats.Weight} ${c.Product.Stats.WeightMeasurementType?.Name ?? ''}`.trim()
      : '';

    console.log('🔍 applySearchResultToRow - resultCartItem:', resultCartItem);
    console.log('🔍 applySearchResultToRow - extracted values:', { brand, partNumber, name, quantity, price, total, eta, supplier, purchase, hscode, coo, weight });

    const newRowData = {
      index: rowNode.data.index,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      supplier,
      purchase,
      hscode,
      coo,
      weight,
      // Preserve order info columns
      OfferDBID: originalOfferDBID,
      OfferID: originalOfferID,
      ReferenceNumber: originalReferenceNumber,
      DebatorPO: originalDebatorPO,
      PartnerName: originalPartnerName,
      OfferEventRegister: originalOfferEventRegister,
      CartItem: c
    };

    // ✅ Use setData like quotations/new to properly update the row
    rowNode.setData(newRowData);

    // ✅ Also update ProductItems array (source data)
    if (this.ProductItems && rowIndex >= 0 && rowIndex < this.ProductItems.length) {
      this.ProductItems[rowIndex] = newRowData;
    }

    // ✅ Refresh the row after setData (like quotations/new does)
    gridApi.refreshCells({ rowNodes: [rowNode], force: true });

    // Save the change to backend using AddUpdateOrderConfirmationCartItem
    this.AddUpdateOrderConfirmationCartItem({ data: newRowData, node: rowNode, api: gridApi });
  }

  AddUpdateOrderConfirmationCartItem(params: any) {
    console.log('💾 AddUpdateOrderConfirmationCartItem called');
    console.log('   params.data:', params.data);

    const cartItem = params.data?.CartItem;

    // Debug: Check both sources for OrderConfirmationDBID
    console.log('   cartItem?.CartItemOrderInfo?.OrderDBID:', cartItem?.CartItemOrderInfo?.OrderDBID);
    console.log('   params.data?.OrderConfirmationDBID:', params.data?.OrderConfirmationDBID);
    console.log('   params.data?.OfferDBID:', params.data?.OfferDBID);
    console.log('   this.CurrentOrder?.DBID:', this.CurrentOrder?.DBID);

    // Try CartItemOrderInfo.OrderDBID first, fallback to row's OrderConfirmationDBID, then OfferDBID, then CurrentOrder.DBID
    const orderConfirmationDBID = cartItem?.CartItemOrderInfo?.OrderDBID || params.data?.OrderConfirmationDBID || params.data?.OfferDBID || this.CurrentOrder?.DBID;

    console.log('   cartItem exists:', !!cartItem);
    console.log('   cartItem.ID:', cartItem?.ID);
    console.log('   ✅ Final orderConfirmationDBID:', orderConfirmationDBID);

    if (!cartItem || !orderConfirmationDBID) {
      console.log('❌ Cannot save - missing data:');
      console.log('   cartItem:', cartItem);
      console.log('   orderConfirmationDBID:', orderConfirmationDBID);
      console.log('   params.data:', params.data);
      this.parent.openSnackBar('Cannot save: missing cart item or order confirmation ID', 'OK', 'alert-info-snackbar');
      return;
    }

    // ✅ VAT.ID == 0 is invalid — null it out so the backend can resolve the correct VAT
    if (cartItem?.Price?.VAT?.ID === 0) {
      cartItem.Price.VAT = null;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItem: cartItem,
      OrderConfirmationDBID: orderConfirmationDBID
    };

    console.log('📤 Sending request to AddUpdateOrderConfirmationCartItem API:');
    console.log('   Language:', request.Language);
    console.log('   User.ID:', request.User?.ID);
    console.log('   CartItem.ID:', request.CartItem?.ID);
    console.log('   CartItem.Quantity:', request.CartItem?.Quantity);
    console.log('   CartItem.Price:', request.CartItem?.Price);
    console.log('   CartItem.SelectedOffer:', request.CartItem?.SelectedOffer);
    console.log('   OrderConfirmationDBID:', request.OrderConfirmationDBID);
    console.log('   Full CartItem object:', JSON.stringify(request.CartItem, null, 2));

    // Use savingGridRow for minimalist spinner (not parent.loading which blocks entire UI)
    this.savingGridRow = true;
    this.managementService.AddUpdateOrderConfirmationCartItem(request).subscribe((response: any) => {
      this.savingGridRow = false;
      console.log('📥 AddUpdateOrderConfirmationCartItem response:', response);
      console.log('   Status:', response.Status);
      console.log('   Message:', response.Message);

      if (response.Status === 1) {
        console.log(`✅ [OC-AddUpdateCartItem] SUCCESS. Response CartItem.ID=${response.CartItem?.ID}, Qty=${response.CartItem?.Quantity}`);
        // Success - no snackbar, just silently update the row
        if (response.CartItem) {
          params.data.CartItem = response.CartItem;
          // ✅ Also update CurrentOrder.Cart.Items to keep references in sync
          this.syncCartItemToCurrentOrder(response.CartItem);
          params.api.refreshCells({ rowNodes: [params.node], force: true });
        }
        // ✅ Save undo snapshot AFTER successful save
        this.saveUndoSnapshot();
      } else {
        console.log('❌ Save failed:', response.Message);
        this.parent.openSnackBar(response.Message || 'Error saving', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      console.log('❌ API Error:', error);
      console.log('   Error status:', error.status);
      console.log('   Error message:', error.message);
      console.log('   Error details:', error.error);
      this.parent.openSnackBar('Error saving', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ GREEN DISK: Create new offer via SaveAdminQuotationProduct, then save OC cart item with the new offer ID
  SaveNewOfferThenUpdateCartItem(params: any): void {
    const cartItem = params.data?.CartItem;
    if (!cartItem) {
      this.parent.openSnackBar('Cannot save: missing cart item', 'OK', 'alert-info-snackbar');
      return;
    }

    console.log('🟢 [SaveNewOffer] Creating new offer via SaveAdminQuotationProduct...');
    console.log('   CartItem.Product.ID:', cartItem?.Product?.ID);
    console.log('   CartItem.SelectedOffer.Partner:', cartItem?.SelectedOffer?.Partner?.Name);
    console.log('   CartItem.SelectedOffer.ListPrice:', cartItem?.SelectedOffer?.ListPrice);

    // ✅ Build a clean, minimal CartItem for SaveAdminQuotationProduct
    // Only include properties the backend expects — avoids serialization issues from OC-specific nested objects
    const sellPrice = cartItem.SelectedOffer?.SellingPrice || cartItem.Price?.UIUnitPrice || cartItem.SelectedOffer?.FinalPrice || cartItem.SelectedOffer?.ListPrice || 0;
    const offerCurrency = cartItem.SelectedOffer?.Currency || cartItem.SelectedOffer?.PurchaseCurrency || this.CurrentOrder?.Cart?.Currency;

    // Build clean SelectedOffer
    const cleanOffer: any = {
      ID: 0,
      ListPrice: cartItem.SelectedOffer?.ListPrice ?? null,
      SellingPrice: sellPrice,
      Currency: offerCurrency,
      PurchaseCurrency: cartItem.SelectedOffer?.PurchaseCurrency || offerCurrency,
      Partner: cartItem.SelectedOffer?.Partner ? { ID: cartItem.SelectedOffer.Partner.ID, Name: cartItem.SelectedOffer.Partner.Name } : null,
      LeadTime: cartItem.SelectedOffer?.LeadTime || null,
      IsStockOffer: cartItem.SelectedOffer?.IsStockOffer || false,
      StockQuantity: cartItem.SelectedOffer?.StockQuantity || null,
      MOQ: cartItem.SelectedOffer?.MOQ || null,
      SellPrice: {
        UIUnitPrice: sellPrice,
        Currency: offerCurrency
      }
    };

    // Build clean Product.Stats
    let cleanWeight = cartItem.Product?.Stats?.Weight;
    let cleanWeightType = cartItem.Product?.Stats?.WeightMeasurementType;
    if (cleanWeight != null && typeof cleanWeight === 'object') {
      cleanWeightType = cleanWeight.Type || cleanWeightType;
      cleanWeight = cleanWeight.Units ?? null;
    }
    let cleanCOO = cartItem.Product?.Stats?.COO;
    if (cleanCOO && (!cleanCOO.ID || cleanCOO.ID === 0)) {
      cleanCOO = null;
    }

    const saveCartItem: any = {
      ID: cartItem.ID || 0,
      UIID: cartItem.UIID || null,
      Quantity: cartItem.Quantity || 0,
      UIProductValue: cartItem.UIProductValue || cartItem.Product?.Name || '',
      CartItemStatus: cartItem.CartItemStatus || { ID: 1 },
      Price: cartItem.Price ? { UIUnitPrice: cartItem.Price.UIUnitPrice, UIQtyPrice: cartItem.Price.UIQtyPrice, PurchaseDiscount: cartItem.Price.PurchaseDiscount, Currency: cartItem.Price.Currency || offerCurrency } : { UIUnitPrice: sellPrice, Currency: offerCurrency },
      SelectedOffer: cleanOffer,
      Product: {
        ID: cartItem.Product?.ID || 0,
        Name: cartItem.Product?.Name || cartItem.UIProductValue || '',
        PartNumber: cartItem.Product?.PartNumber || null,
        Brand: cartItem.Product?.Brand ? { ID: cartItem.Product.Brand.ID, Name: cartItem.Product.Brand.Name } : null,
        ManufacturingStatus: cartItem.Product?.ManufacturingStatus || null,
        VersionStatus: cartItem.Product?.VersionStatus || null,
        Stats: cartItem.Product?.Stats ? {
          ID: cartItem.Product.Stats.ID || 0,
          StandardListPrice: cartItem.Product.Stats.StandardListPrice || null,
          StandardLeadTime: cartItem.Product.Stats.StandardLeadTime || cleanOffer.LeadTime,
          Weight: cleanWeight,
          WeightMeasurementType: cleanWeightType,
          HSCode: cartItem.Product.Stats.HSCode || null,
          COO: cleanCOO,
          MOQ: cartItem.Product.Stats.MOQ || null,
          DatasheetLink: cartItem.Product.Stats.DatasheetLink || null,
        } : null,
        ListPriceOffers: [cleanOffer]
      }
    };

    console.log('🟢 [SaveNewOffer] Clean CartItem built:', JSON.stringify(saveCartItem).substring(0, 500));

    const saveRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItem: saveCartItem
    };

    this.savingGridRow = true;
    this.B2BService.SaveAdminQuotationProduct(saveRequest).subscribe((response: any) => {
      console.log('🟢 [SaveNewOffer] SaveAdminQuotationProduct response:', response);

      if (response.Status !== 1) {
        this.savingGridRow = false;
        console.error('❌ [SaveNewOffer] Failed:', response.Message);
        this.parent.openSnackBar(response.Message || 'Error creating offer', 'OK', 'alert-info-snackbar');
        return;
      }

      const updatedCartItem = response.CartItem;
      if (!updatedCartItem) {
        this.savingGridRow = false;
        console.error('❌ [SaveNewOffer] No CartItem in response');
        this.parent.openSnackBar('Error: No CartItem returned', 'OK', 'alert-info-snackbar');
        return;
      }

      const newOfferID = updatedCartItem.SelectedOffer?.ID || updatedCartItem.Product?.ListPriceOffers?.[0]?.ID || 0;
      console.log('🟢 [SaveNewOffer] New Offer ID:', newOfferID);
      console.log('🟢 [SaveNewOffer] Product.ID:', updatedCartItem.Product?.ID);

      // ✅ Apply the new offer ID back to the original CartItem
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.ID = newOfferID;
      if (cartItem.Product?.ListPriceOffers?.[0]) {
        cartItem.Product.ListPriceOffers[0].ID = newOfferID;
      }

      // ✅ Also sync Product.ID and Stats.ID if they were newly created
      if (updatedCartItem.Product?.ID && (!cartItem.Product?.ID || cartItem.Product.ID <= 0)) {
        cartItem.Product.ID = updatedCartItem.Product.ID;
      }
      if (updatedCartItem.Product?.Stats?.ID && (!cartItem.Product?.Stats?.ID || cartItem.Product.Stats.ID <= 0)) {
        if (!cartItem.Product.Stats) cartItem.Product.Stats = {};
        cartItem.Product.Stats.ID = updatedCartItem.Product.Stats.ID;
      }

      console.log('🟢 [SaveNewOffer] Now saving OC cart item with new offer ID:', newOfferID);

      // ✅ Now save the OC cart item with the newly created offer ID
      this.AddUpdateOrderConfirmationCartItem(params);

    }, (error: any) => {
      this.savingGridRow = false;
      console.error('❌ [SaveNewOffer] HTTP Error:', error);
      this.parent.openSnackBar('Error creating offer', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Auto-save delay localStorage methods
  private loadAutoSaveDelay(): void {
    const stored = localStorage.getItem(this.AUTO_SAVE_DELAY_KEY);
    if (stored) {
      const val = parseFloat(stored);
      if (!isNaN(val) && val >= 0.25 && val <= 2.00) {
        this.autoSaveDelay = val;
      }
    }
  }

  private saveAutoSaveDelay(): void {
    localStorage.setItem(this.AUTO_SAVE_DELAY_KEY, this.autoSaveDelay.toFixed(2));
  }

  increaseAutoSaveDelay(): void {
    if (this.autoSaveDelay < 2.00) {
      this.autoSaveDelay = Math.min(2.00, Math.round((this.autoSaveDelay + 0.25) * 100) / 100);
      this.saveAutoSaveDelay();
    }
  }

  decreaseAutoSaveDelay(): void {
    if (this.autoSaveDelay > 0.25) {
      this.autoSaveDelay = Math.max(0.25, Math.round((this.autoSaveDelay - 0.25) * 100) / 100);
      this.saveAutoSaveDelay();
    }
  }

  // ✅ Auto-save timer methods - configurable delay after cell edit
  startAutoSaveTimer(rowIndex: number, cartItem: any, isProductsGrid: boolean, columnField: string = ''): void {
    // Check the appropriate auto-save toggle for each grid
    if (isProductsGrid && !this.AutoSave) return;
    if (!isProductsGrid && !this.OfferAutoSave) return;

    // For the single-order popup grid, only auto-save if the order already exists (has a DBID)
    if (!isProductsGrid && (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0)) return;

    // Cancel any existing timer
    this.cancelAutoSaveTimer();

    // Store pending save info
    this.autoSaveRowIndex = rowIndex;
    this.autoSavePendingCartItem = cartItem;
    this.autoSaveIsProductsGrid = isProductsGrid;
    this.autoSaveLastEditedColumn = columnField;

    const delayMs = Math.round(this.autoSaveDelay * 1000);
    console.log(`⏱️ AUTO-SAVE: Starting ${this.autoSaveDelay}s timer for row`, rowIndex, 'column', columnField);

    // Start configurable timer
    this.autoSaveTimer = setTimeout(() => {
      this.executeAutoSave();
    }, delayMs);
  }

  cancelAutoSaveTimer(): void {
    if (this.autoSaveTimer) {
      clearTimeout(this.autoSaveTimer);
      this.autoSaveTimer = null;
      console.log('⏱️ AUTO-SAVE: Timer cancelled');
    }
  }

  executeAutoSave(): void {
    if (!this.autoSavePendingCartItem) {
      console.log('⏱️ AUTO-SAVE: No pending cart item to save');
      return;
    }

    console.log('⏱️ AUTO-SAVE: 350ms passed, saving row', this.autoSaveRowIndex);

    const gridApi = this.autoSaveIsProductsGrid ? this.productsGridApi : this.offerGridApi;
    const rowNode = gridApi?.getDisplayedRowAtIndex(this.autoSaveRowIndex);

    if (rowNode && rowNode.data) {
      this.savingRow = true;
      this.AddUpdateOrderConfirmationCartItem({
        data: rowNode.data,
        node: rowNode,
        api: gridApi
      });
      this.savingRow = false;
    }

    // Clear pending save state
    this.autoSaveTimer = null;
    this.autoSaveRowIndex = -1;
    this.autoSavePendingCartItem = null;
  }

  // Check if the current cell being edited is on the same row as pending save
  onCellEditingStarted(rowIndex: number, isProductsGrid: boolean, colId?: string): void {
    // If editing same row that has pending save, cancel the timer (user still editing)
    // But only cancel if it's a DIFFERENT column (user moved to edit another field)
    if (this.autoSaveTimer && this.autoSaveRowIndex === rowIndex && this.autoSaveIsProductsGrid === isProductsGrid) {
      if (colId && this.autoSaveLastEditedColumn && colId !== this.autoSaveLastEditedColumn) {
        console.log('⏱️ AUTO-SAVE: Different column edit started on same row, cancelling timer');
        this.cancelAutoSaveTimer();
      } else {
        console.log('⏱️ AUTO-SAVE: Same column edit event ignored (likely from refreshCells)');
      }
    }
  }

  hasSelectedCartItems(): boolean {
    return this.ProductItems?.some((item: any) => item.CartItem?.IsSelected === true) || false;
  }

  // ✅ Check if EditContainer grid has selected items
  hasSelectedEditContainerItems(): boolean {
    return this.CartItemRows?.some((item: any) => item.CartItem?.IsSelected === true) || false;
  }

  // ✅ Get all selected cart items from Products grid
  getSelectedProductItems(): any[] {
    return this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
  }

  // ✅ Grouping key for a row - mirrors the 'reference-group-separator' rowClassRule
  getRowGroupingKey(data: any): any {
    const groupingID = this.selectedGrouping?.ID;
    if (groupingID === 1) return data?.PartnerName;            // Group by Partner
    if (groupingID === 2) return data?.CartItem?.Product?.Brand?.Name; // Group by Brand
    return data?.ReferenceNumber;                              // Default: group by ReferenceNumber
  }

  // ✅ True when a separator border is drawn between two adjacent rows (same logic as the rowClassRule)
  isGroupBoundaryBetween(aData: any, bData: any): boolean {
    const ka = this.getRowGroupingKey(aData);
    const kb = this.getRowGroupingKey(bData);
    return ka != null && kb != null && ka !== kb;
  }

  // ✅ Double-click on a checkbox cell selects/deselects the whole group (block between separator borders)
  toggleProductsGroupSelection(api: any, rowIndex: number): void {
    const clickedNode = api?.getDisplayedRowAtIndex(rowIndex);
    if (!clickedNode?.data?.CartItem) return;

    // Collect the contiguous group: this row + neighbours until a separator border is crossed
    const groupNodes: any[] = [clickedNode];

    for (let i = rowIndex - 1; i >= 0; i--) {
      const node = api.getDisplayedRowAtIndex(i);
      const below = api.getDisplayedRowAtIndex(i + 1);
      if (!node || !below || this.isGroupBoundaryBetween(node.data, below.data)) break;
      groupNodes.push(node);
    }
    const total = api.getDisplayedRowCount();
    for (let i = rowIndex + 1; i < total; i++) {
      const node = api.getDisplayedRowAtIndex(i);
      const above = api.getDisplayedRowAtIndex(i - 1);
      if (!node || !above || this.isGroupBoundaryBetween(above.data, node.data)) break;
      groupNodes.push(node);
    }

    // New state = opposite of the double-clicked row's current selection
    const newState = !(clickedNode.data.CartItem.IsSelected === true);
    groupNodes.forEach((node: any) => {
      if (node.data?.CartItem) {
        node.data.CartItem.IsSelected = newState;
      }
    });

    api.refreshCells({ columns: ['index'], force: true });
    this.cdr.detectChanges();
  }

  // ✅ Bulk update all selected cart items using the new bulk endpoint
  BulkUpdateSelectedCartItems(selectedItems?: any[]): void {
    // ✅ Respect AutoSave toggle
    if (!this.AutoSave) {
      console.log('⏱️ BULK-UPDATE: AutoSave is OFF, skipping bulk save');
      return;
    }

    const items = selectedItems || this.getSelectedProductItems();
    console.log('⏱️ BULK-UPDATE: Items to save:', items.length);
    if (items.length === 0) return;

    // Get OrderConfirmationDBID from first item (all should be from same order)
    const firstItem = items[0];
    const orderConfirmationDBID = firstItem?.CartItem?.CartItemOrderInfo?.OrderDBID
      || firstItem?.OrderConfirmationDBID
      || firstItem?.OfferDBID
      || this.CurrentOrder?.DBID;

    console.log('⏱️ BULK-UPDATE: OrderConfirmationDBID:', orderConfirmationDBID);

    if (!orderConfirmationDBID) {
      console.error('BulkUpdateSelectedCartItems: No OrderConfirmationDBID found');
      return;
    }

    // Extract CartItems from the row data
    const cartItems = items.map((item: any) => item.CartItem).filter((ci: any) => ci != null);
    console.log('⏱️ BULK-UPDATE: CartItems extracted:', cartItems.length);
    if (cartItems.length === 0) return;

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItems: cartItems,
      OrderConfirmationDBID: orderConfirmationDBID
    };

    // Use savingGridRow for minimalist spinner
    this.savingGridRow = true;
    console.log('⏱️ BULK-UPDATE: Sending request to BulkUpdateOrderConfirmationCartItems API...');
    this.managementService.BulkUpdateOrderConfirmationCartItems(request).subscribe((response: any) => {
      this.savingGridRow = false;
      if (response.Status === 1) {
        // Success - no snackbar, just silently complete
        console.log(`✅ Bulk updated ${response.UpdatedCount} items`);
        // ✅ Save undo snapshot AFTER successful save
        this.saveUndoSnapshot();
      } else {
        console.error('❌ Bulk update failed:', response.Message);
        this.parent.openSnackBar(response.Message || 'Bulk update failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      console.error('❌ Bulk update error:', error);
      this.parent.openSnackBar('Bulk update failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Deselect all items in Products grid (called by overlay click)
  deselectAllProductItems(): void {
    this.ProductItems?.forEach((item: any) => {
      if (item.CartItem) item.CartItem.IsSelected = false;
    });
    this.productsHeaderCheckboxSelected = false;
    this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
    this.updateHeaderCheckbox(this.productsGridApi);
  }

  // ✅ Deselect all items in EditContainer grid (called by overlay click)
  deselectAllEditContainerItems(): void {
    this.CartItemRows?.forEach((item: any) => {
      if (item.CartItem) item.CartItem.IsSelected = false;
    });
    this.offerHeaderCheckboxSelected = false;
    this.offerGridApi?.refreshCells({ columns: ['index'], force: true });
    this.updateOfferHeaderCheckbox();
  }

  // ✅ Save all selected items in EditContainer grid
  SaveAllSelectedEditContainerItems() {
    console.log('💾 ORDER-CONFIRMATIONS: SaveAllSelectedEditContainerItems called');
    console.log('   CartItemRows:', this.CartItemRows?.length);

    const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];
    console.log('   Selected items:', selectedItems.length);

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      return;
    }

    let savedCount = 0;
    let errorCount = 0;
    this.parent.loading = true;

    selectedItems.forEach((item: any) => {
      const cartItem = item.CartItem;
      // Try multiple sources for OrderConfirmationDBID
      const orderConfirmationDBID = cartItem?.CartItemOrderInfo?.OrderDBID || item.OrderConfirmationDBID || item.OfferDBID || this.CurrentOrder?.DBID;

      console.log('   Item:', item);
      console.log('   orderConfirmationDBID:', orderConfirmationDBID);

      if (!cartItem || !orderConfirmationDBID) {
        console.log('   ❌ Skipping item - missing cartItem or orderConfirmationDBID');
        errorCount++;
        return;
      }

      const request = {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItem: cartItem,
        OrderConfirmationDBID: orderConfirmationDBID
      };

      this.managementService.AddUpdateOrderConfirmationCartItem(request).subscribe((response: any) => {
        if (response.Status === 1) {
          savedCount++;
        } else {
          errorCount++;
        }

        // Check if all requests completed
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.CartItemRows?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.offerGridApi?.refreshCells({ columns: ['index'], force: true });

          if (errorCount === 0) {
            this.parent.openSnackBar(`Saved ${savedCount} items`, 'OK', 'light-info-snackbar');
          } else {
            this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
          }
        }
      }, () => {
        errorCount++;
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          this.CartItemRows?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.offerGridApi?.refreshCells({ columns: ['index'], force: true });
          this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
        }
      });
    });
  }

  SaveAllSelectedCartItems() {
    // Get all selected rows from ProductItems
    const selectedItems = this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      return;
    }

    let savedCount = 0;
    let errorCount = 0;
    this.parent.loading = true;

    selectedItems.forEach((item: any) => {
      const cartItem = item.CartItem;
      // Try multiple sources for OrderConfirmationDBID
      const orderConfirmationDBID = cartItem?.CartItemOrderInfo?.OrderDBID || item.OrderConfirmationDBID || item.OfferDBID;

      console.log('   Item:', item);
      console.log('   orderConfirmationDBID:', orderConfirmationDBID);

      if (!cartItem || !orderConfirmationDBID) {
        console.log('   ❌ Skipping item - missing cartItem or orderConfirmationDBID');
        errorCount++;
        return;
      }

      const request = {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItem: cartItem,
        OrderConfirmationDBID: orderConfirmationDBID
      };

      this.managementService.AddUpdateOrderConfirmationCartItem(request).subscribe((response: any) => {
        if (response.Status === 1) {
          savedCount++;
        } else {
          errorCount++;
        }

        // Check if all requests completed
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.ProductItems?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.productsHeaderCheckboxSelected = false;
          this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
          this.updateHeaderCheckbox(this.productsGridApi);

          // ✅ Save undo snapshot AFTER all saves completed successfully
          if (savedCount > 0) {
            this.saveUndoSnapshot();
          }

          if (errorCount === 0) {
            this.parent.openSnackBar(`Saved ${savedCount} items`, 'OK', 'light-info-snackbar');
          } else {
            this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
          }
        }
      }, () => {
        errorCount++;
        if (savedCount + errorCount === selectedItems.length) {
          this.parent.loading = false;
          // Deselect all cart items
          this.ProductItems?.forEach((item: any) => {
            if (item.CartItem) {
              item.CartItem.IsSelected = false;
            }
          });
          this.productsHeaderCheckboxSelected = false;
          this.productsGridApi?.refreshCells({ columns: ['index'], force: true });
          this.updateHeaderCheckbox(this.productsGridApi);

          this.parent.openSnackBar(`Saved ${savedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
        }
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    if (this.offerGridApi) {
      this.offerGridApi.sizeColumnsToFit();
      setTimeout(() => this.syncColumnWidths(), 100);
    }
  }

  // ✅ Close status dropdowns when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.StatusDropdownContainer')) {
      this.closeAllStatusDropdowns();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    console.log('🔑 ORDER-CONFIRMATIONS: Key pressed:', event.key, 'Ctrl:', event.ctrlKey);

    if (event.ctrlKey && event.key === 's') {
      event.preventDefault();
      console.log('💾 ORDER-CONFIRMATIONS: Ctrl+S detected');
      console.log('   ShowEditContainer:', this.ShowEditContainer);
      console.log('   hasSelectedEditContainerItems:', this.hasSelectedEditContainerItems());
      console.log('   hasSelectedCartItems:', this.hasSelectedCartItems());
      console.log('   CartItemRows length:', this.CartItemRows?.length);
      console.log('   ProductItems length:', this.ProductItems?.length);

      // ✅ Check EditContainer first (if open), then Products tab
      if (this.ShowEditContainer && this.hasSelectedEditContainerItems()) {
        console.log('✅ ORDER-CONFIRMATIONS: Saving EditContainer items');
        this.SaveAllSelectedEditContainerItems();
      } else if (this.hasSelectedCartItems()) {
        console.log('✅ ORDER-CONFIRMATIONS: Saving Products tab items');
        this.SaveAllSelectedCartItems();
      } else {
        console.log('⚠️ ORDER-CONFIRMATIONS: No items selected to save');
        this.parent.openSnackBar('No items selected to save', 'OK', 'alert-info-snackbar');
      }
    }
    if (event.ctrlKey && event.key === 'd') {
      event.preventDefault();
      console.log('🗑️ ORDER-CONFIRMATIONS: Ctrl+D detected');
      // ✅ Check EditContainer first (if open), then Products tab
      if (this.ShowEditContainer && this.hasSelectedEditContainerItems()) {
        this.IsMultiDeleteEditContainer = true;
        this.ShowDeleteCartItemConfirmation = true;
      } else if (this.hasSelectedCartItems()) {
        this.IsMultiDelete = true;
        this.ShowDeleteCartItemConfirmation = true;
      }
    }
  }

  ConfirmDeleteCartItem() {
    if (this.IsMultiDeleteEditContainer) {
      this.DeleteAllSelectedEditContainerItems();
    } else if (this.IsMultiDelete) {
      this.DeleteAllSelectedCartItems();
    } else {
      this.DeleteSingleCartItem();
    }
  }

  DeleteSingleCartItem() {
    if (!this.DeleteCartItemParams) {
      this.ShowDeleteCartItemConfirmation = false;
      return;
    }

    const cartItem = this.DeleteCartItemParams.data?.CartItem;
    const cartItemID = cartItem?.ID;

    if (!cartItemID || cartItemID <= 0) {
      this.parent.openSnackBar('Cannot delete: missing cart item ID', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
      return;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItemID: cartItemID,
      CartItem: cartItem
    };

    this.parent.loading = true;
    this.managementService.DeleteOrderConfirmationCartItem(request).subscribe((res: any) => {
      this.parent.loading = false;
      if (res.Status === 1) {
        this.parent.openSnackBar('Item deleted', 'OK', 'alert-info-snackbar');

        // If Products TAB is active, remove the item visually
        if (!this.showOffersTab) {
          const rowIndex = this.DeleteCartItemParams.rowIndex;
          if (rowIndex >= 0 && this.ProductItems) {
            this.ProductItems.splice(rowIndex, 1);
            this.productsGridApi?.setRowData(this.ProductItems);
          }
        }

        // If EditContainer is open, reload the entire order to refresh totals
        if (this.ShowEditContainer && this.CurrentOrder?.ID) {
          this.GetOffer(this.CurrentOrder.ID);
        }
      } else {
        this.parent.openSnackBar(res.Message || 'Error deleting', 'OK', 'alert-info-snackbar');
      }
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.DeleteCartItemParams = null;
    });
  }

  DeleteAllSelectedCartItems() {
    const selectedItems = this.ProductItems?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
      return;
    }

    const deleteRequests = selectedItems.map((item: any) => {
      const cartItem = item.CartItem;
      const cartItemID = cartItem?.ID;
      if (!cartItemID || cartItemID <= 0) return null;
      return {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItemID: cartItemID,
        CartItem: cartItem
      };
    }).filter((req: any) => req !== null);

    if (deleteRequests.length === 0) {
      this.parent.openSnackBar('No valid items to delete', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
      return;
    }

    this.parent.loading = true;
    let deletedCount = 0;
    let errorCount = 0;
    const deletedIds: number[] = [];

    forkJoin(deleteRequests.map((req: any) => this.managementService.DeleteOrderConfirmationCartItem(req))).subscribe((results: any[]) => {
      this.parent.loading = false;
      results.forEach((res: any, index: number) => {
        if (res.Status === 1) {
          deletedCount++;
          deletedIds.push(deleteRequests[index].CartItemID);
        } else {
          errorCount++;
        }
      });

      // If Products TAB is active, remove deleted items visually
      if (!this.showOffersTab && deletedIds.length > 0) {
        this.ProductItems = this.ProductItems.filter((item: any) => !deletedIds.includes(item.CartItem?.ID));
        this.productsGridApi?.setRowData(this.ProductItems);
      }

      // Deselect all and reset header checkbox
      this.ProductItems?.forEach((item: any) => {
        if (item.CartItem) item.CartItem.IsSelected = false;
      });
      this.productsHeaderCheckboxSelected = false;
      this.updateHeaderCheckbox(this.productsGridApi);
      this.productsGridApi?.refreshCells({ force: true });

      // If EditContainer is open, reload the entire order to refresh totals
      if (this.ShowEditContainer && this.CurrentOrder?.ID && deletedCount > 0) {
        this.GetOffer(this.CurrentOrder.ID);
      }

      this.parent.openSnackBar(`Deleted ${deletedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting items', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDelete = false;
    });
  }

  // ✅ Delete all selected items in EditContainer grid
  DeleteAllSelectedEditContainerItems() {
    const selectedItems = this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
      return;
    }

    const deleteRequests = selectedItems.map((item: any) => {
      const cartItem = item.CartItem;
      const cartItemID = cartItem?.ID;
      if (!cartItemID || cartItemID <= 0) return null;
      return {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItemID: cartItemID,
        CartItem: cartItem
      };
    }).filter((req: any) => req !== null);

    if (deleteRequests.length === 0) {
      this.parent.openSnackBar('No valid items to delete', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
      return;
    }

    this.parent.loading = true;
    let deletedCount = 0;
    let errorCount = 0;
    const deletedIds: number[] = [];

    forkJoin(deleteRequests.map((req: any) => this.managementService.DeleteOrderConfirmationCartItem(req))).subscribe((results: any[]) => {
      this.parent.loading = false;
      results.forEach((res: any, index: number) => {
        if (res.Status === 1) {
          deletedCount++;
          deletedIds.push(deleteRequests[index].CartItemID);
        } else {
          errorCount++;
        }
      });

      this.parent.openSnackBar(`Deleted ${deletedCount}, failed ${errorCount}`, 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;

      // Reload the entire order to refresh totals, items, and all related data
      if (this.CurrentOrder?.ID && deletedCount > 0) {
        this.GetOffer(this.CurrentOrder.ID);
      }
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error deleting items', 'OK', 'alert-info-snackbar');
      this.ShowDeleteCartItemConfirmation = false;
      this.IsMultiDeleteEditContainer = false;
    });
  }

  // ✅ Progress Status right-click popup methods
  closeProgressStatusCellPopup(): void {
    this.showProgressStatusCellPopup = false;
    this.progressStatusPopupCartItem = null;
    this.progressStatusPopupRowIndex = -1;
  }

  selectProgressStatusForCartItem(status: any): void {
    console.log('🔄 selectProgressStatusForCartItem called');
    console.log('   status:', status);
    console.log('   progressStatusPopupCartItem:', this.progressStatusPopupCartItem);
    console.log('   progressStatusPopupIsProductsGrid:', this.progressStatusPopupIsProductsGrid);
    console.log('   AutoSave:', this.AutoSave);

    if (!this.progressStatusPopupCartItem) {
      this.closeProgressStatusCellPopup();
      return;
    }

    // Check if we have multiple selected items (bulk update)
    const selectedItems = this.progressStatusPopupIsProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    console.log('   selectedItems.length:', selectedItems.length);

    if (selectedItems.length > 1) {
      console.log('   → Multi-select mode: applying to', selectedItems.length, 'items');
      // Apply ProgressStatus to ALL selected items
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          item.CartItem.ProgressStatus = JSON.parse(JSON.stringify(status));
        }
      });

      // Refresh the grid and bulk save
      if (this.progressStatusPopupIsProductsGrid) {
        console.log('   → Products grid: calling BulkUpdateSelectedCartItems');
        // ✅ redrawRows to re-evaluate rowClassRules (updates row background color instantly)
        const rowNodes = selectedItems.map((item: any) => {
          const idx = this.ProductItems.indexOf(item);
          return this.productsGridApi?.getDisplayedRowAtIndex(idx);
        }).filter((n: any) => n != null);
        this.productsGridApi?.redrawRows({ rowNodes: rowNodes });
        // Bulk update all selected items (Products grid)
        this.BulkUpdateSelectedCartItems(selectedItems);
      } else {
        console.log('   → Offers grid: calling SaveAllSelectedEditContainerItems');
        // ✅ redrawRows to re-run cellRenderers (status uses DOM-based renderer)
        const offerRowNodes = selectedItems.map((item: any) => {
          const idx = this.CartItemRows?.indexOf(item) ?? -1;
          return idx >= 0 ? this.offerGridApi?.getDisplayedRowAtIndex(idx) : null;
        }).filter((n: any) => n != null);
        if (offerRowNodes.length > 0) {
          this.offerGridApi?.redrawRows({ rowNodes: offerRowNodes });
        }
        // ✅ Bulk update all selected items (Offers/EditContainer grid)
        if (this.AutoSave) {
          this.SaveAllSelectedEditContainerItems();
        }
      }
    } else {
      console.log('   → Single item mode: applying to row', this.progressStatusPopupRowIndex);
      // Single item update (original behavior)
      this.progressStatusPopupCartItem.ProgressStatus = status;

      // Refresh the grid
      if (this.progressStatusPopupIsProductsGrid) {
        console.log('   → Products grid: calling startAutoSaveTimer');
        // ✅ redrawRows to re-evaluate rowClassRules (updates row background color instantly)
        const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(this.progressStatusPopupRowIndex);
        if (rowNode) {
          this.productsGridApi?.redrawRows({ rowNodes: [rowNode] });
        }
        // ✅ Trigger auto-save for single item (Products grid)
        this.startAutoSaveTimer(this.progressStatusPopupRowIndex, this.progressStatusPopupCartItem, true);
      } else {
        console.log('   → Offers grid: redrawRows + startAutoSaveTimer');
        // ✅ redrawRows to re-run cellRenderers (status uses DOM-based renderer)
        const rowNode = this.offerGridApi?.getDisplayedRowAtIndex(this.progressStatusPopupRowIndex);
        if (rowNode) {
          this.offerGridApi?.redrawRows({ rowNodes: [rowNode] });
        }
        // ✅ Trigger auto-save for single item (Offers grid)
        this.startAutoSaveTimer(this.progressStatusPopupRowIndex, this.progressStatusPopupCartItem, false);
      }
    }

    this.closeProgressStatusCellPopup();
  }

  // ✅ DeliveryPreference right-click popup methods
  closeDeliveryPreferencePopup(): void {
    this.showDeliveryPreferencePopup = false;
    this.deliveryPreferencePopupCartItem = null;
    this.deliveryPreferencePopupRowIndex = -1;
  }

  selectDeliveryPreferenceForCartItem(pref: any): void {
    if (!this.deliveryPreferencePopupCartItem) {
      this.closeDeliveryPreferencePopup();
      return;
    }

    const selectedItems = this.deliveryPreferencePopupIsProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length > 1) {
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          item.CartItem.DeliveryPreference = JSON.parse(JSON.stringify(pref));
        }
      });
      if (this.deliveryPreferencePopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      }
    } else {
      this.deliveryPreferencePopupCartItem.DeliveryPreference = pref;
      if (this.deliveryPreferencePopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        this.startAutoSaveTimer(this.deliveryPreferencePopupRowIndex, this.deliveryPreferencePopupCartItem, true);
      }
    }
    this.closeDeliveryPreferencePopup();
  }

  // ✅ ConsolidationType right-click popup methods
  closeConsolidationTypePopup(): void {
    this.showConsolidationTypePopup = false;
    this.consolidationTypePopupCartItem = null;
    this.consolidationTypePopupRowIndex = -1;
  }

  selectConsolidationTypeForCartItem(ct: any): void {
    if (!this.consolidationTypePopupCartItem) {
      this.closeConsolidationTypePopup();
      return;
    }

    const selectedItems = this.consolidationTypePopupIsProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    if (selectedItems.length > 1) {
      selectedItems.forEach((item: any) => {
        if (item.CartItem) {
          item.CartItem.ConsolidationType = JSON.parse(JSON.stringify(ct));
        }
      });
      if (this.consolidationTypePopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        this.BulkUpdateSelectedCartItems(selectedItems);
      }
    } else {
      this.consolidationTypePopupCartItem.ConsolidationType = ct;
      if (this.consolidationTypePopupIsProductsGrid) {
        this.productsGridApi?.refreshCells({ force: true });
        this.startAutoSaveTimer(this.consolidationTypePopupRowIndex, this.consolidationTypePopupCartItem, true);
      }
    }
    this.closeConsolidationTypePopup();
  }

  // ✅ Split Product popup methods
  closeSplitProductPopup(): void {
    this.showSplitProductPopup = false;
    this.splitProductCartItem = null;
    this.splitProductRowIndex = -1;
  }

  openSplitProductDialog(): void {
    // Close the context menu and open the dialog
    this.showSplitProductPopup = false;

    // Initialize with default values: qty1 = original - 1, qty2 = 1
    this.splitProductQty1 = this.splitProductOriginalQty - 1;
    this.splitProductQty2 = 1;

    // Reset associations
    this.splitProductInvoices = [];
    this.splitProductShippingData = [];
    this.splitProductLoadingAssociations = false;

    // Open the dialog
    this.showSplitProductDialog = true;

    // Fetch invoice & shipping associations for this cart item
    const cartItemID = this.splitProductCartItem?.ID;
    if (cartItemID && cartItemID > 0) {
      this.splitProductLoadingAssociations = true;

      const invoiceReq = { User: this.parent.User, Language: this.parent.getLanguage(), CartItemID: cartItemID };
      const shippingReq = { User: this.parent.User, Language: this.parent.getLanguage(), CartItemID: cartItemID };

      forkJoin([
        this.managementService.GetInvoiceByCartItemID(invoiceReq),
        this.managementService.GetOrderConfirmationCartItemShippingData(shippingReq)
      ]).subscribe(([invoiceRes, shippingRes]: any[]) => {
        this.splitProductLoadingAssociations = false;
        this.splitProductInvoices = invoiceRes?.Invoices || [];
        this.splitProductShippingData = shippingRes?.ShippingDataItems || [];
        this.cdr.detectChanges();
      }, () => {
        this.splitProductLoadingAssociations = false;
        this.cdr.detectChanges();
      });
    }
  }

  closeSplitProductDialog(): void {
    this.showSplitProductDialog = false;
    this.splitProductCartItem = null;
    this.splitProductRowIndex = -1;
    this.splitProductOriginalQty = 0;
    this.splitProductQty1 = 0;
    this.splitProductQty2 = 0;
    this.splitProductInvoices = [];
    this.splitProductShippingData = [];
    this.splitProductLoadingAssociations = false;
  }

  onSplitQty1Change(value: number): void {
    // When qty1 changes, recalculate qty2 = originalQty - qty1
    const newQty1 = Math.max(1, Math.min(value, this.splitProductOriginalQty - 1));
    this.splitProductQty1 = newQty1;
    this.splitProductQty2 = this.splitProductOriginalQty - newQty1;
  }

  onSplitQty2Change(value: number): void {
    // When qty2 changes, recalculate qty1 = originalQty - qty2
    const newQty2 = Math.max(0, Math.min(value, this.splitProductOriginalQty - 1));
    this.splitProductQty2 = newQty2;
    this.splitProductQty1 = this.splitProductOriginalQty - newQty2;
  }

  confirmSplitProduct(): void {
    if (!this.splitProductCartItem || this.splitProductQty1 <= 0 || this.splitProductQty2 <= 0) {
      this.parent.openSnackBar('Invalid split quantities', 'OK', 'alert-info-snackbar');
      return;
    }

    if (!this.splitProductCartItem.ID) {
      this.parent.openSnackBar('Missing cart item ID', 'OK', 'alert-info-snackbar');
      return;
    }

    // Create OriginalCartItem with adjusted quantity (first textbox)
    const originalCartItem = JSON.parse(JSON.stringify(this.splitProductCartItem));
    originalCartItem.Quantity = this.splitProductQty1;
    // Recalculate TotalPrice for original item
    if (originalCartItem.Price?.UIUnitPrice) {
      originalCartItem.Price.TotalPrice = originalCartItem.Price.UIUnitPrice * this.splitProductQty1;
    }

    // Create NewCartItem as a copy with split quantity (second textbox) and ID=0
    const newCartItem = JSON.parse(JSON.stringify(this.splitProductCartItem));
    newCartItem.ID = 0; // New item - will get new ID from database
    newCartItem.Quantity = this.splitProductQty2;
    // Recalculate TotalPrice for new item
    if (newCartItem.Price?.UIUnitPrice) {
      newCartItem.Price.TotalPrice = newCartItem.Price.UIUnitPrice * this.splitProductQty2;
    }

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      OriginalCartItem: originalCartItem,
      NewCartItem: newCartItem
    };

    this.parent.loading = true;
    this.managementService.SplitOrderConfirmationItem(request).subscribe((response: any) => {
      this.parent.loading = false;

      if (response.Status === 1) {
        this.parent.openSnackBar(response.Message || 'Product split successfully', 'OK', 'light-info-snackbar');
        this.closeSplitProductDialog();

        // Refresh the grid to show both items
        if (this.splitProductIsProductsGrid) {
          // Refresh current tab's grid
          this.applyFilter(this.Filter.Pager.PageIndex);
        } else {
          // Refresh the offer grid (Edit container)
          if (this.CurrentOrder?.ID) {
            this.GetOffer(this.CurrentOrder.ID);
          }
        }
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to split product', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      console.error('❌ Split product error:', error);
      this.parent.openSnackBar('Error splitting product', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Export Products methods
  openExportDialog(): void {
    console.log('📤 openExportDialog called');
    this.showExportDialog = true;
    this.cdr.detectChanges();
  }

  closeExportDialog(): void {
    this.showExportDialog = false;
  }

  // ✅ Package List dialog methods
  openPackageListDialog(): void {
    this.showPackageListDialog = true;
    this.cdr.detectChanges();
  }

  closePackageListDialog(): void {
    this.showPackageListDialog = false;
  }

  get allExportProductColumnsSelected(): boolean {
    return this.exportableColumns.every(col => col.selected);
  }

  toggleAllExportProductColumns(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.exportableColumns.forEach(col => col.selected = checked);
  }

  hasSelectedExportColumns(): boolean {
    return this.exportableColumns.some(col => col.selected);
  }

  exportProducts(): void {
    if (!this.hasSelectedExportColumns()) {
      this.parent.openSnackBar('Please select at least one column', 'OK', 'alert-info-snackbar');
      return;
    }

    const selectedColumns = this.exportableColumns
      .filter(col => col.selected)
      .map(col => col.field);

    // Get selected CartItems by checking CartItem.IsSelected property (not AG Grid's selection API)
    // We extract the CartItem from the row data (not the flattened row data itself)
    let selectedCartItems: any[] = [];
    this.productsGridApi.forEachNode((node: any) => {
      if (node.data?.CartItem?.IsSelected === true && node.data?.CartItem) {
        selectedCartItems.push(node.data.CartItem);
      }
    });

    const request: any = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      Filter: this.Filter,
      SelectedColumns: selectedColumns
    };

    // If rows are selected, send only those CartItems (skip database fetch)
    if (selectedCartItems.length > 0) {
      request.SelectedItems = selectedCartItems;
    }

    this.exporting = true;
    this.managementService.ExportOrderConfirmationProducts(request).subscribe((response: any) => {
      this.exporting = false;

      if (response.Status === 1 && response.Document?.PDFStream) {
        this.downloadExcel(response.Document.Name || 'OrderConfirmationProducts.xlsx', response.Document.PDFStream);
        this.parent.openSnackBar('Export completed successfully', 'OK', 'light-info-snackbar');
        this.closeExportDialog();
      } else {
        this.parent.openSnackBar(response.Message || 'Export failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.exporting = false;
      console.error('❌ Export error:', error);
      this.parent.openSnackBar('Error exporting products', 'OK', 'alert-info-snackbar');
    });
  }

  downloadExcel(filename: string, base64Data: string): void {
    // Convert Base64 to Blob and trigger download
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Create download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    // Clean up
    URL.revokeObjectURL(link.href);
  }

  // ✅ Generate Package List PDF for products ready in warehouse
  generatePackageList(): void {
    // Get selected CartItems by checking CartItem.IsSelected property (not AG Grid's selection API)
    // We extract the CartItem from the row data (not the flattened row data itself)
    let selectedCartItems: any[] = [];
    this.productsGridApi.forEachNode((node: any) => {
      if (node.data?.CartItem?.IsSelected === true && node.data?.CartItem) {
        selectedCartItems.push(node.data.CartItem);
      }
    });

    // Map the variant string to backend enum value
    const variantValue = this.packageListVariant === 'showSupplier' ? 1 : 2; // 1 = ShowSupplier, 2 = Confidential

    const request: any = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      Filter: this.Filter,
      Variant: variantValue
    };

    // If rows are selected, send only those CartItems
    if (selectedCartItems.length > 0) {
      request.SelectedItems = selectedCartItems;
    }

    this.generatingPackageList = true;
    this.closePackageListDialog(); // Close dialog immediately
    this.managementService.GeneratePackageList(request).subscribe((response: any) => {
      this.generatingPackageList = false;

      if (response.Status === 1 && response.Document?.PDFStream) {
        this.downloadPDF(response.Document.Name || 'PackageList.pdf', response.Document.PDFStream);
        this.parent.openSnackBar('Package List generated successfully', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to generate Package List', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.generatingPackageList = false;
      console.error('❌ Package List error:', error);
      this.parent.openSnackBar('Error generating Package List', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Download PDF helper
  downloadPDF(filename: string, base64Data: string): void {
    // Convert Base64 to Blob and trigger download
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create download link
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    // Clean up
    URL.revokeObjectURL(link.href);
  }

  // ✅ Receive Items
  receivingItems: boolean = false;

  receiveItems(): void {
    // TODO: Implement receive items logic
  }

  // ✅ Process Orders - prepares batches for full processing (grouping by Partner, ZipCode, ShippingServiceType)
  processingOrders: boolean = false;
  ShowProcessOrdersBatchReview: boolean = false;
  ProcessOrdersBatches: any[] = [];
  executingProcessOrders: boolean = false;
  decimalPrecisionOptions: any[] = [
    { ID: 2, Meaning: '2 Decimals' },
    { ID: 3, Meaning: '3 Decimals' },
    { ID: 4, Meaning: '4 Decimals' }
  ];

  processOrders(): void {
    // Check if user has selected items in the grid
    const selectedItems = this.getSelectedProductItems();
    let eligibleCartItems: any[] = [];

    if (selectedItems.length > 0) {
      // User has selected items → filter only ReadyInWarehouse (ID=2) from selection
      eligibleCartItems = selectedItems
        .filter((item: any) => item.CartItem?.ProgressStatus?.ID === 2)
        .map((item: any) => item.CartItem);
    } else {
      // No selection → take all visible grid items → filter only ReadyInWarehouse (ID=2)
      this.productsGridApi.forEachNode((node: any) => {
        if (node.data?.CartItem && node.data?.CartItem?.ProgressStatus?.ID === 2) {
          eligibleCartItems.push(node.data.CartItem);
        }
      });
    }

    if (eligibleCartItems.length === 0) {
      this.parent.openSnackBar('No items with "Ready In Warehouse" status found', 'OK', 'alert-info-snackbar');
      return;
    }

    // Pre-check: validate FullDelivery orders have all items ready
    this.processingOrders = true;
    this._pendingEligibleCartItems = eligibleCartItems;
    const preCheckRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItems: eligibleCartItems
    };

    this.managementService.ValidateFullDeliveryPreCheck(preCheckRequest).subscribe((preCheckResponse: any) => {
      if (preCheckResponse.Status === 1 && preCheckResponse.HasConflicts && preCheckResponse.Conflicts?.length > 0) {
        this.processingOrders = false;
        this.fullDeliveryConflicts = preCheckResponse.Conflicts;
        this.showFullDeliveryConflictPopup = true;
        return;
      }
      // No conflicts — proceed to consolidation check
      this.checkDispatchImmediately(eligibleCartItems);
    }, () => {
      // Pre-check failed — proceed anyway (non-blocking)
      this.checkDispatchImmediately(eligibleCartItems);
    });
  }

  // ========== Full Delivery Conflict Popup ==========
  showFullDeliveryConflictPopup: boolean = false;
  fullDeliveryConflicts: any[] = [];
  _pendingEligibleCartItems: any[] = [];

  /** Check if ALL conflicts only have UnselectedReady items (no NotReady) */
  hasOnlyUnselectedReadyConflicts(): boolean {
    return this.fullDeliveryConflicts?.every((c: any) =>
      (c.UnselectedReadyItems?.length > 0) && (!c.NotReadyItems || c.NotReadyItems.length === 0)
    );
  }

  /** User chose "Include All Ready Items" — add unselected ready items to the eligible list */
  fullDeliveryIncludeReadyItems(): void {
    this.showFullDeliveryConflictPopup = false;
    // Collect CartItemIDs of unselected ready items from all conflicts
    const unselectedReadyIDs: number[] = [];
    this.fullDeliveryConflicts.forEach((c: any) => {
      c.UnselectedReadyItems?.forEach((item: any) => unselectedReadyIDs.push(item.CartItemID));
    });
    // Find the actual CartItem objects from the grid
    const additionalItems: any[] = [];
    this.productsGridApi.forEachNode((node: any) => {
      if (node.data?.CartItem && unselectedReadyIDs.includes(node.data.CartItem.ID)) {
        additionalItems.push(node.data.CartItem);
      }
    });
    // Merge: original selection + unselected ready items (avoid duplicates)
    const existingIDs = new Set(this._pendingEligibleCartItems.map((ci: any) => ci.ID));
    const merged = [...this._pendingEligibleCartItems];
    additionalItems.forEach((ci: any) => {
      if (!existingIDs.has(ci.ID)) {
        merged.push(ci);
      }
    });
    this.checkDispatchImmediately(merged);
  }

  /** User chose "Process Only Selected" — proceed with original selection despite FullDelivery warning */
  fullDeliveryProcessOnlySelected(): void {
    this.showFullDeliveryConflictPopup = false;
    this.checkDispatchImmediately(this._pendingEligibleCartItems);
  }

  /** User chose "Include Anyway" — proceed with original selection (has NotReady items, user accepts risk) */
  fullDeliveryIncludeAnyway(): void {
    this.showFullDeliveryConflictPopup = false;
    this.checkDispatchImmediately(this._pendingEligibleCartItems);
  }

  /** User chose "Remove & Process Rest" — remove all conflict ReadyItems from the eligible list */
  fullDeliveryRemoveConflicts(): void {
    this.showFullDeliveryConflictPopup = false;
    const conflictCartIDs = new Set<number>();
    this.fullDeliveryConflicts.forEach((c: any) => {
      c.ReadyItems?.forEach((item: any) => conflictCartIDs.add(item.CartItemID));
    });
    const filtered = this._pendingEligibleCartItems.filter((ci: any) => !conflictCartIDs.has(ci.ID));
    if (filtered.length === 0) {
      this.processingOrders = false;
      this.parent.openSnackBar('No items remaining after removing FullDelivery conflicts', 'OK', 'alert-info-snackbar');
      return;
    }
    this.checkDispatchImmediately(filtered);
  }

  // ========== Dispatch Immediately Check ==========
  showDispatchImmediatelyPopup: boolean = false;
  dispatchImmediatelyItems: any[] = [];
  _separateDispatchImmediately: boolean = false;

  private checkDispatchImmediately(eligibleCartItems: any[]): void {
    const dispatchItems = eligibleCartItems.filter((ci: any) => ci.ConsolidationType?.ID === 1);
    if (dispatchItems.length > 0 && dispatchItems.length < eligibleCartItems.length) {
      this._pendingEligibleCartItems = eligibleCartItems;
      this.dispatchImmediatelyItems = dispatchItems;
      this.showDispatchImmediatelyPopup = true;
      this.processingOrders = false;
    } else {
      this._separateDispatchImmediately = false;
      this.proceedWithBatchPreparation(eligibleCartItems);
    }
  }

  dispatchImmediatelyYes(): void {
    this.showDispatchImmediatelyPopup = false;
    this._separateDispatchImmediately = true;
    this.proceedWithBatchPreparation(this._pendingEligibleCartItems);
  }

  dispatchImmediatelyNo(): void {
    this.showDispatchImmediatelyPopup = false;
    this._separateDispatchImmediately = false;
    this.proceedWithBatchPreparation(this._pendingEligibleCartItems);
  }

  private proceedWithBatchPreparation(eligibleCartItems: any[]): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItems: eligibleCartItems,
      SeparateDispatchImmediately: this._separateDispatchImmediately
    };

    this.processingOrders = true;
    this.managementService.PrepareFullProcessOrderedBatches(request).subscribe((response: any) => {
      this.processingOrders = false;

      if (response.Status === 1) {
        const batchCount = response.Batches?.length || 0;
        if (batchCount === 0) {
          this.parent.openSnackBar('No batches created', 'OK', 'alert-info-snackbar');
          return;
        }

        // Store batches and open review popup
        this.ProcessOrdersBatches = response.Batches || [];

        // Ensure shipping master data is loaded for responsabilities fallback
        if (this.ShippingResponsabilities.length === 0 || this.ShippingServiceTypes.length === 0) {
          this.GetShippingMasterData();
        }

        // Derive UI display properties from batch data and match objects for dropdowns
        this.ProcessOrdersBatches.forEach((batch: any, idx: number) => {
          // Derive PartnerID and PartnerName from first CartItem
          const firstItem = batch.CartItems?.[0];
          batch._partnerID = firstItem?.CartItemOrderInfo?.OrderPartner?.ID || '';
          batch._partnerName = firstItem?.CartItemOrderInfo?.OrderPartner?.Name || '';

          // Derive ZipCode from ShippingDetails.Receiver
          batch._zipCode = batch.ShippingDetails?.Receiver?.ZipCode || '';
          batch._city = batch.ShippingDetails?.Receiver?.City || '';

          // Match shipping objects with batch-level AvailableShippingCompanies (from GetCountryShippingOptions), fallback to global
          const batchCompanies = batch.AvailableShippingCompanies?.length > 0 ? batch.AvailableShippingCompanies : this.ShippingCompanies;
          if (batch.ShippingDetails) {
            if (batch.ShippingDetails.ShippingServiceType?.ID) {
              const matchedType = this.ShippingServiceTypes.find((t: any) => t.ID === batch.ShippingDetails.ShippingServiceType.ID);
              if (matchedType) batch.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(matchedType));
            }
            if (batch.ShippingDetails.ShippingResponsability?.ID) {
              const matchedResp = this.ShippingResponsabilities.find((r: any) => r.ID === batch.ShippingDetails.ShippingResponsability.ID);
              if (matchedResp) batch.ShippingDetails.ShippingResponsability = JSON.parse(JSON.stringify(matchedResp));
            }
            if (batch.ShippingDetails.ShippingCompany?.ID) {
              const matchedCompany = batchCompanies.find((c: any) => c.ID === batch.ShippingDetails.ShippingCompany.ID);
              if (matchedCompany) batch.ShippingDetails.ShippingCompany = JSON.parse(JSON.stringify(matchedCompany));
            } else {
              // Fallback: preselect the company marked IsSelected by GetCountryShippingOptions (last-used or default)
              const preselected = batchCompanies.find((c: any) => c.IsSelected === true);
              if (preselected) batch.ShippingDetails.ShippingCompany = JSON.parse(JSON.stringify(preselected));
            }
            // If ShippingServiceType is still not set, pick the one marked IsSelected from the selected company's service types
            if (!batch.ShippingDetails.ShippingServiceType?.ID && batch.ShippingDetails.ShippingCompany?.ID) {
              const selectedCompany = batchCompanies.find((c: any) => c.ID === batch.ShippingDetails.ShippingCompany.ID);
              const preselectedType = selectedCompany?.ShippingServiceTypes?.find((t: any) => t.IsSelected === true);
              if (preselectedType) batch.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(preselectedType));
            }
          }

          // Match ProcessingSettings objects with master data for dropdown binding
          if (batch.ProcessingSettings) {
            if (batch.ProcessingSettings.PartnerCompany?.ID) {
              const matchedComp = this.parent.User?.Rights?.AssignedCompanies?.find((c: any) => c.ID === batch.ProcessingSettings.PartnerCompany.ID);
              if (matchedComp) batch.ProcessingSettings.PartnerCompany = JSON.parse(JSON.stringify(matchedComp));
            }
            if (batch.ProcessingSettings.Currency?.ID && this.parent.masterData?.Currencies) {
              const matchedCur = this.parent.masterData.Currencies.find((c: any) => c.ID === batch.ProcessingSettings.Currency.ID);
              if (matchedCur) batch.ProcessingSettings.Currency = JSON.parse(JSON.stringify(matchedCur));
            }
          }

          // Ensure GroupingSettings exists on each batch (backend provides it, but fallback if missing)
          if (!batch.GroupingSettings) {
            batch.GroupingSettings = {
              PartnerID: batch._partnerID,
              GroupByShippingServiceType: true,
              GroupByShippingAddress: true,
              GroupByShippingCompany: false,
              GroupByCurrency: false,
              GroupByInvoicingCompany: true
            };
          }

          // Generate unique batch ID for drag-drop
          batch._batchId = `batch_${batch._partnerID}_${batch._zipCode}_${batch.ShippingDetails?.ShippingServiceType?.ID || 0}_${idx}`;
          // Track expansion state
          batch._expanded = true;
          // Track regrouping state
          batch._regrouping = false;
          // Initialize boxes array on ShippingDetails if not present (default 1 box)
          if (!batch.ShippingDetails) batch.ShippingDetails = {};
          if (!batch.ShippingDetails.Boxes || batch.ShippingDetails.Boxes.length === 0) {
            batch.ShippingDetails.Boxes = [{ ID: 0, Length: 10, Width: 10, Height: 10, Weight: 1, TrackingLabel: null, IsPallet: false, UIID: this.parent.newGuid() }];
          }

          // Match current Receiver to AvailableShippingAddresses so the checkmark shows on load
          if (batch.ShippingDetails?.Receiver && batch.AvailableShippingAddresses?.length > 0) {
            const recv = batch.ShippingDetails.Receiver;
            const matched = batch.AvailableShippingAddresses.find((a: any) =>
              a.ID === recv.ID ||
              (a.ZipCode === recv.ZipCode && a.AddressLine === recv.AddressLine && a.City === recv.City && a.ContactCompany === recv.ContactCompany)
            );
            if (matched) {
              batch.ShippingDetails.Receiver = matched;
            }
          }
        });

        this.ShowProcessOrdersBatchReview = true;
        console.log('✅ Prepared batches:', this.ProcessOrdersBatches);
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to prepare batches', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.processingOrders = false;
      console.error('❌ Process Orders error:', error);
      this.parent.openSnackBar('Error preparing order batches', 'OK', 'alert-info-snackbar');
    });
  }

  // Get unique available service types from a batch's AvailableShippingCompanies
  getBatchAvailableServiceTypes(batch: any): any[] {
    if (!batch?.AvailableShippingCompanies?.length) return this.ShippingServiceTypes || [];
    const serviceTypeMap: { [id: number]: any } = {};
    batch.AvailableShippingCompanies.forEach((company: any) => {
      if (company.ShippingServiceTypes?.length) {
        company.ShippingServiceTypes.forEach((svc: any) => {
          if (!serviceTypeMap[svc.ID]) serviceTypeMap[svc.ID] = svc;
        });
      }
    });
    const result = Object.values(serviceTypeMap);
    return result.length > 0 ? result : this.ShippingServiceTypes || [];
  }

  // Get display text for a DecimalPrecision object by matching its ID to decimalPrecisionOptions
  getDecimalPrecisionMeaning(dp: any): string {
    if (!dp || !dp.ID) return 'Select...';
    const match = this.decimalPrecisionOptions.find((o: any) => o.ID === dp.ID);
    return match?.Meaning || dp.Meaning || (dp.ID + ' Decimals');
  }

  // Select decimal precision for a batch and sync to currency
  selectBatchDecimalPrecision(batch: any, dp: any): void {
    batch.ProcessingSettings.DecimalPrecision = dp;
    if (batch.ProcessingSettings.Currency) {
      batch.ProcessingSettings.Currency.DecimalPrecision = dp;
    }
    batch._showProcPrecisionDropdown = false;
  }

  // Save batch processing settings to backend
  saveBatchProcessingSettings(batch: any): void {
    if (!batch?.ProcessingSettings?.PartnerID || batch._savingSettings) return;
    batch._savingSettings = true;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ProcessingSettings: batch.ProcessingSettings
    };

    this.service.AddUpdatePartnerProcessingSettings(request).subscribe((response: any) => {
      batch._savingSettings = false;
      if (response.Status === 1) {
        this.parent.openSnackBar('Processing settings saved', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to save settings', 'OK', 'alert-info-snackbar');
      }
    }, () => {
      batch._savingSettings = false;
      this.parent.openSnackBar('Error saving processing settings', 'OK', 'alert-info-snackbar');
    });
  }

  // Calculate sub-total (cart items only, no shipping)
  getBatchSubTotal(batch: any): number {
    if (!batch?.CartItems?.length) return 0;
    return batch.CartItems.reduce((sum: number, item: any) => sum + (item.Price?.UIQtyPrice || 0), 0);
  }

  // Calculate total shipping costs
  getBatchShippingTotal(batch: any): number {
    if (!batch?.ShippingCosts?.length) return 0;
    return batch.ShippingCosts.reduce((sum: number, sc: any) => sum + (parseFloat(sc.ShippingCost) || 0), 0);
  }

  // Grand total = sub-total + all shipping costs
  getBatchGrandTotal(batch: any): number {
    return this.getBatchSubTotal(batch) + this.getBatchShippingTotal(batch);
  }

  // Get batches grouped by PartnerID for drag-drop compatibility
  getBatchesByPartner(partnerId: string): any[] {
    return this.ProcessOrdersBatches.filter((b: any) => b._partnerID === partnerId);
  }

  // Get unique partner IDs from batches
  getUniquePartnerIDs(): string[] {
    const ids = this.ProcessOrdersBatches.map((b: any) => b._partnerID);
    return [...new Set(ids)];
  }

  // Get connected drop lists for drag-drop (same partner only)
  getConnectedDropLists(batch: any): string[] {
    return this.ProcessOrdersBatches
      .filter((b: any) => b._partnerID === batch._partnerID && b._batchId !== batch._batchId)
      .map((b: any) => b._batchId);
  }

  // Handle drag-drop of cart item between batches
  onBatchItemDrop(event: any, targetBatch: any): void {
    if (event.previousContainer === event.container) {
      // Reorder within same batch - no action needed
      return;
    }

    // Move item from source batch to target batch
    const item = event.previousContainer.data[event.previousIndex];

    // Remove from source batch
    event.previousContainer.data.splice(event.previousIndex, 1);

    // Add to target batch
    event.container.data.splice(event.currentIndex, 0, item);

    // Check if source batch is now empty and remove it
    const sourceBatch = this.ProcessOrdersBatches.find((b: any) => b.CartItems === event.previousContainer.data);
    if (sourceBatch && sourceBatch.CartItems.length === 0) {
      this.ProcessOrdersBatches = this.ProcessOrdersBatches.filter((b: any) => b !== sourceBatch);
    }

    console.log('✅ Moved item to batch:', targetBatch._batchId);
  }

  // Remove single item from batch
  removeItemFromBatch(batch: any, item: any): void {
    const index = batch.CartItems.indexOf(item);
    if (index > -1) {
      batch.CartItems.splice(index, 1);

      // If batch is now empty, remove it
      if (batch.CartItems.length === 0) {
        this.ProcessOrdersBatches = this.ProcessOrdersBatches.filter((b: any) => b !== batch);
        this.parent.openSnackBar('Batch removed (no items remaining)', 'OK', 'light-info-snackbar');
      }
    }
  }

  // Select a different shipping address for a batch
  selectBatchAddress(batch: any, addr: any): void {
    if (!batch.ShippingDetails) batch.ShippingDetails = {};
    batch.ShippingDetails.Receiver = addr;
    batch._zipCode = addr.ZipCode || '';
    batch._city = addr.City || '';
    batch._showAddressSelector = false;
  }

  // ========== Batch Address Edit Popup ==========
  showBatchAddressEditPopup: boolean = false;
  batchAddressEditing: any = {};
  batchAddressEditBatch: any = null;
  savingBatchAddress: boolean = false;

  openBatchAddressEditor(batch: any): void {
    this.batchAddressEditBatch = batch;
    this.batchAddressEditing = JSON.parse(JSON.stringify(batch.ShippingDetails?.Receiver || {}));
    this.showBatchAddressEditPopup = true;
  }

  closeBatchAddressEditor(): void {
    this.showBatchAddressEditPopup = false;
    this.batchAddressEditing = {};
    this.batchAddressEditBatch = null;
  }

  saveBatchAddress(): void {
    const batch = this.batchAddressEditBatch;
    if (!batch || !this.batchAddressEditing) return;
    const partnerId = batch.CartItems?.[0]?.CartItemOrderInfo?.OrderPartner?.ID;
    if (!partnerId) return;

    this.savingBatchAddress = true;
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: this.batchAddressEditing,
      PartnerID: partnerId
    };

    this.service.AddUpdateShippingAddress(request).subscribe((response: any) => {
      this.savingBatchAddress = false;
      if (response.Status === 1) {
        const saved = response.ShippingAddress;
        batch.ShippingDetails.Receiver = saved;
        batch._zipCode = saved.ZipCode || '';
        batch._city = saved.City || '';
        if (batch.AvailableShippingAddresses) {
          const idx = batch.AvailableShippingAddresses.findIndex((a: any) => a.ID === saved.ID);
          if (idx >= 0) batch.AvailableShippingAddresses[idx] = saved;
          else batch.AvailableShippingAddresses.push(saved);
        }
        this.closeBatchAddressEditor();
        this.parent.openSnackBar('Address saved', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response.Message || 'Error', 'OK', 'alert-info-snackbar');
      }
    }, () => {
      this.savingBatchAddress = false;
      this.parent.openSnackBar('Error saving address', 'OK', 'alert-info-snackbar');
    });
  }

  // Remove entire batch from processing
  removeBatchFromProcessing(batch: any): void {
    this.ProcessOrdersBatches = this.ProcessOrdersBatches.filter((b: any) => b !== batch);
  }

  // Close batch review popup
  closeBatchReview(): void {
    this.ShowProcessOrdersBatchReview = false;
    this.ProcessOrdersBatches = [];
  }

  // ✅ Batch Grouping Settings Popup
  ShowBatchGroupingSettings: boolean = false;
  CurrentGroupingSettings: any = {};
  CurrentGroupingPartnerID: string = '';
  CurrentGroupingPartnerName: string = '';
  regroupingBatches: boolean = false;

  openBatchGroupingSettings(batch: any): void {
    this.CurrentGroupingPartnerID = batch._partnerID;
    this.CurrentGroupingPartnerName = batch._partnerName || 'Partner #' + batch._partnerID;

    // Fetch current grouping settings for this partner
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: batch._partnerID
    };

    this.parent.loading = true;
    this.service.GetPartnerProcessingSettingsGrouping(request).subscribe((response: any) => {
      this.parent.loading = false;
      if (response.Status === 1 && response.GroupingSettings) {
        this.CurrentGroupingSettings = JSON.parse(JSON.stringify(response.GroupingSettings));
      } else {
        // Default settings if none exist
        this.CurrentGroupingSettings = {
          PartnerID: batch._partnerID,
          GroupByShippingServiceType: true,
          GroupByShippingAddress: true,
          GroupByShippingCompany: false,
          GroupByCurrency: false,
          GroupByInvoicingCompany: true
        };
      }
      this.ShowBatchGroupingSettings = true;
    }, (error: any) => {
      this.parent.loading = false;
      this.parent.openSnackBar('Failed to load grouping settings', 'OK', 'alert-info-snackbar');
    });
  }

  closeBatchGroupingSettings(): void {
    this.ShowBatchGroupingSettings = false;
    this.CurrentGroupingSettings = {};
    this.CurrentGroupingPartnerID = '';
    this.CurrentGroupingPartnerName = '';
  }

  saveAndCloseGroupingSettings(): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      GroupingSettings: this.CurrentGroupingSettings
    };

    this.parent.loading = true;
    this.service.AddUpdatePartnerProcessingSettingsGrouping(request).subscribe((response: any) => {
      this.parent.loading = false;
      if (response.Status === 1) {
        this.parent.openSnackBar('Grouping settings saved', 'OK', 'light-info-snackbar');
        this.closeBatchGroupingSettings();
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to save settings', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      this.parent.openSnackBar('Failed to save grouping settings', 'OK', 'alert-info-snackbar');
    });
  }

  regroupBatchesForPartner(): void {
    if (this.regroupingBatches) return;

    // Save settings first, then regroup
    const saveRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      GroupingSettings: this.CurrentGroupingSettings
    };

    this.regroupingBatches = true;

    // Save settings
    this.service.AddUpdatePartnerProcessingSettingsGrouping(saveRequest).subscribe((saveResponse: any) => {
      if (saveResponse.Status !== 1) {
        this.regroupingBatches = false;
        this.parent.openSnackBar(saveResponse.Message || 'Failed to save settings', 'OK', 'alert-info-snackbar');
        return;
      }

      // Get all cart items from batches for this partner
      const partnerBatches = this.ProcessOrdersBatches.filter((b: any) => b._partnerID === this.CurrentGroupingPartnerID);
      const allCartItems: any[] = [];
      partnerBatches.forEach((batch: any) => {
        if (batch.CartItems) {
          allCartItems.push(...batch.CartItems);
        }
      });

      if (allCartItems.length === 0) {
        this.regroupingBatches = false;
        this.parent.openSnackBar('No items to regroup', 'OK', 'alert-info-snackbar');
        return;
      }

      // Call backend to regroup these items
      // Send full CartItem objects (backend filters by ProgressStatus.ID == 2)
      const regroupRequest = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CartItems: allCartItems,
        ShippingMasterData: {
          ShippingResponsabilities: this.ShippingResponsabilities,
          ShippingServiceTypes: this.ShippingServiceTypes,
          ShippingCompanies: this.ShippingCompanies
        }
      };

      this.managementService.PrepareFullProcessOrderedBatches(regroupRequest).subscribe((response: any) => {
        this.regroupingBatches = false;

        if (response.Status === 1 && response.Batches) {
          // Find the position of the first old batch for this partner so we insert new ones in-place
          const firstOldIndex = this.ProcessOrdersBatches.findIndex((b: any) => b._partnerID === this.CurrentGroupingPartnerID);
          const oldCount = this.ProcessOrdersBatches.filter((b: any) => b._partnerID === this.CurrentGroupingPartnerID).length;

          // Prepare new batches with UI properties
          const preparedBatches: any[] = [];
          response.Batches.forEach((batch: any, idx: number) => {
            const firstItem = batch.CartItems?.[0];
            batch._partnerID = firstItem?.CartItemOrderInfo?.OrderPartner?.ID || '';
            batch._partnerName = firstItem?.CartItemOrderInfo?.OrderPartner?.Name || '';
            batch._zipCode = batch.ShippingDetails?.Receiver?.ZipCode || '';
            batch._city = batch.ShippingDetails?.Receiver?.City || '';

            // Match dropdown objects
            if (batch.ShippingDetails?.ShippingServiceType?.ID) {
              const match = this.ShippingServiceTypes.find((s: any) => s.ID === batch.ShippingDetails.ShippingServiceType.ID);
              if (match) batch.ShippingDetails.ShippingServiceType = match;
            }
            if (batch.ShippingDetails?.ShippingResponsability?.ID) {
              const match = this.ShippingResponsabilities.find((r: any) => r.ID === batch.ShippingDetails.ShippingResponsability.ID);
              if (match) batch.ShippingDetails.ShippingResponsability = match;
            }
            if (batch.ShippingDetails?.ShippingCompany?.ID) {
              const match = this.ShippingCompanies.find((c: any) => c.ID === batch.ShippingDetails.ShippingCompany.ID);
              if (match) batch.ShippingDetails.ShippingCompany = match;
            }

            batch._batchId = `batch_${batch._partnerID}_${batch._zipCode}_${batch.ShippingDetails?.ShippingServiceType?.ID || 0}_${Date.now()}_${idx}`;
            batch._expanded = true;

            preparedBatches.push(batch);
          });

          // Replace old batches in-place: remove old ones and insert new ones at the same position
          const insertAt = firstOldIndex >= 0 ? firstOldIndex : this.ProcessOrdersBatches.length;
          this.ProcessOrdersBatches.splice(insertAt, oldCount, ...preparedBatches);

          this.closeBatchGroupingSettings();
          this.parent.openSnackBar('Batches regrouped successfully', 'OK', 'light-info-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Failed to regroup batches', 'OK', 'alert-info-snackbar');
        }
      }, (error: any) => {
        this.regroupingBatches = false;
        this.parent.openSnackBar('Failed to regroup batches', 'OK', 'alert-info-snackbar');
      });
    }, (error: any) => {
      this.regroupingBatches = false;
      this.parent.openSnackBar('Failed to save settings', 'OK', 'alert-info-snackbar');
    });
  }

  /**
   * Regroup a single batch (and all batches from the same partner) based on updated grouping settings.
   * Uses the dedicated RegroupBatch endpoint which saves settings and regroups in one call.
   */
  regroupSingleBatch(batch: any): void {
    if (batch._regrouping) return;

    const partnerId = batch._partnerID;
    if (!partnerId) {
      this.parent.openSnackBar('Invalid batch - no partner ID', 'OK', 'alert-info-snackbar');
      return;
    }

    // Ensure GroupingSettings exists
    if (!batch.GroupingSettings) {
      batch.GroupingSettings = {
        PartnerID: partnerId,
        GroupByShippingServiceType: true,
        GroupByShippingAddress: true,
        GroupByShippingCompany: false,
        GroupByCurrency: false,
        GroupByInvoicingCompany: true
      };
    }

    // Get all cart items from ALL batches for this partner
    const partnerBatches = this.ProcessOrdersBatches.filter((b: any) => b._partnerID === partnerId);
    const allCartItems: any[] = [];
    partnerBatches.forEach((b: any) => {
      if (b.CartItems) {
        allCartItems.push(...b.CartItems);
      }
    });

    if (allCartItems.length === 0) {
      this.parent.openSnackBar('No items to regroup', 'OK', 'alert-info-snackbar');
      return;
    }

    // Mark this batch as regrouping
    batch._regrouping = true;

    // Call the new RegroupBatch endpoint (saves settings + regroups in one call)
    const regroupRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      OriginalBatchID: batch.ID,
      PartnerID: partnerId,
      CartItems: allCartItems,
      GroupingSettings: { ...batch.GroupingSettings, PartnerID: partnerId }
    };

    this.managementService.RegroupBatch(regroupRequest).subscribe((response: any) => {
      batch._regrouping = false;

      if (response.Status === 1 && response.NewBatches) {
        // Find the position of the first old batch for this partner so we insert new ones in-place
        const firstOldIndex = this.ProcessOrdersBatches.findIndex((b: any) => b._partnerID === partnerId);
        const oldCount = this.ProcessOrdersBatches.filter((b: any) => b._partnerID === partnerId).length;

        // Prepare new batches with UI properties
        const preparedBatches: any[] = [];
        response.NewBatches.forEach((newBatch: any, idx: number) => {
          const firstItem = newBatch.CartItems?.[0];
          newBatch._partnerID = firstItem?.CartItemOrderInfo?.OrderPartner?.ID || '';
          newBatch._partnerName = firstItem?.CartItemOrderInfo?.OrderPartner?.Name || '';
          newBatch._zipCode = newBatch.ShippingDetails?.Receiver?.ZipCode || '';
          newBatch._city = newBatch.ShippingDetails?.Receiver?.City || '';

          // Ensure GroupingSettings exists on the new batch
          if (!newBatch.GroupingSettings) {
            newBatch.GroupingSettings = {
              PartnerID: newBatch._partnerID,
              GroupByShippingServiceType: batch.GroupingSettings?.GroupByShippingServiceType ?? true,
              GroupByShippingAddress: batch.GroupingSettings?.GroupByShippingAddress ?? true,
              GroupByShippingCompany: batch.GroupingSettings?.GroupByShippingCompany ?? false,
              GroupByCurrency: batch.GroupingSettings?.GroupByCurrency ?? false,
              GroupByInvoicingCompany: batch.GroupingSettings?.GroupByInvoicingCompany ?? true
            };
          }

          // Match dropdown objects
          if (newBatch.ShippingDetails?.ShippingServiceType?.ID) {
            const match = this.ShippingServiceTypes.find((s: any) => s.ID === newBatch.ShippingDetails.ShippingServiceType.ID);
            if (match) newBatch.ShippingDetails.ShippingServiceType = match;
          }
          if (newBatch.ShippingDetails?.ShippingResponsability?.ID) {
            const match = this.ShippingResponsabilities.find((r: any) => r.ID === newBatch.ShippingDetails.ShippingResponsability.ID);
            if (match) newBatch.ShippingDetails.ShippingResponsability = match;
          }
          if (newBatch.ShippingDetails?.ShippingCompany?.ID) {
            const match = this.ShippingCompanies.find((c: any) => c.ID === newBatch.ShippingDetails.ShippingCompany.ID);
            if (match) newBatch.ShippingDetails.ShippingCompany = match;
          }

          newBatch._batchId = `batch_${newBatch._partnerID}_${newBatch._zipCode}_${newBatch.ShippingDetails?.ShippingServiceType?.ID || 0}_${Date.now()}_${idx}`;
          newBatch._expanded = true;
          newBatch._regrouping = false;

          // Initialize boxes array on ShippingDetails if not present (default 1 box)
          if (!newBatch.ShippingDetails) newBatch.ShippingDetails = {};
          if (!newBatch.ShippingDetails.Boxes || newBatch.ShippingDetails.Boxes.length === 0) {
            newBatch.ShippingDetails.Boxes = [{ ID: 0, Length: 10, Width: 10, Height: 10, Weight: 1, TrackingLabel: null, IsPallet: false, UIID: this.parent.newGuid() }];
          }

          // Match Receiver to AvailableShippingAddresses so checkmark shows correctly
          if (newBatch.ShippingDetails?.Receiver && newBatch.AvailableShippingAddresses?.length > 0) {
            const recv = newBatch.ShippingDetails.Receiver;
            const matched = newBatch.AvailableShippingAddresses.find((a: any) =>
              a.ID === recv.ID ||
              (a.ZipCode === recv.ZipCode && a.AddressLine === recv.AddressLine && a.City === recv.City && a.ContactCompany === recv.ContactCompany)
            );
            if (matched) newBatch.ShippingDetails.Receiver = matched;
          }

          // Match ProcessingSettings objects with master data for dropdown binding
          if (newBatch.ProcessingSettings) {
            if (newBatch.ProcessingSettings.PartnerCompany?.ID) {
              const matchedComp = this.parent.User?.Rights?.AssignedCompanies?.find((c: any) => c.ID === newBatch.ProcessingSettings.PartnerCompany.ID);
              if (matchedComp) newBatch.ProcessingSettings.PartnerCompany = JSON.parse(JSON.stringify(matchedComp));
            }
            if (newBatch.ProcessingSettings.Currency?.ID && this.parent.masterData?.Currencies) {
              const matchedCur = this.parent.masterData.Currencies.find((c: any) => c.ID === newBatch.ProcessingSettings.Currency.ID);
              if (matchedCur) newBatch.ProcessingSettings.Currency = JSON.parse(JSON.stringify(matchedCur));
            }
          }

          preparedBatches.push(newBatch);
        });

        // Replace old batches in-place: remove old ones and insert new ones at the same position
        const insertAt = firstOldIndex >= 0 ? firstOldIndex : this.ProcessOrdersBatches.length;
        this.ProcessOrdersBatches.splice(insertAt, oldCount, ...preparedBatches);

        this.parent.openSnackBar('Batches regrouped successfully', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response.Message || 'Failed to regroup batches', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      batch._regrouping = false;
      this.parent.openSnackBar('Failed to regroup batches', 'OK', 'alert-info-snackbar');
    });
  }

  // ========== Processing Results ==========
  ShowProcessingResults: boolean = false;
  ProcessingResultsResponse: any = null;

  // ========== Processing Progress (SignalR) ==========
  ShowProcessingProgress: boolean = false;
  ProcessingProgressPercent: number = 0;
  ProcessingOverallPercent: number = 0;
  ProcessingProgressMessage: string = '';
  ProcessingProgressStepName: string = '';
  ProcessingProgressBatchIndex: number = 0;
  ProcessingProgressTotalBatches: number = 0;
  private processingProgressSub: any = null;

  // Execute processing for all batches
  async executeProcessAllBatches(): Promise<void> {
    if (this.ProcessOrdersBatches.length === 0) {
      this.parent.openSnackBar('No batches to process', 'OK', 'alert-info-snackbar');
      return;
    }

    if (this.executingProcessOrders) return;

    this.executingProcessOrders = true;

    // Hide any previous results container so progress overlay is fully visible
    this.ShowProcessingResults = false;

    // Reset and show progress bar
    this.ProcessingProgressPercent = 0;
    this.ProcessingOverallPercent = 0;
    this.ProcessingProgressMessage = this.translate.instant('ProcessingStarting');
    this.ProcessingProgressStepName = '';
    this.ProcessingProgressBatchIndex = 0;
    this.ProcessingProgressTotalBatches = this.ProcessOrdersBatches.length;
    this.ShowProcessingProgress = true;

    // Connect SignalR for real-time progress
    let signalRConnectionId = '';
    try {
      signalRConnectionId = await this.signalRService.connect();
    } catch (error) {
      console.warn('SignalR connection failed, proceeding without real-time updates', error);
    }

    // Subscribe to progress updates
    this.processingProgressSub = this.signalRService.orderProcessingProgress$.subscribe(
      (update: OrderProcessingProgressUpdate) => {
        this.ngZone.run(() => {
          this.ProcessingProgressPercent = update.ProgressPercent;
          this.ProcessingOverallPercent = update.OverallPercent;
          this.ProcessingProgressMessage = update.Message;
          this.ProcessingProgressStepName = update.StepName;
          this.ProcessingProgressBatchIndex = update.BatchIndex;
          this.ProcessingProgressTotalBatches = update.TotalBatches;
        });
      }
    );

    const request: any = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      SignalRConnectionId: signalRConnectionId,
      Batches: this.ProcessOrdersBatches.map((batch: any) => ({
        ID: batch.ID,
        CartItems: batch.CartItems,
        ShippingDetails: batch.ShippingDetails,
        ProcessingSettings: batch.ProcessingSettings,
        GroupingSettings: batch.GroupingSettings,
        ContractualConditions: batch.ContractualConditions,
        Agents: batch.Agents,
        Documents: batch.Documents || [],
        ShippingCosts: batch.ShippingCosts || [],
        NotificationRecipients: batch.NotificationRecipients || [],
        LogisticsRecipients: batch.LogisticsRecipients || [],
        InvoiceRecipients: batch.InvoiceRecipients || []
      }))
    };

    this.managementService.FullProcessOrderedItems(request).subscribe((response: any) => {
      this.executingProcessOrders = false;
      this.ShowProcessingProgress = false;
      this.cleanupProcessingProgress();

      // Always show results container with detailed per-batch information
      this.ProcessingResultsResponse = response;
      this.ShowProcessOrdersBatchReview = false;
      this.ShowProcessingResults = true;

      // Update grid cart items ProgressStatus for successfully processed batches
      if (response.BatchResults?.length > 0) {
        const invoicedIds = new Set<number>();
        response.BatchResults.forEach((br: any) => {
          if (br.Success && br.OriginalBatch?.CartItems?.length > 0) {
            br.OriginalBatch.CartItems.forEach((ci: any) => {
              if (ci.ID > 0 && ci.ProgressStatus) {
                invoicedIds.add(ci.ID);
              }
            });
          }
        });

        if (invoicedIds.size > 0 && this.productsGridApi) {
          const invoicedStatus = response.BatchResults.find((br: any) => br.Success)?.OriginalBatch?.CartItems?.find((ci: any) => ci.ProgressStatus)?.ProgressStatus;
          if (invoicedStatus) {
            this.productsGridApi.forEachNode((node: any) => {
              if (node.data?.CartItem && invoicedIds.has(node.data.CartItem.ID)) {
                node.data.CartItem.ProgressStatus = invoicedStatus;
              }
            });
            this.productsGridApi.refreshCells({ force: true });
          }
        }
      }

      if (response.Status === 1) {
        this.parent.openSnackBar(response.Message || 'Batches processed successfully', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response.Message || 'Some batches failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.executingProcessOrders = false;
      this.ShowProcessingProgress = false;
      this.cleanupProcessingProgress();
      console.error('FullProcessOrderedItems error:', error);
      this.parent.openSnackBar('Error processing batches', 'OK', 'alert-info-snackbar');
    });
  }

  private cleanupProcessingProgress(): void {
    if (this.processingProgressSub) {
      this.processingProgressSub.unsubscribe();
      this.processingProgressSub = null;
    }
  }

  // Close processing results and refresh grid
  closeProcessingResults(): void {
    this.ShowProcessingResults = false;
    this.ProcessingResultsResponse = null;
    this.ProcessOrdersBatches = [];
    this.applyFilter(1);
  }

  // Download a document from its base64 content
  downloadDocument(doc: any): void {
    if (!doc?.PDFStream) return;
    const byteCharacters = atob(doc.PDFStream);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = doc.Name || 'document.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  // Print a document from its base64 content
  printDocument(doc: any): void {
    if (!doc?.PDFStream) return;
    const byteCharacters = atob(doc.PDFStream);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const printWindow = window.open(url);
    if (printWindow) {
      printWindow.onload = () => printWindow.print();
    }
  }

  // Download a result document — for invoices (DocType=2) re-export via ExportInvoice to include shipping details
  downloadResultDocument(doc: any): void {
    if (doc?.DocType === 2 && doc?.ID) {
      this.service.ExportInvoice({
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        InvoiceID: doc.ID
      }).subscribe((response: any) => {
        if (response.Status === 1 && response.Document) {
          this.downloadDocument(response.Document);
        } else {
          // Fallback to cached PDF
          this.downloadDocument(doc);
        }
      }, () => this.downloadDocument(doc));
    } else {
      this.downloadDocument(doc);
    }
  }

  // Print a result document — for invoices (DocType=2) re-export via ExportInvoice to include shipping details
  printResultDocument(doc: any): void {
    if (doc?.DocType === 2 && doc?.ID) {
      this.service.ExportInvoice({
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        InvoiceID: doc.ID
      }).subscribe((response: any) => {
        if (response.Status === 1 && response.Document) {
          this.printDocument(response.Document);
        } else {
          // Fallback to cached PDF
          this.printDocument(doc);
        }
      }, () => this.printDocument(doc));
    } else {
      this.printDocument(doc);
    }
  }

  // Get step status label translation key
  getStepStatusKey(status: number): string {
    switch (status) {
      case 0: return 'StepSkipped';
      case 1: return 'StepSuccess';
      case 2: return 'StepFailed';
      case 3: return 'StepPending';
      default: return 'StepPending';
    }
  }

  // Get step status CSS class
  getStepStatusClass(status: number): string {
    switch (status) {
      case 0: return 'step-skipped';
      case 1: return 'step-success';
      case 2: return 'step-failed';
      case 3: return 'step-pending';
      default: return 'step-pending';
    }
  }

  // Get available service types for a result batch (from OriginalBatch.AvailableShippingCompanies, fallback global)
  getResultAvailableServiceTypes(br: any): any[] {
    const companies = br.OriginalBatch?.AvailableShippingCompanies;
    if (!companies?.length) return this.ShippingServiceTypes || [];
    const map: { [id: number]: any } = {};
    companies.forEach((c: any) => {
      if (c.ShippingServiceTypes?.length) {
        c.ShippingServiceTypes.forEach((svc: any) => { if (!map[svc.ID]) map[svc.ID] = svc; });
      }
    });
    const result = Object.values(map);
    return result.length > 0 ? result : this.ShippingServiceTypes || [];
  }

  // Get available companies for a result batch (from OriginalBatch.AvailableShippingCompanies, fallback global)
  getResultAvailableCompanies(br: any): any[] {
    return br.OriginalBatch?.AvailableShippingCompanies?.length > 0
      ? br.OriginalBatch.AvailableShippingCompanies
      : this.ShippingCompanies || [];
  }

  // Get slave companies for "Sell Through" dropdown — only companies where current company is Master
  getSlaveCompanies(): any[] {
    const currentCompany = this.parent.User?.Rights?.AssignedCompanies?.find((c: any) => c.IsSelected);
    if (!currentCompany?.Relationships?.length) return [];
    const slaveIds = currentCompany.Relationships
      .filter((r: any) => r.Active)
      .map((r: any) => r.SlaveCompanyID);
    return (this.parent.User?.Rights?.AssignedCompanies || [])
      .filter((c: any) => slaveIds.includes(c.ID));
  }

  // Retry a single failed batch — sends OriginalBatch back with existing Documents
  retryBatch(batchResult: any): void {
    if (!batchResult?.OriginalBatch) return;
    if (batchResult._retrying) return;

    batchResult._retrying = true;

    const retryBatch = batchResult.OriginalBatch;
    // Documents from previous successful steps are already in retryBatch.Documents (set by backend)

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Batches: [{
        ID: retryBatch.ID,
        CartItems: retryBatch.CartItems,
        ShippingDetails: retryBatch.ShippingDetails,
        ProcessingSettings: retryBatch.ProcessingSettings,
        GroupingSettings: retryBatch.GroupingSettings,
        ContractualConditions: retryBatch.ContractualConditions,
        Agents: retryBatch.Agents,
        Documents: retryBatch.Documents || [],
        ShippingCosts: retryBatch.ShippingCosts || [],
        NotificationRecipients: retryBatch.NotificationRecipients || [],
        LogisticsRecipients: retryBatch.LogisticsRecipients || [],
        InvoiceRecipients: retryBatch.InvoiceRecipients || []
      }]
    };

    this.managementService.FullProcessOrderedItems(request).subscribe((response: any) => {
      batchResult._retrying = false;

      if (response?.BatchResults?.length > 0) {
        const newResult = response.BatchResults[0];
        // Replace the old batch result in the results array
        const idx = this.ProcessingResultsResponse.BatchResults.indexOf(batchResult);
        if (idx > -1) {
          this.ProcessingResultsResponse.BatchResults[idx] = newResult;
        }

        // Recalculate summary message
        const total = this.ProcessingResultsResponse.BatchResults.length;
        const success = this.ProcessingResultsResponse.BatchResults.filter((r: any) => r.Success).length;
        const failed = total - success;
        this.ProcessingResultsResponse.Message = response.Message || `Processed ${total} batch(es): ${success} succeeded, ${failed} failed`;

        if (newResult.Success) {
          // Update grid cart items ProgressStatus for retry success
          if (newResult.OriginalBatch?.CartItems?.length > 0 && this.productsGridApi) {
            const invoicedStatus = newResult.OriginalBatch.CartItems.find((ci: any) => ci.ProgressStatus)?.ProgressStatus;
            if (invoicedStatus) {
              const retryIds = new Set(newResult.OriginalBatch.CartItems.filter((ci: any) => ci.ID > 0).map((ci: any) => ci.ID));
              this.productsGridApi.forEachNode((node: any) => {
                if (node.data?.CartItem && retryIds.has(node.data.CartItem.ID)) {
                  node.data.CartItem.ProgressStatus = invoicedStatus;
                }
              });
              this.productsGridApi.refreshCells({ force: true });
            }
          }
          this.parent.openSnackBar('Batch retried successfully', 'OK', 'light-info-snackbar');
        } else {
          this.parent.openSnackBar(newResult.ErrorMessage || 'Retry failed', 'OK', 'alert-info-snackbar');
        }
      }
    }, (error: any) => {
      batchResult._retrying = false;
      this.parent.openSnackBar('Retry failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ========== Batch Shipping Costs Management ==========

  addBatchShippingCost(batch: any): void {
    if (!batch.ShippingCosts) batch.ShippingCosts = [];
    const firstItem = batch.CartItems?.[0];
    const defaultSplitType = this.MasterData?.ShippingCostSplitTypes?.find((st: any) => st.ID === -1) || { ID: -1, Name: 'Full On First Invoice' };
    batch.ShippingCosts.push({
      OrderDBID: 0,
      OrderID: null,
      ReferenceNumber: null,
      CartID: 0,
      ShippingCost: 0,
      Currency: firstItem?.CartItemOrderInfo?.OrderCurrency || firstItem?.SelectedOffer?.Currency || null,
      IsTransferred: false,
      DischargeType: null,
      SplitType: defaultSplitType,
      UIID: this.parent.newGuid()
    });
  }

  removeBatchShippingCost(batch: any, index: number): void {
    if (batch.ShippingCosts?.length > 1) {
      batch.ShippingCosts.splice(index, 1);
    }
  }

  // ========== Simulate Shipping Cost ==========

  simulateBatchShippingCost(batch: any): void {
    if (batch._simulatingCost) return;
    const sd = batch.ShippingDetails;
    if (!sd?.ShippingCompany?.ID) {
      this.parent.openSnackBar('Please select a shipping company first', 'OK', 'alert-info-snackbar');
      return;
    }
    if (!sd?.Sender || !sd?.Receiver) {
      this.parent.openSnackBar('Sender and Receiver addresses are required', 'OK', 'alert-info-snackbar');
      return;
    }

    batch._simulatingCost = true;
    batch._simulatedCost = null;
    batch._simulatedCostCurrency = null;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingDetails: {
        Sender: sd.Sender,
        Receiver: sd.Receiver,
        ShippingCompany: sd.ShippingCompany,
        ShippingServiceType: sd.ShippingServiceType,
        ShippingDirection: sd.ShippingDirection || { ID: 1, Name: 'Export' },
        WeightType: sd.WeightType || { ID: 1, Name: 'KGS' },
        TotalWeight: sd.Boxes?.reduce((sum: number, b: any) => sum + (b.Weight || 1), 0) || 1,
        Boxes: sd.Boxes || [{ Weight: 1, Length: 30, Width: 20, Height: 15, Multiply: 1 }],
      },
      CreateShippingLabelSettings: {
        DownloadType: { ID: 1, Name: 'Download' },
        SendEmail: false
      }
    };

    this.managementService.SimulateShippingCost(request).subscribe((response: any) => {
      batch._simulatingCost = false;
      if (response.Status === 1 && response.ShippingDetails?.Price) {
        batch._simulatedCost = response.ShippingDetails.Price.UIUnitPrice || 0;
        batch._simulatedCostCurrency = response.ShippingDetails.Price.Currency?.Symbol
          || response.ShippingDetails.Price.Currency?.Name || '';
      } else {
        this.parent.openSnackBar(response.Message || 'Simulation failed', 'OK', 'alert-info-snackbar');
      }
    }, () => {
      batch._simulatingCost = false;
      this.parent.openSnackBar('Simulation request failed', 'OK', 'alert-info-snackbar');
    });
  }

  allocateSimulatedCost(batch: any): void {
    if (batch._simulatedCost == null) return;
    if (!batch.ShippingCosts || batch.ShippingCosts.length === 0) {
      this.addBatchShippingCost(batch);
    }
    batch.ShippingCosts[0].ShippingCost = batch._simulatedCost;
    batch._simulatedCost = null;
    batch._simulatedCostCurrency = null;
  }

  // ========== Batch Notification Recipients ==========

  refreshBatchNotificationRecipients(batch: any): void {
    const partnerId = batch.CartItems?.[0]?.CartItemOrderInfo?.OrderPartner?.ID;
    if (!partnerId) return;

    const cartIDs = [...new Set(batch.CartItems
      ?.filter((ci: any) => ci.CartItemOrderInfo?.CartID > 0)
      .map((ci: any) => ci.CartItemOrderInfo.CartID) || [])];

    batch._loadingRecipients = true;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: partnerId,
      CartIDs: cartIDs,
      SendEachFileToTheAppropriateDepartment: batch.ProcessingSettings?.SendEachFileToTheAppropriateDepartment || false
    };

    this.managementService.GetBatchNotificationRecipients(request).subscribe((response: any) => {
      batch._loadingRecipients = false;
      if (response?.Status === 1) {
        batch.NotificationRecipients = response.NotificationRecipients || [];
        batch.LogisticsRecipients = response.LogisticsRecipients || [];
        batch.InvoiceRecipients = response.InvoiceRecipients || [];
      }
    }, () => { batch._loadingRecipients = false; });
  }

  // ========== Batch Boxes Management ==========

  addBatchBox(batch: any): void {
    if (!batch.ShippingDetails) batch.ShippingDetails = {};
    if (!batch.ShippingDetails.Boxes) batch.ShippingDetails.Boxes = [];
    batch.ShippingDetails.Boxes.push({ ID: 0, Length: 10, Width: 10, Height: 10, Weight: 1, TrackingLabel: null, IsPallet: false, UIID: this.parent.newGuid(), _multiplyFactor: null });
  }

  removeBatchBox(batch: any, index: number): void {
    batch.ShippingDetails.Boxes.splice(index, 1);
  }

  multiplyBatchBox(batch: any, box: any, index: number): void {
    const factor = parseInt(box._multiplyFactor);
    if (!factor || factor < 2 || factor > 10) return;

    const newBoxes = [];
    for (let i = 0; i < factor - 1; i++) {
      newBoxes.push({ ID: 0, Length: box.Length, Width: box.Width, Height: box.Height, Weight: box.Weight, TrackingLabel: null, IsPallet: false, UIID: this.parent.newGuid(), _multiplyFactor: null });
    }
    batch.ShippingDetails.Boxes.splice(index + 1, 0, ...newBoxes);
    box._multiplyFactor = null;
  }

  // Compare function for ngModel select binding
  compareById(a: any, b: any): boolean {
    return a && b && a.ID === b.ID;
  }

  // ✅ Pure next-status resolver (no side effects). Returns the next status ID or null.
  // Shortcuts: Hold -> New, New -> ReadyInWarehouse, OrderedToSupplier -> ReadyInWarehouse, ReadyInWarehouse -> Invoiced
  // Canceled and Invoiced return null (no shortcut transition)
  private getNextProgressStatusId(currentStatusId: number): number | null {
    // eCartItemProgressStatus enum values:
    // Canceled = -9999, Hold = -1000, New = 0, OrderedToSupplier = -10, ReadyInWarehouse = 2, Invoiced = 3
    switch (currentStatusId) {
      case -1000: return 0; // Hold -> New
      case 0: return 2;     // New -> ReadyInWarehouse
      case -10: return 2;   // OrderedToSupplier -> ReadyInWarehouse
      case 2: return 3;     // ReadyInWarehouse -> Invoiced
      default: return null; // Canceled (-9999), Invoiced (3), unknown -> nothing
    }
  }

  // ✅ Progress Status double-click shortcut handler
  // Computes the implied item(s) (single double-clicked row, or all selected rows when multi-selected),
  // then shows a confirmation popup before changing status (prevents accidental double-click changes).
  handleProgressStatusDoubleClick(params: any, isProductsGrid: boolean): void {
    const cartItem = params.data?.CartItem;
    if (!cartItem) return;

    // Check if we have multiple selected items (bulk update)
    const selectedItems = isProductsGrid
      ? this.getSelectedProductItems()
      : this.CartItemRows?.filter((item: any) => item.CartItem?.IsSelected === true) || [];

    const isMulti = selectedItems.length > 1;
    const itemsToProcess = isMulti ? selectedItems : [params.data];

    // Special case: single Invoiced item -> open invoice popup directly (navigation, not a status change)
    if (!isMulti && cartItem.ProgressStatus?.ID === 3) {
      this.openInvoicePopupForCartItem(cartItem);
      return;
    }

    // Compute the items that would actually transition (and to which status)
    const pending: any[] = [];
    itemsToProcess.forEach((row: any) => {
      const ci = row?.CartItem;
      if (!ci?.ProgressStatus) return;
      const nextStatusId = this.getNextProgressStatusId(ci.ProgressStatus.ID);
      if (nextStatusId == null) return;
      const nextStatus = this.MasterData?.CartItemProgressStatuses?.find((s: any) => s.ID === nextStatusId) || null;
      if (!nextStatus) return;
      pending.push({
        row,
        cartItem: ci,
        nextStatus,
        brand: ci?.Product?.Brand?.Name || ci?.UserSelectedBrand?.Name || '',
        name: ci?.UIProductValue || ci?.Product?.Name || '',
        currentStatusName: ci?.ProgressStatus?.Alias || '',
        nextStatusName: nextStatus?.Alias || ''
      });
    });

    // Nothing would change -> nothing to confirm
    if (pending.length === 0) return;

    // Store the pending change and show the confirmation popup
    this.pendingStatusChange = { params, isProductsGrid, isMulti, items: pending };
    this.statusChangeConfirmItems = pending;
    this.ShowStatusChangeConfirmation = true;
  }

  // ✅ Cancel the pending progress status change (no changes applied)
  cancelProgressStatusChange(): void {
    this.ShowStatusChangeConfirmation = false;
    this.pendingStatusChange = null;
    this.statusChangeConfirmItems = [];
  }

  // ✅ Apply the pending progress status change after user confirmation
  confirmProgressStatusChange(): void {
    const pc = this.pendingStatusChange;
    if (!pc) {
      this.ShowStatusChangeConfirmation = false;
      return;
    }

    const { params, isProductsGrid, isMulti, items } = pc;

    // Apply the computed status transitions
    items.forEach((p: any) => {
      p.cartItem.ProgressStatus = JSON.parse(JSON.stringify(p.nextStatus));
    });

    if (isMulti) {
      const rows = items.map((p: any) => p.row);
      if (isProductsGrid) {
        // ✅ redrawRows to re-evaluate rowClassRules (updates row background color instantly)
        const rowNodes = rows.map((item: any) => {
          const idx = this.ProductItems.indexOf(item);
          return this.productsGridApi?.getDisplayedRowAtIndex(idx);
        }).filter((n: any) => n != null);
        this.productsGridApi?.redrawRows({ rowNodes: rowNodes });
        // Bulk update all selected items (Products grid)
        this.BulkUpdateSelectedCartItems(rows);
      } else {
        this.offerGridApi?.refreshCells({ force: true });
        // ✅ Bulk update all selected items (Offers/EditContainer grid)
        if (this.AutoSave) {
          this.SaveAllSelectedEditContainerItems();
        }
      }
    } else {
      const cartItem = items[0].cartItem;
      // Refresh the grid and trigger auto-save
      if (isProductsGrid) {
        // ✅ redrawRows to re-evaluate rowClassRules (updates row background color instantly)
        const rowNode = this.productsGridApi?.getDisplayedRowAtIndex(params.rowIndex);
        if (rowNode) {
          this.productsGridApi?.redrawRows({ rowNodes: [rowNode] });
        }
        // ✅ Trigger auto-save for single item (Products grid)
        this.startAutoSaveTimer(params.rowIndex, cartItem, true);
      } else {
        this.offerGridApi?.refreshCells({ force: true });
        // ✅ Trigger auto-save for single item (Offers grid)
        this.startAutoSaveTimer(params.rowIndex, cartItem, false);
      }
    }

    this.ShowStatusChangeConfirmation = false;
    this.pendingStatusChange = null;
    this.statusChangeConfirmItems = [];
  }

  // ========== In-Memory Undo System ==========

  private initUndoDatabase(): void {
    this.clearUndoHistory();
  }

  // Save a snapshot of the current ProductItems
  saveUndoSnapshot(): void {
    if (!this.ProductItems || this.ProductItems.length === 0) return;

    // Deep copy via JSON serialization
    const snapshot = JSON.stringify(this.ProductItems);

    // ✅ Skip if identical to the last snapshot (prevents duplicates from double-firing events)
    if (this.undoSnapshots.length > 0 && this.undoSnapshots[this.undoSnapshots.length - 1] === snapshot) {
      console.log('⏭️ UNDO: skipped duplicate snapshot');
      return;
    }

    this.undoSnapshots.push(snapshot);

    // Keep only the latest MAX_UNDO_SNAPSHOTS
    if (this.undoSnapshots.length > this.MAX_UNDO_SNAPSHOTS) {
      this.undoSnapshots = this.undoSnapshots.slice(-this.MAX_UNDO_SNAPSHOTS);
    }

    this.undoSnapshotCount = this.undoSnapshots.length;
    console.log(`✅ UNDO: snapshot saved (${this.undoSnapshotCount} total, size=${Math.round(snapshot.length/1024)}KB)`);

    // Log first item discount for debugging
    const firstItem = this.ProductItems[0];
    console.log(`✅ UNDO: first item discount=${firstItem?.officialDiscount}, price=${firstItem?.price}`);
  }

  // Undo: pop the latest snapshot and restore the one before it
  undoLastChange(): void {
    console.log(`↩️ UNDO: undoLastChange called. snapshots=${this.undoSnapshots.length}`);

    if (this.undoSnapshots.length <= 1) {
      this.parent.openSnackBar('No undo history available', 'OK', 'alert-info-snackbar');
      return;
    }

    // Remove the current state (latest)
    this.undoSnapshots.pop();

    // Restore the previous state (now the latest)
    const previousJson = this.undoSnapshots[this.undoSnapshots.length - 1];
    const restoredItems = JSON.parse(previousJson);
    this.undoSnapshotCount = this.undoSnapshots.length;

    console.log(`↩️ UNDO: restored ${restoredItems?.length} items, remaining snapshots=${this.undoSnapshotCount}`);
    console.log(`↩️ UNDO: first item discount=${restoredItems[0]?.officialDiscount}, price=${restoredItems[0]?.price}`);

    // Replace ProductItems and force AG Grid to re-render
    this.ProductItems = restoredItems;
    if (this.productsGridApi) {
      this.productsGridApi.setRowData(this.ProductItems);
      console.log('↩️ UNDO: setRowData called on productsGridApi');
    } else {
      console.log('↩️ UNDO: ⚠️ productsGridApi is NULL');
    }

    // If AutoSave is ON, persist to DB (without clearing undo history)
    if (this.AutoSave) {
      setTimeout(() => this.SaveAllCartItemsAfterUndo(true), 300);
    } else {
      this.showSaveAfterUndo = true;
    }
  }

  // Clear all undo history
  clearUndoHistory(): void {
    this.undoSnapshots = [];
    this.undoSnapshotCount = 0;
    console.log('🗑️ UNDO: history cleared');
  }

  // Save all cart items after undo - persists the restored state to the database using BULK API
  // keepUndoHistory=true when called from auto-undo (so user can keep undoing)
  SaveAllCartItemsAfterUndo(keepUndoHistory: boolean = false): void {
    console.log(`💾 UNDO-SAVE: SaveAllCartItemsAfterUndo called, keepUndoHistory=${keepUndoHistory}`);
    const allItems = this.ProductItems?.filter((item: any) => item.CartItem && item.CartItem.ID > 0) || [];

    if (allItems.length === 0) {
      this.parent.openSnackBar('No items to save', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    // Get OrderConfirmationDBID from first item (all items should be from same order)
    const firstItem = allItems[0];
    const orderConfirmationDBID = firstItem?.CartItem?.CartItemOrderInfo?.OrderDBID
      || firstItem?.OrderConfirmationDBID
      || firstItem?.OfferDBID
      || this.CurrentOrder?.DBID;

    if (!orderConfirmationDBID) {
      this.parent.openSnackBar('Cannot save: missing order reference', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    // Extract CartItems from the row data
    const cartItems = allItems.map((item: any) => item.CartItem).filter((ci: any) => ci != null);
    if (cartItems.length === 0) {
      this.parent.openSnackBar('No items to save', 'OK', 'alert-info-snackbar');
      this.showSaveAfterUndo = false;
      return;
    }

    console.log(`💾 UNDO-SAVE: saving ${cartItems.length} items to OrderConfirmationDBID=${orderConfirmationDBID}`);

    const request = {
      Language: this.parent.getLanguage(),
      User: this.parent.User,
      CartItems: cartItems,
      OrderConfirmationDBID: orderConfirmationDBID
    };

    this.savingGridRow = true;
    this.managementService.BulkUpdateOrderConfirmationCartItems(request).subscribe((response: any) => {
      this.savingGridRow = false;
      this.showSaveAfterUndo = false;

      if (response.Status === 1) {
        console.log(`💾 UNDO-SAVE: ✅ saved ${response.UpdatedCount} items, keepUndoHistory=${keepUndoHistory}`);
        if (!keepUndoHistory) {
          this.clearUndoHistory();
        }
      } else {
        console.log(`💾 UNDO-SAVE: ❌ failed: ${response.Message}`);
        this.parent.openSnackBar(response.Message || 'Bulk save failed', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.savingGridRow = false;
      this.showSaveAfterUndo = false;
      console.error('❌ Bulk save error:', error);
      this.parent.openSnackBar('Bulk save failed', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Lock Shipping Settings toggle handler
  // ✅ Invoice Popup — double-click on INV status (supports multiple invoices per cart item)
  invoicePopupInvoices: any[] = [];

  openInvoicePopupForCartItem(cartItem: any) {
    if (!cartItem?.ID) return;
    this.invoicePopupData = null;
    this.invoicePopupInvoices = [];
    this.invoicePopupLoading = true;
    this.showInvoicePopup = true;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItemID: cartItem.ID
    };

    this.managementService.GetInvoiceByCartItemID(request).subscribe((response: any) => {
      this.invoicePopupLoading = false;
      if (response.Status === 1) {
        this.invoicePopupData = response;
        this.invoicePopupInvoices = response.Invoices || [];
      } else {
        this.parent.openSnackBar(response.Message || 'Invoice not found', 'OK', 'alert-info-snackbar');
        this.showInvoicePopup = false;
      }
    });
  }

  printInvoicePopupItem(invoice: any) {
    if (!invoice?.InvoiceID) return;
    invoice._loading = true;
    this.service.ExportInvoice({
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      InvoiceID: invoice.InvoiceID
    }).subscribe((response: any) => {
      invoice._loading = false;
      if (response.Status === 1 && response.Document) {
        this.printDocument(response.Document);
      } else {
        this.parent.openSnackBar(response.Message || 'Error', 'OK', 'alert-info-snackbar');
      }
    });
  }

  downloadInvoicePopupItem(invoice: any) {
    if (!invoice?.InvoiceID) return;
    invoice._loading = true;
    this.service.ExportInvoice({
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      InvoiceID: invoice.InvoiceID
    }).subscribe((response: any) => {
      invoice._loading = false;
      if (response.Status === 1 && response.Document) {
        this.downloadDocument(response.Document);
      } else {
        this.parent.openSnackBar(response.Message || 'Error', 'OK', 'alert-info-snackbar');
      }
    });
  }

  onLockShippingSettingsChange() {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      OrderConfirmationDBID: this.CurrentOrder?.DBID,
      LockShippingSettings: this.CurrentOrder?.Cart?.LockShippingSettings
    };

    this.managementService.UpdateOrderConfirmationCartLockShippingSettings(request).subscribe();
  }

  // ✅ Get project discount amount (OriginalTotal - Total after discount)
  getProjectDiscountAmount(): string {
    const originalTotal = this.CurrentOrder?.Cart?.OriginalTotal?.TotalQtyPriceNOVAT || 0;
    const discountedTotal = this.CurrentOrder?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const discountAmount = originalTotal - discountedTotal;
    return discountAmount.toFixed(2);
  }

  // ✅ Get absolute total (Subtotal after discount + Shipping Cost)
  getAbsoluteTotal(): string {
    const subtotalAfterDiscount = this.CurrentOrder?.Cart?.Total?.TotalQtyPriceNOVAT || 0;
    const shippingCost = this.CurrentOrder?.Cart?.ShippingCost?.UIUnitPrice || 0;
    const absoluteTotal = subtotalAfterDiscount + shippingCost;
    return absoluteTotal.toFixed(2);
  }

  // ✅ Recalculate cart-level totals after quantity/price/discount changes in AG-Grid
  recalculateCartTotals(): void {
    if (!this.CurrentOrder?.Cart) return;

    // Sum all cart item totals (UIQtyPrice = FinalPrice × Quantity)
    let subtotalNOVAT = 0;
    const items = this.CurrentOrder.Cart.Items || [];
    for (const item of items) {
      const sp = item?.SelectedOffer?.SellingPrice || item?.Price?.UIUnitPrice || 0;
      const q = item?.Quantity || 0;
      subtotalNOVAT += sp * q;
    }
    subtotalNOVAT = Math.round(subtotalNOVAT * 100) / 100;

    // Store in OriginalTotal (before discount)
    if (!this.CurrentOrder.Cart.OriginalTotal) {
      this.CurrentOrder.Cart.OriginalTotal = {};
    }
    this.CurrentOrder.Cart.OriginalTotal.TotalQtyPriceNOVAT = subtotalNOVAT;

    // Apply project discount if exists
    let discountedTotal = subtotalNOVAT;
    const discount = this.CurrentOrder.Cart.Total?.Discount;
    if (discount && discount.Value > 0 && discount.Type) {
      if (discount.Type.ID === 1) {
        // Percentage discount
        discountedTotal = subtotalNOVAT * (1 - discount.Value / 100);
      } else if (discount.Type.ID === 2) {
        // Absolute value discount
        discountedTotal = subtotalNOVAT - discount.Value;
      }
      discountedTotal = Math.round(discountedTotal * 100) / 100;
    }

    // Store in Total (after discount)
    if (!this.CurrentOrder.Cart.Total) {
      this.CurrentOrder.Cart.Total = {};
    }
    this.CurrentOrder.Cart.Total.TotalQtyPriceNOVAT = discountedTotal;
  }

  // ✅ Sync all CartItems from the AG Grid back to CurrentOrder.Cart.Items
  syncGridItemsToCurrentOrder(): void {
    if (!this.offerGridApi || !this.CurrentOrder?.Cart) return;
    const gridItems: any[] = [];
    let mismatchCount = 0;
    const oldItems = this.CurrentOrder.Cart.Items || [];
    this.offerGridApi.forEachNode((node: any, nodeIndex: number) => {
      if (node.data?.CartItem) {
        gridItems.push(node.data.CartItem);
        const oldItem = oldItems[nodeIndex];
        if (oldItem && oldItem !== node.data.CartItem) {
          mismatchCount++;
          console.warn(`🔗 [OC-syncGridItems] ROW ${nodeIndex} MISMATCH! Grid CartItem.ID=${node.data.CartItem?.ID} (Qty=${node.data.CartItem?.Quantity}) vs CurrentOrder CartItem.ID=${oldItem?.ID} (Qty=${oldItem?.Quantity})`);
        }
      }
    });
    console.log(`🔗 [OC-syncGridItems] Grid nodes: ${gridItems.length}, Old items: ${oldItems.length}, Mismatches fixed: ${mismatchCount}`);
    if (gridItems.length > 0) {
      this.CurrentOrder.Cart.Items = gridItems;
    }
  }

  // ✅ Sync a single CartItem back to CurrentOrder.Cart.Items by matching ID
  syncCartItemToCurrentOrder(updatedCartItem: any): void {
    if (!this.CurrentOrder?.Cart?.Items || !updatedCartItem) return;
    const idx = this.CurrentOrder.Cart.Items.findIndex((item: any) =>
      item.ID && updatedCartItem.ID && item.ID === updatedCartItem.ID
    );
    if (idx !== -1) {
      this.CurrentOrder.Cart.Items[idx] = updatedCartItem;
      console.log(`🔗 [OC-syncCartItem] Synced CartItem.ID=${updatedCartItem?.ID} at index ${idx}`);
    } else {
      console.warn(`🔗 [OC-syncCartItem] CartItem.ID=${updatedCartItem?.ID} NOT FOUND in CurrentOrder.Cart.Items`);
    }
  }


  // ========== EDITCONTAINER PARTNER & CURRENCY MANAGEMENT ==========

  onEditContainerPartnerSearchFocus(): void {
    this.showEditContainerPartnerResults = true;
    if (this.editContainerSearchedPartners.length === 0) {
      this.GetEditContainerPartnersFiltered();
    }
  }

  GetEditContainerPartnersFiltered(): void {
    const request = {
      SearchTerm: this.editContainerPartnerSearchTerm,
      PageIndex: 1,
      PageSize: 20,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.editContainerLoadingPartners = true;
    this.service.GetPartnersFiltered(request).subscribe((response: any) => {
      this.editContainerLoadingPartners = false;
      if (response["Status"] == 1) {
        this.editContainerSearchedPartners = response["Partners"] || [];
      }
    });
  }

  selectEditContainerPartner(partner: any): void {
    // If order is already saved, show confirmation popup
    if (this.CurrentOrder?.DBID && this.CurrentOrder.DBID > 0 && this.CurrentOrder?.Cart?.ID > 0) {
      this.PendingPartnerChange = partner;
      this.ShowChangePartnerConfirmation = true;
      this.showEditContainerPartnerResults = false;
      this.editContainerPartnerSearchTerm = '';
      this.editContainerSearchedPartners = [];
    } else {
      // Order not saved yet, just update locally
      if (this.CurrentOrder?.Cart) {
        this.CurrentOrder.Cart.Partner = partner;
      }
      this.showEditContainerPartnerResults = false;
      this.editContainerPartnerSearchTerm = '';
      this.editContainerSearchedPartners = [];
    }
  }

  confirmChangePartner(): void {
    if (!this.PendingPartnerChange || !this.CurrentOrder?.Cart?.ID) {
      this.ShowChangePartnerConfirmation = false;
      this.PendingPartnerChange = null;
      return;
    }

    this.parent.loading = true;
    this.ShowChangePartnerConfirmation = false;

    const request = {
      CartID: this.CurrentOrder.Cart.ID,
      NewPartner: this.PendingPartnerChange,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
    };

    this.managementService.ChangeOrderConfirmationPartner(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the new partner
          this.CurrentOrder.Cart.Partner = this.PendingPartnerChange;
          // Reload offer items to refresh data
          setTimeout(() => {
            this.loadOfferGridData();
          }, 0);
          this.parent.openSnackBar('Partner updated successfully', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating partner', 'OK', 'alert-info-snackbar');
        }
        this.PendingPartnerChange = null;
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating partner', 'OK', 'alert-info-snackbar');
        this.PendingPartnerChange = null;
      }
    });
  }

  cancelChangePartner(): void {
    this.ShowChangePartnerConfirmation = false;
    this.PendingPartnerChange = null;
  }

  openPartnerInNewTab(): void {
    if (this.CurrentOrder?.Cart?.Partner?.ID) {
      const url = `/management/partners/data?partnerID=${encodeURIComponent(this.CurrentOrder.Cart.Partner.ID)}`;
      window.open(url, '_blank');
    }
  }

  clearEditContainerPartnerSearch(): void {
    this.editContainerPartnerSearchTerm = '';
    this.editContainerSearchedPartners = [];
    this.showEditContainerPartnerResults = false;
  }

  toggleEditContainerCurrencyDropdown(): void {
    this.showEditContainerCurrencyResults = !this.showEditContainerCurrencyResults;
  }

  selectEditContainerCurrency(currency: any): void {
    if (!this.CurrentOrder?.DBID || this.CurrentOrder.DBID <= 0) {
      this.parent.openSnackBar('Order not saved yet', 'OK', 'alert-info-snackbar');
      return;
    }

    this.parent.loading = true;
    this.showEditContainerCurrencyResults = false;

    const request = {
      OrderConfirmationDBID: this.CurrentOrder.DBID,
      CurrencyID: currency.ID,
      NewCurrency: currency,
      OrderConfirmation: this.CurrentOrder,
      Language: this.parent.getLanguage(),
      User: this.parent.User,
    };

    this.managementService.ChangeOrderConfirmationCurrency(request).subscribe({
      next: (response: any) => {
        this.parent.loading = false;
        if (response.Status === 1) {
          // Update CurrentOrder with the returned OrderConfirmation (with exchanged prices)
          if (response.OrderConfirmation) {
            this.CurrentOrder = response.OrderConfirmation;
          } else {
            this.CurrentOrder.Cart.Currency = currency;
          }
          // Reload offer items to get updated prices (use setTimeout to allow Angular change detection to complete)
          setTimeout(() => {
            this.loadOfferGridData();
          }, 0);
          this.parent.openSnackBar('Currency updated with exchanged prices', 'OK', 'alert-success-snackbar');
        } else {
          this.parent.openSnackBar(response.Message || 'Error updating currency', 'OK', 'alert-info-snackbar');
        }
      },
      error: (err: any) => {
        this.parent.loading = false;
        this.parent.openSnackBar('Error updating currency', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ========================================
  // ✅ Generate PO Popup Methods
  // ========================================

  openGeneratePOPopup(): void {
    const selectedItems = this.getSelectedProductItems();
    if (selectedItems.length === 0) {
      this.parent.openSnackBar('No items selected', 'OK', 'alert-info-snackbar');
      return;
    }

    // ✅ Collect CartItems from selected items (with deep copy to avoid binding to original objects)
    const cartItems: any[] = [];
    selectedItems.forEach((item: any) => {
      if (item.CartItem) {
        const cartItemCopy = JSON.parse(JSON.stringify(item.CartItem));
        cartItems.push(cartItemCopy);
      }
    });

    if (cartItems.length === 0) {
      this.parent.openSnackBar('No valid CartItems to process', 'OK', 'alert-info-snackbar');
      return;
    }

    // ✅ Pre-check: Validate purchase columns (Supplier, Purchase Price, Purchase Currency) before PO generation
    const invalidItems: any[] = [];
    const problematicGridItems: any[] = [];
    cartItems.forEach((ci: any, index: number) => {
      const supplierID = ci.SelectedOffer?.Partner?.ID;
      const purchasePrice = ci.SelectedOffer?.ListPrice;
      const purchaseCurrencyID = ci.SelectedOffer?.PurchaseCurrency?.ID;
      const missingFields: string[] = [];

      if (!supplierID || supplierID <= 0) {
        missingFields.push(this.parent.translate.instant('Supplier'));
      }
      if (purchasePrice == null || purchasePrice <= 0) {
        missingFields.push(this.parent.translate.instant('PurchasePrice'));
      }
      if (!purchaseCurrencyID || purchaseCurrencyID <= 0) {
        missingFields.push(this.parent.translate.instant('PurchaseCurrency'));
      }

      if (missingFields.length > 0) {
        invalidItems.push({
          product: ci.Product?.PartNumber || ci.Product?.Name || ci.UIProductValue || '?',
          missing: missingFields.join(', ')
        });
        // Store the original grid row item for Get Best Offers
        if (selectedItems[index]) {
          problematicGridItems.push(selectedItems[index]);
        }
      }
    });

    if (invalidItems.length > 0) {
      // Show styled popup with detailed missing purchase data info
      this.POPurchaseDataWarningItems = invalidItems;
      this.POPurchaseDataProblematicGridItems = problematicGridItems;
      this.ShowPOPurchaseDataWarning = true;
      return;
    }

    // ✅ Pre-check: Validate mixed Purchase Currencies per Supplier before PO generation
    const mixedCurrencyWarnings = this.checkMixedPurchaseCurrencies(cartItems);
    if (mixedCurrencyWarnings.length > 0) {
      this.POMixedCurrencyWarningItems = mixedCurrencyWarnings;
      this._pendingPOMixedCurrencyCartItems = cartItems;
      this.ShowPOMixedCurrencyWarning = true;
      return;
    }

    // Store cartItems for potential re-use after pre-check
    this._pendingPOCartItems = cartItems;

    // Call backend — it will do the pre-check and either return warnings or POs
    this.proceedGeneratePO(cartItems, false);
  }

  // ✅ Check if any supplier has items with different Purchase Currencies
  private checkMixedPurchaseCurrencies(cartItems: any[]): any[] {
    // Group by Supplier ID
    const supplierMap: { [key: string]: { supplierName: string; currencies: { [currId: number]: { currName: string; products: string[] } } } } = {};

    cartItems.forEach((ci: any) => {
      const supplierID = ci.SelectedOffer?.Partner?.ID;
      const supplierName = ci.SelectedOffer?.Partner?.Name || '?';
      const currID = ci.SelectedOffer?.PurchaseCurrency?.ID || ci.SelectedOffer?.Currency?.ID;
      const currName = ci.SelectedOffer?.PurchaseCurrency?.Name || ci.SelectedOffer?.Currency?.Name || '?';
      const productLabel = ci.Product?.PartNumber || ci.Product?.Name || ci.UIProductValue || '?';

      if (!supplierID || !currID) return;

      const key = String(supplierID);
      if (!supplierMap[key]) {
        supplierMap[key] = { supplierName, currencies: {} };
      }
      if (!supplierMap[key].currencies[currID]) {
        supplierMap[key].currencies[currID] = { currName, products: [] };
      }
      supplierMap[key].currencies[currID].products.push(productLabel);
    });

    // Find suppliers with more than 1 distinct currency
    const warnings: any[] = [];
    Object.keys(supplierMap).forEach((key: string) => {
      const entry = supplierMap[key];
      const currKeys = Object.keys(entry.currencies);
      if (currKeys.length > 1) {
        currKeys.forEach((currId: string) => {
          const curr = entry.currencies[Number(currId)];
          warnings.push({
            supplier: entry.supplierName,
            currency: curr.currName,
            products: curr.products
          });
        });
      }
    });

    return warnings;
  }

  // ✅ Mixed Currency Warning: user chose "Cancel"
  closePOMixedCurrencyWarning(): void {
    this.ShowPOMixedCurrencyWarning = false;
    this.POMixedCurrencyWarningItems = [];
    this._pendingPOMixedCurrencyCartItems = [];
  }

  // ✅ Mixed Currency Warning: user chose "Proceed with split POs by currency"
  proceedWithMixedCurrencyPOs(): void {
    this.ShowPOMixedCurrencyWarning = false;
    const cartItems = this._pendingPOMixedCurrencyCartItems;
    this._pendingPOMixedCurrencyCartItems = [];
    this.POMixedCurrencyWarningItems = [];

    // Store and proceed — backend will split by supplier, and same supplier will get separate POs per currency
    this._pendingPOCartItems = cartItems;
    this.proceedGeneratePO(cartItems, false);
  }

  // ✅ Stored cart items for re-call after pre-check decision
  private _pendingPOCartItems: any[] = [];

  // ✅ Pre-check: user chose "Remove" — re-generate excluding warning item IDs
  preCheckRemoveAndProceed(): void {
    this.ShowPOPreCheckWarning = false;
    const warningIDs = this.POPreCheckWarningItems.map((w: any) => w.ID);
    const validItems = this._pendingPOCartItems.filter((ci: any) => !warningIDs.includes(ci.ID));
    if (validItems.length === 0) {
      this.parent.openSnackBar('No items with Not Ordered status remain', 'OK', 'alert-info-snackbar');
      return;
    }
    this.proceedGeneratePO(validItems, true);
  }

  // ✅ Pre-check: user chose "Ignore" — proceed with ALL items, skip pre-check
  preCheckIgnoreAndProceed(): void {
    this.ShowPOPreCheckWarning = false;
    this.proceedGeneratePO(this._pendingPOCartItems, true);
  }

  // ✅ Pre-check: user chose "Close" — cancel entirely
  preCheckClose(): void {
    this.ShowPOPreCheckWarning = false;
    this.POPreCheckWarningItems = [];
    this.POPreCheckValidItems = [];
    this._pendingPOCartItems = [];
  }

  // ✅ Close PO Purchase Data Missing Warning Popup
  closePOPurchaseDataWarning(): void {
    this.ShowPOPurchaseDataWarning = false;
    this.POPurchaseDataWarningItems = [];
    this.POPurchaseDataProblematicGridItems = [];
  }

  // ✅ Get Best Offers for problematic items, auto-save, then re-trigger PO generation
  getBestOffersAndGeneratePO(): void {
    const problematicItems = this.POPurchaseDataProblematicGridItems;
    if (!problematicItems || problematicItems.length === 0) {
      this.closePOPurchaseDataWarning();
      return;
    }

    // Build product list from problematic items only
    const products = problematicItems
      .filter((item: any) => item?.CartItem?.Product?.ID != null && item.CartItem.Product.ID > 0)
      .map((item: any) => ({
        IndustryProductID: item.CartItem.Product.ID,
        Brand: item.CartItem.Product?.Brand || null
      }));

    if (products.length === 0) {
      this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
      this.closePOPurchaseDataWarning();
      return;
    }

    this.POPurchaseDataBestOffersLoading = true;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      Products: products,
      SelectedOfferID: 0,
      MaxRank: 1,
      Pager: { PageIndex: 1, PageSize: 1 },
      ApplyClientRestrictions: false,
      StockStatus: -1,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: this.CurrentOrder?.Cart?.Currency,
        ConfigStatus: { ID: -9000 }
      }
    };

    this.B2BService.GetIndustryProductsBulkBestOffers(request).subscribe((response: any) => {
      this.POPurchaseDataBestOffersLoading = false;

      if (response["Status"] !== 1) {
        this.parent.openSnackBar(response["Message"], 'OK', 'alert-info-snackbar');
        return;
      }

      const resultItems = response["CartItems"] || [];
      if (resultItems.length === 0) {
        this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
        return;
      }

      // Apply best offers to the problematic grid items (Supplier, Purchase, PC only — NOT sell price)
      const appliedItems: any[] = [];
      problematicItems.forEach((item: any) => {
        const productId = item?.CartItem?.Product?.ID;
        if (productId == null) return;

        const match = resultItems.find((r: any) => r?.Product?.ID === productId);
        const bestOffer = match?.SelectedOffer;
        if (!bestOffer) return;

        // Apply purchase-side data only
        if (!item.CartItem.SelectedOffer) item.CartItem.SelectedOffer = {};
        item.CartItem.SelectedOffer.Partner = bestOffer.Partner;
        item.CartItem.SelectedOffer.ID = (bestOffer.ID != null && bestOffer.ID > 0) ? bestOffer.ID : 0;
        item.CartItem.SelectedOffer.ListPrice = bestOffer.ListPrice;
        item.CartItem.SelectedOffer.Currency = bestOffer.Currency;
        item.CartItem.SelectedOffer.PurchaseCurrency = bestOffer.Currency;

        if (item.CartItem.Product?.ListPriceOffers?.length > 0) {
          item.CartItem.Product.ListPriceOffers[0].ListPrice = bestOffer.ListPrice;
          item.CartItem.Product.ListPriceOffers[0].Currency = bestOffer.Currency;
          item.CartItem.Product.ListPriceOffers[0].Partner = bestOffer.Partner;
        }

        // Sync flat display fields
        item.supplier = bestOffer?.Partner?.Name || '';
        item.purchase = bestOffer?.ListPrice ?? '';

        // Update the grid node display
        this.productsGridApi?.forEachNode((node: any) => {
          if (node.data?.CartItem?.ID === item.CartItem?.ID) {
            node.data.supplier = item.supplier;
            node.data.purchase = item.purchase;
          }
        });

        appliedItems.push(item);
      });

      this.productsGridApi?.refreshCells({ force: true });

      if (appliedItems.length === 0) {
        this.parent.openSnackBar(this.translate.instant('NoOffersFound'), 'OK', 'alert-info-snackbar');
        return;
      }

      // Close the warning popup
      this.ShowPOPurchaseDataWarning = false;
      this.POPurchaseDataWarningItems = [];
      this.POPurchaseDataProblematicGridItems = [];

      // Bulk save the updated items, then re-trigger PO generation
      const orderConfirmationDBID = appliedItems[0]?.CartItem?.CartItemOrderInfo?.OrderDBID
        || appliedItems[0]?.OrderConfirmationDBID
        || appliedItems[0]?.OfferDBID
        || this.CurrentOrder?.DBID;

      if (!orderConfirmationDBID) {
        this.parent.openSnackBar('Cannot save: No OrderConfirmationDBID', 'OK', 'alert-info-snackbar');
        return;
      }

      const cartItems = appliedItems.map((item: any) => item.CartItem).filter((ci: any) => ci != null);
      const saveRequest = {
        Language: this.parent.getLanguage(),
        User: this.parent.User,
        CartItems: cartItems,
        OrderConfirmationDBID: orderConfirmationDBID
      };

      this.savingGridRow = true;
      this.managementService.BulkUpdateOrderConfirmationCartItems(saveRequest).subscribe((saveResponse: any) => {
        this.savingGridRow = false;
        if (saveResponse.Status === 1) {
          console.log(`✅ Best offers applied & saved for ${saveResponse.UpdatedCount} items, re-triggering PO generation...`);
          this.saveUndoSnapshot();
          // Re-trigger the PO generation flow
          this.openGeneratePOPopup();
        } else {
          this.parent.openSnackBar(saveResponse.Message || 'Save failed', 'OK', 'alert-info-snackbar');
        }
      }, (error: any) => {
        this.savingGridRow = false;
        this.parent.openSnackBar('Save failed', 'OK', 'alert-info-snackbar');
      });
    }, () => {
      this.POPurchaseDataBestOffersLoading = false;
      this.parent.openSnackBar('Could not retrieve best offers', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Actual PO generation call (skipPreCheck=true bypasses backend progress status check)
  private proceedGeneratePO(cartItems: any[], skipPreCheck: boolean): void {
    // Reset state
    this.GeneratedPurchaseOrders = [];
    this.generatePOGridApis = [];
    this.generatePODropdownStates = {};
    this.generatePOGroupCollapsed = {};

    // Initialize AG Grid column definitions
    this.initGeneratePOGridColumns();

    // Show loading
    this.parent.loading = true;

    // ✅ Call API to generate Purchase Orders (with pre-check unless skipped)
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItems: cartItems,
      Company: this.parent.Company,
      SendEmail: false,
      SkipPreCheck: skipPreCheck
    };

    this.managementService.GeneratePurchaseOrdersFromCartItems(request).subscribe((response: any) => {
      this.parent.loading = false;

      // ✅ Handle pre-check warning from backend
      if (response["IsPreCheckWarning"] === true && response["WarningItems"]?.length > 0) {
        this.POPreCheckWarningItems = response["WarningItems"];
        this.POPreCheckValidItems = cartItems.filter((ci: any) =>
          !response["WarningItems"].some((w: any) => w.ID === ci.ID)
        );
        this.ShowPOPreCheckWarning = true;
        return;
      }

      if (response["Status"] === 1 && response["PurchaseOrders"]) {
        // Show popup only after successful PO generation
        this.ShowGeneratePOPopup = true;
        this.GeneratedPurchaseOrders = response["PurchaseOrders"] || [];

        // Initialize dropdown states for each PO and set default values
        this.GeneratedPurchaseOrders.forEach((po: any, idx: number) => {
          this.initPODropdownState(idx);

          // ✅ Ensure CartItemStatus exists on all existing items (valid by default from backend)
          // ✅ Lock SelectedOffer.Partner to the PO's Cart.Partner on every row
          const poPartner = po.Cart?.Partner || null;
          if (po.Cart?.Items) {
            po.Cart.Items.forEach((item: any) => {
              if (!item.CartItemStatus) {
                item.CartItemStatus = { ID: 1, Name: 'Valid' };
              }
              if (!item.Quantity) item.Quantity = 1;
              // ✅ Force supplier to PO partner on all existing items
              if (poPartner) {
                if (!item.SelectedOffer) item.SelectedOffer = {};
                item.SelectedOffer.Partner = JSON.parse(JSON.stringify(poPartner));
              }
            });
            // ✅ Append 5 empty rows for adding new products (with PO partner pre-set)
            for (let i = 0; i < 5; i++) {
              po.Cart.Items.push(this.createEmptyGeneratePORow(poPartner));
            }
          }

          // ✅ Initialize Discount object from backend Cart.Total.Discount or create default (required for ngModel binding)
          if (!po.Discount) {
            if (po.Cart?.Total?.Discount?.Type) {
              po.Discount = { Type: JSON.parse(JSON.stringify(po.Cart.Total.Discount.Type)), Value: po.Cart.Total.Discount.Value || 0, Applied: false };
            } else {
              po.Discount = { Type: null, Value: 0, Applied: false };
            }
          }

          // ✅ Initialize Cart.ShippingCost object if it doesn't exist (required for ngModel binding)
          if (!po.Cart) {
            po.Cart = {};
          }
          if (!po.Cart.ShippingCost) {
            po.Cart.ShippingCost = { UIUnitPrice: 0 };
          }

          // ✅ Default SendEmail to true (PO email with PDF attachment to selected agents)
          if (po.SendEmail == null || po.SendEmail === undefined) {
            po.SendEmail = true;
          }

          // ✅ Pre-select "Partial Delivery" (ID = -1) as default for DeliveryPreference
          if (!po.DeliveryPreference && this.MasterData?.OrderDeliveryPreferences) {
            const partialDelivery = this.MasterData.OrderDeliveryPreferences.find((d: any) => d.ID === -1);
            if (partialDelivery) {
              po.DeliveryPreference = JSON.parse(JSON.stringify(partialDelivery));
            }
          }

          // ✅ Pre-select "Consolidated" (ID = -1) as default for ConsolidationType
          if (!po.ConsolidationType && this.MasterData?.OrderConsolidationTypes) {
            const consolidated = this.MasterData.OrderConsolidationTypes.find((t: any) => t.ID === -1);
            if (consolidated) {
              po.ConsolidationType = JSON.parse(JSON.stringify(consolidated));
            }
          }
        });

        // Ensure shipping master data is loaded (including ShippingCompanies)
        if (this.ShippingResponsabilities.length === 0 || this.ShippingServiceTypes.length === 0 || this.ShippingCompanies.length === 0) {
          this.GetShippingMasterData();
        }

        this.parent.openSnackBar(`Generated ${this.GeneratedPurchaseOrders.length} Purchase Order(s)`, 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"] || 'Failed to generate Purchase Orders', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error generating Purchase Orders', 'OK', 'alert-info-snackbar');
      console.error('Generate PO API error:', error);
    });
  }

  closeGeneratePOPopup(): void {
    this.ShowGeneratePOPopup = false;
    this.GeneratedPurchaseOrders = [];
    this.generatePOGridApis = [];
    this.generatePODropdownStates = {};
    this.generatePOGroupCollapsed = {};
  }

  // ✅ NEW PO: open the partner pre-popup (search a supplier, then generate an EMPTY PO for him)
  openNewPOPartnerPopup(): void {
    this.showNewPOPartnerPopup = true;
    this.newPOPartnerSearchTerm = '';
    this.newPOPartners = [];
  }

  // ✅ NEW PO: close the partner pre-popup
  closeNewPOPartnerPopup(): void {
    this.showNewPOPartnerPopup = false;
    this.newPOPartnerSearchTerm = '';
    this.newPOPartners = [];
  }

  // ✅ NEW PO: search suppliers for the pre-popup (api/Partners/Search/Simplified/Filtered)
  searchNewPOPartners(searchTerm: string): void {
    const request = {
      SearchTerm: searchTerm,
      CountryID: null,
      PageIndex: 1,
      PageSize: 50,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Company: this.parent.Company
    };

    this.loadingNewPOPartners = true;
    this.service.SearchPartnersSimplifiedFiltered(request).subscribe((response: any) => {
      this.loadingNewPOPartners = false;
      if (response["Status"] == 1) {
        this.newPOPartners = response["Partners"] || [];
      }
    }, () => {
      this.loadingNewPOPartners = false;
    });
  }

  // ✅ NEW PO: supplier chosen — generate an EMPTY PO (10 empty rows) and open the Generate PO popup
  selectNewPOPartner(partner: any): void {
    if (!partner?.ID) return;

    this.closeNewPOPartnerPopup();

    // Reset Generate PO state (mirrors the cart-based flow)
    this.GeneratedPurchaseOrders = [];
    this.generatePOGridApis = [];
    this.generatePODropdownStates = {};
    this.generatePOGroupCollapsed = {};

    // Initialize AG Grid column definitions
    this.initGeneratePOGridColumns();

    this.parent.loading = true;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: partner.ID,
      Company: this.parent.Company
    };

    this.managementService.GenerateEmptyPurchaseOrder(request).subscribe((response: any) => {
      this.parent.loading = false;

      if (response["Status"] === 1 && response["PurchaseOrder"]) {
        // Show popup only after successful empty PO generation
        this.ShowGeneratePOPopup = true;
        this.GeneratedPurchaseOrders = [response["PurchaseOrder"]];

        // Initialize the single empty PO (same defaults as cart-based flow, 10 empty rows)
        this.GeneratedPurchaseOrders.forEach((po: any, idx: number) => {
          this.initPODropdownState(idx);

          if (!po.Cart) po.Cart = {};
          if (!po.Cart.Items) po.Cart.Items = [];
          // ✅ Append 10 empty rows for adding new products (with PO partner pre-set)
          const poPartner = po.Cart?.Partner || null;
          for (let i = 0; i < 10; i++) {
            po.Cart.Items.push(this.createEmptyGeneratePORow(poPartner));
          }

          // ✅ Initialize Discount object from backend Cart.Total.Discount or create default (required for ngModel binding)
          if (!po.Discount) {
            if (po.Cart?.Total?.Discount?.Type) {
              po.Discount = { Type: JSON.parse(JSON.stringify(po.Cart.Total.Discount.Type)), Value: po.Cart.Total.Discount.Value || 0, Applied: false };
            } else {
              po.Discount = { Type: null, Value: 0, Applied: false };
            }
          }

          // ✅ Initialize Cart.ShippingCost object if it doesn't exist (required for ngModel binding)
          if (!po.Cart.ShippingCost) {
            po.Cart.ShippingCost = { UIUnitPrice: 0 };
          }

          // ✅ Default SendEmail to true (PO email with PDF attachment to selected agents)
          if (po.SendEmail == null || po.SendEmail === undefined) {
            po.SendEmail = true;
          }

          // ✅ Pre-select "Partial Delivery" (ID = -1) as default for DeliveryPreference
          if (!po.DeliveryPreference && this.MasterData?.OrderDeliveryPreferences) {
            const partialDelivery = this.MasterData.OrderDeliveryPreferences.find((d: any) => d.ID === -1);
            if (partialDelivery) {
              po.DeliveryPreference = JSON.parse(JSON.stringify(partialDelivery));
            }
          }

          // ✅ Pre-select "Consolidated" (ID = -1) as default for ConsolidationType
          if (!po.ConsolidationType && this.MasterData?.OrderConsolidationTypes) {
            const consolidated = this.MasterData.OrderConsolidationTypes.find((t: any) => t.ID === -1);
            if (consolidated) {
              po.ConsolidationType = JSON.parse(JSON.stringify(consolidated));
            }
          }
        });

        // Ensure shipping master data is loaded (including ShippingCompanies)
        if (this.ShippingResponsabilities.length === 0 || this.ShippingServiceTypes.length === 0 || this.ShippingCompanies.length === 0) {
          this.GetShippingMasterData();
        }

        this.parent.openSnackBar('Empty Purchase Order created', 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"] || 'Failed to create Purchase Order', 'OK', 'alert-info-snackbar');
      }
    }, (error: any) => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error creating Purchase Order', 'OK', 'alert-info-snackbar');
      console.error('Generate Empty PO API error:', error);
    });
  }

  // ✅ Toggle collapse state for an entire PO group card
  togglePOGroupCollapse(poIndex: number): void {
    this.generatePOGroupCollapsed[poIndex] = !this.generatePOGroupCollapsed[poIndex];
  }

  // ✅ Remove a PO group from the generated list
  removePOGroup(poIndex: number): void {
    if (this.GeneratedPurchaseOrders.length > poIndex) {
      this.GeneratedPurchaseOrders.splice(poIndex, 1);
      // Rebuild collapse/dropdown states after removal
      const newCollapsed: { [k: number]: boolean } = {};
      const newDropdowns: { [k: number]: any } = {};
      this.GeneratedPurchaseOrders.forEach((_: any, idx: number) => {
        newCollapsed[idx] = this.generatePOGroupCollapsed[idx >= poIndex ? idx + 1 : idx] || false;
        newDropdowns[idx] = this.generatePODropdownStates[idx >= poIndex ? idx + 1 : idx] || null;
      });
      this.generatePOGroupCollapsed = newCollapsed;
      this.generatePODropdownStates = newDropdowns;
    }
  }

  // ✅ Initialize dropdown toggle states for a PO at given index
  initPODropdownState(poIndex: number): void {
    if (!this.generatePODropdownStates[poIndex]) {
      this.generatePODropdownStates[poIndex] = {
        showResp: false,
        showType: false,
        showCompany: false,
        showDeliveryPref: false,
        showConsolidation: false,
        showPaymentTerm: false,
        showPaymentType: false,
        showSendEmail: false,
        showAgents: false,
        showDiscountType: false,
        showPickupAddress: false
      };
    }
    // Initialize section collapse states
    if (!this.generatePOSectionCollapsed[poIndex]) {
      this.generatePOSectionCollapsed[poIndex] = {
        totals: false,
        contactInfo: false,
        terms: false,
        shipping: false
      };
    }
    // Initialize selected agents from po.Cart.Partner.PartnerAgents where IsSelected = true
    if (!this.generatePOSelectedAgents[poIndex]) {
      this.generatePOSelectedAgents[poIndex] = [];
      // Sync from PartnerAgents where IsSelected = true
      const po = this.GeneratedPurchaseOrders[poIndex];
      if (po?.Cart?.Partner?.PartnerAgents) {
        const preSelectedAgents = po.Cart.Partner.PartnerAgents.filter((a: any) => a.IsSelected === true);
        this.generatePOSelectedAgents[poIndex] = JSON.parse(JSON.stringify(preSelectedAgents));
      }
    }
    // Initialize new agent email
    if (!this.generatePONewAgentEmail[poIndex]) {
      this.generatePONewAgentEmail[poIndex] = '';
    }
    if (this.generatePOIsValidEmail[poIndex] === undefined) {
      this.generatePOIsValidEmail[poIndex] = false;
    }
  }

  // ✅ Toggle ShippingResponsability dropdown for a specific PO
  togglePOShippingResponsability(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showResp = !this.generatePODropdownStates[poIndex].showResp;
  }

  // ✅ Toggle ShippingServiceType dropdown for a specific PO
  togglePOShippingServiceType(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showType = !this.generatePODropdownStates[poIndex].showType;
  }

  // ✅ Toggle ShippingCompany dropdown for a specific PO
  togglePOShippingCompany(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showCompany = !this.generatePODropdownStates[poIndex].showCompany;
  }

  // ✅ Toggle DeliveryPreference dropdown for a specific PO
  togglePODeliveryPreference(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = !this.generatePODropdownStates[poIndex].showDeliveryPref;
  }

  // ✅ Toggle ConsolidationType dropdown for a specific PO
  togglePOConsolidationType(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showConsolidation = !this.generatePODropdownStates[poIndex].showConsolidation;
  }

  // ✅ Toggle PaymentTerm dropdown for a specific PO
  togglePOPaymentTerm(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentType = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = !this.generatePODropdownStates[poIndex].showPaymentTerm;
  }

  // ✅ Toggle PaymentType dropdown for a specific PO
  togglePOPaymentType(poIndex: number): void {
    this.initPODropdownState(poIndex);
    // Close all other dropdowns for this PO
    this.generatePODropdownStates[poIndex].showResp = false;
    this.generatePODropdownStates[poIndex].showType = false;
    this.generatePODropdownStates[poIndex].showCompany = false;
    this.generatePODropdownStates[poIndex].showDeliveryPref = false;
    this.generatePODropdownStates[poIndex].showConsolidation = false;
    this.generatePODropdownStates[poIndex].showPaymentTerm = false;
    this.generatePODropdownStates[poIndex].showPaymentType = !this.generatePODropdownStates[poIndex].showPaymentType;
  }

  // ✅ Close all dropdowns for a specific PO
  closePODropdowns(poIndex: number): void {
    if (this.generatePODropdownStates[poIndex]) {
      this.generatePODropdownStates[poIndex].showResp = false;
      this.generatePODropdownStates[poIndex].showType = false;
      this.generatePODropdownStates[poIndex].showCompany = false;
      this.generatePODropdownStates[poIndex].showDeliveryPref = false;
      this.generatePODropdownStates[poIndex].showConsolidation = false;
      this.generatePODropdownStates[poIndex].showPaymentTerm = false;
      this.generatePODropdownStates[poIndex].showPaymentType = false;
      this.generatePODropdownStates[poIndex].showSendEmail = false;
      this.generatePODropdownStates[poIndex].showAgents = false;
      this.generatePODropdownStates[poIndex].showDiscountType = false;
      this.generatePODropdownStates[poIndex].showPickupAddress = false;
    }
  }

  // ✅ Select ShippingResponsability for a specific PO
  selectPOShippingResponsability(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Cart) {
        this.GeneratedPurchaseOrders[poIndex].Cart = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Cart.ShippingResponsability = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select ShippingServiceType for a specific PO
  selectPOShippingServiceType(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Cart) {
        this.GeneratedPurchaseOrders[poIndex].Cart = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Cart.ShippingServiceType = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select ShippingCompany for a specific PO
  selectPOShippingCompany(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Cart) {
        this.GeneratedPurchaseOrders[poIndex].Cart = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Cart.ShippingCompany = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select DeliveryPreference for a specific PO (stored in po.DeliveryPreference, NOT po.Cart)
  selectPODeliveryPreference(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      this.GeneratedPurchaseOrders[poIndex].DeliveryPreference = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select ConsolidationType for a specific PO (stored in po.ConsolidationType, NOT po.Cart)
  selectPOConsolidationType(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      this.GeneratedPurchaseOrders[poIndex].ConsolidationType = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select PaymentTerm for a specific PO (stored in po.Cart.PaymentTerm)
  selectPOPaymentTerm(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Cart) {
        this.GeneratedPurchaseOrders[poIndex].Cart = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Cart.PaymentTerm = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Select PaymentType for a specific PO (stored in po.Cart.PaymentType)
  selectPOPaymentType(poIndex: number, item: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Cart) {
        this.GeneratedPurchaseOrders[poIndex].Cart = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Cart.PaymentType = JSON.parse(JSON.stringify(item));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Toggle PO section collapse state
  togglePOSection(poIndex: number, section: 'totals' | 'contactInfo' | 'terms' | 'shipping'): void {
    this.initPODropdownState(poIndex);
    this.generatePOSectionCollapsed[poIndex][section] = !this.generatePOSectionCollapsed[poIndex][section];
  }

  // ✅ Toggle SendEmail dropdown for a specific PO
  togglePOSendEmail(poIndex: number): void {
    this.initPODropdownState(poIndex);
    this.closePODropdowns(poIndex);
    this.generatePODropdownStates[poIndex].showSendEmail = !this.generatePODropdownStates[poIndex].showSendEmail;
  }

  // ✅ Toggle Agents dropdown for a specific PO
  togglePOAgents(poIndex: number): void {
    this.initPODropdownState(poIndex);
    this.closePODropdowns(poIndex);
    this.generatePODropdownStates[poIndex].showAgents = !this.generatePODropdownStates[poIndex].showAgents;
  }

  // ✅ Toggle DiscountType dropdown for a specific PO
  togglePODiscountType(poIndex: number): void {
    this.initPODropdownState(poIndex);
    this.closePODropdowns(poIndex);
    this.generatePODropdownStates[poIndex].showDiscountType = !this.generatePODropdownStates[poIndex].showDiscountType;
  }

  // ✅ Toggle PickupAddress dropdown for a specific PO
  togglePOPickupAddress(poIndex: number): void {
    this.initPODropdownState(poIndex);
    this.closePODropdowns(poIndex);
    this.generatePODropdownStates[poIndex].showPickupAddress = !this.generatePODropdownStates[poIndex].showPickupAddress;
  }

  // ✅ Select SendEmail for a specific PO (sets po.SendEmail — inherited from UXModel on PurchaseOrder)
  selectPOSendEmail(poIndex: number, value: boolean): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (po) {
      po.SendEmail = value;
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Toggle a Partner Agent selection for a specific PO
  togglePOAgent(poIndex: number, agent: any): void {
    this.initPODropdownState(poIndex);
    const po = this.GeneratedPurchaseOrders[poIndex];

    // Toggle the IsSelected property on the actual agent in po.Cart.Partner.PartnerAgents
    if (po?.Cart?.Partner?.PartnerAgents) {
      const actualAgent = po.Cart.Partner.PartnerAgents.find((a: any) => a.ID === agent.ID);
      if (actualAgent) {
        actualAgent.IsSelected = !actualAgent.IsSelected;
      }
    }

    // Sync generatePOSelectedAgents with agents where IsSelected = true
    this.syncPOSelectedAgents(poIndex);

    // Update PO's PartnerAgents (the selected ones for sending)
    if (po) {
      po.PartnerAgents = JSON.parse(JSON.stringify(this.generatePOSelectedAgents[poIndex]));
    }
  }

  // ✅ Sync generatePOSelectedAgents with agents where IsSelected = true in po.Cart.Partner.PartnerAgents
  syncPOSelectedAgents(poIndex: number): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (po?.Cart?.Partner?.PartnerAgents) {
      const selectedAgents = po.Cart.Partner.PartnerAgents.filter((a: any) => a.IsSelected === true);
      this.generatePOSelectedAgents[poIndex] = JSON.parse(JSON.stringify(selectedAgents));
    } else {
      this.generatePOSelectedAgents[poIndex] = [];
    }
  }

  // ✅ Check if agent is selected for a specific PO (reads from agent.IsSelected)
  isPOAgentSelected(poIndex: number, agent: any): boolean {
    // Check the IsSelected property directly on the agent
    return agent.IsSelected === true;
  }

  // ✅ Get Partner Agents label for a specific PO
  getPOAgentsLabel(poIndex: number): string {
    const selectedAgents = this.generatePOSelectedAgents[poIndex] || [];
    if (selectedAgents.length === 0) {
      return '';
    }
    if (selectedAgents.length === 1) {
      return selectedAgents[0].Email || selectedAgents[0].Name || '';
    }
    return `${selectedAgents.length} agents selected`;
  }

  // ✅ Validate new agent email for a specific PO
  onPONewAgentEmailChange(poIndex: number): void {
    const email = this.generatePONewAgentEmail[poIndex] || '';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.generatePOIsValidEmail[poIndex] = emailRegex.test(email);
  }

  // ✅ Create new agent from email for a specific PO
  createPONewAgentFromEmail(poIndex: number): void {
    if (!this.generatePOIsValidEmail[poIndex]) return;
    const email = this.generatePONewAgentEmail[poIndex];
    if (!email) return;

    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart?.Partner?.ID) {
      this.parent.openSnackBar('Partner not found', 'OK', 'alert-info-snackbar');
      return;
    }

    // ✅ Find Department with ID == 4 from CartMasterData
    const department = this.parent.CartMasterData?.Departments?.find((d: any) => d.ID === 4);

    if (!department) {
      this.parent.openSnackBar('Department not found', 'OK', 'alert-info-snackbar');
      return;
    }

    // ✅ Create new PartnerAgent object
    const newAgent = {
      ID: 0,
      Name: email,
      Email: email,
      Phone: null,
      PartnerID: po.Cart.Partner.ID,
      AllocatedShippingAddress: null,
      Department: department,
      IsSelected: false,
      Disabled: false,
      LastModified: false
    };

    // ✅ Call backend to save the new agent
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerAgent: newAgent
    };

    this.parent.loading = true;
    this.service.AddUpdatePartnerAgent(request).subscribe((response: any) => {
      this.parent.loading = false;

      if (response["Status"] !== 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        return;
      }

      // ✅ Get the saved agent from response
      const savedAgent = response["PartnerAgent"];

      // ✅ Mark the new agent as selected
      savedAgent.IsSelected = true;

      // ✅ Add to PO's Partner.PartnerAgents array
      if (!po.Cart.Partner.PartnerAgents) {
        po.Cart.Partner.PartnerAgents = [];
      }
      po.Cart.Partner.PartnerAgents.push(savedAgent);

      // ✅ Sync the selected agents array
      this.syncPOSelectedAgents(poIndex);

      // ✅ Update PO's PartnerAgents (the selected ones for sending)
      if (this.GeneratedPurchaseOrders[poIndex]) {
        this.GeneratedPurchaseOrders[poIndex].PartnerAgents = JSON.parse(JSON.stringify(this.generatePOSelectedAgents[poIndex]));
      }

      // ✅ Clear input and reset validation
      this.generatePONewAgentEmail[poIndex] = '';
      this.generatePOIsValidEmail[poIndex] = false;

      // ✅ Show success message
      this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }, () => {
      this.parent.loading = false;
      this.parent.openSnackBar('Error creating agent', 'OK', 'alert-info-snackbar');
    });
  }

  // ✅ Select DiscountType for a specific PO
  selectPODiscountType(poIndex: number, type: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      if (!this.GeneratedPurchaseOrders[poIndex].Discount) {
        this.GeneratedPurchaseOrders[poIndex].Discount = {};
      }
      this.GeneratedPurchaseOrders[poIndex].Discount.Type = JSON.parse(JSON.stringify(type));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Apply PO Discount
  applyPODiscount(poIndex: number): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (po && po.Discount) {
      po.Discount.Applied = true;
    }
  }

  // ✅ Clear PO Discount
  clearPODiscount(poIndex: number): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (po) {
      po.Discount = { Type: null, Value: 0, Applied: false };
    }
  }

  // ✅ Get PO discount amount
  getPODiscountAmount(poIndex: number): number {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Discount || !po.Discount.Applied) return 0;
    const subtotal = this.getPOSubtotal(poIndex);
    const discountValue = po.Discount.Value || 0;
    if (po.Discount.Type?.ID === 1) { // Percentage
      return subtotal * (discountValue / 100);
    }
    return discountValue; // Fixed amount
  }

  // ✅ Get PO subtotal (skip empty/awaiting-selection rows)
  getPOSubtotal(poIndex: number): number {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart || !po.Cart.Items) return 0;
    return po.Cart.Items.reduce((sum: number, item: any) => {
      const statusId = item?.CartItemStatus?.ID;
      if (statusId === -2 || statusId === -1 || statusId == null) return sum;
      const qty = item.QuantityRequested || item.Quantity || 0;
      // For Purchase Orders, use the purchase price (ListPrice) - what we pay to supplier
      const price = item.SelectedOffer?.ListPrice || item.SelectedOffer?.SellPrice?.UIUnitPrice || item.Price?.UIUnitPrice || 0;
      return sum + (qty * price);
    }, 0);
  }

  // ✅ Get PO subtotal after discount
  getPOSubtotalAfterDiscount(poIndex: number): number {
    return this.getPOSubtotal(poIndex) - this.getPODiscountAmount(poIndex);
  }

  // ✅ Get PO shipping cost
  getPOShippingCost(poIndex: number): number {
    const po = this.GeneratedPurchaseOrders[poIndex];
    return po?.Cart?.ShippingCost?.UIUnitPrice || 0;
  }

  // ✅ Get PO grand total
  getPOGrandTotal(poIndex: number): number {
    return this.getPOSubtotalAfterDiscount(poIndex) + this.getPOShippingCost(poIndex);
  }

  // ✅ Select Pickup Address for a specific PO
  selectPOPickupAddress(poIndex: number, address: any): void {
    if (this.GeneratedPurchaseOrders[poIndex]) {
      this.GeneratedPurchaseOrders[poIndex].PickupAddress = JSON.parse(JSON.stringify(address));
    }
    this.closePODropdowns(poIndex);
  }

  // ✅ Get Pickup Address label for a specific PO
  getPOPickupAddressLabel(poIndex: number): string {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.PickupAddress) return '';
    const addr = po.PickupAddress;
    return [addr.Country?.Name, addr.City, addr.AddressLine].filter(Boolean).join(' - ');
  }

  onGeneratePOGridReady(params: any, groupIndex: number): void {
    this.generatePOGridApis[groupIndex] = params.api;
    setTimeout(() => {
      params.api.sizeColumnsToFit();
      // Inject header checkbox for this PO grid
      this.injectGeneratePOHeaderCheckbox(groupIndex);
    }, 100);

    // ✅ Add range selection handler for click-and-drag multi-select
    params.api.addEventListener('rangeSelectionChanged', (event: any) => {
      if (event.finished) {
        const cellRanges = event.api.getCellRanges();
        if (cellRanges && cellRanges.length > 0) {
          const selectedRowIndices = new Set<number>();
          cellRanges.forEach((range: any) => {
            const startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
            const endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);
            for (let i = startRow; i <= endRow; i++) {
              selectedRowIndices.add(i);
            }
          });
          // Only update IsSelected if more than 1 row is selected (actual multi-select)
          if (selectedRowIndices.size > 1) {
            selectedRowIndices.forEach((rowIndex: number) => {
              const rowNode = event.api.getDisplayedRowAtIndex(rowIndex);
              if (rowNode?.data) {
                rowNode.data.IsSelected = true;
              }
            });
            event.api.refreshCells({ columns: ['index'], force: true });
            this.updateGeneratePOHeaderCheckbox(groupIndex);
          }
        }
      }
    });
  }

  // Calculate dynamic height for each supplier's grid based on item count
  getGeneratePOGridHeight(itemCount: number): number {
    const headerHeight = 32;
    const rowHeight = 32;
    const minHeight = 100;
    // No max height - show all rows
    const calculatedHeight = headerHeight + (itemCount * rowHeight) + 10; // +10 for padding
    return Math.max(calculatedHeight, minHeight);
  }

  // Helper to refresh all Generate PO grids
  refreshAllGeneratePOGrids(): void {
    this.generatePOGridApis.forEach(api => {
      if (api) {
        api.refreshCells({ force: true });
      }
    });
  }

  initGeneratePOGridColumns(): void {
    // ✅ Column definitions for CartItem objects from backend (po.Cart.Items)
    this.generatePOColumnDefs = [
      {
        headerName: '',
        field: 'index',
        width: 55,
        minWidth: 55,
        editable: false,
        sortable: false,
        headerClass: 'generate-po-index-header',
        cellRenderer: (params: any) => {
          const rowIndex = params.rowIndex + 1;
          const isSelected = params.data?.IsSelected === true;
          return `<div style="display: flex; align-items: center; width: 100%; height: 100%; padding: 0 4px 0 0; margin-left: -8px;">
                    <input type="checkbox" ${isSelected ? 'checked' : ''} class="generate-po-item-checkbox" data-row="${params.rowIndex}" />
                    <span style="cursor: pointer; margin-left: auto;">${rowIndex}</span>
                  </div>`;
        },
        onCellClicked: (params: any) => {
          // Toggle IsSelected when clicking on the checkbox
          const target = params.event?.target as HTMLElement;
          if (target?.classList?.contains('generate-po-item-checkbox')) {
            const cartItem = params.data;
            if (cartItem) {
              cartItem.IsSelected = !cartItem.IsSelected;
              params.api.refreshCells({ rowNodes: [params.node], columns: ['index'], force: true });
            }
          }
        }
      },
      {
        headerName: 'Brand',
        field: 'brand',
        width: 100,
        minWidth: 80,
        editable: (params: any) => {
          // ✅ Editable only for RED ROWS (CartItemStatus.ID === 0) and EMPTY (-2)
          const statusId = params.data?.CartItemStatus?.ID;
          return statusId === 0 || statusId === -2 || statusId == null;
        },
        singleClickEdit: true,
        valueGetter: (params: any) => params.data?.Product?.Brand?.Name || '',
        valueSetter: (params: any) => {
          if (!params.data.Product) params.data.Product = {};
          if (!params.data.Product.Brand) params.data.Product.Brand = {};
          params.data.Product.Brand.Name = params.newValue;
          return true;
        }
      },
      {
        headerName: 'Name',
        field: 'name',
        width: 200,
        minWidth: 150,
        editable: true,
        singleClickEdit: false,
        cellStyle: { backgroundColor: 'rgba(0, 201, 189, 0.08)' },
        valueGetter: (params: any) => params.data?.UIProductValue || params.data?.Product?.Name || '',
        valueSetter: (params: any) => {
          if (params.data) {
            params.data.UIProductValue = params.newValue;
            if (!params.data.Product) params.data.Product = {};
            params.data.Product.Name = params.newValue;
          }
          return true;
        }
      },
      {
        headerName: 'PartNumber',
        field: 'partNumber',
        width: 120,
        minWidth: 100,
        editable: (params: any) => {
          const statusId = params.data?.CartItemStatus?.ID;
          return statusId === 0 || statusId === -2 || statusId == null;
        },
        cellStyle: { backgroundColor: 'rgba(0, 201, 189, 0.08)' },
        valueGetter: (params: any) => params.data?.Product?.PartNumber || '',
        valueSetter: (params: any) => {
          if (!params.data.Product) params.data.Product = {};
          params.data.Product.PartNumber = params.newValue;
          return true;
        }
      },
      {
        headerName: 'Qty',
        field: 'Quantity',
        width: 70,
        minWidth: 60,
        editable: true,
        type: 'numericColumn',
        valueParser: this.numberParser,
        cellStyle: { backgroundColor: 'rgba(50, 170, 58, 0.12)', color: '#2e7d32' }
      },
      {
        headerName: 'Purchase',
        field: 'purchase',
        width: 90,
        minWidth: 70,
        editable: true,
        cellStyle: { backgroundColor: 'rgba(50, 170, 58, 0.12)', color: '#2e7d32' },
        valueGetter: (params: any) => {
          const lp = params.data?.SelectedOffer?.ListPrice;
          return (lp != null && lp !== '') ? lp : '';
        },
        valueSetter: (params: any) => {
          const rawValue = (params.newValue ?? '').toString().trim();
          if (!params.data.SelectedOffer) params.data.SelectedOffer = {};
          if (rawValue === '') {
            params.data.SelectedOffer.ListPrice = null;
          } else {
            const parsed = this.parseNumberFromAnyFormat(rawValue);
            if (parsed !== null) {
              params.data.SelectedOffer.ListPrice = parsed;
            }
          }
          return true;
        }
      },
      {
        headerName: 'Supplier',
        field: 'supplier',
        width: 150,
        minWidth: 100,
        // ✅ Locked to the PO's supplier (split-by-supplier grid / selected NEW PO partner) — not editable
        editable: false,
        cellStyle: { backgroundColor: 'rgba(255, 102, 0, 0.06)' },
        valueGetter: (params: any) => {
          const poIndex = this.generatePOGridApis.indexOf(params.api);
          const po = poIndex >= 0 ? this.GeneratedPurchaseOrders[poIndex] : null;
          return po?.Cart?.Partner?.Name || params.data?.SelectedOffer?.Partner?.Name || '';
        }
      },
      {
        headerName: 'PC',
        width: 60,
        minWidth: 50,
        editable: false,
        cellStyle: { backgroundColor: 'rgba(50, 170, 58, 0.12)', color: '#2e7d32' },
        valueGetter: (params: any) => params.data?.SelectedOffer?.PurchaseCurrency?.Name || params.data?.SelectedOffer?.Currency?.Name || ''
      },
      {
        headerName: 'LeadTime',
        field: 'leadTime',
        width: 100,
        minWidth: 80,
        editable: true,
        cellStyle: { backgroundColor: 'rgba(0, 201, 189, 0.08)' },
        valueGetter: (params: any) => params.data?.SelectedOffer?.LeadTime?.UIOutput || params.data?._pendingLeadTimeInput || '',
        valueSetter: (params: any) => {
          if (params.data) {
            params.data._pendingLeadTimeInput = params.newValue;
          }
          return true;
        }
      },
      {
        headerName: 'ListPrice',
        field: 'listPrice',
        width: 90,
        minWidth: 70,
        editable: true,
        cellStyle: { backgroundColor: 'rgba(0, 201, 189, 0.08)' },
        valueGetter: (params: any) => params.data?.Product?.Stats?.StandardListPrice?.UIUnitPrice || 0,
        valueSetter: (params: any) => {
          const parsed = this.parseNumberFromAnyFormat(params.newValue);
          if (parsed !== null) {
            if (!params.data.Product) params.data.Product = {};
            if (!params.data.Product.Stats) params.data.Product.Stats = {};
            if (!params.data.Product.Stats.StandardListPrice) params.data.Product.Stats.StandardListPrice = {};
            params.data.Product.Stats.StandardListPrice.UIUnitPrice = parsed;
            params.data.Product.Stats.StandardListPrice.UnitPrice = parsed;
          }
          return true;
        }
      },
      {
        headerName: 'Discount %',
        field: 'discount',
        width: 90,
        minWidth: 70,
        editable: true,
        cellStyle: { backgroundColor: 'rgba(0, 201, 189, 0.08)' },
        valueGetter: (params: any) => {
          const listPrice = parseFloat(params.data?.Product?.Stats?.StandardListPrice?.UIUnitPrice) || 0;
          const purchasePrice = parseFloat(params.data?.SelectedOffer?.ListPrice) || 0;
          if (listPrice > 0) {
            const discount = (listPrice - purchasePrice) / listPrice * 100;
            const formatted = discount % 1 === 0 ? discount.toFixed(0) : parseFloat(discount.toFixed(2)).toString();
            return `${formatted}%`;
          }
          return '0%';
        },
        valueSetter: (params: any) => {
          let discountStr = String(params.newValue || '').replace('%', '').trim();
          const parsed = this.parseNumberFromAnyFormat(discountStr);
          if (parsed === null) return false;
          const discount = Math.max(0, Math.min(100, parsed));
          const listPrice = parseFloat(params.data?.Product?.Stats?.StandardListPrice?.UIUnitPrice) || 0;
          if (listPrice <= 0) return false;
          const newPurchase = Math.round(listPrice * (1 - discount / 100) * 100) / 100;
          if (!params.data.SelectedOffer) params.data.SelectedOffer = {};
          params.data.SelectedOffer.ListPrice = newPurchase;
          return true;
        }
      },
      {
        headerName: 'Margin',
        field: 'margin',
        width: 65,
        minWidth: 55,
        maxWidth: 80,
        editable: false,
        suppressMenu: true,
        cellStyle: (params: any) => {
          const margin = params.value;
          const parsed = parseFloat(margin);
          const color = isNaN(parsed) ? '#666' : (parsed >= 0 ? '#2e7d32' : '#d32f2f');
          return { fontSize: '10px', fontWeight: '600', color: color, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' };
        },
        valueGetter: (params: any) => {
          // Use backend-calculated ProfitMargin from CartItemPriceStatus if available
          const backendMargin = params.data?.CartItemPriceStatus?.ProfitMargin;
          if (backendMargin != null) {
            return `${backendMargin}%`;
          }
          // Fallback: calculate locally, normalizing both prices to base currency via ExchangeRate
          // (mirrors backend DetermineCartItemPriceStatus logic)
          const sellPrice = parseFloat(params.data?.SelectedOffer?.SellingPrice || params.data?.Price?.UIUnitPrice) || 0;
          const purchasePrice = parseFloat(params.data?.SelectedOffer?.ListPrice) || 0;
          if (sellPrice > 0 && purchasePrice > 0) {
            const sellCurrency = params.data?.Price?.Currency ?? params.data?.SelectedOffer?.Currency;
            const purchaseCurrency = params.data?.SelectedOffer?.PurchaseCurrency ?? params.data?.SelectedOffer?.Currency;
            const sellRate = (sellCurrency?.ExchangeRate > 0) ? sellCurrency.ExchangeRate : 1;
            const purchaseRate = (purchaseCurrency?.ExchangeRate > 0) ? purchaseCurrency.ExchangeRate : 1;
            const sellInBase = sellPrice * sellRate;
            const purchaseInBase = purchasePrice * purchaseRate;
            const margin = ((sellInBase - purchaseInBase) / sellInBase) * 100;
            const formatted = margin % 1 === 0 ? margin.toFixed(0) : parseFloat(margin.toFixed(2)).toString();
            return `${formatted}%`;
          }
          return '';
        }
      },
      {
        headerName: '',
        field: 'delete',
        width: 25,
        minWidth: 25,
        maxWidth: 25,
        editable: false,
        sortable: false,
        suppressMenu: true,
        suppressSizeToFit: true,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' },
        cellRenderer: (params: any) => {
          const statusId = params.data?.CartItemStatus?.ID;
          // Don't show X for empty rows
          if (statusId === -2 || statusId == null) return '';
          return '<i class="material-icons" style="font-size: 14px; color: #d32f2f; cursor: pointer;" title="Remove item">close</i>';
        },
        onCellClicked: (params: any) => {
          const statusId = params.data?.CartItemStatus?.ID;
          if (statusId === -2 || statusId == null) return;
          // Find poIndex from the grid API
          const poIndex = this.generatePOGridApis.indexOf(params.api);
          if (poIndex >= 0) {
            this.deleteGeneratePORow(poIndex, params.rowIndex);
          }
        }
      }
    ];
  }

  onGeneratePOCellValueChanged(event: any, poIndex: number): void {
    const field = event.colDef?.field;
    const cartItem = event.data; // ✅ Row data IS the CartItem directly
    const rowNode = event.node;
    const gridApi = this.generatePOGridApis[poIndex];

    if (!cartItem) return;

    // ✅ Get selected items for bulk editing
    const selectedItems = this.getSelectedGeneratePOItems(poIndex);
    const isMultiSelect = selectedItems.length > 1 && cartItem.IsSelected === true;

    // ✅ All changes are made to the CartItem in the PurchaseOrder's Cart.Items array
    // Changes will be saved when the user clicks "Save"

    // Handle Quantity changes (bulk edit supported)
    if (field === 'Quantity') {
      const newQty = this.numberParser({ newValue: event.newValue }) ?? 0;

      if (isMultiSelect) {
        // Apply same quantity to all selected rows
        selectedItems.forEach(({ data }) => {
          data.Quantity = newQty;
        });
      } else {
        cartItem.Quantity = newQty;
      }
      this.refreshAllGeneratePOGrids();
      return;
    }

    // Handle PartNumber changes (already handled by valueSetter, just refresh)
    if (field === 'partNumber') {
      if (gridApi) {
        gridApi.refreshCells({ rowNodes: [rowNode], force: true });
      }
      return;
    }

    // Handle Brand changes — call IdentifyGridBrand to resolve brand
    if (field === 'brand') {
      const newBrand = (event.newValue ?? '').toString().trim();
      if (!newBrand) return;

      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newBrand,
        CompanyID: this.parent.B2BPartner?.FK_CompanyID || 0
      };

      this.managementService.IdentifyGridBrand(request).subscribe((response: any) => {
        if (response["Status"] === 1 && response["Brand"]) {
          const identifiedBrand = response["Brand"];
          if (!cartItem.Product) cartItem.Product = {};
          cartItem.Product.Brand = identifiedBrand;
          if (gridApi) {
            gridApi.refreshCells({ rowNodes: [rowNode], force: true });
            gridApi.redrawRows({ rowNodes: [rowNode] });
          }
        } else {
          // Brand not found — keep typed name
          if (!cartItem.Product) cartItem.Product = {};
          if (!cartItem.Product.Brand) cartItem.Product.Brand = {};
          cartItem.Product.Brand.Name = newBrand;
          cartItem.Product.Brand.ID = 0;
          if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        }
      }, () => {
        if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
      });
      return;
    }

    // Handle Name changes — trigger product search (like source quotations/new)
    if (field === 'name') {
      const newName = (event.newValue ?? '').toString().trim();
      const oldName = (event.oldValue ?? '').toString().trim();
      if (!newName || newName === oldName) return;
      // Skip if already searched (valid row)
      if (cartItem?.CartItemStatus?.ID === 1 && cartItem?.WasSearchedFor === true) {
        if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        return;
      }
      this.searchGeneratePOProduct(poIndex, event.rowIndex, newName, cartItem?.Quantity || 1);
      return;
    }

    // Handle ListPrice changes - recalculate discount
    if (field === 'listPrice') {
      // Discount column will auto-recalculate via valueGetter
      this.refreshAllGeneratePOGrids();
      return;
    }

    // Handle Discount % changes (bulk edit supported - each row calculates its own Purchase)
    if (field === 'discount') {
      if (isMultiSelect) {
        // Parse the discount value from the edited cell
        let discountStr = String(event.newValue || '').replace('%', '').trim();
        const parsed = this.parseNumberFromAnyFormat(discountStr);
        if (parsed === null) return;
        const discount = Math.max(0, Math.min(100, parsed));

        // Apply same discount % to all selected rows, each calculates its own Purchase
        selectedItems.forEach(({ data }) => {
          const listPrice = parseFloat(data?.Product?.Stats?.StandardListPrice?.UIUnitPrice) || 0;
          if (listPrice > 0) {
            const newPurchase = Math.round(listPrice * (1 - discount / 100) * 100) / 100;
            if (!data.SelectedOffer) data.SelectedOffer = {};
            data.SelectedOffer.ListPrice = newPurchase;
          }
        });
      }
      // Single row already handled by valueSetter
      this.refreshAllGeneratePOGrids();
      return;
    }

    // Handle Purchase changes (bulk edit supported - same price to all)
    if (field === 'purchase') {
      if (isMultiSelect) {
        const parsed = this.parseNumberFromAnyFormat(event.newValue);
        if (parsed !== null) {
          // Apply same purchase price to all selected rows
          selectedItems.forEach(({ data }) => {
            if (!data.SelectedOffer) data.SelectedOffer = {};
            data.SelectedOffer.ListPrice = parsed;
          });
        }
      }
      // ✅ RED ROW (CartItemStatus.ID === 0): route through AdminEditGridCell so the backend
      // recalculates status, PurchaseDiscount and other derived fields correctly
      if (!isMultiSelect && cartItem?.CartItemStatus?.ID === 0) {
        this.adminEditGeneratePORedRow(poIndex, event.rowIndex, cartItem);
        return;
      }
      // Single row already handled by valueSetter
      this.refreshAllGeneratePOGrids();
      return;
    }

    // Handle LeadTime changes (bulk edit supported - each row calls backend)
    if (field === 'leadTime') {
      // Read the raw user input from the temporary property set by valueSetter
      const newLeadTime = (cartItem._pendingLeadTimeInput ?? '').toString().trim();

      // Clear the temporary property
      delete cartItem._pendingLeadTimeInput;

      if (!newLeadTime || newLeadTime === '------') return;

      if (isMultiSelect) {
        // Apply lead time to all selected rows - each calls backend for validation
        selectedItems.forEach(({ node, data }) => {
          const request = {
            User: this.parent.User,
            Language: this.parent.getLanguage(),
            CellText: newLeadTime,
            IsProlonged: false
          };

          this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
            if (response["Status"] === 1 && response["LeadTime"]) {
              const leadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
              const isStock = response["IsStock"];

              if (!data.SelectedOffer) data.SelectedOffer = {};
              data.SelectedOffer.LeadTime = leadTime;
              data.SelectedOffer.IsStockOffer = isStock;

              if (gridApi) {
                gridApi.refreshCells({ rowNodes: [node], force: true });
              }
            }
          });
        });
      } else {
        // Single row - original logic
        const request = {
          User: this.parent.User,
          Language: this.parent.getLanguage(),
          CellText: newLeadTime,
          IsProlonged: false
        };

        this.managementService.IdentifyGridLeadTime(request).subscribe(response => {
          if (response["Status"] === 1 && response["LeadTime"]) {
            const leadTime = JSON.parse(JSON.stringify(response["LeadTime"]));
            const isStock = response["IsStock"];

            if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
            cartItem.SelectedOffer.LeadTime = leadTime;
            cartItem.SelectedOffer.IsStockOffer = isStock;

            if (gridApi) {
              gridApi.refreshCells({ rowNodes: [rowNode], force: true });
            }
          } else {
            if (gridApi) {
              gridApi.refreshCells({ rowNodes: [rowNode], force: true });
            }
            this.parent.openSnackBar(response["Message"] || 'Could not parse lead time', "OK", "alert-info-snackbar");
          }
        }, () => {
          if (gridApi) {
            gridApi.refreshCells({ rowNodes: [rowNode], force: true });
          }
          this.parent.openSnackBar('Error parsing lead time', "OK", "alert-info-snackbar");
        });
      }
      return;
    }

    // ✅ Handle Supplier changes — call IdentifyPartnerWithOffers to resolve partner + best offer
    if (field === 'supplier') {
      const newSupplier = (cartItem._pendingSupplierInput ?? '').toString().trim();
      delete cartItem._pendingSupplierInput;

      if (!newSupplier) return;

      const productId = cartItem?.Product?.ID;
      const fallbackCurrency = cartItem?.SelectedOffer?.Currency || cartItem?.SelectedOffer?.PurchaseCurrency;
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        CellText: newSupplier,
        CompanyID: this.parent.B2BPartner?.FK_CompanyID || 0,
        ProductID: productId || null,
        FallbackCurrency: fallbackCurrency
      };

      this.managementService.IdentifyPartnerWithOffers(request).subscribe(response => {
        if (response["Status"] === 1 && response["Offers"] && response["Offers"].length > 0) {
          const identifiedOffer = response["Offers"][0];
          const identifiedPartner = identifiedOffer?.Partner;

          if (!identifiedPartner) {
            this.parent.openSnackBar('Supplier found but missing partner details', "OK", "alert-info-snackbar");
            return;
          }

          // Apply partner + best offer to the CartItem
          if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
          cartItem.SelectedOffer.Partner = identifiedPartner;
          cartItem.SelectedOffer.ID = identifiedOffer.ID || 0;
          if (identifiedOffer.ListPrice > 0) {
            cartItem.SelectedOffer.ListPrice = identifiedOffer.ListPrice;
          }
          if (identifiedOffer.Currency) cartItem.SelectedOffer.Currency = identifiedOffer.Currency;
          if (identifiedOffer.PurchaseCurrency) cartItem.SelectedOffer.PurchaseCurrency = identifiedOffer.PurchaseCurrency;

          if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        } else {
          // Partner not found — keep typed name as Partner.Name but clear offer ID (new offer)
          if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
          if (!cartItem.SelectedOffer.Partner) cartItem.SelectedOffer.Partner = {};
          cartItem.SelectedOffer.Partner.Name = newSupplier;
          cartItem.SelectedOffer.ID = 0;
          if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
          this.parent.openSnackBar(response["Message"] || 'Supplier not found — enter purchase price manually', "OK", "alert-info-snackbar");
        }
      }, () => {
        if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Could not identify supplier', "OK", "alert-info-snackbar");
      });
      return;
    }
  }

  // ✅ Route a completed RED ROW (invalid, CartItemStatus.ID === 0) through /api/B2B/Admin/Edit/Grid/Cell
  // so the backend recalculates status, PurchaseDiscount and other derived fields after a purchase price is set.
  adminEditGeneratePORedRow(poIndex: number, rowIndex: number, cartItem: any): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    const gridApi = this.generatePOGridApis[poIndex];
    if (!cartItem) return;

    // ✅ Lock supplier to the PO's partner before sending
    if (po?.Cart?.Partner) {
      if (!cartItem.SelectedOffer) cartItem.SelectedOffer = {};
      cartItem.SelectedOffer.Partner = JSON.parse(JSON.stringify(po.Cart.Partner));
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CartItem: cartItem,
      OriginalCartItem: null,
      Partner: po?.Cart?.Partner || null,
      FinalPriceEdit: false,
      DiscountEdit: false
    };

    cartItem.LoadingCell = true;
    if (gridApi) gridApi.refreshCells({ rowNodes: [gridApi.getDisplayedRowAtIndex(rowIndex)].filter(Boolean), force: true });

    this.B2BService.AdminEditGridCell(request).subscribe((response: any) => {
      if (response["Status"] === 1 && response["CartItem"]) {
        const updated = JSON.parse(JSON.stringify(response["CartItem"]));
        updated.LoadingCell = false;
        // ✅ Re-lock supplier to the PO's partner (backend response may not carry it)
        if (po?.Cart?.Partner) {
          if (!updated.SelectedOffer) updated.SelectedOffer = {};
          updated.SelectedOffer.Partner = JSON.parse(JSON.stringify(po.Cart.Partner));
        }
        if (po?.Cart?.Items && rowIndex < po.Cart.Items.length) {
          po.Cart.Items[rowIndex] = updated;
        }
        if (gridApi) {
          gridApi.setRowData(po.Cart.Items);
          gridApi.redrawRows();
        }
      } else {
        cartItem.LoadingCell = false;
        this.parent.openSnackBar(response["Message"] || 'Could not update item', 'OK', 'alert-info-snackbar');
        if (gridApi) gridApi.refreshCells({ force: true });
      }
    }, () => {
      cartItem.LoadingCell = false;
      this.parent.openSnackBar('Error updating item', 'OK', 'alert-info-snackbar');
      if (gridApi) gridApi.refreshCells({ force: true });
    });
  }

  // ✅ Create an empty CartItem row for the Generate PO grid
  createEmptyGeneratePORow(partner?: any): any {
    return {
      CartItemStatus: { ID: -2, Name: 'Empty' },
      Product: { Brand: {}, Stats: {}, PartNumber: '' },
      SelectedOffer: { Partner: partner ? JSON.parse(JSON.stringify(partner)) : {}, ListPrice: null, PurchaseCurrency: null, Currency: null, LeadTime: null },
      Quantity: 1,
      UIProductValue: '',
      IsSelected: false,
      WasSearchedFor: false
    };
  }

  // ✅ Add more empty rows to a specific PO grid
  addMoreGeneratePORows(poIndex: number, count: number = 10): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart) return;
    if (!po.Cart.Items) po.Cart.Items = [];

    const poPartner = po.Cart?.Partner || null;
    for (let i = 0; i < count; i++) {
      po.Cart.Items.push(this.createEmptyGeneratePORow(poPartner));
    }

    const gridApi = this.generatePOGridApis[poIndex];
    if (gridApi) {
      gridApi.setRowData(po.Cart.Items);
      setTimeout(() => gridApi.sizeColumnsToFit(), 50);
    }
  }

  // ✅ Delete a row from a specific PO grid (removes from Cart.Items)
  deleteGeneratePORow(poIndex: number, rowIndex: number): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po || !po.Cart?.Items) return;

    // ✅ Resolve actual data array index (display index may differ if grid is sorted)
    const gridApi = this.generatePOGridApis[poIndex];
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    const dataArrayIndex = rowNode ? po.Cart.Items.indexOf(rowNode.data) : rowIndex;
    const targetIndex = dataArrayIndex >= 0 ? dataArrayIndex : rowIndex;

    po.Cart.Items.splice(targetIndex, 1);

    if (gridApi) {
      gridApi.setRowData(po.Cart.Items);
    }
  }

  // ✅ Search product for Generate PO grid (single item — uses Combined endpoint like source)
  searchGeneratePOProduct(poIndex: number, rowIndex: number, searchTerm: string, quantity: number): void {
    if (!searchTerm || searchTerm.trim().length < 2) return;

    const gridApi = this.generatePOGridApis[poIndex];
    const rowNode = gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;

    // Get currency from PO's first item or default
    const po = this.GeneratedPurchaseOrders[poIndex];

    // ✅ Resolve the actual data array index (display index may differ from array index if grid is sorted)
    const dataArrayIndex = po?.Cart?.Items ? po.Cart.Items.indexOf(rowNode.data) : -1;
    const targetIndex = dataArrayIndex >= 0 ? dataArrayIndex : rowIndex;
    const poFirstItem = po?.Cart?.Items?.find((i: any) => i?.SelectedOffer?.PurchaseCurrency || i?.SelectedOffer?.Currency);
    const itemCurrency = poFirstItem?.SelectedOffer?.PurchaseCurrency || poFirstItem?.SelectedOffer?.Currency || null;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: searchTerm,
      Quantity: quantity,
      Pager: { PageIndex: 1, PageSize: 10 },
      MaxRank: 10,
      ApplyClientRestrictions: false,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: itemCurrency,
        ConfigStatus: { ID: -9000 }
      },
      // ─── Pre-loaded data: eliminates sequential DB fetches per search ───
      PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
      PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
      PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
      PreloadedPartner: this.parent.B2BPartner || null,
      PreloadedIsBlocked: false,
    };

    // Show loading
    rowNode.data.LoadingCell = true;
    if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], columns: ['name'], force: true });

    this.B2BService.SearchIndustryProductB2BOffersWithMasterDataCombined(request).subscribe({
      next: (response: any) => {
        if (response.Status === 1 || response.Status === -2) {
          const c = JSON.parse(JSON.stringify(response.CartItem));
          c.LoadingCell = false;
          c.WasSearchedFor = true;
          if (!c.Quantity || c.Quantity <= 0) c.Quantity = quantity;

          console.log('💱 [PO-Search] INCOMING CartItem from API:');
          console.log('   ListPrice (purchase):', c.SelectedOffer?.ListPrice);
          console.log('   PurchaseCurrency:', c.SelectedOffer?.PurchaseCurrency?.Name, 'ID:', c.SelectedOffer?.PurchaseCurrency?.ID);
          console.log('   Currency (sell):', c.SelectedOffer?.Currency?.Name, 'ID:', c.SelectedOffer?.Currency?.ID);
          console.log('   StandardListPrice:', c.Product?.Stats?.StandardListPrice?.UIUnitPrice);
          console.log('   StandardListPrice.Currency:', c.Product?.Stats?.StandardListPrice?.Currency?.Name, 'ID:', c.Product?.Stats?.StandardListPrice?.Currency?.ID);
          console.log('   SellingPrice:', c.SelectedOffer?.SellingPrice);
          console.log('   PO Cart.Currency:', po.Cart?.Currency?.Name, 'ID:', po.Cart?.Currency?.ID);

          // ✅ Lock supplier to the PO's partner (split-by-supplier grid / selected NEW PO partner)
          if (po?.Cart?.Partner) {
            if (!c.SelectedOffer) c.SelectedOffer = {};
            // ✅ If the incoming offer's supplier differs from the PO's locked partner,
            // reset SelectedOffer.ID to 0 (will be saved as NULL in DB) — the offer belongs to a different supplier
            const incomingSupplierID = c.SelectedOffer?.Partner?.ID;
            const poPartnerID = po.Cart.Partner.ID;
            if (incomingSupplierID && poPartnerID && incomingSupplierID !== poPartnerID) {
              c.SelectedOffer.ID = 0;
            }
            c.SelectedOffer.Partner = JSON.parse(JSON.stringify(po.Cart.Partner));
          }

          // ✅ Check if purchase currency differs from PO Cart currency — exchange if needed
          // IMPORTANT: Compare against SelectedOffer.Currency (the actual currency the numerical values are in),
          // NOT PurchaseCurrency (which is just the original supplier currency tag).
          // The B2B search API already exchanges ListPrice to the user's preferred currency,
          // but leaves PurchaseCurrency as the original tag — so comparing PurchaseCurrency would cause double exchange.
          const poCurrencyID = po.Cart?.Currency?.ID;
          const itemActualCurrencyID = c.SelectedOffer?.Currency?.ID;
          const itemPurchaseCurrencyID = c.SelectedOffer?.PurchaseCurrency?.ID;

          console.log('💱 [PO-Search] Currency comparison: poCurrencyID=', poCurrencyID,
            'itemActualCurrencyID=', itemActualCurrencyID, '(SelectedOffer.Currency)',
            'itemPurchaseCurrencyID=', itemPurchaseCurrencyID, '(PurchaseCurrency tag)');

          // ✅ If values are already in the PO's currency, just align the PurchaseCurrency tag
          if (itemActualCurrencyID && poCurrencyID && itemActualCurrencyID === poCurrencyID) {
            if (itemPurchaseCurrencyID && itemPurchaseCurrencyID !== poCurrencyID) {
              console.log('💱 [PO-Search] Values already in PO currency — aligning PurchaseCurrency tag from', c.SelectedOffer?.PurchaseCurrency?.Name, 'to', po.Cart.Currency?.Name);
              c.SelectedOffer.PurchaseCurrency = JSON.parse(JSON.stringify(po.Cart.Currency));
            }
          }

          // Only exchange if the actual value currency differs from the PO currency
          const needsExchange = poCurrencyID && itemActualCurrencyID && poCurrencyID !== itemActualCurrencyID;
          console.log('💱 [PO-Search] needsExchange=', needsExchange);

          if (needsExchange) {
            // Exchange the cart item's purchase price to the PO's currency
            const exchangeRequest = {
              User: this.parent.User,
              Language: this.parent.getLanguage(),
              CartItems: [c],
              NewPurchaseCurrency: po.Cart.Currency
            };

            console.log('💱 [PO-Search] Calling ExchangeCartItemsPurchaseCurrency with:', JSON.stringify({
              ListPrice: c.SelectedOffer?.ListPrice,
              PurchaseCurrencyID: c.SelectedOffer?.PurchaseCurrency?.ID,
              PurchaseCurrencyName: c.SelectedOffer?.PurchaseCurrency?.Name,
              NewPurchaseCurrencyID: po.Cart.Currency?.ID,
              NewPurchaseCurrencyName: po.Cart.Currency?.Name,
              StandardListPrice: c.Product?.Stats?.StandardListPrice?.UIUnitPrice,
              StandardListPriceCurrency: c.Product?.Stats?.StandardListPrice?.Currency?.Name
            }));

            this.B2BService.ExchangeCartItemsPurchaseCurrency(exchangeRequest).subscribe((exchangeResponse: any) => {
              console.log('💱 [PO-Search] Exchange response Status:', exchangeResponse?.Status);
              if (exchangeResponse?.Status === 1 && exchangeResponse?.CartItems?.length > 0) {
                const exchangedItem = exchangeResponse.CartItems[0];

                console.log('💱 [PO-Search] EXCHANGED CartItem:');
                console.log('   ListPrice (purchase):', exchangedItem.SelectedOffer?.ListPrice);
                console.log('   PurchaseCurrency:', exchangedItem.SelectedOffer?.PurchaseCurrency?.Name, 'ID:', exchangedItem.SelectedOffer?.PurchaseCurrency?.ID);
                console.log('   Currency (sell):', exchangedItem.SelectedOffer?.Currency?.Name, 'ID:', exchangedItem.SelectedOffer?.Currency?.ID);
                console.log('   StandardListPrice:', exchangedItem.Product?.Stats?.StandardListPrice?.UIUnitPrice);
                console.log('   StandardListPrice.Currency:', exchangedItem.Product?.Stats?.StandardListPrice?.Currency?.Name);
                console.log('   SellingPrice:', exchangedItem.SelectedOffer?.SellingPrice);

                // Preserve fields set above (supplier lock, WasSearchedFor, etc.)
                exchangedItem.LoadingCell = false;
                exchangedItem.WasSearchedFor = true;
                if (po?.Cart?.Partner) {
                  if (!exchangedItem.SelectedOffer) exchangedItem.SelectedOffer = {};
                  exchangedItem.SelectedOffer.Partner = JSON.parse(JSON.stringify(po.Cart.Partner));
                }

                if (po?.Cart?.Items && targetIndex < po.Cart.Items.length) {
                  po.Cart.Items[targetIndex] = exchangedItem;
                }
              } else {
                console.log('💱 [PO-Search] Exchange FAILED, using original. Message:', exchangeResponse?.Message);
                // Exchange failed — use original item as-is
                if (po?.Cart?.Items && targetIndex < po.Cart.Items.length) {
                  po.Cart.Items[targetIndex] = c;
                }
              }

              if (gridApi) {
                gridApi.setRowData(po.Cart.Items);
                gridApi.redrawRows();
              }
            }, (err: any) => {
              console.error('💱 [PO-Search] Exchange HTTP ERROR:', err);
              // Exchange error — use original item
              if (po?.Cart?.Items && targetIndex < po.Cart.Items.length) {
                po.Cart.Items[targetIndex] = c;
              }
              if (gridApi) {
                gridApi.setRowData(po.Cart.Items);
                gridApi.redrawRows();
              }
            });
          } else {
            console.log('💱 [PO-Search] No exchange needed — same currency or no PO currency set');
            // No exchange needed — same currency or no PO currency set
            if (po?.Cart?.Items && targetIndex < po.Cart.Items.length) {
              po.Cart.Items[targetIndex] = c;
            }

            if (gridApi) {
              gridApi.setRowData(po.Cart.Items);
              gridApi.redrawRows();
            }
          }
        } else {
          rowNode.data.LoadingCell = false;
          // Set as red row (not found)
          rowNode.data.CartItemStatus = { ID: 0, Name: 'NotValid' };
          rowNode.data.WasSearchedFor = true;
          if (gridApi) {
            gridApi.refreshCells({ rowNodes: [rowNode], force: true });
            gridApi.redrawRows({ rowNodes: [rowNode] });
          }
        }
      },
      error: () => {
        rowNode.data.LoadingCell = false;
        if (gridApi) gridApi.refreshCells({ rowNodes: [rowNode], force: true });
        this.parent.openSnackBar('Error searching products', 'OK', 'alert-info-snackbar');
      }
    });
  }

  // ✅ Handle paste in Generate PO grid (multi-search like source)
  handleGeneratePOPaste(params: any, poIndex: number): void {
    const gridApi = this.generatePOGridApis[poIndex];
    if (!gridApi) return;

    gridApi.stopEditing();

    const po = this.GeneratedPurchaseOrders[poIndex];
    if (!po?.Cart?.Items) return;

    // Collect pasted rows with name values
    const pastedEntries: [number, { name: string; quantity: any }][] = [];
    gridApi.forEachNode((node: any) => {
      if (!node || node.rowIndex == null) return;
      const name = (node.data?.UIProductValue || node.data?.Product?.Name || '').toString().trim();
      if (!name) return;

      // Only search rows that haven't been searched yet
      const statusId = node.data?.CartItemStatus?.ID;
      if (statusId === 1 && node.data?.WasSearchedFor === true) return;

      const qty = node.data?.Quantity || 1;
      pastedEntries.push([node.rowIndex, { name, quantity: qty }]);
    });

    if (pastedEntries.length === 0) return;

    // Ensure enough rows exist
    const poPartner = po.Cart?.Partner || null;
    const maxRowIndex = Math.max(...pastedEntries.map(([ri]) => ri));
    while (po.Cart.Items.length <= maxRowIndex) {
      po.Cart.Items.push(this.createEmptyGeneratePORow(poPartner));
    }
    gridApi.setRowData(po.Cart.Items);

    // Process each pasted entry (search individually — simpler than bulk for PO context)
    pastedEntries.forEach(([rowIndex, payload]) => {
      this.searchGeneratePOProduct(poIndex, rowIndex, payload.name, payload.quantity);
    });
  }

  // ✅ Save finalized Purchase Orders - calls BulkCreatePurchaseOrders API
  saveFinalPurchaseOrders(): void {
    if (this.GeneratedPurchaseOrders.length === 0) {
      this.parent.openSnackBar('No Purchase Orders to save', 'OK', 'alert-info-snackbar');
      return;
    }

    // All remaining POs are included (user removes unwanted ones with X button)
    // Mark all as IsSelected = true for the backend filter
    // ✅ Filter out empty rows (CartItemStatus.ID === -2) and awaiting selection (-1) before saving
    const posToSave = JSON.parse(JSON.stringify(this.GeneratedPurchaseOrders));
    posToSave.forEach((po: any) => {
      po.IsSelected = true;

      // ✅ PO must NEVER inherit Insurance or OC Cart Discount
      if (po.Cart) {
        po.Cart.HasInsurance = false;
        po.Cart.InsuranceValue = null;
        // ✅ Remove empty and awaiting-selection rows — only send valid (1) and red (0) items
        if (po.Cart.Items) {
          po.Cart.Items = po.Cart.Items.filter((item: any) => {
            const statusId = item?.CartItemStatus?.ID;
            return statusId === 1 || statusId === 0;
          });
        }
      }
    });

    // Build the request object
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PurchaseOrders: posToSave,
      SendEmail: true // Default to sending email; can be made configurable per PO
    };

    // Set loading states
    this.BulkPOCreationLoading = true;
    this.parent.loading = true;

    console.log('📤 Calling BulkCreatePurchaseOrders with:', request);

    this.managementService.BulkCreatePurchaseOrders(request).subscribe(
      (response: any) => {
        console.log('📥 BulkCreatePurchaseOrders response:', response);

        if (response["Status"] != 1) {
          // Error or warning
          this.parent.openSnackBar(response["Message"] || 'Error creating Purchase Orders', "OK", "alert-info-snackbar");
        } else {
          // Success - show results popup
          this.BulkPOCreationResults = response;
          this.ShowBulkPOResultsPopup = true;
          this.initBulkPOShipping();
          this.closeGeneratePOPopup();
          this.bulkExportCreatedPurchaseOrders(response["CreatedPurchaseOrders"] || []);
          this.parent.openSnackBar(`Successfully created ${response["SuccessCount"] || 0} Purchase Order(s)`, 'OK', 'light-info-snackbar');
          // Skip undo snapshot on this refresh - it's system-initiated, not user grid edit
          this.skipNextUndoSnapshot = true;
          this.applyFilter(this.Filter.Pager.PageIndex);
        }

        this.BulkPOCreationLoading = false;
        this.parent.loading = false;
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('❌ BulkCreatePurchaseOrders error:', error);
        this.parent.openSnackBar('Error creating Purchase Orders: ' + (error.message || 'Unknown error'), 'OK', 'alert-info-snackbar');
        this.BulkPOCreationLoading = false;
        this.parent.loading = false;
        this.cdr.detectChanges();
      }
    );
  }

  // ✅ After POs are created, fetch PDF + Excel for all of them in one bulk call and download each
  bulkExportCreatedPurchaseOrders(created: any[]): void {
    const ids = (created || [])
      .map((po: any) => po?.PurchaseOrder?.ID)
      .filter((id: any) => !!id);

    if (ids.length === 0) {
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      IDs: ids
    };

    this.managementService.BulkExportPurchaseOrders(request).subscribe(
      (response: any) => {
        if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"] || 'Error exporting Purchase Orders', 'OK', 'alert-info-snackbar');
          return;
        }

        const pdfDocuments = response["PDFDocuments"] || [];
        const excelDocuments = response["ExcelDocuments"] || [];

        pdfDocuments.forEach((doc: any) => {
          if (doc?.PDFStream) {
            this.download(doc.Name, doc.PDFStream);
          }
        });

        excelDocuments.forEach((doc: any) => {
          if (doc?.PDFStream) {
            this.downloadExcel(doc.Name, doc.PDFStream);
          }
        });
      },
      (error: any) => {
        console.error('❌ BulkExportPurchaseOrders error:', error);
        this.parent.openSnackBar('Error exporting Purchase Orders: ' + (error.message || 'Unknown error'), 'OK', 'alert-info-snackbar');
      }
    );
  }

  // ✅ Re-download a single PO from the results popup (PDF + Excel)
  downloadBulkPODocument(po: any): void {
    const poID = po?.PurchaseOrder?.ID;
    if (!poID) return;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: poID
    };

    po._downloadingDocument = true;

    // Download PDF
    this.managementService.ExportPurchaseOrder(request).subscribe((response: any) => {
      if (response["Status"] == 1 && response["Document"]?.PDFStream) {
        this.download(response["Document"].Name, response["Document"].PDFStream);
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error downloading PDF', 'OK', 'alert-info-snackbar');
      }

      // Download Excel
      this.managementService.ExportPurchaseOrderExcel(request).subscribe((excelResponse: any) => {
        if (excelResponse["Status"] == 1 && excelResponse["Document"]?.PDFStream) {
          this.downloadExcel(excelResponse["Document"].Name, excelResponse["Document"].PDFStream);
        }
        po._downloadingDocument = false;
        this.cdr.detectChanges();
      }, () => {
        po._downloadingDocument = false;
        this.cdr.detectChanges();
      });
    }, () => {
      po._downloadingDocument = false;
      this.cdr.detectChanges();
    });
  }

  // ✅ Re-print a single PO from the results popup (PDF in new window)
  printBulkPODocument(po: any): void {
    const poID = po?.PurchaseOrder?.ID;
    if (!poID) return;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ID: poID
    };

    po._printingDocument = true;

    this.managementService.ExportPurchaseOrder(request).subscribe((response: any) => {
      if (response["Status"] == 1 && response["Document"]?.PDFStream) {
        this.printPage(response["Document"].Name, response["Document"].PDFStream, response["Document"].ID);
      } else {
        this.parent.openSnackBar(response["Message"] || 'Error printing PDF', 'OK', 'alert-info-snackbar');
      }
      po._printingDocument = false;
      this.cdr.detectChanges();
    }, () => {
      po._printingDocument = false;
      this.cdr.detectChanges();
    });
  }

  // ========== Bulk PO Shipping Label ==========

  // ✅ Import shipping direction (Supplier -> Company)
  private getImportShippingDirection(): any {
    const dir = this.ShippingDirections?.find((d: any) => d.ID === -1);
    return dir ? JSON.parse(JSON.stringify(dir)) : { ID: -1, Name: 'Import' };
  }

  // ✅ Called when the Bulk PO results popup opens: load company addresses + init each PO shipping context
  initBulkPOShipping(): void {
    const created = this.BulkPOCreationResults?.CreatedPurchaseOrders || [];
    if (created.length === 0) return;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      CompanyID: this.parent.Company.ID
    };

    this.service.GetCompanyShippingAddresses(request).subscribe((response: any) => {
      if (response["Status"] == 1) {
        this.BulkPOCompanyShippingAddresses = response["ShippingAddresses"] || [];
      } else {
        this.BulkPOCompanyShippingAddresses = [];
      }

      created.forEach((po: any) => this.initBulkPOShippingForPO(po));
    });
  }

  // ✅ Build ShippingDetails for one created PO (direction -1: sender = partner, receiver = company address)
  private initBulkPOShippingForPO(po: any): void {
    const partner = po?.PurchaseOrder?.Cart?.Partner || { ID: po?.PartnerID, Name: po?.PartnerName };

    // Default receiver = first company shipping address (user can change via dropdown)
    const defaultReceiver = this.BulkPOCompanyShippingAddresses?.length > 0
      ? JSON.parse(JSON.stringify(this.BulkPOCompanyShippingAddresses[0]))
      : null;

    // Default carrier/service from API-capable carriers only (full ShippingCompanies list includes
    // non-API couriers whose ID cannot construct the carrier service => _iService null on the backend)
    const defaultCompany = this.APIShippingCompanies?.length > 0
      ? JSON.parse(JSON.stringify(this.APIShippingCompanies[0]))
      : null;

    po.Shipping = {
      ShippingDetails: {
        ShippingDirection: this.getImportShippingDirection(),
        ShippingServiceType: defaultCompany?.ShippingServiceTypes?.length > 0
          ? JSON.parse(JSON.stringify(defaultCompany.ShippingServiceTypes[0]))
          : (this.ShippingServiceTypes?.length > 0 ? JSON.parse(JSON.stringify(this.ShippingServiceTypes[0])) : null),
        ShippingCompany: defaultCompany,
        ShippingResponsability: this.ShippingResponsabilities?.length > 0 ? JSON.parse(JSON.stringify(this.ShippingResponsabilities[0])) : null,
        ShippingWay: this.ShippingWays?.length > 0 ? JSON.parse(JSON.stringify(this.ShippingWays[0])) : null,
        WeightType: this.ShippingWeightTypes?.length > 0 ? JSON.parse(JSON.stringify(this.ShippingWeightTypes[0])) : null,
        Partner: JSON.parse(JSON.stringify(partner)),
        Receiver: defaultReceiver,
        Boxes: [{ ID: 0, Length: 10, Width: 10, Height: 10, Weight: 1, TrackingLabel: null, IsPallet: false, UIID: this.parent.newGuid(), _multiplyFactor: null }]
      },
      AvailableShippingAddresses: this.BulkPOCompanyShippingAddresses,
      AvailableShippingCompanies: JSON.parse(JSON.stringify(this.APIShippingCompanies || [])),
      AvailablePartnerAddresses: [],
      _showServiceTypeDropdown: false,
      _showCompanyDropdown: false,
      _showAddressSelector: false,
      _showSenderSelector: false,
      _generating: false,
      _generated: false,
      _errorMessage: null
    };

    // Load the supplier's shipping addresses so the user can choose the pickup location (sender)
    if (partner?.ID) {
      this.service.GetPartnerShippingAddresses({
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        PartnerID: partner.ID
      }).subscribe((addrResponse: any) => {
        if (addrResponse["Status"] == 1) {
          po.Shipping.AvailablePartnerAddresses = addrResponse["ShippingAddresses"] || [];
        }

        // ✅ If partner has 0 or null shipping addresses, auto-generate one via GenerateInitialShippingAddress
        if (!po.Shipping.AvailablePartnerAddresses || po.Shipping.AvailablePartnerAddresses.length === 0) {
          this.service.GenerateInitialShippingAddress({
            User: this.parent.User,
            Language: this.parent.getLanguage(),
            Partner: partner,
            AutoAdd: true
          }).subscribe((genResponse: any) => {
            if (genResponse["Status"] == 1 && genResponse["NewShippingAddress"]) {
              const newAddr = genResponse["NewShippingAddress"];
              if (!po.Shipping.AvailablePartnerAddresses) {
                po.Shipping.AvailablePartnerAddresses = [];
              }
              po.Shipping.AvailablePartnerAddresses.push(newAddr);

              // Also set as Sender if not already resolved
              if (!po.Shipping.ShippingDetails.Sender) {
                po.Shipping.ShippingDetails.Sender = JSON.parse(JSON.stringify(newAddr));
              }
            }
          });
        }
      });
    }

    // Resolve the supplier sender address via InitializeSenderReceiver (direction -1)
    var request = {
      Partner: partner,
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingDirection: po.Shipping.ShippingDetails.ShippingDirection
    };

    this.managementService.InitializeSenderReceiver(request).subscribe((response: any) => {
      if (response["Status"] == 1) {
        // Import (-1): Sender = the supplier (partner)
        po.Shipping.ShippingDetails.Sender = response["Sender"];

        // Keep the user-selectable company address as receiver; fall back to backend receiver if none loaded
        if (!po.Shipping.ShippingDetails.Receiver) {
          po.Shipping.ShippingDetails.Receiver = response["Receiver"];
        }

        // Refine carriers/service for this supplier's country (import => use the sender/supplier country)
        const supplierCountry = po.Shipping.ShippingDetails.Sender?.Country;
        if (supplierCountry?.ID) {
          this.loadBulkPOCountryShippingOptions(po, supplierCountry);
        }
      }
    });
  }

  // ✅ Load country-specific API carriers for one PO (import -1) and preselect a valid carrier + service type
  private loadBulkPOCountryShippingOptions(po: any, country: any): void {
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Country: country,
      PartnerID: po?.Shipping?.ShippingDetails?.Partner?.ID,
      DirectionID: po?.Shipping?.ShippingDetails?.ShippingDirection?.ID,
      ShippingCompany: po?.Shipping?.ShippingDetails?.ShippingCompany
    };

    this.managementService.GetCountryShippingOptions(request).subscribe((response: any) => {
      if (response["Status"] != 1) return;

      const companies = response["ShippingCompanies"] || [];
      if (companies.length === 0) return;

      po.Shipping.AvailableShippingCompanies = companies;

      // Preselect the carrier the backend marked IsSelected (last-used / default), else the first
      const selectedCompany = companies.find((c: any) => c.IsSelected === true) || companies[0];
      po.Shipping.ShippingDetails.ShippingCompany = JSON.parse(JSON.stringify(selectedCompany));

      // Preselect the service type the backend marked IsSelected within that carrier, else the first
      const svcTypes = selectedCompany.ShippingServiceTypes || [];
      const selectedSvc = svcTypes.find((s: any) => s.IsSelected === true) || svcTypes[0];
      if (selectedSvc) {
        po.Shipping.ShippingDetails.ShippingServiceType = JSON.parse(JSON.stringify(selectedSvc));
      }

      this.cdr.detectChanges();
    });
  }

  // ✅ Select a different company receiver address for a PO label
  selectBulkPOReceiverAddress(po: any, addr: any): void {
    if (!po?.Shipping?.ShippingDetails) return;
    po.Shipping.ShippingDetails.Receiver = JSON.parse(JSON.stringify(addr));
    po.Shipping._showAddressSelector = false;
  }

  // ✅ Select the supplier pickup address (sender) for a PO label (import -1)
  selectBulkPOSenderAddress(po: any, addr: any): void {
    if (!po?.Shipping?.ShippingDetails || !addr) return;

    // Mark the chosen address as selected within the partner address list
    (po.Shipping.AvailablePartnerAddresses || []).forEach((a: any) => a.IsSelected = (a.ID === addr.ID));

    // Construct the full sender address from the chosen partner address via the backend
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: addr,
      PartnerID: po.Shipping.ShippingDetails.Partner?.ID
    };

    this.managementService.SelectShippingAddressFromUI(request).subscribe((response: any) => {
      if (response["Status"] == 1) {
        po.Shipping.ShippingDetails.Sender = response["ShippingAddress"];

        // Refresh carriers for the new pickup country (import => sender/supplier country)
        const supplierCountry = po.Shipping.ShippingDetails.Sender?.Country;
        if (supplierCountry?.ID) {
          this.loadBulkPOCountryShippingOptions(po, supplierCountry);
        }
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }

      po.Shipping._showSenderSelector = false;
      this.cdr.detectChanges();
    });
  }

  // ✅ Available countries for the From/To country selectors (OrderConfirmations master data)
  getBulkPOCountries(): any[] {
    return this.MasterData?.Countries || this.parent?.masterData?.Countries || [];
  }

  // ✅ Select the sender (pickup) country for a PO label (import -1) and refresh carriers
  selectBulkPOSenderCountry(po: any, country: any): void {
    if (!po?.Shipping?.ShippingDetails?.Sender || !country) return;
    po.Shipping.ShippingDetails.Sender.Country = JSON.parse(JSON.stringify(country));
    po.Shipping._showSenderCountryDropdown = false;
    this.loadBulkPOCountryShippingOptions(po, po.Shipping.ShippingDetails.Sender.Country);
  }

  // ✅ Select the receiver (delivery) country for a PO label
  selectBulkPOReceiverCountry(po: any, country: any): void {
    if (!po?.Shipping?.ShippingDetails?.Receiver || !country) return;
    po.Shipping.ShippingDetails.Receiver.Country = JSON.parse(JSON.stringify(country));
    po.Shipping._showReceiverCountryDropdown = false;
  }

  // ✅ Add (ID == 0) or Update (ID > 0) the supplier pickup address (sender, import -1)
  addUpdateBulkPOPartnerShippingAddress(po: any): void {
    const sender = po?.Shipping?.ShippingDetails?.Sender;
    const partnerId = po?.Shipping?.ShippingDetails?.Partner?.ID;
    if (!sender || !partnerId || po.Shipping._savingSenderAddress) return;

    po.Shipping._savingSenderAddress = true;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: sender,
      PartnerID: partnerId
    };

    this.service.AddUpdateShippingAddress(request).subscribe((response: any) => {
      po.Shipping._savingSenderAddress = false;
      if (response["Status"] == 1) {
        const saved = response["ShippingAddress"];
        po.Shipping.ShippingDetails.Sender = saved;

        if (po.Shipping.AvailablePartnerAddresses) {
          const idx = po.Shipping.AvailablePartnerAddresses.findIndex((a: any) => a.ID === saved.ID);
          if (idx >= 0) po.Shipping.AvailablePartnerAddresses[idx] = saved;
          else po.Shipping.AvailablePartnerAddresses.push(saved);
        }

        this.parent.openSnackBar(this.translate.instant('AddressUpdatedSuccessfully'), 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"], 'OK', 'alert-info-snackbar');
      }
      this.cdr.detectChanges();
    }, () => {
      po.Shipping._savingSenderAddress = false;
    });
  }

  // ✅ Update the company receiver (delivery) shipping address
  addUpdateBulkPOCompanyShippingAddress(po: any): void {
    const receiver = po?.Shipping?.ShippingDetails?.Receiver;
    if (!receiver || po.Shipping._savingReceiverAddress) return;

    po.Shipping._savingReceiverAddress = true;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: receiver,
      CompanyID: this.parent.Company.ID
    };

    this.service.AddUpdateCompanyShippingAddress(request).subscribe((response: any) => {
      po.Shipping._savingReceiverAddress = false;
      if (response["Status"] == 1) {
        const saved = response["ShippingAddress"];
        po.Shipping.ShippingDetails.Receiver = saved;

        if (po.Shipping.AvailableShippingAddresses) {
          const idx = po.Shipping.AvailableShippingAddresses.findIndex((a: any) => a.ID === saved.ID);
          if (idx >= 0) po.Shipping.AvailableShippingAddresses[idx] = saved;
          else po.Shipping.AvailableShippingAddresses.push(saved);
        }
        this.BulkPOCompanyShippingAddresses = po.Shipping.AvailableShippingAddresses;

        this.parent.openSnackBar(this.translate.instant('AddressUpdatedSuccessfully'), 'OK', 'light-info-snackbar');
      } else {
        this.parent.openSnackBar(response["Message"], 'OK', 'alert-info-snackbar');
      }
      this.cdr.detectChanges();
    }, () => {
      po.Shipping._savingReceiverAddress = false;
    });
  }

  // ✅ Generate the shipping label for a PO (withPickup = request carrier pickup at the supplier)
  generateBulkPOLabel(po: any, withPickup: boolean): void {
    if (!po?.Shipping?.ShippingDetails || po.Shipping._generating) return;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingDetails: po.Shipping.ShippingDetails,
      WithPickup: withPickup,
      CreateShippingLabelSettings: {},
      SelectedDocumentID: null
    };

    po.Shipping._generating = true;
    po.Shipping._errorMessage = null;

    this.managementService.CreateShippingLabel(request).subscribe((response: any) => {
      if (response["Status"] == 1) {
        po.Shipping.ShippingDetails = response["ShippingDetails"];
        po.Shipping._generated = true;
      } else {
        po.Shipping._errorMessage = response["Message"];
      }

      po.Shipping._generating = false;
      this.cdr.detectChanges();
    }, (error: any) => {
      po.Shipping._generating = false;
      po.Shipping._errorMessage = error?.message || 'Error generating shipping label';
      this.cdr.detectChanges();
    });
  }

  // ✅ Download (1) / Print (2) the generated label documents for a PO
  downloadBulkPOLabel(po: any, downloadTypeID: number): void {
    const docs = po?.Shipping?.ShippingDetails?.Documents || [];
    for (var i = 0; i < docs.length; i++) {
      var Document = JSON.parse(JSON.stringify(docs[i]));

      if (downloadTypeID == 1) {
        this.download(Document.Name, Document.PDFStream);
      } else if (downloadTypeID == 2) {
        this.printPage(Document.Name, Document.PDFStream, Document.ID);
      }
    }
  }

  // ✅ Add/remove/multiply parcels for a PO label (reuse batch helpers via the PO shipping context)
  addBulkPOBox(po: any): void {
    this.addBatchBox(po.Shipping);
  }

  removeBulkPOBox(po: any, index: number): void {
    this.removeBatchBox(po.Shipping, index);
  }

  multiplyBulkPOBox(po: any, box: any, index: number): void {
    this.multiplyBatchBox(po.Shipping, box, index);
  }

  // ✅ Inject header checkbox into Generate PO grid for a specific PO index
  injectGeneratePOHeaderCheckbox(poIndex: number): void {
    // Find all generate-po-index-header elements and get the one for this poIndex
    const headerCells = document.querySelectorAll('.generate-po-index-header');
    const headerCell = headerCells[poIndex] as HTMLElement;
    if (headerCell) {
      let headerContent = headerCell.querySelector('.ag-header-cell-text') as HTMLElement;
      if (!headerContent) {
        headerContent = headerCell.querySelector('.ag-header-cell-comp-wrapper') as HTMLElement;
      }
      if (!headerContent) {
        headerContent = headerCell as HTMLElement;
      }
      if (headerContent && !headerContent.querySelector('.generate-po-header-checkbox')) {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'generate-po-header-checkbox';
        checkbox.dataset['poIndex'] = String(poIndex);
        checkbox.checked = this.generatePOHeaderCheckboxSelected[poIndex] || false;
        checkbox.style.cursor = 'pointer';
        checkbox.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleAllGeneratePOSelected(poIndex);
        });
        headerContent.innerHTML = '';
        headerContent.appendChild(checkbox);
      }
    }
  }

  // ✅ Toggle all items selected in a specific Generate PO grid
  toggleAllGeneratePOSelected(poIndex: number): void {
    this.generatePOHeaderCheckboxSelected[poIndex] = !this.generatePOHeaderCheckboxSelected[poIndex];
    const gridApi = this.generatePOGridApis[poIndex];
    if (gridApi) {
      gridApi.forEachNode((node: any) => {
        if (node.data) {
          node.data.IsSelected = this.generatePOHeaderCheckboxSelected[poIndex];
        }
      });
      gridApi.refreshCells({ columns: ['index'], force: true });
    }
    this.updateGeneratePOHeaderCheckbox(poIndex);
  }

  // ✅ Update header checkbox state for a specific Generate PO grid
  updateGeneratePOHeaderCheckbox(poIndex: number): void {
    const headerCheckboxes = document.querySelectorAll('.generate-po-header-checkbox');
    headerCheckboxes.forEach((cb: any) => {
      if (cb.dataset?.poIndex === String(poIndex)) {
        cb.checked = this.generatePOHeaderCheckboxSelected[poIndex] || false;
      }
    });
  }

  // ✅ Get selected cart items from a specific Generate PO grid
  getSelectedGeneratePOItems(poIndex: number): any[] {
    const gridApi = this.generatePOGridApis[poIndex];
    const selectedItems: any[] = [];
    if (gridApi) {
      gridApi.forEachNode((node: any) => {
        if (node.data?.IsSelected === true) {
          selectedItems.push({ node, data: node.data });
        }
      });
    }
    return selectedItems;
  }

  // ✅ Check if any items are selected in a specific Generate PO grid (for overlay visibility)
  hasSelectedGeneratePOItems(poIndex: number): boolean {
    const po = this.GeneratedPurchaseOrders[poIndex];
    return po?.Cart?.Items?.some((item: any) => item.IsSelected === true) || false;
  }

  // ✅ Deselect all items in a specific Generate PO grid (called by overlay click)
  deselectAllGeneratePOItems(poIndex: number): void {
    const po = this.GeneratedPurchaseOrders[poIndex];
    po?.Cart?.Items?.forEach((item: any) => {
      item.IsSelected = false;
    });
    this.generatePOHeaderCheckboxSelected[poIndex] = false;
    const gridApi = this.generatePOGridApis[poIndex];
    if (gridApi) {
      gridApi.refreshCells({ columns: ['index'], force: true });
    }
    this.updateGeneratePOHeaderCheckbox(poIndex);
  }

  // ========== AGENT PHASES MANAGEMENT ==========
  showAgentPhasesPopup: boolean = false;
  selectedPhaseAgent: any = null;
  agentOrderPhasesMasterData: any[] = [];
  selectedPhaseIDs: number[] = [];
  savingAgentPhases: boolean = false;

  openAgentPhasesPopup(agent: any): void {
    this.selectedPhaseAgent = agent;
    this.selectedPhaseIDs = (agent.OrderPhases || []).map((p: any) => p.ID);

    // Load phases master data if not loaded
    if (this.agentOrderPhasesMasterData.length === 0) {
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage()
      };
      this.service.GetPartnersMasterData(request).subscribe((response: any) => {
        if (response.Status === 1) {
          this.agentOrderPhasesMasterData = response.PartnerAgentOrderPhases || [];
        }
      });
    }

    this.showAgentPhasesPopup = true;
  }

  closeAgentPhasesPopup(): void {
    this.showAgentPhasesPopup = false;
    this.selectedPhaseAgent = null;
    this.selectedPhaseIDs = [];
  }

  isAgentPhaseSelected(phase: any): boolean {
    return this.selectedPhaseIDs.includes(phase.ID);
  }

  toggleAgentPhaseInPopup(phase: any): void {
    const idx = this.selectedPhaseIDs.indexOf(phase.ID);
    if (idx >= 0) {
      this.selectedPhaseIDs.splice(idx, 1);
    } else {
      this.selectedPhaseIDs.push(phase.ID);
    }
  }

  saveAgentPhases(): void {
    if (!this.selectedPhaseAgent || this.savingAgentPhases) return;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ParentID: this.selectedPhaseAgent.ConnectionID,
      PhaseIDs: this.selectedPhaseIDs
    };

    this.savingAgentPhases = true;

    // Save order-level phases (if agent has a ConnectionID from this order)
    if (this.selectedPhaseAgent.ConnectionID > 0) {
      this.service.AddUpdateOCAgentPhases(request).subscribe((response: any) => {
        if (response.Status === 1 && response.Phases?.length > 0) {
          this.selectedPhaseAgent.OrderPhases = response.Phases;
        } else {
          this.selectedPhaseAgent.OrderPhases = [];
        }
      });
    }

    // Always save as default phases for this agent
    const defaultRequest = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      AgentID: this.selectedPhaseAgent.ID,
      PhaseIDs: this.selectedPhaseIDs
    };

    this.service.AddUpdatePartnerAgentDefaultPhases(defaultRequest).subscribe((response: any) => {
      this.savingAgentPhases = false;
      if (response.Status === 1) {
        // If no ConnectionID (order-level wasn't saved), use default response
        if (!(this.selectedPhaseAgent.ConnectionID > 0)) {
          this.selectedPhaseAgent.OrderPhases = response.Phases || [];
        }
        this.parent.openSnackBar(response.Message || 'Phases saved', 'OK', 'light-info-snackbar');
        this.closeAgentPhasesPopup();
      } else {
        this.parent.openSnackBar(response.Message || 'Error saving phases', 'OK', 'alert-info-snackbar');
      }
    });
  }

}